import { jsx as g, Fragment as Ge, jsxs as re } from "react/jsx-runtime";
import * as v from "react";
import a, { useState as Ce, useCallback as se, createContext as St, useContext as rt, useLayoutEffect as En, useRef as ue, forwardRef as de, useEffect as ye, useMemo as Le, useId as Gm, createElement as B, Children as yn, isValidElement as _r, cloneElement as vi, Fragment as Ym, useReducer as Xs } from "react";
import * as ir from "react-dom";
import qs, { createPortal as Um, flushSync as Zs } from "react-dom";
import { M as Js, a as Km, b as Xm, c as qm, d as Zm, e as Jm, f as Qm, g as e6, h as t6, i as Pn, j as n6, k as r6, l as a6, m as o6, n as i6, o as l6, p as s6 } from "./xmark-j2hzaTsQ.js";
import pe from "./colors.js";
import { g as Qs } from "./_commonjsHelpers-C6fGbg64.js";
function lr(e, t = []) {
  let n = [];
  function r(i, l) {
    const s = v.createContext(l), c = n.length;
    n = [...n, l];
    function d(u) {
      const { scope: m, children: p, ...y } = u, h = m?.[e][c] || s, b = v.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ g(h.Provider, { value: b, children: p });
    }
    function f(u, m) {
      const p = m?.[e][c] || s, y = v.useContext(p);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, f];
  }
  const o = () => {
    const i = n.map((l) => v.createContext(l));
    return function(s) {
      const c = s?.[e] || i;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, c6(o, ...t)];
}
function c6(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((s, { useScope: c, scopeName: d }) => {
        const u = c(i)[`__scope${d}`];
        return { ...s, ...u };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function d6(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function aa(...e) {
  return (t) => e.forEach((n) => d6(n, t));
}
function xe(...e) {
  return v.useCallback(aa(...e), e);
}
var en = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = v.Children.toArray(n), i = o.find(f6);
  if (i) {
    const l = i.props.children, s = o.map((c) => c === i ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : c);
    return /* @__PURE__ */ g(xo, { ...r, ref: t, children: v.isValidElement(l) ? v.cloneElement(l, void 0, s) : null });
  }
  return /* @__PURE__ */ g(xo, { ...r, ref: t, children: n });
});
en.displayName = "Slot";
var xo = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const o = m6(n);
    return v.cloneElement(n, {
      ...h6(r, n.props),
      // @ts-ignore
      ref: t ? aa(t, o) : o
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
xo.displayName = "SlotClone";
var u6 = ({ children: e }) => /* @__PURE__ */ g(Ge, { children: e });
function f6(e) {
  return v.isValidElement(e) && e.type === u6;
}
function h6(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function m6(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function oa(e) {
  const t = e + "CollectionProvider", [n, r] = lr(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (p) => {
    const { scope: y, children: h } = p, b = a.useRef(null), w = a.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ g(o, { scope: y, itemMap: w, collectionRef: b, children: h });
  };
  l.displayName = t;
  const s = e + "CollectionSlot", c = a.forwardRef(
    (p, y) => {
      const { scope: h, children: b } = p, w = i(s, h), $ = xe(y, w.collectionRef);
      return /* @__PURE__ */ g(en, { ref: $, children: b });
    }
  );
  c.displayName = s;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", u = a.forwardRef(
    (p, y) => {
      const { scope: h, children: b, ...w } = p, $ = a.useRef(null), x = xe(y, $), P = i(d, h);
      return a.useEffect(() => (P.itemMap.set($, { ref: $, ...w }), () => void P.itemMap.delete($))), /* @__PURE__ */ g(en, { [f]: "", ref: x, children: b });
    }
  );
  u.displayName = d;
  function m(p) {
    const y = i(e + "CollectionConsumer", p);
    return a.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${f}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, E) => w.indexOf(P.ref.current) - w.indexOf(E.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: l, Slot: c, ItemSlot: u },
    m,
    r
  ];
}
function ee(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function Je(e) {
  const t = v.useRef(e);
  return v.useEffect(() => {
    t.current = e;
  }), v.useMemo(() => (...n) => t.current?.(...n), []);
}
function bt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = p6({ defaultProp: t, onChange: n }), i = e !== void 0, l = i ? e : r, s = Je(n), c = v.useCallback(
    (d) => {
      if (i) {
        const u = typeof d == "function" ? d(e) : d;
        u !== e && s(u);
      } else
        o(d);
    },
    [i, e, o, s]
  );
  return [l, c];
}
function p6({
  defaultProp: e,
  onChange: t
}) {
  const n = v.useState(e), [r] = n, o = v.useRef(r), i = Je(t);
  return v.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var v6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], me = v6.reduce((e, t) => {
  const n = v.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, s = i ? en : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(s, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function ec(e, t) {
  e && ir.flushSync(() => e.dispatchEvent(t));
}
var ke = globalThis?.document ? v.useLayoutEffect : () => {
};
function g6(e, t) {
  return v.useReducer((n, r) => t[n][r] ?? n, e);
}
var tc = (e) => {
  const { present: t, children: n } = e, r = y6(t), o = typeof n == "function" ? n({ present: r.isPresent }) : v.Children.only(n), i = xe(r.ref, b6(o));
  return typeof n == "function" || r.isPresent ? v.cloneElement(o, { ref: i }) : null;
};
tc.displayName = "Presence";
function y6(e) {
  const [t, n] = v.useState(), r = v.useRef({}), o = v.useRef(e), i = v.useRef("none"), l = e ? "mounted" : "unmounted", [s, c] = g6(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const d = Er(r.current);
    i.current = s === "mounted" ? d : "none";
  }, [s]), ke(() => {
    const d = r.current, f = o.current;
    if (f !== e) {
      const m = i.current, p = Er(d);
      e ? c("MOUNT") : p === "none" || d?.display === "none" ? c("UNMOUNT") : c(f && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), ke(() => {
    if (t) {
      const d = (u) => {
        const p = Er(r.current).includes(u.animationName);
        u.target === t && p && ir.flushSync(() => c("ANIMATION_END"));
      }, f = (u) => {
        u.target === t && (i.current = Er(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: v.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Er(e) {
  return e?.animationName || "none";
}
function b6(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var w6 = v.useId || (() => {
}), $6 = 0;
function qe(e) {
  const [t, n] = v.useState(w6());
  return ke(() => {
    n((r) => r ?? String($6++));
  }, [e]), t ? `radix-${t}` : "";
}
var gi = "Collapsible", [E6, nc] = lr(gi), [x6, yi] = E6(gi), rc = v.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: l,
      ...s
    } = e, [c = !1, d] = bt({
      prop: r,
      defaultProp: o,
      onChange: l
    });
    return /* @__PURE__ */ g(
      x6,
      {
        scope: n,
        disabled: i,
        contentId: qe(),
        open: c,
        onOpenToggle: v.useCallback(() => d((f) => !f), [d]),
        children: /* @__PURE__ */ g(
          me.div,
          {
            "data-state": wi(c),
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
rc.displayName = gi;
var ac = "CollapsibleTrigger", oc = v.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = yi(ac, n);
    return /* @__PURE__ */ g(
      me.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": wi(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: ee(e.onClick, o.onOpenToggle)
      }
    );
  }
);
oc.displayName = ac;
var bi = "CollapsibleContent", ic = v.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = yi(bi, e.__scopeCollapsible);
    return /* @__PURE__ */ g(tc, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ g(M6, { ...r, ref: t, present: i }) });
  }
);
ic.displayName = bi;
var M6 = v.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = e, l = yi(bi, n), [s, c] = v.useState(r), d = v.useRef(null), f = xe(t, d), u = v.useRef(0), m = u.current, p = v.useRef(0), y = p.current, h = l.open || s, b = v.useRef(h), w = v.useRef();
  return v.useEffect(() => {
    const $ = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame($);
  }, []), ke(() => {
    const $ = d.current;
    if ($) {
      w.current = w.current || {
        transitionDuration: $.style.transitionDuration,
        animationName: $.style.animationName
      }, $.style.transitionDuration = "0s", $.style.animationName = "none";
      const x = $.getBoundingClientRect();
      u.current = x.height, p.current = x.width, b.current || ($.style.transitionDuration = w.current.transitionDuration, $.style.animationName = w.current.animationName), c(r);
    }
  }, [l.open, r]), /* @__PURE__ */ g(
    me.div,
    {
      "data-state": wi(l.open),
      "data-disabled": l.disabled ? "" : void 0,
      id: l.contentId,
      hidden: !h,
      ...i,
      ref: f,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": y ? `${y}px` : void 0,
        ...e.style
      },
      children: h && o
    }
  );
});
function wi(e) {
  return e ? "open" : "closed";
}
var C6 = rc, P6 = oc, S6 = ic, z6 = v.createContext(void 0);
function ia(e) {
  const t = v.useContext(z6);
  return e || t || "ltr";
}
var Dt = "Accordion", F6 = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [$i, N6, D6] = oa(Dt), [la] = lr(Dt, [
  D6,
  nc
]), Ei = nc(), lc = a.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, i = r;
    return /* @__PURE__ */ g($i.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ g(k6, { ...i, ref: t }) : /* @__PURE__ */ g(T6, { ...o, ref: t }) });
  }
);
lc.displayName = Dt;
var [sc, O6] = la(Dt), [cc, A6] = la(
  Dt,
  { collapsible: !1 }
), T6 = a.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...l
    } = e, [s, c] = bt({
      prop: n,
      defaultProp: r,
      onChange: o
    });
    return /* @__PURE__ */ g(
      sc,
      {
        scope: e.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: c,
        onItemClose: a.useCallback(() => i && c(""), [i, c]),
        children: /* @__PURE__ */ g(cc, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ g(dc, { ...l, ref: t }) })
      }
    );
  }
), k6 = a.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = e, [l = [], s] = bt({
    prop: n,
    defaultProp: r,
    onChange: o
  }), c = a.useCallback(
    (f) => s((u = []) => [...u, f]),
    [s]
  ), d = a.useCallback(
    (f) => s((u = []) => u.filter((m) => m !== f)),
    [s]
  );
  return /* @__PURE__ */ g(
    sc,
    {
      scope: e.__scopeAccordion,
      value: l,
      onItemOpen: c,
      onItemClose: d,
      children: /* @__PURE__ */ g(cc, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ g(dc, { ...i, ref: t }) })
    }
  );
}), [H6, sa] = la(Dt), dc = a.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: i = "vertical", ...l } = e, s = a.useRef(null), c = xe(s, t), d = N6(n), u = ia(o) === "ltr", m = ee(e.onKeyDown, (p) => {
      if (!F6.includes(p.key)) return;
      const y = p.target, h = d().filter((F) => !F.ref.current?.disabled), b = h.findIndex((F) => F.ref.current === y), w = h.length;
      if (b === -1) return;
      p.preventDefault();
      let $ = b;
      const x = 0, P = w - 1, E = () => {
        $ = b + 1, $ > P && ($ = x);
      }, z = () => {
        $ = b - 1, $ < x && ($ = P);
      };
      switch (p.key) {
        case "Home":
          $ = x;
          break;
        case "End":
          $ = P;
          break;
        case "ArrowRight":
          i === "horizontal" && (u ? E() : z());
          break;
        case "ArrowDown":
          i === "vertical" && E();
          break;
        case "ArrowLeft":
          i === "horizontal" && (u ? z() : E());
          break;
        case "ArrowUp":
          i === "vertical" && z();
          break;
      }
      const S = $ % w;
      h[S].ref.current?.focus();
    });
    return /* @__PURE__ */ g(
      H6,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ g($i.Slot, { scope: n, children: /* @__PURE__ */ g(
          me.div,
          {
            ...l,
            "data-orientation": i,
            ref: c,
            onKeyDown: r ? void 0 : m
          }
        ) })
      }
    );
  }
), Lr = "AccordionItem", [I6, xi] = la(Lr), uc = a.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, i = sa(Lr, n), l = O6(Lr, n), s = Ei(n), c = qe(), d = r && l.value.includes(r) || !1, f = i.disabled || e.disabled;
    return /* @__PURE__ */ g(
      I6,
      {
        scope: n,
        open: d,
        disabled: f,
        triggerId: c,
        children: /* @__PURE__ */ g(
          C6,
          {
            "data-orientation": i.orientation,
            "data-state": gc(d),
            ...s,
            ...o,
            ref: t,
            disabled: f,
            open: d,
            onOpenChange: (u) => {
              u ? l.onItemOpen(r) : l.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
uc.displayName = Lr;
var fc = "AccordionHeader", hc = a.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = sa(Dt, n), i = xi(fc, n);
    return /* @__PURE__ */ g(
      me.h3,
      {
        "data-orientation": o.orientation,
        "data-state": gc(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
hc.displayName = fc;
var Mo = "AccordionTrigger", mc = a.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = sa(Dt, n), i = xi(Mo, n), l = A6(Mo, n), s = Ei(n);
    return /* @__PURE__ */ g($i.ItemSlot, { scope: n, children: /* @__PURE__ */ g(
      P6,
      {
        "aria-disabled": i.open && !l.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
mc.displayName = Mo;
var pc = "AccordionContent", vc = a.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = sa(Dt, n), i = xi(pc, n), l = Ei(n);
    return /* @__PURE__ */ g(
      S6,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...l,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
vc.displayName = pc;
function gc(e) {
  return e ? "open" : "closed";
}
var R6 = lc, yc = uc, bc = hc, wc = mc, $c = vc;
const Mi = "-";
function _6(e) {
  const t = B6(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  function o(l) {
    const s = l.split(Mi);
    return s[0] === "" && s.length !== 1 && s.shift(), Ec(s, t) || L6(l);
  }
  function i(l, s) {
    const c = n[l] || [];
    return s && r[l] ? [...c, ...r[l]] : c;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: i
  };
}
function Ec(e, t) {
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Ec(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Mi);
  return t.validators.find(({
    validator: l
  }) => l(i))?.classGroupId;
}
const Dl = /^\[(.+)\]$/;
function L6(e) {
  if (Dl.test(e)) {
    const t = Dl.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function B6(e) {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return V6(Object.entries(e.classGroups), n).forEach(([i, l]) => {
    Co(l, r, i, t);
  }), r;
}
function Co(e, t, n, r) {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : Ol(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (W6(o)) {
        Co(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, l]) => {
      Co(l, Ol(t, i), n, r);
    });
  });
}
function Ol(e, t) {
  let n = e;
  return t.split(Mi).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function W6(e) {
  return e.isThemeGetter;
}
function V6(e, t) {
  return t ? e.map(([n, r]) => {
    const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([l, s]) => [t + l, s])) : i);
    return [n, o];
  }) : e;
}
function j6(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(i, l) {
    n.set(i, l), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(i) {
      let l = n.get(i);
      if (l !== void 0)
        return l;
      if ((l = r.get(i)) !== void 0)
        return o(i, l), l;
    },
    set(i, l) {
      n.has(i) ? n.set(i, l) : o(i, l);
    }
  };
}
const xc = "!";
function G6(e) {
  const t = e.separator, n = t.length === 1, r = t[0], o = t.length;
  return function(l) {
    const s = [];
    let c = 0, d = 0, f;
    for (let h = 0; h < l.length; h++) {
      let b = l[h];
      if (c === 0) {
        if (b === r && (n || l.slice(h, h + o) === t)) {
          s.push(l.slice(d, h)), d = h + o;
          continue;
        }
        if (b === "/") {
          f = h;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" && c--;
    }
    const u = s.length === 0 ? l : l.substring(d), m = u.startsWith(xc), p = m ? u.substring(1) : u, y = f && f > d ? f - d : void 0;
    return {
      modifiers: s,
      hasImportantModifier: m,
      baseClassName: p,
      maybePostfixModifierPosition: y
    };
  };
}
function Y6(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}
function U6(e) {
  return {
    cache: j6(e.cacheSize),
    splitModifiers: G6(e),
    ..._6(e)
  };
}
const K6 = /\s+/;
function X6(e, t) {
  const {
    splitModifiers: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = /* @__PURE__ */ new Set();
  return e.trim().split(K6).map((l) => {
    const {
      modifiers: s,
      hasImportantModifier: c,
      baseClassName: d,
      maybePostfixModifierPosition: f
    } = n(l);
    let u = r(f ? d.substring(0, f) : d), m = !!f;
    if (!u) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      if (u = r(d), !u)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      m = !1;
    }
    const p = Y6(s).join(":");
    return {
      isTailwindClass: !0,
      modifierId: c ? p + xc : p,
      classGroupId: u,
      originalClassName: l,
      hasPostfixModifier: m
    };
  }).reverse().filter((l) => {
    if (!l.isTailwindClass)
      return !0;
    const {
      modifierId: s,
      classGroupId: c,
      hasPostfixModifier: d
    } = l, f = s + c;
    return i.has(f) ? !1 : (i.add(f), o(c, d).forEach((u) => i.add(s + u)), !0);
  }).reverse().map((l) => l.originalClassName).join(" ");
}
function q6() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Mc(t)) && (r && (r += " "), r += n);
  return r;
}
function Mc(e) {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Mc(e[r])) && (n && (n += " "), n += t);
  return n;
}
function Z6(e, ...t) {
  let n, r, o, i = l;
  function l(c) {
    const d = t.reduce((f, u) => u(f), e());
    return n = U6(d), r = n.cache.get, o = n.cache.set, i = s, s(c);
  }
  function s(c) {
    const d = r(c);
    if (d)
      return d;
    const f = X6(c, n);
    return o(c, f), f;
  }
  return function() {
    return i(q6.apply(null, arguments));
  };
}
function Ne(e) {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}
const Cc = /^\[(?:([a-z-]+):)?(.+)\]$/i, J6 = /^\d+\/\d+$/, Q6 = /* @__PURE__ */ new Set(["px", "full", "screen"]), e7 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, t7 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, n7 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, r7 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, a7 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Et(e) {
  return Zt(e) || Q6.has(e) || J6.test(e);
}
function kt(e) {
  return Sn(e, "length", f7);
}
function Zt(e) {
  return !!e && !Number.isNaN(Number(e));
}
function xr(e) {
  return Sn(e, "number", Zt);
}
function kn(e) {
  return !!e && Number.isInteger(Number(e));
}
function o7(e) {
  return e.endsWith("%") && Zt(e.slice(0, -1));
}
function he(e) {
  return Cc.test(e);
}
function Ht(e) {
  return e7.test(e);
}
const i7 = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function l7(e) {
  return Sn(e, i7, Pc);
}
function s7(e) {
  return Sn(e, "position", Pc);
}
const c7 = /* @__PURE__ */ new Set(["image", "url"]);
function d7(e) {
  return Sn(e, c7, m7);
}
function u7(e) {
  return Sn(e, "", h7);
}
function Hn() {
  return !0;
}
function Sn(e, t, n) {
  const r = Cc.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function f7(e) {
  return t7.test(e) && !n7.test(e);
}
function Pc() {
  return !1;
}
function h7(e) {
  return r7.test(e);
}
function m7(e) {
  return a7.test(e);
}
function p7() {
  const e = Ne("colors"), t = Ne("spacing"), n = Ne("blur"), r = Ne("brightness"), o = Ne("borderColor"), i = Ne("borderRadius"), l = Ne("borderSpacing"), s = Ne("borderWidth"), c = Ne("contrast"), d = Ne("grayscale"), f = Ne("hueRotate"), u = Ne("invert"), m = Ne("gap"), p = Ne("gradientColorStops"), y = Ne("gradientColorStopPositions"), h = Ne("inset"), b = Ne("margin"), w = Ne("opacity"), $ = Ne("padding"), x = Ne("saturate"), P = Ne("scale"), E = Ne("sepia"), z = Ne("skew"), S = Ne("space"), F = Ne("translate"), O = () => ["auto", "contain", "none"], I = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", he, t], _ = () => [he, t], ne = () => ["", Et, kt], R = () => ["auto", Zt, he], Y = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], W = () => ["solid", "dashed", "dotted", "double", "none"], V = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], J = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], T = () => ["", "0", he], N = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], D = () => [Zt, xr], K = () => [Zt, he];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Hn],
      spacing: [Et, kt],
      blur: ["none", "", Ht, he],
      brightness: D(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ht, he],
      borderSpacing: _(),
      borderWidth: ne(),
      contrast: D(),
      grayscale: T(),
      hueRotate: K(),
      invert: T(),
      gap: _(),
      gradientColorStops: [e],
      gradientColorStopPositions: [o7, kt],
      inset: L(),
      margin: L(),
      opacity: D(),
      padding: _(),
      saturate: D(),
      scale: D(),
      sepia: T(),
      skew: K(),
      space: _(),
      translate: _()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", he]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ht]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": N()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": N()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Y(), he]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", kn, he]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: L()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", he]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: T()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: T()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", kn, he]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Hn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", kn, he]
        }, he]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": R()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": R()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Hn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [kn, he]
        }, he]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": R()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": R()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", he]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", he]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...J()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...J(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...J(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [$]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [$]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [$]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [$]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [$]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [$]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [$]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [$]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [$]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", he, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [he, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [he, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ht]
        }, Ht]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [he, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [he, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [he, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [he, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ht, kt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", xr]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Hn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", he]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Zt, xr]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Et, he]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", he]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", he]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...W(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Et, kt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Et, he]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: _()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", he]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", he]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Y(), s7]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", l7]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, d7]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [y]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...W(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: W()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...W()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Et, he]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Et, kt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ne()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Et, kt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ht, u7]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Hn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": V()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ht, he]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [d]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [E]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [d]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [E]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", he]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: K()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", he]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: K()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", he]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [P]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [P]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [P]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [kn, he]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [F]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [F]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [z]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [z]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", he]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", he]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": _()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": _()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": _()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": _()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": _()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": _()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": _()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": _()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": _()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": _()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": _()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": _()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": _()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": _()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": _()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": _()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": _()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": _()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", he]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Et, kt, xr]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const Sc = /* @__PURE__ */ Z6(p7);
function zc(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = zc(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function Fc() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = zc(e)) && (r && (r += " "), r += t);
  return r;
}
function j(...e) {
  return Sc(Fc(...e));
}
const Al = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Tl = Fc, v7 = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return Tl(e, n?.class, n?.className);
  const { variants: o, defaultVariants: i } = t, l = Object.keys(o).map((d) => {
    const f = n?.[d], u = i?.[d];
    if (f === null) return null;
    const m = Al(f) || Al(u);
    return o[d][m];
  }), s = n && Object.entries(n).reduce((d, f) => {
    let [u, m] = f;
    return m === void 0 || (d[u] = m), d;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, f) => {
    let { class: u, className: m, ...p } = f;
    return Object.entries(p).every((y) => {
      let [h, b] = y;
      return Array.isArray(b) ? b.includes({
        ...i,
        ...s
      }[h]) : {
        ...i,
        ...s
      }[h] === b;
    }) ? [
      ...d,
      u,
      m
    ] : d;
  }, []);
  return Tl(e, l, c, n?.class, n?.className);
};
function Se(...e) {
  const t = v7(...e);
  return (...n) => Sc(t(...n));
}
function g7() {
  const [, e] = Ce({});
  return se(() => e({}), []);
}
function E_(e) {
  const t = St({
    registerSlot: () => null,
    unregisterSlot: () => null,
    context: {}
  }), n = Object.freeze({});
  function r({
    context: l = n,
    slotChildren: s,
    children: c
  }) {
    const d = {};
    e.map((w) => d[w] = []);
    const f = ue(d), u = g7(), [m, p] = Ce(!1);
    En(() => {
      u(), p(!0);
    }, [u]);
    const y = se(
      (w, $) => {
        f.current[w]?.push($), m && u();
      },
      [m, u]
    ), h = se(
      (w, $) => {
        const x = f.current[w];
        if (x) {
          const P = x.indexOf($);
          P !== -1 && x.splice(P, 1);
        }
        u();
      },
      [u]
    ), { current: b } = f;
    return /* @__PURE__ */ g(
      t.Provider,
      {
        value: {
          registerSlot: y,
          unregisterSlot: h,
          context: l
        },
        children: /* @__PURE__ */ re(Ge, { children: [
          c(
            Object.fromEntries(
              Object.entries(b).map(([w, $]) => Array.isArray($) && $.length === 1 ? [w, $[0]] : [w, $])
            )
          ),
          s
        ] })
      }
    );
  }
  function o({ name: l, children: s }) {
    const { registerSlot: c, unregisterSlot: d, context: f } = rt(t);
    return En(() => {
      const u = typeof s == "function" ? s(f) : s;
      return c(l, u), () => d(l, u);
    }, [l, s, c, d, f]), null;
  }
  function i() {
    const { context: l } = rt(t);
    return l;
  }
  return { Slots: r, Slot: o, useSlotsContext: i };
}
function y7() {
  const e = Date.now().toString(36), t = Math.random().toString(36).substring(2, 9);
  return `${e}-${t}`;
}
class zn {
  x;
  y;
  z;
  duration;
  constructor() {
    this.x = 0, this.y = 0, this.z = 0, this.duration = 500;
  }
  findFurthestPoint(t, n, r, o, i, l) {
    return this.x = t - r > n / 2 ? 0 : n, this.y = o - l > i / 2 ? 0 : i, this.z = Math.hypot(this.x - (t - r), this.y - (o - l)), this.z;
  }
  appyStyles(t, n, r, o, i) {
    t.classList.add("ripple"), t.style.backgroundColor = n, t.style.borderRadius = "50%", t.style.pointerEvents = "none", t.style.position = "absolute", t.style.left = `${i.clientX - r.left - o}px`, t.style.top = `${i.clientY - r.top - o}px`, t.style.width = t.style.height = `${o * 2}px`;
  }
  applyAnimation(t, n) {
    t.animate(
      [
        {
          transform: "scale(0)",
          opacity: n
        },
        {
          transform: "scale(1.5)",
          opacity: 0
        }
      ],
      {
        duration: this.duration,
        easing: "linear"
      }
    );
  }
  apply(t, n) {
    const r = t.currentTarget;
    r.style.position = "relative", r.style.overflow = "hidden";
    const o = r.getBoundingClientRect(), i = this.findFurthestPoint(
      t.clientX,
      r.offsetWidth,
      o.left,
      t.clientY,
      r.offsetHeight,
      o.top
    ), l = document.createElement("span");
    this.appyStyles(l, n.color, o, i, t), this.applyAnimation(l, n.opacity), r.appendChild(l), setTimeout(() => l.remove(), this.duration);
  }
}
const b7 = Se(["animate-spin", "text-transparent"], {
  variants: {
    variant: {
      primary: ["fill-white"],
      secondary: ["fill-secondary-500"],
      tertiary: ["fill-secondary-500"],
      ancillary: ["fill-secondary-500"],
      destructive: ["fill-white"],
      cta: ["fill-white"],
      link: ["fill-blue-500"]
    },
    inverse: {
      true: []
    },
    size: {
      sm: ["h-4", "w-4"],
      md: ["h-4", "w-4"],
      lg: ["h-5", "w-5"]
    }
  },
  compoundVariants: [
    {
      variant: "primary",
      inverse: !0,
      class: ["fill-secondary-500"]
    },
    {
      variant: "secondary",
      inverse: !0,
      class: ["fill-white"]
    },
    {
      variant: "ancillary",
      inverse: !0,
      class: ["fill-white"]
    },
    {
      variant: "destructive",
      inverse: !0,
      class: ["fill-error-500"]
    }
  ],
  defaultVariants: {
    variant: "primary",
    size: "md"
  }
}), Nc = ({
  inverse: e = !1,
  size: t,
  variant: n
}) => /* @__PURE__ */ re(Ge, { children: [
  /* @__PURE__ */ re(
    "svg",
    {
      "aria-hidden": "true",
      className: b7({ inverse: e, size: t, variant: n }),
      fill: "none",
      viewBox: "0 0 100 101",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ g(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ g(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ g("span", { className: "sr-only", children: "Loading" })
] }), ot = {
  deepBlueRipple: {
    color: pe.secondary[500],
    opacity: 0.2
  },
  grayRipple: {
    color: pe.deepGray[900]
  },
  linkRipple: {
    color: pe.blue[500],
    opacity: 0.3
  },
  whiteRipple: {
    color: pe.white,
    opacity: 0.3
  }
}, Lt = {
  ancillary: ot.deepBlueRipple,
  "ancillary-inverse": ot.whiteRipple,
  cta: ot.whiteRipple,
  "cta-inverse": ot.whiteRipple,
  destructive: ot.whiteRipple,
  link: ot.linkRipple,
  primary: ot.whiteRipple,
  "primary-inverse": ot.deepBlueRipple,
  secondary: ot.deepBlueRipple,
  "secondary-inverse": ot.whiteRipple,
  tertiary: ot.whiteRipple
}, Dc = Se(
  [
    "relative",
    "flex",
    "shrink-0",
    "select-none",
    "flex-nowrap",
    "items-center",
    "justify-center",
    "rounded-full",
    "transition-all",
    "duration-200",
    "disabled:pointer-events-none",
    "disabled:opacity-38",
    "overflow-hidden",
    // Baseline styles for focus effect
    "focus:outline-0",
    "focus:outline-offset-0",
    "focus-visible:outline-0",
    "focus-visible:outline-offset-0",
    "outline-none",
    "before:absolute",
    "before:block",
    "before:-inset-y-1",
    "before:inset-x-2",
    "before:bg-transparent",
    // baseline bg of transparent for transition effects
    "focus-visible:before:bg-white/30",
    // This bg color is overridden later in certain variants
    "before:transition-all",
    "before:scale-75",
    // baseline scale of 75 for transition effects
    "focus-visible:before:scale-100",
    // scale to 100 on focus
    "before:rounded-full",
    "before:content-['']",
    "before:pointer-events-none"
  ],
  {
    variants: {
      variant: {
        primary: ["bg-secondary-500", "hover:bg-secondary-700"],
        secondary: ["bg-secondary-500/5", "hover:bg-secondary-500/10", "border-secondary-500", "border-[1.5px]"],
        tertiary: ["bg-gray-200", "hover:bg-gray-400", "focus-visible:before:bg-deepGray-900/10"],
        ancillary: ["bg-transparent", "hover:bg-secondary-100"],
        destructive: ["bg-error-500", "hover:bg-error-600"],
        cta: ["relative", "bg-primary-500", "button-3d-secondary-500", "hover:bg-primary-700"],
        link: ["bg-transparent", "hover:bg-blue-500/[.04]", "focus-visible:before:bg-blue-500/30"]
      },
      inverse: {
        true: []
      },
      dark: {
        true: []
      },
      size: {
        sm: ["h-[2.25rem]", "w-[2.25rem]"],
        md: ["h-[2.75rem]", "w-[2.75rem]"],
        lg: ["h-[3.5rem]", "w-[3.5rem]"]
      }
    },
    compoundVariants: [
      // Size compound variants
      {
        variant: "secondary",
        size: "sm",
        // Using calcs here to subtract the size of the border from the padding and keep consistent button sizing across variants,
        // We tried other tricks, but this works better for subpixel rendering in Safari, and allows our focus state to be consistent.
        class: ["h-[calc(2.25rem-1.5px)]", "w-[calc(2.25rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "md",
        class: ["h-[calc(2.75rem-1.5px)]", "w-[calc(2.75rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "lg",
        class: ["h-[calc(3.5rem-1.5px)]", "w-[calc(3.5rem-1.5px)]"]
      },
      // Inverse compound variants
      {
        variant: "cta",
        inverse: !0,
        class: ["button-3d-white"]
      },
      {
        variant: "cta",
        dark: !0,
        class: ["bg-secondary-500", "button-3d-white", "hover:bg-secondary-800"]
      },
      {
        variant: "primary",
        inverse: !0,
        class: ["bg-white", "hover:bg-secondary-100", "focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "secondary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "secondary",
        inverse: !0,
        class: ["border-white", "bg-white/5", "hover:bg-white/10"]
      },
      {
        variant: "ancillary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "ancillary",
        inverse: !0,
        class: ["hover:bg-white/20"]
      },
      {
        variant: "destructive",
        inverse: !0,
        class: ["bg-white", "hover:bg-gray-100", "focus-visible:before:bg-deepGray-900/10"]
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), Br = {
  ancillary: pe.secondary[500],
  "ancillary-inverse": pe.white,
  cta: pe.white,
  "cta-inverse": pe.white,
  destructive: pe.white,
  "destructive-inverse": pe.error[500],
  link: pe.blue[500],
  primary: pe.white,
  "primary-inverse": pe.secondary[500],
  secondary: pe.secondary[500],
  "secondary-inverse": pe.white,
  tertiary: pe.secondary[500]
}, Oc = de(function({ className: t, dark: n = !1, icon: r, inverse: o = !1, loading: i, name: l, size: s = "md", variant: c = "primary", ...d }, f) {
  const u = new zn(), m = `${c}${o ? "-inverse" : ""}`;
  return /* @__PURE__ */ g(
    "button",
    {
      "aria-label": l,
      className: Dc({ className: t, dark: n, inverse: o, size: s, variant: c }),
      ref: f,
      type: "button",
      ...d,
      ...i && { disabled: !0 },
      onMouseDown: (p) => {
        const y = d?.onMouseDown;
        return u.apply(p, Lt[m] ?? Lt.primary), typeof y == "function" && y(p);
      },
      children: i ? /* @__PURE__ */ g(Nc, { inverse: o, size: s, variant: c }) : /* @__PURE__ */ g(r, { fill: Br[m] ?? Br.primary, className: "h-6 w-6" })
    }
  );
}), x_ = R6, w7 = Se([], {
  variants: {
    divided: {
      true: ["border-t", "border-b", "first:border-t-0", "last:border-b-0"],
      false: []
    }
  },
  defaultVariants: {
    divided: !1
  }
}), $7 = v.forwardRef(({ children: e, className: t, divided: n, ...r }, o) => /* @__PURE__ */ g(yc, { ref: o, className: j(w7({ divided: n }), t), ...r, children: e }));
$7.displayName = yc.displayName;
const E7 = v.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ g(
  bc,
  {
    ref: r,
    className: j("m-0 flex items-center px-4 py-2 text-base font-normal text-text-primary", t),
    ...n,
    children: e
  }
));
E7.displayName = bc.displayName;
const x7 = v.forwardRef(({ className: e, name: t, size: n = "sm", variant: r = "ancillary", ...o }, i) => /* @__PURE__ */ g(wc, { ref: i, ...o, asChild: !0, children: /* @__PURE__ */ g(
  Oc,
  {
    icon: Js,
    name: t ?? "Accordion Toggle",
    size: n,
    variant: r,
    className: j(
      "ml-2 fill-text-primary [&>svg]:transition-transform [&>svg]:duration-200 [&>svg]:data-[state=open]:rotate-180",
      e
    )
  }
) }));
x7.displayName = wc.displayName;
const M7 = v.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ g(
  $c,
  {
    ref: r,
    className: "overflow-hidden data-[state=closed]:animate-close-up data-[state=open]:animate-open-down",
    ...n,
    children: /* @__PURE__ */ g("div", { className: j("pb-4", t), children: e })
  }
));
M7.displayName = $c.displayName;
const C7 = Se(["p-4", "rounded-md"], {
  variants: {
    variant: {
      standard: ["border"],
      filled: [],
      outlined: ["border", "bg-white"]
    },
    type: {
      default: [],
      success: [],
      info: [],
      error: [],
      warning: []
    },
    full: {
      false: ["w-fit"],
      true: ["w-full"]
    }
  },
  compoundVariants: [
    // filled
    {
      variant: "filled",
      type: "default",
      className: ["bg-gray-100", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "success",
      className: ["bg-success-200", "text-success-900"]
    },
    {
      variant: "filled",
      type: "info",
      className: ["bg-info-200", "text-info-900"]
    },
    {
      variant: "filled",
      type: "warning",
      className: ["bg-warning-200", "text-warning-900"]
    },
    {
      variant: "filled",
      type: "error",
      className: ["bg-error-200", "text-error-900"]
    },
    // standard
    {
      variant: "standard",
      type: "default",
      className: ["border-gray-700", "bg-gray-100", "text-text-primary"]
    },
    {
      variant: "standard",
      type: "success",
      className: ["border-success-900", "bg-success-100", "text-success-900"]
    },
    {
      variant: "standard",
      type: "info",
      className: ["border-info-900", "bg-info-100", "text-info-900"]
    },
    {
      variant: "standard",
      type: "warning",
      className: ["border-warning-900", "bg-warning-100", "text-warning-900"]
    },
    {
      variant: "standard",
      type: "error",
      className: ["border-error-900", "bg-error-100", "text-error-900"]
    },
    // outlined
    {
      variant: "outlined",
      type: "default",
      className: ["border-gray-700", "text-text-primary", "bg-gray-100"]
    },
    {
      variant: "outlined",
      type: "success",
      className: ["border-success-900", "text-success-900", "bg-success-50"]
    },
    {
      variant: "outlined",
      type: "info",
      className: ["border-info-900", "text-info-900", "bg-info-50"]
    },
    {
      variant: "outlined",
      type: "warning",
      className: ["border-warning-900", "text-warning-900", "bg-warning-50"]
    },
    {
      variant: "outlined",
      type: "error",
      className: ["border-error-900", "text-error-900", "bg-error-50"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    type: "default",
    full: !1
  }
}), kl = {
  default: { fill: pe.text.primary, icon: /* @__PURE__ */ g(Jm, { fill: pe.text.primary }) },
  error: { fill: pe.error[900], icon: /* @__PURE__ */ g(Zm, { fill: pe.error[900] }) },
  info: { fill: pe.info[900], icon: /* @__PURE__ */ g(qm, { fill: pe.info[900] }) },
  success: { fill: pe.success[900], icon: /* @__PURE__ */ g(Xm, { fill: pe.success[900] }) },
  warning: { fill: pe.warning[900], icon: /* @__PURE__ */ g(Km, { fill: pe.warning[900] }) }
};
function M_({
  action: e,
  description: t,
  full: n = !1,
  icon: r = !0,
  title: o,
  type: i = "default",
  variant: l = "standard"
}) {
  const s = new zn();
  return /* @__PURE__ */ re("div", { "aria-atomic": "true", "aria-live": "assertive", className: C7({ variant: l, type: i, full: n }), role: "alert", children: [
    /* @__PURE__ */ re("div", { className: "flex items-center", children: [
      r && /* @__PURE__ */ g("div", { className: j("mr-3"), children: kl[i].icon }),
      o && /* @__PURE__ */ g("div", { className: "font-bold", children: o }),
      t && !o && /* @__PURE__ */ g("div", { className: "text-sm", children: t }),
      e && /* @__PURE__ */ g("div", { className: "ml-auto shrink-0 pl-4", children: /* @__PURE__ */ re(
        "button",
        {
          className: j(
            "flex items-center gap-2 rounded-full px-2 py-1 font-bold hover:enabled:bg-black/10 disabled:opacity-38"
          ),
          onClick: e.onClick,
          type: "button",
          onMouseDown: (c) => {
            s.apply(c, { color: pe.black, opacity: 0.1 });
          },
          disabled: e.loading,
          children: [
            e.loading && /* @__PURE__ */ re(Ge, { children: [
              /* @__PURE__ */ re(
                "svg",
                {
                  "aria-hidden": "true",
                  className: "h-4 w-4 animate-spin text-transparent",
                  fill: kl[i].fill,
                  viewBox: "0 0 100 101",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ g(
                      "path",
                      {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                      }
                    ),
                    /* @__PURE__ */ g(
                      "path",
                      {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ g("span", { className: "sr-only", children: "Loading" })
            ] }),
            e.text
          ]
        }
      ) })
    ] }),
    t && o && /* @__PURE__ */ g("div", { className: j("mt-0.5 text-sm", { "ml-7": r }), children: t })
  ] });
}
const Ac = Se(
  [
    "relative",
    "text-center",
    "font-bold",
    "rounded-full",
    "select-none",
    "disabled:pointer-events-none",
    "transition-all",
    "duration-200",
    "disabled:opacity-38",
    "flex",
    "shrink-0",
    "items-center",
    "flex-nowrap",
    "justify-center",
    "overflow-hidden",
    // Baseline styles for focus effect
    "focus:outline-0",
    "focus:outline-offset-0",
    "focus-visible:outline-0",
    "focus-visible:outline-offset-0",
    "outline-none",
    "before:absolute",
    "before:block",
    "before:-inset-y-3",
    "before:inset-x-2",
    "before:bg-transparent",
    // baseline bg of transparent for transition effects
    "focus-visible:before:bg-white/30",
    // This bg color is overridden later in certain variants
    "before:transition-all",
    "before:scale-75",
    // baseline scale of 75 for transition effects
    "focus-visible:before:scale-100",
    // scale to 100 on focus
    "before:rounded-full",
    "before:content-['']",
    "before:pointer-events-none"
  ],
  {
    variants: {
      variant: {
        primary: ["hover:bg-secondary-700", "text-white", "bg-secondary-500"],
        secondary: [
          "text-secondary-500",
          "hover:bg-secondary-500/10",
          "bg-secondary-500/5",
          "border-secondary-500",
          "border-[1.5px]"
        ],
        tertiary: ["text-secondary-500", "bg-gray-200", "hover:bg-gray-400", "focus-visible:before:bg-deepGray-900/10"],
        ancillary: ["hover:bg-secondary-100", "bg-transparent", "text-secondary-500"],
        destructive: ["bg-error-500", "hover:bg-error-600", "text-white"],
        cta: ["text-white", "relative", "button-3d-secondary-500", "bg-primary-500", "hover:bg-primary-700"],
        link: ["text-blue-500", "hover:bg-blue-500/[.04]", "bg-transparent", "focus-visible:before:bg-blue-500/30"]
      },
      inverse: {
        true: []
      },
      dark: {
        true: []
      },
      full: {
        true: "w-full"
      },
      size: {
        sm: ["px-[0.75rem]", "py-[0.25rem]", "gap-2", "before:inset-x-2"],
        md: ["text-lg", "px-[1.25rem]", "py-[0.5rem]", "gap-2", "before:inset-x-4"],
        lg: ["text-xl", "px-[1.5rem]", "py-[1rem]", "gap-3", "before:inset-x-4"]
      }
    },
    compoundVariants: [
      // Size compound variants
      {
        variant: "secondary",
        size: "sm",
        // Using calcs here to subtract the size of the border from the padding and keep consistent button sizing across variants,
        // We tried other tricks (like box shadow), but this works better for subpixel rendering in Safari, and allows our focus state to be consistent.
        class: ["px-[calc(0.75rem-1.5px)]", "py-[calc(0.25rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "md",
        class: ["px-[calc(1.25rem-1.5px)]", "py-[calc(0.5rem-1.5px)]"]
      },
      {
        variant: "secondary",
        size: "lg",
        class: ["px-[calc(1.5rem-1.5px)]", "py-[calc(1rem-1.5px)]"]
      },
      // Inverse compound variants
      {
        variant: "cta",
        inverse: !0,
        class: ["button-3d-white"]
      },
      {
        variant: "cta",
        dark: !0,
        class: ["button-3d-white", "bg-secondary-500", "hover:bg-secondary-800"]
      },
      {
        variant: "primary",
        inverse: !0,
        class: ["hover:bg-secondary-100", "text-secondary-500", "bg-white", "focus-visible:before:bg-secondary-500/30"]
      },
      {
        variant: "secondary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "secondary",
        inverse: !0,
        class: ["hover:bg-white/10", "text-white", "bg-white/5", "border-white"]
      },
      {
        variant: "ancillary",
        inverse: !1,
        class: ["focus-visible:before:bg-secondary-500/20"]
      },
      {
        variant: "ancillary",
        inverse: !0,
        class: ["text-white", "hover:bg-white/20"]
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), P7 = de(function({
  children: t,
  className: n,
  dark: r = !1,
  full: o,
  icon: i,
  inverse: l = !1,
  loading: s,
  size: c = "md",
  variant: d = "primary",
  ...f
}, u) {
  const m = new zn();
  return /* @__PURE__ */ re(
    "button",
    {
      type: "button",
      ref: u,
      className: Ac({ variant: d, size: c, full: o, inverse: l, className: n, dark: r }),
      ...f,
      ...s && { disabled: !0 },
      onMouseDown: (p) => {
        const y = f?.onMouseDown;
        return m.apply(
          p,
          Lt[`${d}${l ? "-inverse" : ""}`] ?? Lt.primary
        ), typeof y == "function" && y(p);
      },
      children: [
        s ? /* @__PURE__ */ g(Nc, { inverse: l, size: c, variant: d }) : i ? /* @__PURE__ */ g(
          "span",
          {
            className: j("[&>*]:h-full [&>*]:w-full", {
              "h-4 w-4": c === "sm",
              "h-5 w-5": c === "md",
              "h-6 w-6": c === "lg"
            }),
            children: i
          }
        ) : null,
        /* @__PURE__ */ g("span", { className: "relative z-[1]", children: t })
      ]
    }
  );
}), C_ = de(function({
  as: t,
  children: n,
  className: r,
  dark: o = !1,
  disabled: i = !1,
  full: l,
  icon: s,
  inverse: c = !1,
  size: d = "md",
  variant: f = "primary",
  ...u
}, m) {
  const p = Ac({ variant: f, size: d, full: l, inverse: c, className: r, dark: o }), y = /* @__PURE__ */ re(Ge, { children: [
    s ? /* @__PURE__ */ g(
      "span",
      {
        className: j("[&>*]:h-full [&>*]:w-full", {
          "h-4 w-4": d === "sm",
          "h-5 w-5": d === "md",
          "h-6 w-6": d === "lg"
        }),
        children: s
      }
    ) : null,
    /* @__PURE__ */ g("span", { className: "relative z-[1]", children: n })
  ] });
  if (i)
    return /* @__PURE__ */ g("span", { ref: m, className: j(p, "pointer-events-none opacity-38"), children: y });
  const h = t ?? "a", b = new zn();
  return /* @__PURE__ */ g(
    h,
    {
      ref: m,
      className: p,
      ...u,
      onMouseDown: (w) => {
        const $ = u?.onMouseDown;
        return b.apply(
          w,
          Lt[`${f}${c ? "-inverse" : ""}`] ?? Lt.primary
        ), typeof $ == "function" && $(w);
      },
      children: y
    }
  );
});
function S7(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const z7 = {}, Bn = {};
function Jt(e, t) {
  try {
    const r = (z7[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return r in Bn ? Bn[r] : Hl(r, r.split(":"));
  } catch {
    if (e in Bn) return Bn[e];
    const n = e?.match(F7);
    return n ? Hl(e, n.slice(1)) : NaN;
  }
}
const F7 = /([+-]\d\d):?(\d\d)?/;
function Hl(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return Bn[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class gt extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Jt(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), Tc(this), Po(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new gt(...n, t) : new gt(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new gt(+this, t);
  }
  getTimezoneOffset() {
    const t = -Jt(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), Po(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new gt(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Il = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Il.test(e)) return;
  const t = e.replace(Il, "$1UTC");
  gt.prototype[t] && (e.startsWith("get") ? gt.prototype[e] = function() {
    return this.internal[t]();
  } : (gt.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), N7(this), +this;
  }, gt.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), Po(this), +this;
  }));
});
function Po(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-Jt(e.timeZone, e) * 60));
}
function N7(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Tc(e);
}
function Tc(e) {
  const t = Jt(e.timeZone, e), n = t > 0 ? Math.floor(t) : Math.ceil(t), r = /* @__PURE__ */ new Date(+e);
  r.setUTCHours(r.getUTCHours() - 1);
  const o = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), l = o - i, s = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  l && s && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + l);
  const c = o - n;
  c && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + c);
  const d = /* @__PURE__ */ new Date(+e);
  d.setUTCSeconds(0);
  const f = o > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, u = Math.round(-(Jt(e.timeZone, e) * 60)) % 60;
  (u || f) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + u), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + u + f));
  const m = Jt(e.timeZone, e), p = m > 0 ? Math.floor(m) : Math.ceil(m), h = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - p, b = p !== n, w = h - c;
  if (b && w) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + w);
    const $ = Jt(e.timeZone, e), x = $ > 0 ? Math.floor($) : Math.ceil($), P = p - x;
    P && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + P), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + P));
  }
}
class Re extends gt {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Re(...n, t) : new Re(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${S7(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Re(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Re(+new Date(t), this.timeZone);
  }
  //#endregion
}
const kc = 6048e5, D7 = 864e5, Rl = Symbol.for("constructDateFrom");
function Ae(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Rl in e ? e[Rl](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Pe(e, t) {
  return Ae(t || e, e);
}
function Hc(e, t, n) {
  const r = Pe(e, n?.in);
  return isNaN(t) ? Ae(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Ic(e, t, n) {
  const r = Pe(e, n?.in);
  if (isNaN(t)) return Ae(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = Ae(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const l = i.getDate();
  return o >= l ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
let O7 = {};
function sr() {
  return O7;
}
function xn(e, t) {
  const n = sr(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Pe(e, t?.in), i = o.getDay(), l = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - l), o.setHours(0, 0, 0, 0), o;
}
function Un(e, t) {
  return xn(e, { ...t, weekStartsOn: 1 });
}
function Rc(e, t) {
  const n = Pe(e, t?.in), r = n.getFullYear(), o = Ae(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Un(o), l = Ae(n, 0);
  l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0);
  const s = Un(l);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function _l(e) {
  const t = Pe(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Fn(e, ...t) {
  const n = Ae.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Kn(e, t) {
  const n = Pe(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Ci(e, t, n) {
  const [r, o] = Fn(
    n?.in,
    e,
    t
  ), i = Kn(r), l = Kn(o), s = +i - _l(i), c = +l - _l(l);
  return Math.round((s - c) / D7);
}
function A7(e, t) {
  const n = Rc(e, t), r = Ae(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Un(r);
}
function T7(e, t, n) {
  return Hc(e, t * 7, n);
}
function k7(e, t, n) {
  return Ic(e, t * 12, n);
}
function H7(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Ae.bind(null, o));
    const i = Pe(o, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), Ae(r, n || NaN);
}
function I7(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Ae.bind(null, o));
    const i = Pe(o, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), Ae(r, n || NaN);
}
function R7(e, t, n) {
  const [r, o] = Fn(
    n?.in,
    e,
    t
  );
  return +Kn(r) == +Kn(o);
}
function _c(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function _7(e) {
  return !(!_c(e) && typeof e != "number" || isNaN(+Pe(e)));
}
function Lc(e, t, n) {
  const [r, o] = Fn(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), l = r.getMonth() - o.getMonth();
  return i * 12 + l;
}
function L7(e, t) {
  const n = Pe(e, t?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Bc(e, t) {
  const [n, r] = Fn(e, t.start, t.end);
  return { start: n, end: r };
}
function B7(e, t) {
  const { start: n, end: r } = Bc(t?.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, l = o ? r : n;
  l.setHours(0, 0, 0, 0), l.setDate(1);
  let s = 1;
  const c = [];
  for (; +l <= i; )
    c.push(Ae(n, l)), l.setMonth(l.getMonth() + s);
  return o ? c.reverse() : c;
}
function W7(e, t) {
  const n = Pe(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function V7(e, t) {
  const n = Pe(e, t?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Wc(e, t) {
  const n = Pe(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function j7(e, t) {
  const { start: n, end: r } = Bc(t?.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, l = o ? r : n;
  l.setHours(0, 0, 0, 0), l.setMonth(0, 1);
  let s = 1;
  const c = [];
  for (; +l <= i; )
    c.push(Ae(n, l)), l.setFullYear(l.getFullYear() + s);
  return o ? c.reverse() : c;
}
function Vc(e, t) {
  const n = sr(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Pe(e, t?.in), i = o.getDay(), l = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + l), o.setHours(23, 59, 59, 999), o;
}
function G7(e, t) {
  return Vc(e, { ...t, weekStartsOn: 1 });
}
const Y7 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, U7 = (e, t, n) => {
  let r;
  const o = Y7[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Ya(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const K7 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, X7 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, q7 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Z7 = {
  date: Ya({
    formats: K7,
    defaultWidth: "full"
  }),
  time: Ya({
    formats: X7,
    defaultWidth: "full"
  }),
  dateTime: Ya({
    formats: q7,
    defaultWidth: "full"
  })
}, J7 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Q7 = (e, t, n, r) => J7[e];
function In(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : l;
      o = e.formattingValues[s] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[l];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const e8 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, t8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, n8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, r8 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, a8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, o8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, i8 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, l8 = {
  ordinalNumber: i8,
  era: In({
    values: e8,
    defaultWidth: "wide"
  }),
  quarter: In({
    values: t8,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: In({
    values: n8,
    defaultWidth: "wide"
  }),
  day: In({
    values: r8,
    defaultWidth: "wide"
  }),
  dayPeriod: In({
    values: a8,
    defaultWidth: "wide",
    formattingValues: o8,
    defaultFormattingWidth: "wide"
  })
};
function Rn(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const l = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? c8(s, (u) => u.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      s8(s, (u) => u.test(l))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(c) : c, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(l.length);
    return { value: d, rest: f };
  };
}
function s8(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function c8(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function d8(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let l = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    l = n.valueCallback ? n.valueCallback(l) : l;
    const s = t.slice(o.length);
    return { value: l, rest: s };
  };
}
const u8 = /^(\d+)(th|st|nd|rd)?/i, f8 = /\d+/i, h8 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, m8 = {
  any: [/^b/i, /^(a|c)/i]
}, p8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, v8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, g8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, y8 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, b8 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, w8 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, $8 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, E8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, x8 = {
  ordinalNumber: d8({
    matchPattern: u8,
    parsePattern: f8,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Rn({
    matchPatterns: h8,
    defaultMatchWidth: "wide",
    parsePatterns: m8,
    defaultParseWidth: "any"
  }),
  quarter: Rn({
    matchPatterns: p8,
    defaultMatchWidth: "wide",
    parsePatterns: v8,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Rn({
    matchPatterns: g8,
    defaultMatchWidth: "wide",
    parsePatterns: y8,
    defaultParseWidth: "any"
  }),
  day: Rn({
    matchPatterns: b8,
    defaultMatchWidth: "wide",
    parsePatterns: w8,
    defaultParseWidth: "any"
  }),
  dayPeriod: Rn({
    matchPatterns: $8,
    defaultMatchWidth: "any",
    parsePatterns: E8,
    defaultParseWidth: "any"
  })
}, vn = {
  code: "en-US",
  formatDistance: U7,
  formatLong: Z7,
  formatRelative: Q7,
  localize: l8,
  match: x8,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function M8(e, t) {
  const n = Pe(e, t?.in);
  return Ci(n, Wc(n)) + 1;
}
function Pi(e, t) {
  const n = Pe(e, t?.in), r = +Un(n) - +A7(n);
  return Math.round(r / kc) + 1;
}
function jc(e, t) {
  const n = Pe(e, t?.in), r = n.getFullYear(), o = sr(), i = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, l = Ae(t?.in || e, 0);
  l.setFullYear(r + 1, 0, i), l.setHours(0, 0, 0, 0);
  const s = xn(l, t), c = Ae(t?.in || e, 0);
  c.setFullYear(r, 0, i), c.setHours(0, 0, 0, 0);
  const d = xn(c, t);
  return +n >= +s ? r + 1 : +n >= +d ? r : r - 1;
}
function C8(e, t) {
  const n = sr(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = jc(e, t), i = Ae(t?.in || e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), xn(i, t);
}
function Si(e, t) {
  const n = Pe(e, t?.in), r = +xn(n, t) - +C8(n, t);
  return Math.round(r / kc) + 1;
}
function Me(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const It = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Me(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Me(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Me(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Me(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Me(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Me(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Me(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Me(o, t.length);
  }
}, sn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ll = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return It.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = jc(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const l = i % 100;
      return Me(l, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Me(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Rc(e);
    return Me(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Me(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Me(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Me(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return It.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Me(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = Si(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Me(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Pi(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Me(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : It.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = M8(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Me(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Me(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Me(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return Me(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = sn.noon : r === 0 ? o = sn.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = sn.evening : r >= 12 ? o = sn.afternoon : r >= 4 ? o = sn.morning : o = sn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return It.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : It.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Me(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Me(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : It.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : It.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return It.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Wl(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return qt(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return qt(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Wl(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return qt(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return qt(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Bl(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + qt(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Bl(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + qt(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Me(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Me(+e, t.length);
  }
};
function Bl(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Me(i, 2);
}
function Wl(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Me(Math.abs(e) / 60, 2) : qt(e, t);
}
function qt(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Me(Math.trunc(r / 60), 2), i = Me(r % 60, 2);
  return n + o + t + i;
}
const Vl = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Gc = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, P8 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Vl(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Vl(r, t)).replace("{{time}}", Gc(o, t));
}, S8 = {
  p: Gc,
  P: P8
}, z8 = /^D+$/, F8 = /^Y+$/, N8 = ["D", "DD", "YY", "YYYY"];
function D8(e) {
  return z8.test(e);
}
function O8(e) {
  return F8.test(e);
}
function A8(e, t, n) {
  const r = T8(e, t, n);
  if (console.warn(r), N8.includes(e)) throw new RangeError(r);
}
function T8(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const k8 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, H8 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, I8 = /^'([^]*?)'?$/, R8 = /''/g, _8 = /[a-zA-Z]/;
function Wn(e, t, n) {
  const r = sr(), o = n?.locale ?? r.locale ?? vn, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, l = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Pe(e, n?.in);
  if (!_7(s))
    throw new RangeError("Invalid time value");
  let c = t.match(H8).map((f) => {
    const u = f[0];
    if (u === "p" || u === "P") {
      const m = S8[u];
      return m(f, o.formatLong);
    }
    return f;
  }).join("").match(k8).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const u = f[0];
    if (u === "'")
      return { isToken: !1, value: L8(f) };
    if (Ll[u])
      return { isToken: !0, value: f };
    if (u.match(_8))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + u + "`"
      );
    return { isToken: !1, value: f };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(s, c));
  const d = {
    firstWeekContainsDate: i,
    weekStartsOn: l,
    locale: o
  };
  return c.map((f) => {
    if (!f.isToken) return f.value;
    const u = f.value;
    (!n?.useAdditionalWeekYearTokens && O8(u) || !n?.useAdditionalDayOfYearTokens && D8(u)) && A8(u, t, String(e));
    const m = Ll[u[0]];
    return m(s, u, o.localize, d);
  }).join("");
}
function L8(e) {
  const t = e.match(I8);
  return t ? t[1].replace(R8, "'") : e;
}
function B8(e, t) {
  const n = Pe(e, t?.in), r = n.getFullYear(), o = n.getMonth(), i = Ae(n, 0);
  return i.setFullYear(r, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function W8(e, t) {
  return Pe(e, t?.in).getMonth();
}
function V8(e, t) {
  return Pe(e, t?.in).getFullYear();
}
function j8(e, t) {
  return +Pe(e) > +Pe(t);
}
function G8(e, t) {
  return +Pe(e) < +Pe(t);
}
function Y8(e, t, n) {
  const [r, o] = Fn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function U8(e, t, n) {
  const [r, o] = Fn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function K8(e, t, n) {
  const r = Pe(e, n?.in), o = r.getFullYear(), i = r.getDate(), l = Ae(e, 0);
  l.setFullYear(o, t, 15), l.setHours(0, 0, 0, 0);
  const s = B8(l);
  return r.setMonth(t, Math.min(i, s)), r;
}
function X8(e, t, n) {
  const r = Pe(e, n?.in);
  return isNaN(+r) ? Ae(e, NaN) : (r.setFullYear(t), r);
}
const jl = 5, q8 = 4;
function Z8(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), i = t.addDays(o, jl * 7 - 1);
  return t.getMonth(e) === t.getMonth(i) ? jl : q8;
}
function Yc(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function J8(e, t) {
  const n = Yc(e, t), r = Z8(e, t);
  return t.addDays(n, r * 7 - 1);
}
const Uc = {
  ...vn,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (l, s) => Wn(l, s, { locale: vn, ...n });
      let i = o(e, "PPPP");
      return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, i) => Wn(o, i, { locale: vn, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (l, s) => Wn(l, s, { locale: vn, ...n });
      let i = o(e, "PPPP");
      return t?.today && (i = `Today, ${i}`), i;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, i) => Wn(o, i, { locale: vn, ...t }), r(e, "cccc");
    }
  }
};
class Qe {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? Re.tz(this.options.timeZone) : new this.Date(), this.newDate = (r, o, i) => this.overrides?.newDate ? this.overrides.newDate(r, o, i) : this.options.timeZone ? new Re(r, o, i, this.options.timeZone) : new Date(r, o, i), this.addDays = (r, o) => this.overrides?.addDays ? this.overrides.addDays(r, o) : Hc(r, o), this.addMonths = (r, o) => this.overrides?.addMonths ? this.overrides.addMonths(r, o) : Ic(r, o), this.addWeeks = (r, o) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, o) : T7(r, o), this.addYears = (r, o) => this.overrides?.addYears ? this.overrides.addYears(r, o) : k7(r, o), this.differenceInCalendarDays = (r, o) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Ci(r, o), this.differenceInCalendarMonths = (r, o) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : Lc(r, o), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : B7(r), this.eachYearOfInterval = (r) => {
      const o = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : j7(r), i = new Set(o.map((s) => this.getYear(s)));
      if (i.size === o.length)
        return o;
      const l = [];
      return i.forEach((s) => {
        l.push(new Date(s, 0, 1));
      }), l;
    }, this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : J8(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : G7(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : L7(r), this.endOfWeek = (r, o) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, o) : Vc(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : V7(r), this.format = (r, o, i) => {
      const l = this.overrides?.format ? this.overrides.format(r, o, this.options) : Wn(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(l) : l;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : Pi(r), this.getMonth = (r, o) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : W8(r, this.options), this.getYear = (r, o) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : V8(r, this.options), this.getWeek = (r, o) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : Si(r, this.options), this.isAfter = (r, o) => this.overrides?.isAfter ? this.overrides.isAfter(r, o) : j8(r, o), this.isBefore = (r, o) => this.overrides?.isBefore ? this.overrides.isBefore(r, o) : G8(r, o), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : _c(r), this.isSameDay = (r, o) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, o) : R7(r, o), this.isSameMonth = (r, o) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, o) : Y8(r, o), this.isSameYear = (r, o) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, o) : U8(r, o), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : H7(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : I7(r), this.setMonth = (r, o) => this.overrides?.setMonth ? this.overrides.setMonth(r, o) : K8(r, o), this.setYear = (r, o) => this.overrides?.setYear ? this.overrides.setYear(r, o) : X8(r, o), this.startOfBroadcastWeek = (r, o) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : Yc(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : Kn(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Un(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : W7(r), this.startOfWeek = (r, o) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : xn(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : Wc(r), this.options = { locale: Uc, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && Qe.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, i = n?.code;
    if (i && Qe.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const l = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, l);
  }
}
Qe.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const $t = new Qe();
class Kc {
  constructor(t, n, r = $t) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class Q8 {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class e9 {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function t9(e) {
  return a.createElement("button", { ...e });
}
function n9(e) {
  return a.createElement("span", { ...e });
}
function r9(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    a.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && a.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && a.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && a.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && a.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function a9(e) {
  const { day: t, modifiers: n, ...r } = e;
  return a.createElement("td", { ...r });
}
function o9(e) {
  const { day: t, modifiers: n, ...r } = e, o = a.useRef(null);
  return a.useEffect(() => {
    n.focused && o.current?.focus();
  }, [n.focused]), a.createElement("button", { ref: o, ...r });
}
var te;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(te || (te = {}));
var De;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(De || (De = {}));
var ut;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(ut || (ut = {}));
var Ke;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(Ke || (Ke = {}));
function i9(e) {
  const { options: t, className: n, components: r, classNames: o, ...i } = e, l = [o[te.Dropdown], n].join(" "), s = t?.find(({ value: c }) => c === i.value);
  return a.createElement(
    "span",
    { "data-disabled": i.disabled, className: o[te.DropdownRoot] },
    a.createElement(r.Select, { className: l, ...i }, t?.map(({ value: c, label: d, disabled: f }) => a.createElement(r.Option, { key: c, value: c, disabled: f }, d))),
    a.createElement(
      "span",
      { className: o[te.CaptionLabel], "aria-hidden": !0 },
      s?.label,
      a.createElement(r.Chevron, { orientation: "down", size: 18, className: o[te.Chevron] })
    )
  );
}
function l9(e) {
  return a.createElement("div", { ...e });
}
function s9(e) {
  return a.createElement("div", { ...e });
}
function c9(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return a.createElement("div", { ...r }, e.children);
}
function d9(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return a.createElement("div", { ...r });
}
function u9(e) {
  return a.createElement("table", { ...e });
}
function f9(e) {
  return a.createElement("div", { ...e });
}
const Xc = St(void 0);
function cr() {
  const e = rt(Xc);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function h9(e) {
  const { components: t } = cr();
  return a.createElement(t.Dropdown, { ...e });
}
function m9(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...i } = e, { components: l, classNames: s, labels: { labelPrevious: c, labelNext: d } } = cr(), f = se((m) => {
    o && n?.(m);
  }, [o, n]), u = se((m) => {
    r && t?.(m);
  }, [r, t]);
  return a.createElement(
    "nav",
    { ...i },
    a.createElement(
      l.PreviousMonthButton,
      { type: "button", className: s[te.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: u },
      a.createElement(l.Chevron, { disabled: r ? void 0 : !0, className: s[te.Chevron], orientation: "left" })
    ),
    a.createElement(
      l.NextMonthButton,
      { type: "button", className: s[te.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": d(o), onClick: f },
      a.createElement(l.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: s[te.Chevron] })
    )
  );
}
function p9(e) {
  const { components: t } = cr();
  return a.createElement(t.Button, { ...e });
}
function v9(e) {
  return a.createElement("option", { ...e });
}
function g9(e) {
  const { components: t } = cr();
  return a.createElement(t.Button, { ...e });
}
function y9(e) {
  const { rootRef: t, ...n } = e;
  return a.createElement("div", { ...n, ref: t });
}
function b9(e) {
  return a.createElement("select", { ...e });
}
function w9(e) {
  const { week: t, ...n } = e;
  return a.createElement("tr", { ...n });
}
function $9(e) {
  return a.createElement("th", { ...e });
}
function E9(e) {
  return a.createElement(
    "thead",
    { "aria-hidden": !0 },
    a.createElement("tr", { ...e })
  );
}
function x9(e) {
  const { week: t, ...n } = e;
  return a.createElement("th", { ...n });
}
function M9(e) {
  return a.createElement("th", { ...e });
}
function C9(e) {
  return a.createElement("tbody", { ...e });
}
function P9(e) {
  const { components: t } = cr();
  return a.createElement(t.Dropdown, { ...e });
}
const S9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: t9,
  CaptionLabel: n9,
  Chevron: r9,
  Day: a9,
  DayButton: o9,
  Dropdown: i9,
  DropdownNav: l9,
  Footer: s9,
  Month: c9,
  MonthCaption: d9,
  MonthGrid: u9,
  Months: f9,
  MonthsDropdown: h9,
  Nav: m9,
  NextMonthButton: p9,
  Option: v9,
  PreviousMonthButton: g9,
  Root: y9,
  Select: b9,
  Week: w9,
  WeekNumber: x9,
  WeekNumberHeader: M9,
  Weekday: $9,
  Weekdays: E9,
  Weeks: C9,
  YearsDropdown: P9
}, Symbol.toStringTag, { value: "Module" }));
function Mt(e, t, n = !1, r = $t) {
  let { from: o, to: i } = e;
  const { differenceInCalendarDays: l, isSameDay: s } = r;
  return o && i ? (l(i, o) < 0 && ([o, i] = [i, o]), l(t, o) >= (n ? 1 : 0) && l(i, t) >= (n ? 1 : 0)) : !n && i ? s(i, t) : !n && o ? s(o, t) : !1;
}
function zi(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function ca(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function Fi(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Ni(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function qc(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Zc(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Ct(e, t, n = $t) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: i, isAfter: l } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return o(e, s);
    if (Zc(s, n))
      return s.some((c) => o(e, c));
    if (ca(s))
      return Mt(s, e, !1, n);
    if (qc(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (zi(s)) {
      const c = i(s.before, e), d = i(s.after, e), f = c > 0, u = d < 0;
      return l(s.before, s.after) ? u && f : f || u;
    }
    return Fi(s) ? i(e, s.after) > 0 : Ni(s) ? i(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function z9(e, t, n, r, o) {
  const { disabled: i, hidden: l, modifiers: s, showOutsideDays: c, broadcastCalendar: d, today: f = o.today() } = t, { isSameDay: u, isSameMonth: m, startOfMonth: p, isBefore: y, endOfMonth: h, isAfter: b } = o, w = n && p(n), $ = r && h(r), x = {
    [De.focused]: [],
    [De.outside]: [],
    [De.disabled]: [],
    [De.hidden]: [],
    [De.today]: []
  }, P = {};
  for (const E of e) {
    const { date: z, displayMonth: S } = E, F = !!(S && !m(z, S)), O = !!(w && y(z, w)), I = !!($ && b(z, $)), L = !!(i && Ct(z, i, o)), _ = !!(l && Ct(z, l, o)) || O || I || // Broadcast calendar will show outside days as default
    !d && !c && F || d && c === !1 && F, ne = u(z, f);
    F && x.outside.push(E), L && x.disabled.push(E), _ && x.hidden.push(E), ne && x.today.push(E), s && Object.keys(s).forEach((R) => {
      const Y = s?.[R];
      Y && Ct(z, Y, o) && (P[R] ? P[R].push(E) : P[R] = [E]);
    });
  }
  return (E) => {
    const z = {
      [De.focused]: !1,
      [De.disabled]: !1,
      [De.hidden]: !1,
      [De.outside]: !1,
      [De.today]: !1
    }, S = {};
    for (const F in x) {
      const O = x[F];
      z[F] = O.some((I) => I === E);
    }
    for (const F in P)
      S[F] = P[F].some((O) => O === E);
    return {
      ...z,
      // custom modifiers should override all the previous ones
      ...S
    };
  };
}
function F9(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [i]) => (n[i] ? o.push(n[i]) : t[De[i]] ? o.push(t[De[i]]) : t[ut[i]] && o.push(t[ut[i]]), o), [t[te.Day]]);
}
function N9(e) {
  return {
    ...S9,
    ...e
  };
}
function D9(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function O9() {
  const e = {};
  for (const t in te)
    e[te[t]] = `rdp-${te[t]}`;
  for (const t in De)
    e[De[t]] = `rdp-${De[t]}`;
  for (const t in ut)
    e[ut[t]] = `rdp-${ut[t]}`;
  for (const t in Ke)
    e[Ke[t]] = `rdp-${Ke[t]}`;
  return e;
}
function Jc(e, t, n) {
  return (n ?? new Qe(t)).formatMonthYear(e);
}
const A9 = Jc;
function T9(e, t, n) {
  return (n ?? new Qe(t)).format(e, "d");
}
function k9(e, t = $t) {
  return t.format(e, "LLLL");
}
function H9(e, t, n) {
  return (n ?? new Qe(t)).format(e, "cccccc");
}
function I9(e, t = $t) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function R9() {
  return "";
}
function Qc(e, t = $t) {
  return t.format(e, "yyyy");
}
const _9 = Qc, L9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Jc,
  formatDay: T9,
  formatMonthCaption: A9,
  formatMonthDropdown: k9,
  formatWeekNumber: I9,
  formatWeekNumberHeader: R9,
  formatWeekdayName: H9,
  formatYearCaption: _9,
  formatYearDropdown: Qc
}, Symbol.toStringTag, { value: "Module" }));
function B9(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...L9,
    ...e
  };
}
function Di(e, t, n, r) {
  let o = (r ?? new Qe(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const W9 = Di;
function Oi(e, t, n) {
  return (n ?? new Qe(t)).formatMonthYear(e);
}
const V9 = Oi;
function ed(e, t, n, r) {
  let o = (r ?? new Qe(n)).format(e, "PPPP");
  return t?.today && (o = `Today, ${o}`), o;
}
function td(e) {
  return "Choose the Month";
}
function nd() {
  return "";
}
const j9 = "Go to the Next Month";
function rd(e, t) {
  return j9;
}
function ad(e) {
  return "Go to the Previous Month";
}
function od(e, t, n) {
  return (n ?? new Qe(t)).format(e, "cccc");
}
function id(e, t) {
  return `Week ${e}`;
}
function ld(e) {
  return "Week Number";
}
function sd(e) {
  return "Choose the Year";
}
const G9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: V9,
  labelDay: W9,
  labelDayButton: Di,
  labelGrid: Oi,
  labelGridcell: ed,
  labelMonthDropdown: td,
  labelNav: nd,
  labelNext: rd,
  labelPrevious: ad,
  labelWeekNumber: id,
  labelWeekNumberHeader: ld,
  labelWeekday: od,
  labelYearDropdown: sd
}, Symbol.toStringTag, { value: "Module" })), it = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function Y9(e, t) {
  const n = t.locale?.labels ?? {};
  return {
    ...G9,
    ...e ?? {},
    labelDayButton: it(Di, e?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: it(td, e?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: it(rd, e?.labelNext, n.labelNext),
    labelPrevious: it(ad, e?.labelPrevious, n.labelPrevious),
    labelWeekNumber: it(id, e?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: it(sd, e?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: it(Oi, e?.labelGrid, n.labelGrid),
    labelGridcell: it(ed, e?.labelGridcell, n.labelGridcell),
    labelNav: it(nd, e?.labelNav, n.labelNav),
    labelWeekNumberHeader: it(ld, e?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: it(od, e?.labelWeekday, n.labelWeekday)
  };
}
function U9(e, t, n, r, o) {
  const { startOfMonth: i, startOfYear: l, endOfYear: s, eachMonthOfInterval: c, getMonth: d } = o;
  return c({
    start: l(e),
    end: s(e)
  }).map((m) => {
    const p = r.formatMonthDropdown(m, o), y = d(m), h = t && m < i(t) || n && m > i(n) || !1;
    return { value: y, label: p, disabled: h };
  });
}
function K9(e, t = {}, n = {}) {
  let r = { ...t?.[te.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n?.[o]
    };
  }), r;
}
function X9(e, t, n, r) {
  const o = r ?? e.today(), i = n ? e.startOfBroadcastWeek(o, e) : t ? e.startOfISOWeek(o) : e.startOfWeek(o), l = [];
  for (let s = 0; s < 7; s++) {
    const c = e.addDays(i, s);
    l.push(c);
  }
  return l;
}
function q9(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: i, endOfYear: l, eachYearOfInterval: s, getYear: c } = r, d = i(e), f = l(t), u = s({ start: d, end: f });
  return o && u.reverse(), u.map((m) => {
    const p = n.formatYearDropdown(m, r);
    return {
      value: c(m),
      label: p,
      disabled: !1
    };
  });
}
function Z9(e, t = {}) {
  const { weekStartsOn: n, locale: r } = t, o = n ?? r?.options?.weekStartsOn ?? 0, i = (s) => {
    const c = typeof s == "number" || typeof s == "string" ? new Date(s) : s;
    return new Re(c.getFullYear(), c.getMonth(), c.getDate(), 12, 0, 0, e);
  }, l = (s) => {
    const c = i(s);
    return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => i(Re.tz(e)),
    newDate: (s, c, d) => new Re(s, c, d, 12, 0, 0, e),
    startOfDay: (s) => i(s),
    startOfWeek: (s, c) => {
      const d = i(s), f = c?.weekStartsOn ?? o, u = (d.getDay() - f + 7) % 7;
      return d.setDate(d.getDate() - u), d;
    },
    startOfISOWeek: (s) => {
      const c = i(s), d = (c.getDay() - 1 + 7) % 7;
      return c.setDate(c.getDate() - d), c;
    },
    startOfMonth: (s) => {
      const c = i(s);
      return c.setDate(1), c;
    },
    startOfYear: (s) => {
      const c = i(s);
      return c.setMonth(0, 1), c;
    },
    endOfWeek: (s, c) => {
      const d = i(s), m = (((c?.weekStartsOn ?? o) + 6) % 7 - d.getDay() + 7) % 7;
      return d.setDate(d.getDate() + m), d;
    },
    endOfISOWeek: (s) => {
      const c = i(s), d = (7 - c.getDay()) % 7;
      return c.setDate(c.getDate() + d), c;
    },
    endOfMonth: (s) => {
      const c = i(s);
      return c.setMonth(c.getMonth() + 1, 0), c;
    },
    endOfYear: (s) => {
      const c = i(s);
      return c.setMonth(11, 31), c;
    },
    eachMonthOfInterval: (s) => {
      const c = i(s.start), d = i(s.end), f = [], u = new Re(c.getFullYear(), c.getMonth(), 1, 12, 0, 0, e), m = d.getFullYear() * 12 + d.getMonth();
      for (; u.getFullYear() * 12 + u.getMonth() <= m; )
        f.push(new Re(u, e)), u.setMonth(u.getMonth() + 1, 1);
      return f;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (s, c) => {
      const d = i(s);
      return d.setDate(d.getDate() + c), d;
    },
    addWeeks: (s, c) => {
      const d = i(s);
      return d.setDate(d.getDate() + c * 7), d;
    },
    addMonths: (s, c) => {
      const d = i(s);
      return d.setMonth(d.getMonth() + c), d;
    },
    addYears: (s, c) => {
      const d = i(s);
      return d.setFullYear(d.getFullYear() + c), d;
    },
    eachYearOfInterval: (s) => {
      const c = i(s.start), d = i(s.end), f = [], u = new Re(c.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; u.getFullYear() <= d.getFullYear(); )
        f.push(new Re(u, e)), u.setFullYear(u.getFullYear() + 1, 0, 1);
      return f;
    },
    getWeek: (s, c) => {
      const d = l(s);
      return Si(d, {
        weekStartsOn: c?.weekStartsOn ?? o,
        firstWeekContainsDate: c?.firstWeekContainsDate ?? r?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (s) => {
      const c = l(s);
      return Pi(c);
    },
    differenceInCalendarDays: (s, c) => {
      const d = l(s), f = l(c);
      return Ci(d, f);
    },
    differenceInCalendarMonths: (s, c) => {
      const d = l(s), f = l(c);
      return Lc(d, f);
    }
  };
}
const dr = (e) => e instanceof HTMLElement ? e : null, Ua = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], J9 = (e) => dr(e.querySelector("[data-animated-month]")), Ka = (e) => dr(e.querySelector("[data-animated-caption]")), Xa = (e) => dr(e.querySelector("[data-animated-weeks]")), Q9 = (e) => dr(e.querySelector("[data-animated-nav]")), ep = (e) => dr(e.querySelector("[data-animated-weekdays]"));
function tp(e, t, { classNames: n, months: r, focused: o, dateLib: i }) {
  const l = ue(null), s = ue(r), c = ue(!1);
  En(() => {
    const d = s.current;
    if (s.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || d.length === 0 || r.length !== d.length)
      return;
    const f = i.isSameMonth(r[0].date, d[0].date), u = i.isAfter(r[0].date, d[0].date), m = u ? n[Ke.caption_after_enter] : n[Ke.caption_before_enter], p = u ? n[Ke.weeks_after_enter] : n[Ke.weeks_before_enter], y = l.current, h = e.current.cloneNode(!0);
    if (h instanceof HTMLElement ? (Ua(h).forEach((x) => {
      if (!(x instanceof HTMLElement))
        return;
      const P = J9(x);
      P && x.contains(P) && x.removeChild(P);
      const E = Ka(x);
      E && E.classList.remove(m);
      const z = Xa(x);
      z && z.classList.remove(p);
    }), l.current = h) : l.current = null, c.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const b = y instanceof HTMLElement ? Ua(y) : [], w = Ua(e.current);
    if (w?.every(($) => $ instanceof HTMLElement) && b && b.every(($) => $ instanceof HTMLElement)) {
      c.current = !0, e.current.style.isolation = "isolate";
      const $ = Q9(e.current);
      $ && ($.style.zIndex = "1"), w.forEach((x, P) => {
        const E = b[P];
        if (!E)
          return;
        x.style.position = "relative", x.style.overflow = "hidden";
        const z = Ka(x);
        z && z.classList.add(m);
        const S = Xa(x);
        S && S.classList.add(p);
        const F = () => {
          c.current = !1, e.current && (e.current.style.isolation = ""), $ && ($.style.zIndex = ""), z && z.classList.remove(m), S && S.classList.remove(p), x.style.position = "", x.style.overflow = "", x.contains(E) && x.removeChild(E);
        };
        E.style.pointerEvents = "none", E.style.position = "absolute", E.style.overflow = "hidden", E.setAttribute("aria-hidden", "true");
        const O = ep(E);
        O && (O.style.opacity = "0");
        const I = Ka(E);
        I && (I.classList.add(u ? n[Ke.caption_before_exit] : n[Ke.caption_after_exit]), I.addEventListener("animationend", F));
        const L = Xa(E);
        L && L.classList.add(u ? n[Ke.weeks_before_exit] : n[Ke.weeks_after_exit]), x.insertBefore(E, x.firstChild);
      });
    }
  });
}
function np(e, t, n, r) {
  const o = e[0], i = e[e.length - 1], { ISOWeek: l, fixedWeeks: s, broadcastCalendar: c } = n ?? {}, { addDays: d, differenceInCalendarDays: f, differenceInCalendarMonths: u, endOfBroadcastWeek: m, endOfISOWeek: p, endOfMonth: y, endOfWeek: h, isAfter: b, startOfBroadcastWeek: w, startOfISOWeek: $, startOfWeek: x } = r, P = c ? w(o, r) : l ? $(o) : x(o), E = c ? m(i) : l ? p(y(i)) : h(y(i)), z = t && (c ? m(t) : l ? p(t) : h(t)), S = z && b(E, z) ? z : E, F = f(S, P), O = u(i, o) + 1, I = [];
  for (let ne = 0; ne <= F; ne++) {
    const R = d(P, ne);
    I.push(R);
  }
  const _ = (c ? 35 : 42) * O;
  if (s && I.length < _) {
    const ne = _ - I.length;
    for (let R = 0; R < ne; R++) {
      const Y = d(I[I.length - 1], 1);
      I.push(Y);
    }
  }
  return I;
}
function rp(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((i, l) => i.concat(l.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function ap(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, i = [];
  for (let l = 0; l < o; l++) {
    const s = r.addMonths(e, l);
    if (t && s > t)
      break;
    i.push(s);
  }
  return i;
}
function Gl(e, t, n, r) {
  const { month: o, defaultMonth: i, today: l = r.today(), numberOfMonths: s = 1 } = e;
  let c = o || i || l;
  const { differenceInCalendarMonths: d, addMonths: f, startOfMonth: u } = r;
  if (n && d(n, c) < s - 1) {
    const m = -1 * (s - 1);
    c = f(n, m);
  }
  return t && d(c, t) < 0 && (c = t), u(c);
}
function op(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: i, endOfISOWeek: l, endOfMonth: s, endOfWeek: c, getISOWeek: d, getWeek: f, startOfBroadcastWeek: u, startOfISOWeek: m, startOfWeek: p } = r, y = e.reduce((h, b) => {
    const w = n.broadcastCalendar ? u(b, r) : n.ISOWeek ? m(b) : p(b), $ = n.broadcastCalendar ? i(b) : n.ISOWeek ? l(s(b)) : c(s(b)), x = t.filter((S) => S >= w && S <= $), P = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && x.length < P) {
      const S = t.filter((F) => {
        const O = P - x.length;
        return F > $ && F <= o($, O);
      });
      x.push(...S);
    }
    const E = x.reduce((S, F) => {
      const O = n.ISOWeek ? d(F) : f(F), I = S.find((_) => _.weekNumber === O), L = new Kc(F, b, r);
      return I ? I.days.push(L) : S.push(new e9(O, [L])), S;
    }, []), z = new Q8(b, E);
    return h.push(z), h;
  }, []);
  return n.reverseMonths ? y.reverse() : y;
}
function ip(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: i, startOfMonth: l, endOfMonth: s, addYears: c, endOfYear: d, newDate: f, today: u } = t, { fromYear: m, toYear: p, fromMonth: y, toMonth: h } = e;
  !n && y && (n = y), !n && m && (n = t.newDate(m, 0, 1)), !r && h && (r = h), !r && p && (r = f(p, 11, 31));
  const b = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = l(n) : m ? n = f(m, 0, 1) : !n && b && (n = o(c(e.today ?? u(), -100))), r ? r = s(r) : p ? r = f(p, 11, 31) : !r && b && (r = d(e.today ?? u())), [
    n && i(n),
    r && i(r)
  ];
}
function lp(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i = 1 } = n, { startOfMonth: l, addMonths: s, differenceInCalendarMonths: c } = r, d = o ? i : 1, f = l(e);
  if (!t)
    return s(f, d);
  if (!(c(t, e) < i))
    return s(f, d);
}
function sp(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i } = n, { startOfMonth: l, addMonths: s, differenceInCalendarMonths: c } = r, d = o ? i ?? 1 : 1, f = l(e);
  if (!t)
    return s(f, -d);
  if (!(c(f, t) <= 0))
    return s(f, -d);
}
function cp(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function da(e, t) {
  const [n, r] = Ce(e);
  return [t === void 0 ? n : t, r];
}
function dp(e, t) {
  const [n, r] = ip(e, t), { startOfMonth: o, endOfMonth: i } = t, l = Gl(e, n, r, t), [s, c] = da(
    l,
    // initialMonth is always computed from props.month if provided
    e.month ? l : void 0
  );
  ye(() => {
    const P = Gl(e, n, r, t);
    c(P);
  }, [e.timeZone]);
  const { months: d, weeks: f, days: u, previousMonth: m, nextMonth: p } = Le(() => {
    const P = ap(s, r, { numberOfMonths: e.numberOfMonths }, t), E = np(P, e.endMonth ? i(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), z = op(P, E, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), S = cp(z), F = rp(z), O = sp(s, n, e, t), I = lp(s, r, e, t);
    return {
      months: z,
      weeks: S,
      days: F,
      previousMonth: O,
      nextMonth: I
    };
  }, [
    t,
    s.getTime(),
    r?.getTime(),
    n?.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    e.endMonth?.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: y, onMonthChange: h } = e, b = (P) => f.some((E) => E.days.some((z) => z.isEqualTo(P))), w = (P) => {
    if (y)
      return;
    let E = o(P);
    n && E < o(n) && (E = o(n)), r && E > o(r) && (E = o(r)), c(E), h?.(E);
  };
  return {
    months: d,
    weeks: f,
    days: u,
    navStart: n,
    navEnd: r,
    previousMonth: m,
    nextMonth: p,
    goToMonth: w,
    goToDay: (P) => {
      b(P) || w(P.date);
    }
  };
}
var vt;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(vt || (vt = {}));
function Yl(e) {
  return !e[De.disabled] && !e[De.hidden] && !e[De.outside];
}
function up(e, t, n, r) {
  let o, i = -1;
  for (const l of e) {
    const s = t(l);
    Yl(s) && (s[De.focused] && i < vt.FocusedModifier ? (o = l, i = vt.FocusedModifier) : r?.isEqualTo(l) && i < vt.LastFocused ? (o = l, i = vt.LastFocused) : n(l.date) && i < vt.Selected ? (o = l, i = vt.Selected) : s[De.today] && i < vt.Today && (o = l, i = vt.Today));
  }
  return o || (o = e.find((l) => Yl(t(l)))), o;
}
function fp(e, t, n, r, o, i, l) {
  const { ISOWeek: s, broadcastCalendar: c } = i, { addDays: d, addMonths: f, addWeeks: u, addYears: m, endOfBroadcastWeek: p, endOfISOWeek: y, endOfWeek: h, max: b, min: w, startOfBroadcastWeek: $, startOfISOWeek: x, startOfWeek: P } = l;
  let z = {
    day: d,
    week: u,
    month: f,
    year: m,
    startOfWeek: (S) => c ? $(S, l) : s ? x(S) : P(S),
    endOfWeek: (S) => c ? p(S) : s ? y(S) : h(S)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? z = b([r, z]) : t === "after" && o && (z = w([o, z])), z;
}
function cd(e, t, n, r, o, i, l, s = 0) {
  if (s > 365)
    return;
  const c = fp(e, t, n.date, r, o, i, l), d = !!(i.disabled && Ct(c, i.disabled, l)), f = !!(i.hidden && Ct(c, i.hidden, l)), u = c, m = new Kc(c, u, l);
  return !d && !f ? m : cd(e, t, m, r, o, i, l, s + 1);
}
function hp(e, t, n, r, o) {
  const { autoFocus: i } = e, [l, s] = Ce(), c = up(t.days, n, r || (() => !1), l), [d, f] = Ce(i ? c : void 0);
  return {
    isFocusTarget: (h) => !!c?.isEqualTo(h),
    setFocused: f,
    focused: d,
    blur: () => {
      s(d), f(void 0);
    },
    moveFocus: (h, b) => {
      if (!d)
        return;
      const w = cd(h, b, d, t.navStart, t.navEnd, e, o);
      w && (e.disableNavigation && !t.days.some((x) => x.isEqualTo(w)) || (t.goToDay(w), f(w)));
    }
  };
}
function mp(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, l] = da(n, o ? n : void 0), s = o ? n : i, { isSameDay: c } = t, d = (p) => s?.some((y) => c(y, p)) ?? !1, { min: f, max: u } = e;
  return {
    selected: s,
    select: (p, y, h) => {
      let b = [...s ?? []];
      if (d(p)) {
        if (s?.length === f || r && s?.length === 1)
          return;
        b = s?.filter((w) => !c(w, p));
      } else
        s?.length === u ? b = [p] : b = [...b, p];
      return o || l(b), o?.(b, p, y, h), b;
    },
    isSelected: d
  };
}
function pp(e, t, n = 0, r = 0, o = !1, i = $t) {
  const { from: l, to: s } = t || {}, { isSameDay: c, isAfter: d, isBefore: f } = i;
  let u;
  if (!l && !s)
    u = { from: e, to: n > 0 ? void 0 : e };
  else if (l && !s)
    c(l, e) ? n === 0 ? u = { from: l, to: e } : o ? u = { from: l, to: void 0 } : u = void 0 : f(e, l) ? u = { from: e, to: l } : u = { from: l, to: e };
  else if (l && s)
    if (c(l, e) && c(s, e))
      o ? u = { from: l, to: s } : u = void 0;
    else if (c(l, e))
      u = { from: l, to: n > 0 ? void 0 : e };
    else if (c(s, e))
      u = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, l))
      u = { from: e, to: s };
    else if (d(e, l))
      u = { from: l, to: e };
    else if (d(e, s))
      u = { from: l, to: e };
    else
      throw new Error("Invalid range");
  if (u?.from && u?.to) {
    const m = i.differenceInCalendarDays(u.to, u.from);
    r > 0 && m > r ? u = { from: e, to: void 0 } : n > 1 && m < n && (u = { from: e, to: void 0 });
  }
  return u;
}
function vp(e, t, n = $t) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const i = n.differenceInCalendarDays(e.to, e.from), l = Math.min(i, 6);
  for (let s = 0; s <= l; s++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Ul(e, t, n = $t) {
  return Mt(e, t.from, !1, n) || Mt(e, t.to, !1, n) || Mt(t, e.from, !1, n) || Mt(t, e.to, !1, n);
}
function gp(e, t, n = $t) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Mt(e, s, !1, n) : Zc(s, n) ? s.some((c) => Mt(e, c, !1, n)) : ca(s) ? s.from && s.to ? Ul(e, { from: s.from, to: s.to }, n) : !1 : qc(s) ? vp(e, s.dayOfWeek, n) : zi(s) ? n.isAfter(s.before, s.after) ? Ul(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Ct(e.from, s, n) || Ct(e.to, s, n) : Fi(s) || Ni(s) ? Ct(e.from, s, n) || Ct(e.to, s, n) : !1))
    return !0;
  const l = r.filter((s) => typeof s == "function");
  if (l.length) {
    let s = e.from;
    const c = n.differenceInCalendarDays(e.to, e.from);
    for (let d = 0; d <= c; d++) {
      if (l.some((f) => f(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function yp(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: i, onSelect: l } = e, [s, c] = da(o, l ? o : void 0), d = l ? o : s;
  return {
    selected: d,
    select: (m, p, y) => {
      const { min: h, max: b } = e, w = m ? pp(m, d, h, b, i, t) : void 0;
      return r && n && w?.from && w.to && gp({ from: w.from, to: w.to }, n, t) && (w.from = m, w.to = void 0), l || c(w), l?.(w, m, p, y), w;
    },
    isSelected: (m) => d && Mt(d, m, !1, t)
  };
}
function bp(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, l] = da(n, o ? n : void 0), s = o ? n : i, { isSameDay: c } = t;
  return {
    selected: s,
    select: (u, m, p) => {
      let y = u;
      return !r && s && s && c(u, s) && (y = void 0), o || l(y), o?.(y, u, m, p), y;
    },
    isSelected: (u) => s ? c(s, u) : !1
  };
}
function wp(e, t) {
  const n = bp(e, t), r = mp(e, t), o = yp(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function tt(e, t) {
  return e instanceof Re && e.timeZone === t ? e : new Re(e, t);
}
function cn(e, t, n) {
  return tt(e, t);
}
function Kl(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? cn(e, t) : Array.isArray(e) ? e.map((r) => r instanceof Date ? cn(r, t) : r) : ca(e) ? {
    ...e,
    from: e.from ? tt(e.from, t) : e.from,
    to: e.to ? tt(e.to, t) : e.to
  } : zi(e) ? {
    before: cn(e.before, t),
    after: cn(e.after, t)
  } : Fi(e) ? {
    after: cn(e.after, t)
  } : Ni(e) ? {
    before: cn(e.before, t)
  } : e;
}
function qa(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => Kl(r, t)) : Kl(e, t));
}
function $p(e) {
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = tt(t.today, n)), t.month && (t.month = tt(t.month, n)), t.defaultMonth && (t.defaultMonth = tt(t.defaultMonth, n)), t.startMonth && (t.startMonth = tt(t.startMonth, n)), t.endMonth && (t.endMonth = tt(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = tt(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((fe) => tt(fe, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? tt(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? tt(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = qa(t.disabled, n)), t.hidden !== void 0 && (t.hidden = qa(t.hidden, n)), t.modifiers)) {
    const fe = {};
    Object.keys(t.modifiers).forEach((we) => {
      fe[we] = qa(t.modifiers?.[we], n);
    }), t.modifiers = fe;
  }
  const { components: r, formatters: o, labels: i, dateLib: l, locale: s, classNames: c } = Le(() => {
    const fe = { ...Uc, ...t.locale }, we = t.broadcastCalendar ? 1 : t.weekStartsOn, le = t.noonSafe && t.timeZone ? Z9(t.timeZone, {
      weekStartsOn: we,
      locale: fe
    }) : void 0, be = t.dateLib && le ? { ...le, ...t.dateLib } : t.dateLib ?? le, Ue = new Qe({
      locale: fe,
      weekStartsOn: we,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, be);
    return {
      dateLib: Ue,
      components: N9(t.components),
      formatters: B9(t.formatters),
      labels: Y9(t.labels, Ue.options),
      locale: fe,
      classNames: { ...O9(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: l.today() });
  const { captionLayout: d, mode: f, navLayout: u, numberOfMonths: m = 1, onDayBlur: p, onDayClick: y, onDayFocus: h, onDayKeyDown: b, onDayMouseEnter: w, onDayMouseLeave: $, onNextClick: x, onPrevClick: P, showWeekNumber: E, styles: z } = t, { formatCaption: S, formatDay: F, formatMonthDropdown: O, formatWeekNumber: I, formatWeekNumberHeader: L, formatWeekdayName: _, formatYearDropdown: ne } = o, R = dp(t, l), { days: Y, months: W, navStart: V, navEnd: J, previousMonth: T, nextMonth: N, goToMonth: D } = R, K = z9(Y, t, V, J, l), { isSelected: ae, select: Q, selected: ie } = wp(t, l) ?? {}, { blur: X, focused: A, isFocusTarget: U, moveFocus: oe, setFocused: G } = hp(t, R, K, ae ?? (() => !1), l), { labelDayButton: ce, labelGridcell: k, labelGrid: ze, labelMonthDropdown: Ie, labelNav: We, labelPrevious: Tt, labelNext: Xt, labelWeekday: _a, labelWeekNumber: La, labelWeekNumberHeader: Ba, labelYearDropdown: ln } = i, Fm = Le(() => X9(l, t.ISOWeek, t.broadcastCalendar, t.today), [l, t.ISOWeek, t.broadcastCalendar, t.today]), Fl = f !== void 0 || y !== void 0, Wa = se(() => {
    T && (D(T), P?.(T));
  }, [T, D, P]), Va = se(() => {
    N && (D(N), x?.(N));
  }, [D, N, x]), Nm = se((fe, we) => (le) => {
    le.preventDefault(), le.stopPropagation(), G(fe), !we.disabled && (Q?.(fe.date, we, le), y?.(fe.date, we, le));
  }, [Q, y, G]), Dm = se((fe, we) => (le) => {
    G(fe), h?.(fe.date, we, le);
  }, [h, G]), Om = se((fe, we) => (le) => {
    X(), p?.(fe.date, we, le);
  }, [X, p]), Am = se((fe, we) => (le) => {
    const be = {
      ArrowLeft: [
        le.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        le.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [le.shiftKey ? "year" : "week", "after"],
      ArrowUp: [le.shiftKey ? "year" : "week", "before"],
      PageUp: [le.shiftKey ? "year" : "month", "before"],
      PageDown: [le.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (be[le.key]) {
      le.preventDefault(), le.stopPropagation();
      const [Ue, ge] = be[le.key];
      oe(Ue, ge);
    }
    b?.(fe.date, we, le);
  }, [oe, b, t.dir]), Tm = se((fe, we) => (le) => {
    w?.(fe.date, we, le);
  }, [w]), km = se((fe, we) => (le) => {
    $?.(fe.date, we, le);
  }, [$]), Hm = se((fe) => (we) => {
    const le = Number(we.target.value), be = l.setMonth(l.startOfMonth(fe), le);
    D(be);
  }, [l, D]), Im = se((fe) => (we) => {
    const le = Number(we.target.value), be = l.setYear(l.startOfMonth(fe), le);
    D(be);
  }, [l, D]), { className: Rm, style: _m } = Le(() => ({
    className: [c[te.Root], t.className].filter(Boolean).join(" "),
    style: { ...z?.[te.Root], ...t.style }
  }), [c, t.className, t.style, z]), Lm = D9(t), Nl = ue(null);
  tp(Nl, !!t.animate, {
    classNames: c,
    months: W,
    focused: A,
    dateLib: l
  });
  const Bm = {
    dayPickerProps: t,
    selected: ie,
    select: Q,
    isSelected: ae,
    months: W,
    nextMonth: N,
    previousMonth: T,
    goToMonth: D,
    getModifiers: K,
    components: r,
    classNames: c,
    styles: z,
    labels: i,
    formatters: o
  };
  return a.createElement(
    Xc.Provider,
    { value: Bm },
    a.createElement(
      r.Root,
      { rootRef: t.animate ? Nl : void 0, className: Rm, style: _m, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...Lm },
      a.createElement(
        r.Months,
        { className: c[te.Months], style: z?.[te.Months] },
        !t.hideNavigation && !u && a.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[te.Nav], style: z?.[te.Nav], "aria-label": We(), onPreviousClick: Wa, onNextClick: Va, previousMonth: T, nextMonth: N }),
        W.map((fe, we) => a.createElement(
          r.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: c[te.Month],
            style: z?.[te.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: we,
            displayIndex: we,
            calendarMonth: fe
          },
          u === "around" && !t.hideNavigation && we === 0 && a.createElement(
            r.PreviousMonthButton,
            { type: "button", className: c[te.PreviousMonthButton], tabIndex: T ? void 0 : -1, "aria-disabled": T ? void 0 : !0, "aria-label": Tt(T), onClick: Wa, "data-animated-button": t.animate ? "true" : void 0 },
            a.createElement(r.Chevron, { disabled: T ? void 0 : !0, className: c[te.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          a.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: c[te.MonthCaption], style: z?.[te.MonthCaption], calendarMonth: fe, displayIndex: we }, d?.startsWith("dropdown") ? a.createElement(
            r.DropdownNav,
            { className: c[te.Dropdowns], style: z?.[te.Dropdowns] },
            (() => {
              const le = d === "dropdown" || d === "dropdown-months" ? a.createElement(r.MonthsDropdown, { key: "month", className: c[te.MonthsDropdown], "aria-label": Ie(), classNames: c, components: r, disabled: !!t.disableNavigation, onChange: Hm(fe.date), options: U9(fe.date, V, J, o, l), style: z?.[te.Dropdown], value: l.getMonth(fe.date) }) : a.createElement("span", { key: "month" }, O(fe.date, l)), be = d === "dropdown" || d === "dropdown-years" ? a.createElement(r.YearsDropdown, { key: "year", className: c[te.YearsDropdown], "aria-label": ln(l.options), classNames: c, components: r, disabled: !!t.disableNavigation, onChange: Im(fe.date), options: q9(V, J, o, l, !!t.reverseYears), style: z?.[te.Dropdown], value: l.getYear(fe.date) }) : a.createElement("span", { key: "year" }, ne(fe.date, l));
              return l.getMonthYearOrder() === "year-first" ? [be, le] : [le, be];
            })(),
            a.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, S(fe.date, l.options, l))
          ) : a.createElement(r.CaptionLabel, { className: c[te.CaptionLabel], role: "status", "aria-live": "polite" }, S(fe.date, l.options, l))),
          u === "around" && !t.hideNavigation && we === m - 1 && a.createElement(
            r.NextMonthButton,
            { type: "button", className: c[te.NextMonthButton], tabIndex: N ? void 0 : -1, "aria-disabled": N ? void 0 : !0, "aria-label": Xt(N), onClick: Va, "data-animated-button": t.animate ? "true" : void 0 },
            a.createElement(r.Chevron, { disabled: N ? void 0 : !0, className: c[te.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          we === m - 1 && u === "after" && !t.hideNavigation && a.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[te.Nav], style: z?.[te.Nav], "aria-label": We(), onPreviousClick: Wa, onNextClick: Va, previousMonth: T, nextMonth: N }),
          a.createElement(
            r.MonthGrid,
            { role: "grid", "aria-multiselectable": f === "multiple" || f === "range", "aria-label": ze(fe.date, l.options, l) || void 0, className: c[te.MonthGrid], style: z?.[te.MonthGrid] },
            !t.hideWeekdays && a.createElement(
              r.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: c[te.Weekdays], style: z?.[te.Weekdays] },
              E && a.createElement(r.WeekNumberHeader, { "aria-label": Ba(l.options), className: c[te.WeekNumberHeader], style: z?.[te.WeekNumberHeader], scope: "col" }, L()),
              Fm.map((le) => a.createElement(r.Weekday, { "aria-label": _a(le, l.options, l), className: c[te.Weekday], key: String(le), style: z?.[te.Weekday], scope: "col" }, _(le, l.options, l)))
            ),
            a.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: c[te.Weeks], style: z?.[te.Weeks] }, fe.weeks.map((le) => a.createElement(
              r.Week,
              { className: c[te.Week], key: le.weekNumber, style: z?.[te.Week], week: le },
              E && a.createElement(r.WeekNumber, { week: le, style: z?.[te.WeekNumber], "aria-label": La(le.weekNumber, {
                locale: s
              }), className: c[te.WeekNumber], scope: "row", role: "rowheader" }, I(le.weekNumber, l)),
              le.days.map((be) => {
                const { date: Ue } = be, ge = K(be);
                if (ge[De.focused] = !ge.hidden && !!A?.isEqualTo(be), ge[ut.selected] = ae?.(Ue) || ge.selected, ca(ie)) {
                  const { from: ja, to: Ga } = ie;
                  ge[ut.range_start] = !!(ja && Ga && l.isSameDay(Ue, ja)), ge[ut.range_end] = !!(ja && Ga && l.isSameDay(Ue, Ga)), ge[ut.range_middle] = Mt(ie, Ue, !0, l);
                }
                const Wm = K9(ge, z, t.modifiersStyles), Vm = F9(ge, c, t.modifiersClassNames), jm = !Fl && !ge.hidden ? k(Ue, ge, l.options, l) : void 0;
                return a.createElement(r.Day, { key: `${be.isoDate}_${be.displayMonthId}`, day: be, modifiers: ge, className: Vm.join(" "), style: Wm, role: "gridcell", "aria-selected": ge.selected || void 0, "aria-label": jm, "data-day": be.isoDate, "data-month": be.outside ? be.dateMonthId : void 0, "data-selected": ge.selected || void 0, "data-disabled": ge.disabled || void 0, "data-hidden": ge.hidden || void 0, "data-outside": be.outside || void 0, "data-focused": ge.focused || void 0, "data-today": ge.today || void 0 }, !ge.hidden && Fl ? a.createElement(r.DayButton, { className: c[te.DayButton], style: z?.[te.DayButton], type: "button", day: be, modifiers: ge, disabled: !ge.focused && ge.disabled || void 0, "aria-disabled": ge.focused && ge.disabled || void 0, tabIndex: U(be) ? 0 : -1, "aria-label": ce(Ue, ge, l.options, l), onClick: Nm(be, ge), onBlur: Om(be, ge), onFocus: Dm(be, ge), onKeyDown: Am(be, ge), onMouseEnter: Tm(be, ge), onMouseLeave: km(be, ge) }, F(Ue, l.options, l)) : !ge.hidden && F(be.date, l.options, l));
              })
            )))
          )
        ))
      ),
      t.footer && a.createElement(r.Footer, { className: c[te.Footer], style: z?.[te.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function ve(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
function q(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : l;
      o = e.formattingValues[s] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[l];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
function Z(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const l = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? xp(s, (u) => u.test(l)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Ep(s, (u) => u.test(l))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(c) : c, d = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(l.length);
    return { value: d, rest: f };
  };
}
function Ep(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function xp(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function at(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let l = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    l = n.valueCallback ? n.valueCallback(l) : l;
    const s = t.slice(o.length);
    return { value: l, rest: s };
  };
}
function Mp(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
let Cp = {};
function Pp() {
  return Cp;
}
function Xl(e, t) {
  const n = Pp(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Mp(e), i = o.getDay(), l = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - l), o.setHours(0, 0, 0, 0), o;
}
function Xn(e, t, n) {
  const r = Xl(e, n), o = Xl(t, n);
  return +r == +o;
}
const ql = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Sp = (e, t, n) => {
  let r;
  const o = n?.addSuffix ? ql[e].withPreposition : ql[e].standalone;
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : "vor " + r : r;
}, zp = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, Fp = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Np = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Dp = {
  date: ve({
    formats: zp,
    defaultWidth: "full"
  }),
  time: ve({
    formats: Fp,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: Np,
    defaultWidth: "full"
  })
}, Op = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, Ap = (e, t, n, r) => Op[e], Tp = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, kp = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, So = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, Hp = {
  narrow: So.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: So.wide
}, Ip = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, Rp = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, _p = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Lp = (e) => Number(e) + ".", Bp = {
  ordinalNumber: Lp,
  era: q({
    values: Tp,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: kp,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: So,
    formattingValues: Hp,
    defaultWidth: "wide"
  }),
  day: q({
    values: Ip,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: Rp,
    defaultWidth: "wide",
    formattingValues: _p,
    defaultFormattingWidth: "wide"
  })
}, Wp = /^(\d+)(\.)?/i, Vp = /\d+/i, jp = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, Gp = {
  any: [/^v/i, /^n/i]
}, Yp = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Up = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Kp = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, Xp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, qp = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, Zp = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, Jp = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Qp = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, ev = {
  ordinalNumber: at({
    matchPattern: Wp,
    parsePattern: Vp,
    valueCallback: (e) => parseInt(e)
  }),
  era: Z({
    matchPatterns: jp,
    defaultMatchWidth: "wide",
    parsePatterns: Gp,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: Yp,
    defaultMatchWidth: "wide",
    parsePatterns: Up,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: Kp,
    defaultMatchWidth: "wide",
    parsePatterns: Xp,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: qp,
    defaultMatchWidth: "wide",
    parsePatterns: Zp,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: Jp,
    defaultMatchWidth: "wide",
    parsePatterns: Qp,
    defaultParseWidth: "any"
  })
}, tv = {
  code: "de",
  formatDistance: Sp,
  formatLong: Dp,
  formatRelative: Ap,
  localize: Bp,
  match: ev,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, nv = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, rv = (e, t, n) => {
  let r;
  const o = nv[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
}, av = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ov = (e, t, n, r) => av[e], iv = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, lv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, sv = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, cv = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, dv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, uv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, fv = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, hv = {
  ordinalNumber: fv,
  era: q({
    values: iv,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: lv,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: sv,
    defaultWidth: "wide"
  }),
  day: q({
    values: cv,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: dv,
    defaultWidth: "wide",
    formattingValues: uv,
    defaultFormattingWidth: "wide"
  })
}, mv = /^(\d+)(th|st|nd|rd)?/i, pv = /\d+/i, vv = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, gv = {
  any: [/^b/i, /^(a|c)/i]
}, yv = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $v = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ev = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, xv = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Mv = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Cv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Pv = {
  ordinalNumber: at({
    matchPattern: mv,
    parsePattern: pv,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: vv,
    defaultMatchWidth: "wide",
    parsePatterns: gv,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: yv,
    defaultMatchWidth: "wide",
    parsePatterns: bv,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: wv,
    defaultMatchWidth: "wide",
    parsePatterns: $v,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: Ev,
    defaultMatchWidth: "wide",
    parsePatterns: xv,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: Mv,
    defaultMatchWidth: "any",
    parsePatterns: Cv,
    defaultParseWidth: "any"
  })
}, Sv = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, zv = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Fv = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Nv = {
  date: ve({
    formats: Sv,
    defaultWidth: "full"
  }),
  time: ve({
    formats: zv,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: Fv,
    defaultWidth: "full"
  })
}, Dv = {
  code: "en-US",
  formatDistance: rv,
  formatLong: Nv,
  formatRelative: ov,
  localize: hv,
  match: Pv,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Ov = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, Av = (e, t, n) => {
  let r;
  const o = Ov[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "en " + r : "hace " + r : r;
}, Tv = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, kv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Hv = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Iv = {
  date: ve({
    formats: Tv,
    defaultWidth: "full"
  }),
  time: ve({
    formats: kv,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: Hv,
    defaultWidth: "full"
  })
}, Rv = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, _v = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, Lv = (e, t, n, r) => t.getHours() !== 1 ? _v[e] : Rv[e], Bv = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, Wv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Vv = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, jv = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Gv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Yv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Uv = (e, t) => Number(e) + "º", Kv = {
  ordinalNumber: Uv,
  era: q({
    values: Bv,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: Wv,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: q({
    values: Vv,
    defaultWidth: "wide"
  }),
  day: q({
    values: jv,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: Gv,
    defaultWidth: "wide",
    formattingValues: Yv,
    defaultFormattingWidth: "wide"
  })
}, Xv = /^(\d+)(º)?/i, qv = /\d+/i, Zv = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Jv = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, Qv = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, eg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tg = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, ng = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, rg = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, ag = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, og = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, ig = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, lg = {
  ordinalNumber: at({
    matchPattern: Xv,
    parsePattern: qv,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Z({
    matchPatterns: Zv,
    defaultMatchWidth: "wide",
    parsePatterns: Jv,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: Qv,
    defaultMatchWidth: "wide",
    parsePatterns: eg,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: tg,
    defaultMatchWidth: "wide",
    parsePatterns: ng,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: rg,
    defaultMatchWidth: "wide",
    parsePatterns: ag,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: og,
    defaultMatchWidth: "any",
    parsePatterns: ig,
    defaultParseWidth: "any"
  })
}, sg = {
  code: "es",
  formatDistance: Av,
  formatLong: Iv,
  formatRelative: Lv,
  localize: Kv,
  match: lg,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, cg = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, dg = (e, t, n) => {
  let r;
  const o = cg[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "dans " + r : "il y a " + r : r;
}, ug = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, fg = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, hg = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mg = {
  date: ve({
    formats: ug,
    defaultWidth: "full"
  }),
  time: ve({
    formats: fg,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: hg,
    defaultWidth: "full"
  })
}, pg = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, vg = (e, t, n, r) => pg[e], gg = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, yg = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, bg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, wg = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, $g = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, Eg = (e, t) => {
  const n = Number(e), r = t?.unit;
  if (n === 0) return "0";
  const o = ["year", "week", "hour", "minute", "second"];
  let i;
  return n === 1 ? i = r && o.includes(r) ? "ère" : "er" : i = "ème", n + i;
}, xg = ["MMM", "MMMM"], Mg = {
  preprocessor: (e, t) => e.getDate() === 1 || !t.some(
    (r) => r.isToken && xg.includes(r.value)
  ) ? t : t.map(
    (r) => r.isToken && r.value === "do" ? { isToken: !0, value: "d" } : r
  ),
  ordinalNumber: Eg,
  era: q({
    values: gg,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: yg,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: bg,
    defaultWidth: "wide"
  }),
  day: q({
    values: wg,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: $g,
    defaultWidth: "wide"
  })
}, Cg = /^(\d+)(ième|ère|ème|er|e)?/i, Pg = /\d+/i, Sg = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, zg = {
  any: [/^av/i, /^ap/i]
}, Fg = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, Ng = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Dg = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, Og = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ag = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, Tg = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, kg = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, Hg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, Ig = {
  ordinalNumber: at({
    matchPattern: Cg,
    parsePattern: Pg,
    valueCallback: (e) => parseInt(e)
  }),
  era: Z({
    matchPatterns: Sg,
    defaultMatchWidth: "wide",
    parsePatterns: zg,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: Fg,
    defaultMatchWidth: "wide",
    parsePatterns: Ng,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: Dg,
    defaultMatchWidth: "wide",
    parsePatterns: Og,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: Ag,
    defaultMatchWidth: "wide",
    parsePatterns: Tg,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: kg,
    defaultMatchWidth: "any",
    parsePatterns: Hg,
    defaultParseWidth: "any"
  })
}, Rg = {
  code: "fr",
  formatDistance: dg,
  formatLong: mg,
  formatRelative: vg,
  localize: Mg,
  match: Ig,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, _g = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, Lg = (e, t, n) => {
  let r;
  const o = _g[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "tra " + r : r + " fa" : r;
}, Bg = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Wg = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vg = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, jg = {
  date: ve({
    formats: Bg,
    defaultWidth: "full"
  }),
  time: ve({
    formats: Wg,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: Vg,
    defaultWidth: "full"
  })
}, Ai = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato"
];
function Gg(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + Ai[e] + " scorso alle' p";
  }
}
function Zl(e) {
  return "'" + Ai[e] + " alle' p";
}
function Yg(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + Ai[e] + " prossimo alle' p";
  }
}
const Ug = {
  lastWeek: (e, t, n) => {
    const r = e.getDay();
    return Xn(e, t, n) ? Zl(r) : Gg(r);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (e, t, n) => {
    const r = e.getDay();
    return Xn(e, t, n) ? Zl(r) : Yg(r);
  },
  other: "P"
}, Kg = (e, t, n, r) => {
  const o = Ug[e];
  return typeof o == "function" ? o(t, n, r) : o;
}, Xg = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, qg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Zg = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic"
  ],
  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre"
  ]
}, Jg = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato"
  ]
}, Qg = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, ey = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, ty = (e, t) => {
  const n = Number(e);
  return String(n);
}, ny = {
  ordinalNumber: ty,
  era: q({
    values: Xg,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: qg,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: Zg,
    defaultWidth: "wide"
  }),
  day: q({
    values: Jg,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: Qg,
    defaultWidth: "wide",
    formattingValues: ey,
    defaultFormattingWidth: "wide"
  })
}, ry = /^(\d+)(º)?/i, ay = /\d+/i, oy = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, iy = {
  any: [/^a/i, /^(d|e)/i]
}, ly = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, sy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cy = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, dy = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, uy = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, fy = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, hy = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, my = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, py = {
  ordinalNumber: at({
    matchPattern: ry,
    parsePattern: ay,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: oy,
    defaultMatchWidth: "wide",
    parsePatterns: iy,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: ly,
    defaultMatchWidth: "wide",
    parsePatterns: sy,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: cy,
    defaultMatchWidth: "wide",
    parsePatterns: dy,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: uy,
    defaultMatchWidth: "wide",
    parsePatterns: fy,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: hy,
    defaultMatchWidth: "any",
    parsePatterns: my,
    defaultParseWidth: "any"
  })
}, vy = {
  code: "it",
  formatDistance: Lg,
  formatLong: jg,
  formatRelative: Kg,
  localize: ny,
  match: py,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, gy = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒"
  },
  xSeconds: {
    one: "1秒",
    other: "{{count}}秒"
  },
  halfAMinute: "30秒",
  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分"
  },
  xMinutes: {
    one: "1分",
    other: "{{count}}分"
  },
  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間"
  },
  xHours: {
    one: "1時間",
    other: "{{count}}時間"
  },
  xDays: {
    one: "1日",
    other: "{{count}}日"
  },
  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間"
  },
  xWeeks: {
    one: "1週間",
    other: "{{count}}週間"
  },
  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月"
  },
  xMonths: {
    one: "1か月",
    other: "{{count}}か月"
  },
  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年"
  },
  xYears: {
    one: "1年",
    other: "{{count}}年"
  },
  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上"
  },
  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く"
  }
}, yy = (e, t, n) => {
  n = n || {};
  let r;
  const o = gy[e];
  return typeof o == "string" ? r = o : t === 1 ? n.addSuffix && o.oneWithSuffix ? r = o.oneWithSuffix : r = o.one : n.addSuffix && o.otherWithSuffix ? r = o.otherWithSuffix.replace("{{count}}", String(t)) : r = o.other.replace("{{count}}", String(t)), n.addSuffix ? n.comparison && n.comparison > 0 ? r + "後" : r + "前" : r;
}, by = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, wy = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, $y = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ey = {
  date: ve({
    formats: by,
    defaultWidth: "full"
  }),
  time: ve({
    formats: wy,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: $y,
    defaultWidth: "full"
  })
}, xy = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P"
}, My = (e, t, n, r) => xy[e], Cy = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"]
}, Py = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"]
}, Sy = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ]
}, zy = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
}, Fy = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, Ny = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, Dy = (e, t) => {
  const n = Number(e);
  switch (String(t?.unit)) {
    case "year":
      return `${n}年`;
    case "quarter":
      return `第${n}四半期`;
    case "month":
      return `${n}月`;
    case "week":
      return `第${n}週`;
    case "date":
      return `${n}日`;
    case "hour":
      return `${n}時`;
    case "minute":
      return `${n}分`;
    case "second":
      return `${n}秒`;
    default:
      return `${n}`;
  }
}, Oy = {
  ordinalNumber: Dy,
  era: q({
    values: Cy,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: Py,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: q({
    values: Sy,
    defaultWidth: "wide"
  }),
  day: q({
    values: zy,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: Fy,
    defaultWidth: "wide",
    formattingValues: Ny,
    defaultFormattingWidth: "wide"
  })
}, Ay = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i, Ty = /\d+/i, ky = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
}, Hy = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
}, Iy = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
}, Ry = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, _y = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
}, Ly = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, By = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
}, Wy = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
}, Vy = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
}, jy = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
}, Gy = {
  ordinalNumber: at({
    matchPattern: Ay,
    parsePattern: Ty,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Z({
    matchPatterns: ky,
    defaultMatchWidth: "wide",
    parsePatterns: Hy,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: Iy,
    defaultMatchWidth: "wide",
    parsePatterns: Ry,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: _y,
    defaultMatchWidth: "wide",
    parsePatterns: Ly,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: By,
    defaultMatchWidth: "wide",
    parsePatterns: Wy,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: Vy,
    defaultMatchWidth: "any",
    parsePatterns: jy,
    defaultParseWidth: "any"
  })
}, Yy = {
  code: "ja",
  formatDistance: yy,
  formatLong: Ey,
  formatRelative: My,
  localize: Oy,
  match: Gy,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Uy = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, Ky = (e, t, n) => {
  let r;
  const o = Uy[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "over " + r : r + " geleden" : r;
}, Xy = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, qy = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Zy = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Jy = {
  date: ve({
    formats: Xy,
    defaultWidth: "full"
  }),
  time: ve({
    formats: qy,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: Zy,
    defaultWidth: "full"
  })
}, Qy = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, eb = (e, t, n, r) => Qy[e], tb = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, nb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, rb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, ab = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, ob = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, ib = (e, t) => Number(e) + "e", lb = {
  ordinalNumber: ib,
  era: q({
    values: tb,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: nb,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: rb,
    defaultWidth: "wide"
  }),
  day: q({
    values: ab,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: ob,
    defaultWidth: "wide"
  })
}, sb = /^(\d+)e?/i, cb = /\d+/i, db = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, ub = {
  any: [/^v/, /^n/]
}, fb = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, hb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mb = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, pb = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, vb = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, gb = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, yb = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, bb = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, wb = {
  ordinalNumber: at({
    matchPattern: sb,
    parsePattern: cb,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: db,
    defaultMatchWidth: "wide",
    parsePatterns: ub,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: fb,
    defaultMatchWidth: "wide",
    parsePatterns: hb,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: mb,
    defaultMatchWidth: "wide",
    parsePatterns: pb,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: vb,
    defaultMatchWidth: "wide",
    parsePatterns: gb,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: yb,
    defaultMatchWidth: "any",
    parsePatterns: bb,
    defaultParseWidth: "any"
  })
}, $b = {
  code: "nl",
  formatDistance: Ky,
  formatLong: Jy,
  formatRelative: eb,
  localize: lb,
  match: wb,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Eb = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, xb = (e, t, n) => {
  let r;
  const o = Eb[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "em " + r : "há " + r : r;
}, Mb = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Cb = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Pb = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Sb = {
  date: ve({
    formats: Mb,
    defaultWidth: "full"
  }),
  time: ve({
    formats: Cb,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: Pb,
    defaultWidth: "full"
  })
}, zb = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Fb = (e, t, n, r) => {
  const o = zb[e];
  return typeof o == "function" ? o(t) : o;
}, Nb = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, Db = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Ob = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, Ab = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, Tb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, kb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, Hb = (e, t) => {
  const n = Number(e);
  return t?.unit === "week" ? n + "ª" : n + "º";
}, Ib = {
  ordinalNumber: Hb,
  era: q({
    values: Nb,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: Db,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: Ob,
    defaultWidth: "wide"
  }),
  day: q({
    values: Ab,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: Tb,
    defaultWidth: "wide",
    formattingValues: kb,
    defaultFormattingWidth: "wide"
  })
}, Rb = /^(\d+)[ºªo]?/i, _b = /\d+/i, Lb = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, Bb = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, Wb = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Vb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jb = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, Gb = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, Yb = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, Ub = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, Kb = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, Xb = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, qb = {
  ordinalNumber: at({
    matchPattern: Rb,
    parsePattern: _b,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: Lb,
    defaultMatchWidth: "wide",
    parsePatterns: Bb,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: Wb,
    defaultMatchWidth: "wide",
    parsePatterns: Vb,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: jb,
    defaultMatchWidth: "wide",
    parsePatterns: Gb,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: Yb,
    defaultMatchWidth: "wide",
    parsePatterns: Ub,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: Kb,
    defaultMatchWidth: "any",
    parsePatterns: Xb,
    defaultParseWidth: "any"
  })
}, Zb = {
  code: "pt-BR",
  formatDistance: xb,
  formatLong: Sb,
  formatRelative: Fb,
  localize: Ib,
  match: qb,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function _n(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Ve(e) {
  return (t, n) => n?.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? _n(e.future, t) : "через " + _n(e.regular, t) : e.past ? _n(e.past, t) : _n(e.regular, t) + " назад" : _n(e.regular, t);
}
const Jb = {
  lessThanXSeconds: Ve({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Ve({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: (e, t) => t?.addSuffix ? t.comparison && t.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты",
  lessThanXMinutes: Ve({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Ve({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Ve({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Ve({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Ve({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Ve({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Ve({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Ve({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Ve({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Ve({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Ve({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Ve({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Ve({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Qb = (e, t, n) => Jb[e](t, n), ew = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, tw = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, nw = {
  any: "{{date}}, {{time}}"
}, rw = {
  date: ve({
    formats: ew,
    defaultWidth: "full"
  }),
  time: ve({
    formats: tw,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: nw,
    defaultWidth: "any"
  })
}, Ti = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу"
];
function aw(e) {
  const t = Ti[e];
  switch (e) {
    case 0:
      return "'в прошлое " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + t + " в' p";
  }
}
function Jl(e) {
  const t = Ti[e];
  return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function ow(e) {
  const t = Ti[e];
  switch (e) {
    case 0:
      return "'в следующее " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + t + " в' p";
  }
}
const iw = {
  lastWeek: (e, t, n) => {
    const r = e.getDay();
    return Xn(e, t, n) ? Jl(r) : aw(r);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (e, t, n) => {
    const r = e.getDay();
    return Xn(e, t, n) ? Jl(r) : ow(r);
  },
  other: "P"
}, lw = (e, t, n, r) => {
  const o = iw[e];
  return typeof o == "function" ? o(t, n, r) : o;
}, sw = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, cw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, dw = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь"
  ]
}, uw = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря"
  ]
}, fw = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ]
}, hw = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, mw = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, pw = (e, t) => {
  const n = Number(e), r = t?.unit;
  let o;
  return r === "date" ? o = "-е" : r === "week" || r === "minute" || r === "second" ? o = "-я" : o = "-й", n + o;
}, vw = {
  ordinalNumber: pw,
  era: q({
    values: sw,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: cw,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: dw,
    defaultWidth: "wide",
    formattingValues: uw,
    defaultFormattingWidth: "wide"
  }),
  day: q({
    values: fw,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: hw,
    defaultWidth: "any",
    formattingValues: mw,
    defaultFormattingWidth: "wide"
  })
}, gw = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, yw = /\d+/i, bw = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, ww = {
  any: [/^д/i, /^н/i]
}, $w = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, Ew = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xw = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, Mw = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, Cw = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, Pw = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, Sw = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, zw = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, Fw = {
  ordinalNumber: at({
    matchPattern: gw,
    parsePattern: yw,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: bw,
    defaultMatchWidth: "wide",
    parsePatterns: ww,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: $w,
    defaultMatchWidth: "wide",
    parsePatterns: Ew,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: xw,
    defaultMatchWidth: "wide",
    parsePatterns: Mw,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: Cw,
    defaultMatchWidth: "wide",
    parsePatterns: Pw,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: Sw,
    defaultMatchWidth: "wide",
    parsePatterns: zw,
    defaultParseWidth: "any"
  })
}, Nw = {
  code: "ru",
  formatDistance: Qb,
  formatLong: rw,
  formatRelative: lw,
  localize: vw,
  match: Fw,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Dw = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yarım dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl"
  },
  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl"
  },
  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl"
  }
}, Ow = (e, t, n) => {
  let r;
  const o = Dw[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? r + " sonra" : r + " önce" : r;
}, Aw = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
}, Tw = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, kw = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Hw = {
  date: ve({
    formats: Aw,
    defaultWidth: "full"
  }),
  time: ve({
    formats: Tw,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: kw,
    defaultWidth: "full"
  })
}, Iw = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
}, Rw = (e, t, n, r) => Iw[e], _w = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"]
}, Lw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"]
}, Bw = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara"
  ],
  wide: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık"
  ]
}, Ww = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: [
    "Pazar",
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi"
  ]
}, Vw = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  }
}, jw = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  }
}, Gw = (e, t) => Number(e) + ".", Yw = {
  ordinalNumber: Gw,
  era: q({
    values: _w,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: Lw,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: q({
    values: Bw,
    defaultWidth: "wide"
  }),
  day: q({
    values: Ww,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: Vw,
    defaultWidth: "wide",
    formattingValues: jw,
    defaultFormattingWidth: "wide"
  })
}, Uw = /^(\d+)(\.)?/i, Kw = /\d+/i, Xw = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
}, qw = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
}, Zw = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
}, Jw = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [
    /^(i|İ)lk çeyrek/i,
    /(i|İ)kinci çeyrek/i,
    /üçüncü çeyrek/i,
    /son çeyrek/i
  ]
}, Qw = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
}, e$ = {
  narrow: [
    /^o/i,
    /^ş/i,
    /^m/i,
    /^n/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^a/i,
    /^e/i,
    /^e/i,
    /^k/i,
    /^a/i
  ],
  any: [
    /^o/i,
    /^ş/i,
    /^mar/i,
    /^n/i,
    /^may/i,
    /^h/i,
    /^t/i,
    /^ağ/i,
    /^ey/i,
    /^ek/i,
    /^k/i,
    /^ar/i
  ]
}, t$ = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
}, n$ = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [
    /^pazar(?!tesi)/i,
    /^pazartesi/i,
    /^salı/i,
    /^çarşamba/i,
    /^perşembe/i,
    /^cuma(?!rtesi)/i,
    /^cumartesi/i
  ]
}, r$ = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
}, a$ = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
}, o$ = {
  ordinalNumber: at({
    matchPattern: Uw,
    parsePattern: Kw,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Z({
    matchPatterns: Xw,
    defaultMatchWidth: "wide",
    parsePatterns: qw,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: Zw,
    defaultMatchWidth: "wide",
    parsePatterns: Jw,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: Qw,
    defaultMatchWidth: "wide",
    parsePatterns: e$,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: t$,
    defaultMatchWidth: "wide",
    parsePatterns: n$,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: r$,
    defaultMatchWidth: "any",
    parsePatterns: a$,
    defaultParseWidth: "any"
  })
}, i$ = {
  code: "tr",
  formatDistance: Ow,
  formatLong: Hw,
  formatRelative: Rw,
  localize: Yw,
  match: o$,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, l$ = {
  lessThanXSeconds: {
    one: "不到 1 秒",
    other: "不到 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分钟",
  lessThanXMinutes: {
    one: "不到 1 分钟",
    other: "不到 {{count}} 分钟"
  },
  xMinutes: {
    one: "1 分钟",
    other: "{{count}} 分钟"
  },
  xHours: {
    one: "1 小时",
    other: "{{count}} 小时"
  },
  aboutXHours: {
    one: "大约 1 小时",
    other: "大约 {{count}} 小时"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大约 1 个星期",
    other: "大约 {{count}} 个星期"
  },
  xWeeks: {
    one: "1 个星期",
    other: "{{count}} 个星期"
  },
  aboutXMonths: {
    one: "大约 1 个月",
    other: "大约 {{count}} 个月"
  },
  xMonths: {
    one: "1 个月",
    other: "{{count}} 个月"
  },
  aboutXYears: {
    one: "大约 1 年",
    other: "大约 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超过 1 年",
    other: "超过 {{count}} 年"
  },
  almostXYears: {
    one: "将近 1 年",
    other: "将近 {{count}} 年"
  }
}, s$ = (e, t, n) => {
  let r;
  const o = l$[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? r + "内" : r + "前" : r;
}, c$ = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, d$ = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, u$ = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, f$ = {
  date: ve({
    formats: c$,
    defaultWidth: "full"
  }),
  time: ve({
    formats: d$,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: u$,
    defaultWidth: "full"
  })
};
function Ql(e, t, n) {
  const r = "eeee p";
  return Xn(e, t, n) ? r : e.getTime() > t.getTime() ? "'下个'" + r : "'上个'" + r;
}
const h$ = {
  lastWeek: Ql,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: Ql,
  // days after tomorrow, maybe in this week or next week
  other: "PP p"
}, m$ = (e, t, n, r) => {
  const o = h$[e];
  return typeof o == "function" ? o(t, n, r) : o;
}, p$ = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, v$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, g$ = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, y$ = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, b$ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, w$ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, $$ = (e, t) => {
  const n = Number(e);
  switch (t?.unit) {
    case "date":
      return n.toString() + "日";
    case "hour":
      return n.toString() + "时";
    case "minute":
      return n.toString() + "分";
    case "second":
      return n.toString() + "秒";
    default:
      return "第 " + n.toString();
  }
}, E$ = {
  ordinalNumber: $$,
  era: q({
    values: p$,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: v$,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: g$,
    defaultWidth: "wide"
  }),
  day: q({
    values: y$,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: b$,
    defaultWidth: "wide",
    formattingValues: w$,
    defaultFormattingWidth: "wide"
  })
}, x$ = /^(第\s*)?\d+(日|时|分|秒)?/i, M$ = /\d+/i, C$ = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, P$ = {
  any: [/^(前)/i, /^(公元)/i]
}, S$ = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
}, z$ = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, F$ = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, N$ = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, D$ = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, O$ = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, A$ = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
}, T$ = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, k$ = {
  ordinalNumber: at({
    matchPattern: x$,
    parsePattern: M$,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: C$,
    defaultMatchWidth: "wide",
    parsePatterns: P$,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: S$,
    defaultMatchWidth: "wide",
    parsePatterns: z$,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: F$,
    defaultMatchWidth: "wide",
    parsePatterns: N$,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: D$,
    defaultMatchWidth: "wide",
    parsePatterns: O$,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: A$,
    defaultMatchWidth: "any",
    parsePatterns: T$,
    defaultParseWidth: "any"
  })
}, H$ = {
  code: "zh-CN",
  formatDistance: s$,
  formatLong: f$,
  formatRelative: m$,
  localize: E$,
  match: k$,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, I$ = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, R$ = (e, t, n) => {
  let r;
  const o = I$[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", String(t)), n?.addSuffix ? n.comparison && n.comparison > 0 ? r + "內" : r + "前" : r;
}, _$ = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, L$ = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, B$ = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, W$ = {
  date: ve({
    formats: _$,
    defaultWidth: "full"
  }),
  time: ve({
    formats: L$,
    defaultWidth: "full"
  }),
  dateTime: ve({
    formats: B$,
    defaultWidth: "full"
  })
}, V$ = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, j$ = (e, t, n, r) => V$[e], G$ = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, Y$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一刻", "第二刻", "第三刻", "第四刻"],
  wide: ["第一刻鐘", "第二刻鐘", "第三刻鐘", "第四刻鐘"]
}, U$ = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, K$ = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, X$ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, q$ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, Z$ = (e, t) => {
  const n = Number(e);
  switch (t?.unit) {
    case "date":
      return n + "日";
    case "hour":
      return n + "時";
    case "minute":
      return n + "分";
    case "second":
      return n + "秒";
    default:
      return "第 " + n;
  }
}, J$ = {
  ordinalNumber: Z$,
  era: q({
    values: G$,
    defaultWidth: "wide"
  }),
  quarter: q({
    values: Y$,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: q({
    values: U$,
    defaultWidth: "wide"
  }),
  day: q({
    values: K$,
    defaultWidth: "wide"
  }),
  dayPeriod: q({
    values: X$,
    defaultWidth: "wide",
    formattingValues: q$,
    defaultFormattingWidth: "wide"
  })
}, Q$ = /^(第\s*)?\d+(日|時|分|秒)?/i, eE = /\d+/i, tE = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, nE = {
  any: [/^(前)/i, /^(公元)/i]
}, rE = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
}, aE = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, oE = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, iE = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, lE = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, sE = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, cE = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, dE = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, uE = {
  ordinalNumber: at({
    matchPattern: Q$,
    parsePattern: eE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Z({
    matchPatterns: tE,
    defaultMatchWidth: "wide",
    parsePatterns: nE,
    defaultParseWidth: "any"
  }),
  quarter: Z({
    matchPatterns: rE,
    defaultMatchWidth: "wide",
    parsePatterns: aE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Z({
    matchPatterns: oE,
    defaultMatchWidth: "wide",
    parsePatterns: iE,
    defaultParseWidth: "any"
  }),
  day: Z({
    matchPatterns: lE,
    defaultMatchWidth: "wide",
    parsePatterns: sE,
    defaultParseWidth: "any"
  }),
  dayPeriod: Z({
    matchPatterns: cE,
    defaultMatchWidth: "any",
    parsePatterns: dE,
    defaultParseWidth: "any"
  })
}, fE = {
  code: "zh-TW",
  formatDistance: R$,
  formatLong: W$,
  formatRelative: j$,
  localize: J$,
  match: uE,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, hE = (e) => {
  switch (e) {
    case "de":
      return tv;
    case "es":
      return sg;
    case "fr":
      return Rg;
    case "it":
      return vy;
    case "ja":
      return Yy;
    case "nl":
      return $b;
    case "pt-BR":
      return Zb;
    case "ru":
      return Nw;
    case "tr":
      return i$;
    case "zh-CN":
      return H$;
    case "zh-TW":
      return fE;
    case "en":
    default:
      return Dv;
  }
};
function P_(e) {
  return /* @__PURE__ */ g(
    $p,
    {
      ...e,
      classNames: {
        month_caption: "flex justify-center items-center h-10",
        caption_label: "font-medium",
        day: "w-10 h-10 align-middle text-center border-0 px-0 hover:bg-primary-50",
        day_button: "w-10 h-10 bg-transparent text-inherit transition-colors focus:outline-none focus-visible:ring focus-visible:ring-primary-300 focus-visible:ring-opacity-50",
        disabled: "opacity-25 hover:!bg-white active:!bg-white active:!text-gray-800",
        outside: "opacity-50 !bg-transparent !text-gray-900 hover:!bg-transparent",
        selected: "bg-primary-500 text-white hover:bg-primary-500",
        range_start: "bg-primary-500 text-white hover:!bg-primary-500",
        range_end: "bg-primary-500 text-white hover:!bg-primary-500",
        range_middle: "!bg-primary-50 !text-gray-900 hover:!bg-primary-100",
        today: "font-bold",
        weekday: "w-10 h-10 uppercase align-middle text-center font-medium text-sm",
        months: "flex gap-4 relative px-4",
        button_next: "inline-flex justify-center items-center absolute top-0 right-0 w-10 h-10 rounded-full hover:bg-gray-100",
        button_previous: "inline-flex justify-center items-center absolute top-0 left-0 w-10 h-10 rounded-full hover:bg-gray-100",
        root: "text-text-primary",
        month_grid: "border-collapse border-spacing-0"
      },
      components: {
        Chevron: ({ orientation: n }) => n === "left" ? /* @__PURE__ */ g(Qm, { "data-testid": "leftIcon", className: "h-5 w-5 fill-gray-600" }) : /* @__PURE__ */ g(e6, { "data-testid": "rightIcon", className: "h-5 w-5 fill-gray-600" })
      },
      locale: hE(e.language ?? "en")
    }
  );
}
const mE = 'before:content-[" "]', pE = Se(
  [
    mE,
    "peer",
    "relative",
    "cursor-pointer",
    "appearance-none",
    "rounded",
    "border-stroke",
    "before:absolute",
    "before:top-2/4",
    "before:left-2/4",
    "before:block",
    "before:-translate-y-2/4",
    "before:-translate-x-2/4",
    "before:rounded-full",
    "before:opacity-0",
    "before:transition-opacity",
    "hover:before:opacity-10",
    "focus:before:opacity-10",
    "focus:outline-none",
    "disabled:hover:before:opacity-0",
    "disabled:focus:before:opacity-0",
    "disabled:opacity-38",
    "disabled:cursor-not-allowed"
  ],
  {
    variants: {
      color: {
        primary: [
          "before:bg-primary-500",
          "checked:border-primary-500",
          "checked:bg-primary-500",
          "checked:before:bg-primary-500",
          "indeterminate:border-primary-500",
          "indeterminate:bg-primary-500",
          "indeterminate:before:bg-primary-500",
          "focus:border-primary-500"
        ],
        secondary: [
          "before:bg-secondary-500",
          "checked:border-secondary-500",
          "checked:bg-secondary-500",
          "checked:before:bg-secondary-500",
          "indeterminate:border-secondary-500",
          "indeterminate:bg-secondary-500",
          "indeterminate:before:bg-secondary-500",
          "focus:border-secondary-500"
        ]
      },
      size: {
        sm: ["h-4", "w-4", "border-[1px]", "before:h-6", "before:w-6"],
        md: ["h-5", "w-5", "border-[1.5px]", "before:h-8", "before:w-8"],
        lg: ["h-6", "w-6", "border-[2px]", "before:h-10", "before:w-10"]
      }
    },
    defaultVariants: {
      color: "primary",
      size: "md"
    }
  }
), vE = /* @__PURE__ */ g("svg", { width: "8", height: "6", viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ g(
  "path",
  {
    d: "M7.35717 0.682099L7.35229 0.676201L7.34697 0.670694C7.19199 0.510193 6.94179 0.50977 6.7863 0.669425L2.87156 4.60131L0.974464 2.69097C0.818984 2.53122 0.568718 2.53161 0.413701 2.69214L0.557573 2.83107L0.413701 2.69214C0.2621 2.84914 0.2621 3.09692 0.413701 3.25391L0.413687 3.25393L0.41566 3.25591L2.39967 5.25377C2.52672 5.3847 2.69957 5.45 2.86048 5.45C3.03491 5.45 3.19601 5.38288 3.3212 5.25386L7.31982 1.23774C7.48732 1.08179 7.4858 0.837501 7.35717 0.682099ZM2.9605 4.69087L2.95881 4.68917L2.96048 4.69088L2.9605 4.69087Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.4"
  }
) }), gE = /* @__PURE__ */ g("svg", { width: "11", height: "7", viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ g(
  "path",
  {
    d: "M10.0915 0.451972L10.0867 0.446075L10.0813 0.440568C9.90076 0.253564 9.61034 0.253146 9.42927 0.439309L4.16201 5.72962L1.58507 3.13469C1.40401 2.94841 1.11351 2.94879 0.932892 3.13584C0.755703 3.31933 0.755703 3.60875 0.932892 3.79224L0.932878 3.79225L0.934851 3.79424L3.58046 6.45832C3.73676 6.61955 3.94983 6.7 4.1473 6.7C4.36196 6.7 4.55963 6.61773 4.71406 6.4584L10.0468 1.10234C10.2436 0.919903 10.2421 0.633904 10.0915 0.451972ZM4.2327 5.80081L4.2317 5.7998C4.23206 5.80015 4.23237 5.80049 4.23269 5.80082L4.2327 5.80081Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.4"
  }
) }), yE = /* @__PURE__ */ g("svg", { width: "13", height: "9", viewBox: "0 0 13 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ g(
  "path",
  {
    d: "M11.8259 0.721846L11.821 0.715949L11.8157 0.710441C11.6095 0.496939 11.2789 0.49652 11.0723 0.709185L4.45247 7.35794L1.19567 4.0784C0.98902 3.86561 0.658291 3.86598 0.452083 4.07953C0.249306 4.28952 0.249306 4.62058 0.452083 4.83057L0.452069 4.83058L0.454042 4.83257L3.76127 8.16287C3.94681 8.3544 4.20009 8.45 4.43413 8.45C4.68901 8.45 4.92324 8.35258 5.10692 8.16295L11.7738 1.46693C11.9999 1.25799 11.9984 0.930301 11.8259 0.721846ZM4.50491 7.41074L4.50457 7.4104C4.5047 7.41053 4.50479 7.41065 4.50489 7.41076L4.50491 7.41074Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.4"
  }
) }), bE = /* @__PURE__ */ g("svg", { width: "6", height: "1.5", viewBox: "0 0 6 1.5", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ g("rect", { x: "0", y: "0", width: "6", height: "1.5", rx: "1", fill: "white" }) }), wE = /* @__PURE__ */ g("svg", { width: "8", height: "1.5", viewBox: "0 0 8 1.5", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ g("rect", { x: "0", y: "0", width: "8", height: "1.5", rx: "1", fill: "white" }) }), $E = /* @__PURE__ */ g("svg", { width: "10", height: "1.5", viewBox: "0 0 10 1.5", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ g("rect", { x: "0", y: "0", width: "10", height: "1.5", rx: "1", fill: "white" }) }), S_ = de(function({ className: t, color: n, id: r, indeterminate: o, label: i, size: l = "md", ...s }, c) {
  const d = (u) => {
    u && (u.indeterminate = !!o), typeof c == "function" ? c(u) : c && (c.current = u);
  }, f = () => o ? l === "sm" ? bE : l === "md" ? wE : $E : l === "sm" ? vE : l === "md" ? gE : yE;
  return /* @__PURE__ */ re("div", { className: "flex items-center", children: [
    /* @__PURE__ */ re("div", { className: "relative flex cursor-pointer items-center rounded-full", children: [
      /* @__PURE__ */ g(
        "input",
        {
          ref: d,
          type: "checkbox",
          id: r,
          className: pE({ color: n, className: t, size: l }),
          checked: o || s.checked,
          ...s
        }
      ),
      /* @__PURE__ */ g(
        "div",
        {
          className: j(
            "pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-white transition-opacity",
            {
              "opacity-0 peer-checked:opacity-100": !o,
              "opacity-100": o
            }
          ),
          children: f()
        }
      )
    ] }),
    i && /* @__PURE__ */ g(
      "label",
      {
        htmlFor: r,
        className: j(
          "cursor-pointer select-none",
          { "ml-1.5": l === "sm", "ml-2": l === "md", "ml-2.5": l === "lg" },
          { "cursor-not-allowed opacity-38": s.disabled }
        ),
        children: i
      }
    )
  ] });
}), EE = Se(["flex max-w-fit items-center gap-1 border border-transparent px-2.5 py-0.5"], {
  variants: {
    variant: {
      standard: [""],
      filled: [""],
      outlined: [""]
    },
    type: {
      default: [],
      primary: [],
      secondary: [],
      info: [],
      error: [],
      warning: []
    },
    isRound: {
      false: ["rounded-md"],
      true: ["rounded-full"]
    },
    size: {
      xs: [],
      sm: [],
      lg: ["px-5", "py-3"]
    },
    disabled: {
      true: ["opacity-[.38]", "pointer-events-none"],
      false: []
    },
    useHoverStyles: {
      true: [],
      // override the hover styles if not a button and useHoverStyles is false
      false: ["pointer-events-none"]
    }
  },
  compoundVariants: [
    // filled
    {
      variant: "filled",
      type: "default",
      className: ["bg-gray-200", "hover:bg-gray-300", "text-gray-900"]
    },
    {
      variant: "filled",
      type: "primary",
      className: ["bg-primary-500", "hover:bg-primary-600", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "secondary",
      className: ["bg-secondary-500", "hover:bg-deepBlue-600", "text-white"]
    },
    {
      variant: "filled",
      type: "info",
      className: ["bg-lightBlue-500", "hover:bg-lightBlue-600", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "warning",
      className: ["bg-warning-500", "hover:bg-warning-600", "text-text-primary"]
    },
    {
      variant: "filled",
      type: "error",
      className: ["bg-error-500", "hover:bg-error-600", "text-white"]
    },
    // outlined
    {
      variant: "outlined",
      type: "default",
      className: ["border-gray-500", "text-gray-900", "bg-gray-50", "hover:bg-gray-100"]
    },
    {
      variant: "outlined",
      type: "primary",
      className: ["border-green-500", "text-green-900", "bg-green-50", "hover:bg-green-100"]
    },
    {
      variant: "outlined",
      type: "secondary",
      className: ["border-secondary-500", "text-deepBlue-900", "bg-deepBlue-50", "hover:bg-deepBlue-100"]
    },
    {
      variant: "outlined",
      type: "info",
      className: ["border-lightBlue-500", "text-lightBlue-900", "bg-lightBlue-50", "hover:bg-lightBlue-100"]
    },
    {
      variant: "outlined",
      type: "warning",
      className: ["border-warning-500", "text-warning-900", "bg-warning-50", "hover:bg-warning-100"]
    },
    {
      variant: "outlined",
      type: "error",
      className: ["border-error-500", "text-error-900", "bg-error-50", "hover:bg-error-100"]
    },
    // standard
    {
      variant: "standard",
      type: "default",
      className: ["bg-gray-100", "text-gray-900", "hover:bg-gray-200"]
    },
    {
      variant: "standard",
      type: "primary",
      className: ["bg-green-100", "text-green-900", "hover:bg-green-200"]
    },
    {
      variant: "standard",
      type: "secondary",
      className: ["bg-deepBlue-100", "text-deepBlue-900", "hover:bg-deepBlue-200"]
    },
    {
      variant: "standard",
      type: "info",
      className: ["bg-lightBlue-100", "text-lightBlue-900", "hover:bg-lightBlue-200"]
    },
    {
      variant: "standard",
      type: "warning",
      className: ["bg-warning-100", "text-warning-900", "hover:bg-warning-200"]
    },
    {
      variant: "standard",
      type: "error",
      className: ["bg-error-100", "text-error-900", "hover:bg-error-200"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    type: "default",
    isRound: !1,
    size: "sm",
    disabled: !1,
    useHoverStyles: !1
  }
}), e1 = Se(["h-4 w-4"], {
  variants: {
    variant: {
      standard: [""],
      filled: [""],
      outlined: [""]
    },
    type: {
      default: [""],
      primary: [""],
      secondary: [""],
      info: [""],
      warning: [""],
      error: [""]
    }
  },
  compoundVariants: [
    // filled
    {
      variant: "filled",
      type: "default",
      className: ["fill-gray-900"]
    },
    {
      variant: "filled",
      type: "primary",
      className: ["fill-text-primary"]
    },
    {
      variant: "filled",
      type: "secondary",
      className: ["fill-white"]
    },
    {
      variant: "filled",
      type: "info",
      className: ["fill-text-primary"]
    },
    {
      variant: "filled",
      type: "warning",
      className: ["fill-text-primary"]
    },
    {
      variant: "filled",
      type: "error",
      className: ["fill-white"]
    },
    // outlined
    {
      variant: "outlined",
      type: "default",
      className: ["fill-gray-900"]
    },
    {
      variant: "outlined",
      type: "primary",
      className: ["fill-green-900"]
    },
    {
      variant: "outlined",
      type: "secondary",
      className: ["fill-deepBlue-900"]
    },
    {
      variant: "outlined",
      type: "info",
      className: ["fill-lightBlue-900"]
    },
    {
      variant: "outlined",
      type: "warning",
      className: ["fill-warning-900"]
    },
    {
      variant: "outlined",
      type: "error",
      className: ["fill-error-900"]
    },
    // standard
    {
      variant: "standard",
      type: "default",
      className: ["fill-gray-900"]
    },
    {
      variant: "standard",
      type: "primary",
      className: ["fill-green-900"]
    },
    {
      variant: "standard",
      type: "secondary",
      className: ["fill-deepBlue-900"]
    },
    {
      variant: "standard",
      type: "info",
      className: ["fill-lightBlue-900"]
    },
    {
      variant: "standard",
      type: "warning",
      className: ["fill-warning-900"]
    },
    {
      variant: "standard",
      type: "error",
      className: ["fill-error-900"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    type: "default"
  }
}), xE = Se(["truncate text-nowrap font-medium"], {
  variants: {
    size: {
      xs: ["text-xs"],
      sm: ["text-sm"],
      lg: ["text-sm"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function t1({
  type: e = "default",
  variant: t = "standard",
  isRound: n = !1,
  size: r = "sm",
  label: o,
  startIcon: i,
  endIcon: l,
  disabled: s = !1,
  onClick: c,
  useHoverStyles: d = !1,
  className: f
}) {
  const u = i?.icon, m = i?.name, p = l?.icon, y = l?.name;
  return /* @__PURE__ */ re(
    "div",
    {
      className: EE({
        variant: t,
        type: e,
        isRound: n,
        size: r,
        disabled: s,
        useHoverStyles: !!c || d,
        className: f
      }),
      children: [
        i && u && /* @__PURE__ */ g(u, { "aria-label": m, className: e1({ variant: t, type: e }) }),
        /* @__PURE__ */ g("div", { className: xE({ size: r }), children: o }),
        l && p && /* @__PURE__ */ g(p, { "aria-label": y, className: e1({ variant: t, type: e }) })
      ]
    }
  );
}
function z_(e) {
  return e.onClick ? /* @__PURE__ */ g("button", { type: "button", onClick: e.onClick, disabled: e.disabled, children: /* @__PURE__ */ g(t1, { ...e }) }) : /* @__PURE__ */ g(t1, { ...e });
}
function ME(e, t) {
  const n = v.createContext(t), r = (i) => {
    const { children: l, ...s } = i, c = v.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ g(n.Provider, { value: c, children: l });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const l = v.useContext(n);
    if (l) return l;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function ur(e, t = []) {
  let n = [];
  function r(i, l) {
    const s = v.createContext(l), c = n.length;
    n = [...n, l];
    const d = (u) => {
      const { scope: m, children: p, ...y } = u, h = m?.[e]?.[c] || s, b = v.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ g(h.Provider, { value: b, children: p });
    };
    d.displayName = i + "Provider";
    function f(u, m) {
      const p = m?.[e]?.[c] || s, y = v.useContext(p);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return [d, f];
  }
  const o = () => {
    const i = n.map((l) => v.createContext(l));
    return function(s) {
      const c = s?.[e] || i;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, CE(o, ...t)];
}
function CE(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((s, { useScope: c, scopeName: d }) => {
        const u = c(i)[`__scope${d}`];
        return { ...s, ...u };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function PE(e, t = globalThis?.document) {
  const n = Je(e);
  v.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var SE = "DismissableLayer", zo = "dismissableLayer.update", zE = "dismissableLayer.pointerDownOutside", FE = "dismissableLayer.focusOutside", n1, dd = v.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ua = v.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: s,
      ...c
    } = e, d = v.useContext(dd), [f, u] = v.useState(null), m = f?.ownerDocument ?? globalThis?.document, [, p] = v.useState({}), y = xe(t, (S) => u(S)), h = Array.from(d.layers), [b] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), $ = f ? h.indexOf(f) : -1, x = d.layersWithOutsidePointerEventsDisabled.size > 0, P = $ >= w, E = OE((S) => {
      const F = S.target, O = [...d.branches].some((I) => I.contains(F));
      !P || O || (o?.(S), l?.(S), S.defaultPrevented || s?.());
    }, m), z = AE((S) => {
      const F = S.target;
      [...d.branches].some((I) => I.contains(F)) || (i?.(S), l?.(S), S.defaultPrevented || s?.());
    }, m);
    return PE((S) => {
      $ === d.layers.size - 1 && (r?.(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, m), v.useEffect(() => {
      if (f)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (n1 = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), r1(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = n1);
        };
    }, [f, m, n, d]), v.useEffect(() => () => {
      f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), r1());
    }, [f, d]), v.useEffect(() => {
      const S = () => p({});
      return document.addEventListener(zo, S), () => document.removeEventListener(zo, S);
    }, []), /* @__PURE__ */ g(
      me.div,
      {
        ...c,
        ref: y,
        style: {
          pointerEvents: x ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ee(e.onFocusCapture, z.onFocusCapture),
        onBlurCapture: ee(e.onBlurCapture, z.onBlurCapture),
        onPointerDownCapture: ee(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
ua.displayName = SE;
var NE = "DismissableLayerBranch", DE = v.forwardRef((e, t) => {
  const n = v.useContext(dd), r = v.useRef(null), o = xe(t, r);
  return v.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ g(me.div, { ...e, ref: o });
});
DE.displayName = NE;
function OE(e, t = globalThis?.document) {
  const n = Je(e), r = v.useRef(!1), o = v.useRef(() => {
  });
  return v.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          ud(
            zE,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function AE(e, t = globalThis?.document) {
  const n = Je(e), r = v.useRef(!1);
  return v.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && ud(FE, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function r1() {
  const e = new CustomEvent(zo);
  document.dispatchEvent(e);
}
function ud(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? ec(o, i) : o.dispatchEvent(i);
}
var Za = 0;
function ki() {
  v.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? a1()), document.body.insertAdjacentElement("beforeend", e[1] ?? a1()), Za++, () => {
      Za === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Za--;
    };
  }, []);
}
function a1() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ja = "focusScope.autoFocusOnMount", Qa = "focusScope.autoFocusOnUnmount", o1 = { bubbles: !1, cancelable: !0 }, TE = "FocusScope", fa = v.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...l
  } = e, [s, c] = v.useState(null), d = Je(o), f = Je(i), u = v.useRef(null), m = xe(t, (h) => c(h)), p = v.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  v.useEffect(() => {
    if (r) {
      let h = function(x) {
        if (p.paused || !s) return;
        const P = x.target;
        s.contains(P) ? u.current = P : Rt(u.current, { select: !0 });
      }, b = function(x) {
        if (p.paused || !s) return;
        const P = x.relatedTarget;
        P !== null && (s.contains(P) || Rt(u.current, { select: !0 }));
      }, w = function(x) {
        if (document.activeElement === document.body)
          for (const E of x)
            E.removedNodes.length > 0 && Rt(s);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const $ = new MutationObserver(w);
      return s && $.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), $.disconnect();
      };
    }
  }, [r, s, p.paused]), v.useEffect(() => {
    if (s) {
      l1.add(p);
      const h = document.activeElement;
      if (!s.contains(h)) {
        const w = new CustomEvent(Ja, o1);
        s.addEventListener(Ja, d), s.dispatchEvent(w), w.defaultPrevented || (kE(LE(fd(s)), { select: !0 }), document.activeElement === h && Rt(s));
      }
      return () => {
        s.removeEventListener(Ja, d), setTimeout(() => {
          const w = new CustomEvent(Qa, o1);
          s.addEventListener(Qa, f), s.dispatchEvent(w), w.defaultPrevented || Rt(h ?? document.body, { select: !0 }), s.removeEventListener(Qa, f), l1.remove(p);
        }, 0);
      };
    }
  }, [s, d, f, p]);
  const y = v.useCallback(
    (h) => {
      if (!n && !r || p.paused) return;
      const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (b && w) {
        const $ = h.currentTarget, [x, P] = HE($);
        x && P ? !h.shiftKey && w === P ? (h.preventDefault(), n && Rt(x, { select: !0 })) : h.shiftKey && w === x && (h.preventDefault(), n && Rt(P, { select: !0 })) : w === $ && h.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ g(me.div, { tabIndex: -1, ...l, ref: m, onKeyDown: y });
});
fa.displayName = TE;
function kE(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Rt(r, { select: t }), document.activeElement !== n) return;
}
function HE(e) {
  const t = fd(e), n = i1(t, e), r = i1(t.reverse(), e);
  return [n, r];
}
function fd(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function i1(e, t) {
  for (const n of e)
    if (!IE(n, { upTo: t })) return n;
}
function IE(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function RE(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Rt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && RE(e) && t && e.select();
  }
}
var l1 = _E();
function _E() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = s1(e, t), e.unshift(t);
    },
    remove(t) {
      e = s1(e, t), e[0]?.resume();
    }
  };
}
function s1(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function LE(e) {
  return e.filter((t) => t.tagName !== "A");
}
const BE = ["top", "right", "bottom", "left"], yt = Math.min, Xe = Math.max, Wr = Math.round, Mr = Math.floor, Bt = (e) => ({
  x: e,
  y: e
}), WE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, VE = {
  start: "end",
  end: "start"
};
function Fo(e, t, n) {
  return Xe(e, yt(t, n));
}
function zt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ft(e) {
  return e.split("-")[0];
}
function Nn(e) {
  return e.split("-")[1];
}
function Hi(e) {
  return e === "x" ? "y" : "x";
}
function Ii(e) {
  return e === "y" ? "height" : "width";
}
function Wt(e) {
  return ["top", "bottom"].includes(Ft(e)) ? "y" : "x";
}
function Ri(e) {
  return Hi(Wt(e));
}
function jE(e, t, n) {
  n === void 0 && (n = !1);
  const r = Nn(e), o = Ri(e), i = Ii(o);
  let l = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (l = Vr(l)), [l, Vr(l)];
}
function GE(e) {
  const t = Vr(e);
  return [No(e), t, No(t)];
}
function No(e) {
  return e.replace(/start|end/g, (t) => VE[t]);
}
function YE(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], l = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : l;
    default:
      return [];
  }
}
function UE(e, t, n, r) {
  const o = Nn(e);
  let i = YE(Ft(e), n === "start", r);
  return o && (i = i.map((l) => l + "-" + o), t && (i = i.concat(i.map(No)))), i;
}
function Vr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => WE[t]);
}
function KE(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function hd(e) {
  return typeof e != "number" ? KE(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function jr(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function c1(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Wt(t), l = Ri(t), s = Ii(l), c = Ft(t), d = i === "y", f = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, m = r[s] / 2 - o[s] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Nn(t)) {
    case "start":
      p[l] -= m * (n && d ? -1 : 1);
      break;
    case "end":
      p[l] += m * (n && d ? -1 : 1);
      break;
  }
  return p;
}
const XE = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: l
  } = n, s = i.filter(Boolean), c = await (l.isRTL == null ? void 0 : l.isRTL(t));
  let d = await l.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: u
  } = c1(d, r, c), m = r, p = {}, y = 0;
  for (let h = 0; h < s.length; h++) {
    const {
      name: b,
      fn: w
    } = s[h], {
      x: $,
      y: x,
      data: P,
      reset: E
    } = await w({
      x: f,
      y: u,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: p,
      rects: d,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = $ ?? f, u = x ?? u, p = {
      ...p,
      [b]: {
        ...p[b],
        ...P
      }
    }, E && y <= 50 && (y++, typeof E == "object" && (E.placement && (m = E.placement), E.rects && (d = E.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: f,
      y: u
    } = c1(d, m, c)), h = -1);
  }
  return {
    x: f,
    y: u,
    placement: m,
    strategy: o,
    middlewareData: p
  };
};
async function qn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: l,
    elements: s,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: m = !1,
    padding: p = 0
  } = zt(t, e), y = hd(p), b = s[m ? u === "floating" ? "reference" : "floating" : u], w = jr(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: f,
    strategy: c
  })), $ = u === "floating" ? {
    x: r,
    y: o,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), P = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = jr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: $,
    offsetParent: x,
    strategy: c
  }) : $);
  return {
    top: (w.top - E.top + y.top) / P.y,
    bottom: (E.bottom - w.bottom + y.bottom) / P.y,
    left: (w.left - E.left + y.left) / P.x,
    right: (E.right - w.right + y.right) / P.x
  };
}
const qE = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: l,
      elements: s,
      middlewareData: c
    } = t, {
      element: d,
      padding: f = 0
    } = zt(e, t) || {};
    if (d == null)
      return {};
    const u = hd(f), m = {
      x: n,
      y: r
    }, p = Ri(o), y = Ii(p), h = await l.getDimensions(d), b = p === "y", w = b ? "top" : "left", $ = b ? "bottom" : "right", x = b ? "clientHeight" : "clientWidth", P = i.reference[y] + i.reference[p] - m[p] - i.floating[y], E = m[p] - i.reference[p], z = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(d));
    let S = z ? z[x] : 0;
    (!S || !await (l.isElement == null ? void 0 : l.isElement(z))) && (S = s.floating[x] || i.floating[y]);
    const F = P / 2 - E / 2, O = S / 2 - h[y] / 2 - 1, I = yt(u[w], O), L = yt(u[$], O), _ = I, ne = S - h[y] - L, R = S / 2 - h[y] / 2 + F, Y = Fo(_, R, ne), W = !c.arrow && Nn(o) != null && R !== Y && i.reference[y] / 2 - (R < _ ? I : L) - h[y] / 2 < 0, V = W ? R < _ ? R - _ : R - ne : 0;
    return {
      [p]: m[p] + V,
      data: {
        [p]: Y,
        centerOffset: R - Y - V,
        ...W && {
          alignmentOffset: V
        }
      },
      reset: W
    };
  }
}), ZE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: l,
        initialPlacement: s,
        platform: c,
        elements: d
      } = t, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: m,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: h = !0,
        ...b
      } = zt(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const w = Ft(o), $ = Wt(s), x = Ft(s) === s, P = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), E = m || (x || !h ? [Vr(s)] : GE(s)), z = y !== "none";
      !m && z && E.push(...UE(s, h, y, P));
      const S = [s, ...E], F = await qn(t, b), O = [];
      let I = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (f && O.push(F[w]), u) {
        const R = jE(o, l, P);
        O.push(F[R[0]], F[R[1]]);
      }
      if (I = [...I, {
        placement: o,
        overflows: O
      }], !O.every((R) => R <= 0)) {
        var L, _;
        const R = (((L = i.flip) == null ? void 0 : L.index) || 0) + 1, Y = S[R];
        if (Y)
          return {
            data: {
              index: R,
              overflows: I
            },
            reset: {
              placement: Y
            }
          };
        let W = (_ = I.filter((V) => V.overflows[0] <= 0).sort((V, J) => V.overflows[1] - J.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!W)
          switch (p) {
            case "bestFit": {
              var ne;
              const V = (ne = I.filter((J) => {
                if (z) {
                  const T = Wt(J.placement);
                  return T === $ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  T === "y";
                }
                return !0;
              }).map((J) => [J.placement, J.overflows.filter((T) => T > 0).reduce((T, N) => T + N, 0)]).sort((J, T) => J[1] - T[1])[0]) == null ? void 0 : ne[0];
              V && (W = V);
              break;
            }
            case "initialPlacement":
              W = s;
              break;
          }
        if (o !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
function d1(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function u1(e) {
  return BE.some((t) => e[t] >= 0);
}
const JE = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = zt(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await qn(t, {
            ...o,
            elementContext: "reference"
          }), l = d1(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: u1(l)
            }
          };
        }
        case "escaped": {
          const i = await qn(t, {
            ...o,
            altBoundary: !0
          }), l = d1(i, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: u1(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function QE(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), l = Ft(n), s = Nn(n), c = Wt(n) === "y", d = ["left", "top"].includes(l) ? -1 : 1, f = i && c ? -1 : 1, u = zt(t, e);
  let {
    mainAxis: m,
    crossAxis: p,
    alignmentAxis: y
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof y == "number" && (p = s === "end" ? y * -1 : y), c ? {
    x: p * f,
    y: m * d
  } : {
    x: m * d,
    y: p * f
  };
}
const ex = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: l,
        middlewareData: s
      } = t, c = await QE(t, e);
      return l === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: l
        }
      };
    }
  };
}, tx = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: l = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: w,
              y: $
            } = b;
            return {
              x: w,
              y: $
            };
          }
        },
        ...c
      } = zt(e, t), d = {
        x: n,
        y: r
      }, f = await qn(t, c), u = Wt(Ft(o)), m = Hi(u);
      let p = d[m], y = d[u];
      if (i) {
        const b = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", $ = p + f[b], x = p - f[w];
        p = Fo($, p, x);
      }
      if (l) {
        const b = u === "y" ? "top" : "left", w = u === "y" ? "bottom" : "right", $ = y + f[b], x = y - f[w];
        y = Fo($, y, x);
      }
      const h = s.fn({
        ...t,
        [m]: p,
        [u]: y
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r
        }
      };
    }
  };
}, nx = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: l
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: d = !0
      } = zt(e, t), f = {
        x: n,
        y: r
      }, u = Wt(o), m = Hi(u);
      let p = f[m], y = f[u];
      const h = zt(s, t), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (c) {
        const x = m === "y" ? "height" : "width", P = i.reference[m] - i.floating[x] + b.mainAxis, E = i.reference[m] + i.reference[x] - b.mainAxis;
        p < P ? p = P : p > E && (p = E);
      }
      if (d) {
        var w, $;
        const x = m === "y" ? "width" : "height", P = ["top", "left"].includes(Ft(o)), E = i.reference[u] - i.floating[x] + (P && ((w = l.offset) == null ? void 0 : w[u]) || 0) + (P ? 0 : b.crossAxis), z = i.reference[u] + i.reference[x] + (P ? 0 : (($ = l.offset) == null ? void 0 : $[u]) || 0) - (P ? b.crossAxis : 0);
        y < E ? y = E : y > z && (y = z);
      }
      return {
        [m]: p,
        [u]: y
      };
    }
  };
}, rx = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...s
      } = zt(e, t), c = await qn(t, s), d = Ft(n), f = Nn(n), u = Wt(n) === "y", {
        width: m,
        height: p
      } = r.floating;
      let y, h;
      d === "top" || d === "bottom" ? (y = d, h = f === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (h = d, y = f === "end" ? "top" : "bottom");
      const b = p - c.top - c.bottom, w = m - c.left - c.right, $ = yt(p - c[y], b), x = yt(m - c[h], w), P = !t.middlewareData.shift;
      let E = $, z = x;
      if (u ? z = f || P ? yt(x, w) : w : E = f || P ? yt($, b) : b, P && !f) {
        const F = Xe(c.left, 0), O = Xe(c.right, 0), I = Xe(c.top, 0), L = Xe(c.bottom, 0);
        u ? z = m - 2 * (F !== 0 || O !== 0 ? F + O : Xe(c.left, c.right)) : E = p - 2 * (I !== 0 || L !== 0 ? I + L : Xe(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: z,
        availableHeight: E
      });
      const S = await o.getDimensions(i.floating);
      return m !== S.width || p !== S.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Dn(e) {
  return md(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ze(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ot(e) {
  var t;
  return (t = (md(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function md(e) {
  return e instanceof Node || e instanceof Ze(e).Node;
}
function ht(e) {
  return e instanceof Element || e instanceof Ze(e).Element;
}
function wt(e) {
  return e instanceof HTMLElement || e instanceof Ze(e).HTMLElement;
}
function f1(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ze(e).ShadowRoot;
}
function fr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = mt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function ax(e) {
  return ["table", "td", "th"].includes(Dn(e));
}
function ha(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function _i(e) {
  const t = Li(), n = ht(e) ? mt(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function ox(e) {
  let t = Vt(e);
  for (; wt(t) && !Mn(t); ) {
    if (_i(t))
      return t;
    if (ha(t))
      return null;
    t = Vt(t);
  }
  return null;
}
function Li() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Mn(e) {
  return ["html", "body", "#document"].includes(Dn(e));
}
function mt(e) {
  return Ze(e).getComputedStyle(e);
}
function ma(e) {
  return ht(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Vt(e) {
  if (Dn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    f1(e) && e.host || // Fallback.
    Ot(e)
  );
  return f1(t) ? t.host : t;
}
function pd(e) {
  const t = Vt(e);
  return Mn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : wt(t) && fr(t) ? t : pd(t);
}
function Zn(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = pd(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), l = Ze(o);
  if (i) {
    const s = Do(l);
    return t.concat(l, l.visualViewport || [], fr(o) ? o : [], s && n ? Zn(s) : []);
  }
  return t.concat(o, Zn(o, [], n));
}
function Do(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function vd(e) {
  const t = mt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = wt(e), i = o ? e.offsetWidth : n, l = o ? e.offsetHeight : r, s = Wr(n) !== i || Wr(r) !== l;
  return s && (n = i, r = l), {
    width: n,
    height: r,
    $: s
  };
}
function Bi(e) {
  return ht(e) ? e : e.contextElement;
}
function bn(e) {
  const t = Bi(e);
  if (!wt(t))
    return Bt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = vd(t);
  let l = (i ? Wr(n.width) : n.width) / r, s = (i ? Wr(n.height) : n.height) / o;
  return (!l || !Number.isFinite(l)) && (l = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: l,
    y: s
  };
}
const ix = /* @__PURE__ */ Bt(0);
function gd(e) {
  const t = Ze(e);
  return !Li() || !t.visualViewport ? ix : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function lx(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ze(e) ? !1 : t;
}
function tn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Bi(e);
  let l = Bt(1);
  t && (r ? ht(r) && (l = bn(r)) : l = bn(e));
  const s = lx(i, n, r) ? gd(i) : Bt(0);
  let c = (o.left + s.x) / l.x, d = (o.top + s.y) / l.y, f = o.width / l.x, u = o.height / l.y;
  if (i) {
    const m = Ze(i), p = r && ht(r) ? Ze(r) : r;
    let y = m, h = Do(y);
    for (; h && r && p !== y; ) {
      const b = bn(h), w = h.getBoundingClientRect(), $ = mt(h), x = w.left + (h.clientLeft + parseFloat($.paddingLeft)) * b.x, P = w.top + (h.clientTop + parseFloat($.paddingTop)) * b.y;
      c *= b.x, d *= b.y, f *= b.x, u *= b.y, c += x, d += P, y = Ze(h), h = Do(y);
    }
  }
  return jr({
    width: f,
    height: u,
    x: c,
    y: d
  });
}
function sx(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", l = Ot(r), s = t ? ha(t.floating) : !1;
  if (r === l || s && i)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Bt(1);
  const f = Bt(0), u = wt(r);
  if ((u || !u && !i) && ((Dn(r) !== "body" || fr(l)) && (c = ma(r)), wt(r))) {
    const m = tn(r);
    d = bn(r), f.x = m.x + r.clientLeft, f.y = m.y + r.clientTop;
  }
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - c.scrollLeft * d.x + f.x,
    y: n.y * d.y - c.scrollTop * d.y + f.y
  };
}
function cx(e) {
  return Array.from(e.getClientRects());
}
function yd(e) {
  return tn(Ot(e)).left + ma(e).scrollLeft;
}
function dx(e) {
  const t = Ot(e), n = ma(e), r = e.ownerDocument.body, o = Xe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Xe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let l = -n.scrollLeft + yd(e);
  const s = -n.scrollTop;
  return mt(r).direction === "rtl" && (l += Xe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: l,
    y: s
  };
}
function ux(e, t) {
  const n = Ze(e), r = Ot(e), o = n.visualViewport;
  let i = r.clientWidth, l = r.clientHeight, s = 0, c = 0;
  if (o) {
    i = o.width, l = o.height;
    const d = Li();
    (!d || d && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: s,
    y: c
  };
}
function fx(e, t) {
  const n = tn(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = wt(e) ? bn(e) : Bt(1), l = e.clientWidth * i.x, s = e.clientHeight * i.y, c = o * i.x, d = r * i.y;
  return {
    width: l,
    height: s,
    x: c,
    y: d
  };
}
function h1(e, t, n) {
  let r;
  if (t === "viewport")
    r = ux(e, n);
  else if (t === "document")
    r = dx(Ot(e));
  else if (ht(t))
    r = fx(t, n);
  else {
    const o = gd(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return jr(r);
}
function bd(e, t) {
  const n = Vt(e);
  return n === t || !ht(n) || Mn(n) ? !1 : mt(n).position === "fixed" || bd(n, t);
}
function hx(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Zn(e, [], !1).filter((s) => ht(s) && Dn(s) !== "body"), o = null;
  const i = mt(e).position === "fixed";
  let l = i ? Vt(e) : e;
  for (; ht(l) && !Mn(l); ) {
    const s = mt(l), c = _i(l);
    !c && s.position === "fixed" && (o = null), (i ? !c && !o : !c && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || fr(l) && !c && bd(e, l)) ? r = r.filter((f) => f !== l) : o = s, l = Vt(l);
  }
  return t.set(e, r), r;
}
function mx(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const l = [...n === "clippingAncestors" ? ha(t) ? [] : hx(t, this._c) : [].concat(n), r], s = l[0], c = l.reduce((d, f) => {
    const u = h1(t, f, o);
    return d.top = Xe(u.top, d.top), d.right = yt(u.right, d.right), d.bottom = yt(u.bottom, d.bottom), d.left = Xe(u.left, d.left), d;
  }, h1(t, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function px(e) {
  const {
    width: t,
    height: n
  } = vd(e);
  return {
    width: t,
    height: n
  };
}
function vx(e, t, n) {
  const r = wt(t), o = Ot(t), i = n === "fixed", l = tn(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Bt(0);
  if (r || !r && !i)
    if ((Dn(t) !== "body" || fr(o)) && (s = ma(t)), r) {
      const u = tn(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else o && (c.x = yd(o));
  const d = l.left + s.scrollLeft - c.x, f = l.top + s.scrollTop - c.y;
  return {
    x: d,
    y: f,
    width: l.width,
    height: l.height
  };
}
function eo(e) {
  return mt(e).position === "static";
}
function m1(e, t) {
  return !wt(e) || mt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function wd(e, t) {
  const n = Ze(e);
  if (ha(e))
    return n;
  if (!wt(e)) {
    let o = Vt(e);
    for (; o && !Mn(o); ) {
      if (ht(o) && !eo(o))
        return o;
      o = Vt(o);
    }
    return n;
  }
  let r = m1(e, t);
  for (; r && ax(r) && eo(r); )
    r = m1(r, t);
  return r && Mn(r) && eo(r) && !_i(r) ? n : r || ox(e) || n;
}
const gx = async function(e) {
  const t = this.getOffsetParent || wd, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: vx(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function yx(e) {
  return mt(e).direction === "rtl";
}
const bx = {
  convertOffsetParentRelativeRectToViewportRelativeRect: sx,
  getDocumentElement: Ot,
  getClippingRect: mx,
  getOffsetParent: wd,
  getElementRects: gx,
  getClientRects: cx,
  getDimensions: px,
  getScale: bn,
  isElement: ht,
  isRTL: yx
};
function wx(e, t) {
  let n = null, r;
  const o = Ot(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function l(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: d,
      top: f,
      width: u,
      height: m
    } = e.getBoundingClientRect();
    if (s || t(), !u || !m)
      return;
    const p = Mr(f), y = Mr(o.clientWidth - (d + u)), h = Mr(o.clientHeight - (f + m)), b = Mr(d), $ = {
      rootMargin: -p + "px " + -y + "px " + -h + "px " + -b + "px",
      threshold: Xe(0, yt(1, c)) || 1
    };
    let x = !0;
    function P(E) {
      const z = E[0].intersectionRatio;
      if (z !== c) {
        if (!x)
          return l();
        z ? l(!1, z) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...$,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, $);
    }
    n.observe(e);
  }
  return l(!0), i;
}
function $d(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, d = Bi(e), f = o || i ? [...d ? Zn(d) : [], ...Zn(t)] : [];
  f.forEach((w) => {
    o && w.addEventListener("scroll", n, {
      passive: !0
    }), i && w.addEventListener("resize", n);
  });
  const u = d && s ? wx(d, n) : null;
  let m = -1, p = null;
  l && (p = new ResizeObserver((w) => {
    let [$] = w;
    $ && $.target === d && p && (p.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = p) == null || x.observe(t);
    })), n();
  }), d && !c && p.observe(d), p.observe(t));
  let y, h = c ? tn(e) : null;
  c && b();
  function b() {
    const w = tn(e);
    h && (w.x !== h.x || w.y !== h.y || w.width !== h.width || w.height !== h.height) && n(), h = w, y = requestAnimationFrame(b);
  }
  return n(), () => {
    var w;
    f.forEach(($) => {
      o && $.removeEventListener("scroll", n), i && $.removeEventListener("resize", n);
    }), u?.(), (w = p) == null || w.disconnect(), p = null, c && cancelAnimationFrame(y);
  };
}
const $x = ex, Ex = tx, xx = ZE, Mx = rx, Cx = JE, p1 = qE, Px = nx, Sx = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: bx,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return XE(e, t, {
    ...o,
    platform: i
  });
};
var Hr = typeof document < "u" ? En : ye;
function Gr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Gr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Gr(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ed(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function v1(e, t) {
  const n = Ed(e);
  return Math.round(t * n) / n;
}
function g1(e) {
  const t = v.useRef(e);
  return Hr(() => {
    t.current = e;
  }), t;
}
function xd(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: l
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: d
  } = e, [f, u] = v.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, p] = v.useState(r);
  Gr(m, r) || p(r);
  const [y, h] = v.useState(null), [b, w] = v.useState(null), $ = v.useCallback((V) => {
    V !== z.current && (z.current = V, h(V));
  }, []), x = v.useCallback((V) => {
    V !== S.current && (S.current = V, w(V));
  }, []), P = i || y, E = l || b, z = v.useRef(null), S = v.useRef(null), F = v.useRef(f), O = c != null, I = g1(c), L = g1(o), _ = v.useCallback(() => {
    if (!z.current || !S.current)
      return;
    const V = {
      placement: t,
      strategy: n,
      middleware: m
    };
    L.current && (V.platform = L.current), Sx(z.current, S.current, V).then((J) => {
      const T = {
        ...J,
        isPositioned: !0
      };
      ne.current && !Gr(F.current, T) && (F.current = T, ir.flushSync(() => {
        u(T);
      }));
    });
  }, [m, t, n, L]);
  Hr(() => {
    d === !1 && F.current.isPositioned && (F.current.isPositioned = !1, u((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [d]);
  const ne = v.useRef(!1);
  Hr(() => (ne.current = !0, () => {
    ne.current = !1;
  }), []), Hr(() => {
    if (P && (z.current = P), E && (S.current = E), P && E) {
      if (I.current)
        return I.current(P, E, _);
      _();
    }
  }, [P, E, _, I, O]);
  const R = v.useMemo(() => ({
    reference: z,
    floating: S,
    setReference: $,
    setFloating: x
  }), [$, x]), Y = v.useMemo(() => ({
    reference: P,
    floating: E
  }), [P, E]), W = v.useMemo(() => {
    const V = {
      position: n,
      left: 0,
      top: 0
    };
    if (!Y.floating)
      return V;
    const J = v1(Y.floating, f.x), T = v1(Y.floating, f.y);
    return s ? {
      ...V,
      transform: "translate(" + J + "px, " + T + "px)",
      ...Ed(Y.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: J,
      top: T
    };
  }, [n, s, Y.floating, f.x, f.y]);
  return v.useMemo(() => ({
    ...f,
    update: _,
    refs: R,
    elements: Y,
    floatingStyles: W
  }), [f, _, R, Y, W]);
}
const zx = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? p1({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? p1({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Md = (e, t) => ({
  ...$x(e),
  options: [e, t]
}), Cd = (e, t) => ({
  ...Ex(e),
  options: [e, t]
}), Pd = (e, t) => ({
  ...Px(e),
  options: [e, t]
}), Sd = (e, t) => ({
  ...xx(e),
  options: [e, t]
}), zd = (e, t) => ({
  ...Mx(e),
  options: [e, t]
}), Fd = (e, t) => ({
  ...Cx(e),
  options: [e, t]
}), Nd = (e, t) => ({
  ...zx(e),
  options: [e, t]
});
var Fx = "Arrow", Dd = v.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ g(
    me.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ g("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Dd.displayName = Fx;
var Nx = Dd;
function Od(e) {
  const [t, n] = v.useState(void 0);
  return ke(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let l, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          l = d.inlineSize, s = d.blockSize;
        } else
          l = e.offsetWidth, s = e.offsetHeight;
        n({ width: l, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Wi = "Popper", [Ad, pa] = lr(Wi), [Dx, Td] = Ad(Wi), kd = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = v.useState(null);
  return /* @__PURE__ */ g(Dx, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
kd.displayName = Wi;
var Hd = "PopperAnchor", Id = v.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Td(Hd, n), l = v.useRef(null), s = xe(t, l);
    return v.useEffect(() => {
      i.onAnchorChange(r?.current || l.current);
    }), r ? null : /* @__PURE__ */ g(me.div, { ...o, ref: s });
  }
);
Id.displayName = Hd;
var Vi = "PopperContent", [Ox, Ax] = Ad(Vi), Rd = v.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: l = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: d = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: y,
      ...h
    } = e, b = Td(Vi, n), [w, $] = v.useState(null), x = xe(t, (A) => $(A)), [P, E] = v.useState(null), z = Od(P), S = z?.width ?? 0, F = z?.height ?? 0, O = r + (i !== "center" ? "-" + i : ""), I = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, L = Array.isArray(d) ? d : [d], _ = L.length > 0, ne = {
      padding: I,
      boundary: L.filter(kx),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: _
    }, { refs: R, floatingStyles: Y, placement: W, isPositioned: V, middlewareData: J } = xd({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: O,
      whileElementsMounted: (...A) => $d(...A, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        Md({ mainAxis: o + F, alignmentAxis: l }),
        c && Cd({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? Pd() : void 0,
          ...ne
        }),
        c && Sd({ ...ne }),
        zd({
          ...ne,
          apply: ({ elements: A, rects: U, availableWidth: oe, availableHeight: G }) => {
            const { width: ce, height: k } = U.reference, ze = A.floating.style;
            ze.setProperty("--radix-popper-available-width", `${oe}px`), ze.setProperty("--radix-popper-available-height", `${G}px`), ze.setProperty("--radix-popper-anchor-width", `${ce}px`), ze.setProperty("--radix-popper-anchor-height", `${k}px`);
          }
        }),
        P && Nd({ element: P, padding: s }),
        Hx({ arrowWidth: S, arrowHeight: F }),
        m && Fd({ strategy: "referenceHidden", ...ne })
      ]
    }), [T, N] = Bd(W), D = Je(y);
    ke(() => {
      V && D?.();
    }, [V, D]);
    const K = J.arrow?.x, ae = J.arrow?.y, Q = J.arrow?.centerOffset !== 0, [ie, X] = v.useState();
    return ke(() => {
      w && X(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ g(
      "div",
      {
        ref: R.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Y,
          transform: V ? Y.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ie,
          "--radix-popper-transform-origin": [
            J.transformOrigin?.x,
            J.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...J.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ g(
          Ox,
          {
            scope: n,
            placedSide: T,
            onArrowChange: E,
            arrowX: K,
            arrowY: ae,
            shouldHideArrow: Q,
            children: /* @__PURE__ */ g(
              me.div,
              {
                "data-side": T,
                "data-align": N,
                ...h,
                ref: x,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Rd.displayName = Vi;
var _d = "PopperArrow", Tx = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Ld = v.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Ax(_d, r), l = Tx[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ g(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [l]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ g(
          Nx,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Ld.displayName = _d;
function kx(e) {
  return e !== null;
}
var Hx = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: o } = t, l = o.arrow?.centerOffset !== 0, s = l ? 0 : e.arrowWidth, c = l ? 0 : e.arrowHeight, [d, f] = Bd(n), u = { start: "0%", center: "50%", end: "100%" }[f], m = (o.arrow?.x ?? 0) + s / 2, p = (o.arrow?.y ?? 0) + c / 2;
    let y = "", h = "";
    return d === "bottom" ? (y = l ? u : `${m}px`, h = `${-c}px`) : d === "top" ? (y = l ? u : `${m}px`, h = `${r.floating.height + c}px`) : d === "right" ? (y = `${-c}px`, h = l ? u : `${p}px`) : d === "left" && (y = `${r.floating.width + c}px`, h = l ? u : `${p}px`), { data: { x: y, y: h } };
  }
});
function Bd(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var ji = kd, Wd = Id, Vd = Rd, jd = Ld, Ix = "Portal", va = v.forwardRef((e, t) => {
  const { container: n, ...r } = e, [o, i] = v.useState(!1);
  ke(() => i(!0), []);
  const l = n || o && globalThis?.document?.body;
  return l ? qs.createPortal(/* @__PURE__ */ g(me.div, { ...r, ref: t }), l) : null;
});
va.displayName = Ix;
function Rx(e, t) {
  return v.useReducer((n, r) => t[n][r] ?? n, e);
}
var Gt = (e) => {
  const { present: t, children: n } = e, r = _x(t), o = typeof n == "function" ? n({ present: r.isPresent }) : v.Children.only(n), i = xe(r.ref, Lx(o));
  return typeof n == "function" || r.isPresent ? v.cloneElement(o, { ref: i }) : null;
};
Gt.displayName = "Presence";
function _x(e) {
  const [t, n] = v.useState(), r = v.useRef({}), o = v.useRef(e), i = v.useRef("none"), l = e ? "mounted" : "unmounted", [s, c] = Rx(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const d = Cr(r.current);
    i.current = s === "mounted" ? d : "none";
  }, [s]), ke(() => {
    const d = r.current, f = o.current;
    if (f !== e) {
      const m = i.current, p = Cr(d);
      e ? c("MOUNT") : p === "none" || d?.display === "none" ? c("UNMOUNT") : c(f && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), ke(() => {
    if (t) {
      let d;
      const f = t.ownerDocument.defaultView ?? window, u = (p) => {
        const h = Cr(r.current).includes(p.animationName);
        if (p.target === t && h && (c("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, m = (p) => {
        p.target === t && (i.current = Cr(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        f.clearTimeout(d), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: v.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Cr(e) {
  return e?.animationName || "none";
}
function Lx(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var to = "rovingFocusGroup.onEntryFocus", Bx = { bubbles: !1, cancelable: !0 }, ga = "RovingFocusGroup", [Oo, Gd, Wx] = oa(ga), [Vx, Yd] = lr(
  ga,
  [Wx]
), [jx, Gx] = Vx(ga), Ud = v.forwardRef(
  (e, t) => /* @__PURE__ */ g(Oo.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(Oo.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(Yx, { ...e, ref: t }) }) })
);
Ud.displayName = ga;
var Yx = v.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: l,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: d,
    preventScrollOnEntryFocus: f = !1,
    ...u
  } = e, m = v.useRef(null), p = xe(t, m), y = ia(i), [h = null, b] = bt({
    prop: l,
    defaultProp: s,
    onChange: c
  }), [w, $] = v.useState(!1), x = Je(d), P = Gd(n), E = v.useRef(!1), [z, S] = v.useState(0);
  return v.useEffect(() => {
    const F = m.current;
    if (F)
      return F.addEventListener(to, x), () => F.removeEventListener(to, x);
  }, [x]), /* @__PURE__ */ g(
    jx,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: o,
      currentTabStopId: h,
      onItemFocus: v.useCallback(
        (F) => b(F),
        [b]
      ),
      onItemShiftTab: v.useCallback(() => $(!0), []),
      onFocusableItemAdd: v.useCallback(
        () => S((F) => F + 1),
        []
      ),
      onFocusableItemRemove: v.useCallback(
        () => S((F) => F - 1),
        []
      ),
      children: /* @__PURE__ */ g(
        me.div,
        {
          tabIndex: w || z === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: ee(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: ee(e.onFocus, (F) => {
            const O = !E.current;
            if (F.target === F.currentTarget && O && !w) {
              const I = new CustomEvent(to, Bx);
              if (F.currentTarget.dispatchEvent(I), !I.defaultPrevented) {
                const L = P().filter((W) => W.focusable), _ = L.find((W) => W.active), ne = L.find((W) => W.id === h), Y = [_, ne, ...L].filter(
                  Boolean
                ).map((W) => W.ref.current);
                qd(Y, f);
              }
            }
            E.current = !1;
          }),
          onBlur: ee(e.onBlur, () => $(!1))
        }
      )
    }
  );
}), Kd = "RovingFocusGroupItem", Xd = v.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...l
    } = e, s = qe(), c = i || s, d = Gx(Kd, n), f = d.currentTabStopId === c, u = Gd(n), { onFocusableItemAdd: m, onFocusableItemRemove: p } = d;
    return v.useEffect(() => {
      if (r)
        return m(), () => p();
    }, [r, m, p]), /* @__PURE__ */ g(
      Oo.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ g(
          me.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...l,
            ref: t,
            onMouseDown: ee(e.onMouseDown, (y) => {
              r ? d.onItemFocus(c) : y.preventDefault();
            }),
            onFocus: ee(e.onFocus, () => d.onItemFocus(c)),
            onKeyDown: ee(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const h = Xx(y, d.orientation, d.dir);
              if (h !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let w = u().filter(($) => $.focusable).map(($) => $.ref.current);
                if (h === "last") w.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && w.reverse();
                  const $ = w.indexOf(y.currentTarget);
                  w = d.loop ? qx(w, $ + 1) : w.slice($ + 1);
                }
                setTimeout(() => qd(w));
              }
            })
          }
        )
      }
    );
  }
);
Xd.displayName = Kd;
var Ux = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Kx(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Xx(e, t, n) {
  const r = Kx(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Ux[r];
}
function qd(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function qx(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Zx = Ud, Jx = Xd, Qx = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, dn = /* @__PURE__ */ new WeakMap(), Pr = /* @__PURE__ */ new WeakMap(), Sr = {}, no = 0, Zd = function(e) {
  return e && (e.host || Zd(e.parentNode));
}, eM = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Zd(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, tM = function(e, t, n, r) {
  var o = eM(t, Array.isArray(e) ? e : [e]);
  Sr[n] || (Sr[n] = /* @__PURE__ */ new WeakMap());
  var i = Sr[n], l = [], s = /* @__PURE__ */ new Set(), c = new Set(o), d = function(u) {
    !u || s.has(u) || (s.add(u), d(u.parentNode));
  };
  o.forEach(d);
  var f = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(m) {
      if (s.has(m))
        f(m);
      else
        try {
          var p = m.getAttribute(r), y = p !== null && p !== "false", h = (dn.get(m) || 0) + 1, b = (i.get(m) || 0) + 1;
          dn.set(m, h), i.set(m, b), l.push(m), h === 1 && y && Pr.set(m, !0), b === 1 && m.setAttribute(n, "true"), y || m.setAttribute(r, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", m, w);
        }
    });
  };
  return f(t), s.clear(), no++, function() {
    l.forEach(function(u) {
      var m = dn.get(u) - 1, p = i.get(u) - 1;
      dn.set(u, m), i.set(u, p), m || (Pr.has(u) || u.removeAttribute(r), Pr.delete(u)), p || u.removeAttribute(n);
    }), no--, no || (dn = /* @__PURE__ */ new WeakMap(), dn = /* @__PURE__ */ new WeakMap(), Pr = /* @__PURE__ */ new WeakMap(), Sr = {});
  };
}, ya = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Qx(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), tM(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, _e = function() {
  return _e = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, _e.apply(this, arguments);
};
function Gi(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Jd(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Gn = "right-scroll-bar-position", Yn = "width-before-scroll-bar", nM = "with-scroll-bars-hidden", rM = "--removed-body-scroll-bar-size";
function ro(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function aM(e, t) {
  var n = Ce(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var oM = typeof window < "u" ? v.useLayoutEffect : v.useEffect, y1 = /* @__PURE__ */ new WeakMap();
function Qd(e, t) {
  var n = aM(null, function(r) {
    return e.forEach(function(o) {
      return ro(o, r);
    });
  });
  return oM(function() {
    var r = y1.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), l = n.current;
      o.forEach(function(s) {
        i.has(s) || ro(s, null);
      }), i.forEach(function(s) {
        o.has(s) || ro(s, l);
      });
    }
    y1.set(n, e);
  }, [e]), n;
}
function iM(e) {
  return e;
}
function lM(e, t) {
  t === void 0 && (t = iM);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var l = t(i, r);
      return n.push(l), function() {
        n = n.filter(function(s) {
          return s !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var l = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), l = n;
      }
      var c = function() {
        var f = l;
        l = [], f.forEach(i);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(f) {
          l.push(f), d();
        },
        filter: function(f) {
          return l = l.filter(f), n;
        }
      };
    }
  };
  return o;
}
function e2(e) {
  e === void 0 && (e = {});
  var t = lM(null);
  return t.options = _e({ async: !0, ssr: !1 }, e), t;
}
var t2 = function(e) {
  var t = e.sideCar, n = Gi(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return v.createElement(r, _e({}, n));
};
t2.isSideCarExport = !0;
function n2(e, t) {
  return e.useMedium(t), t2;
}
var r2 = e2(), ao = function() {
}, ba = v.forwardRef(function(e, t) {
  var n = v.useRef(null), r = v.useState({
    onScrollCapture: ao,
    onWheelCapture: ao,
    onTouchMoveCapture: ao
  }), o = r[0], i = r[1], l = e.forwardProps, s = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, u = e.shards, m = e.sideCar, p = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, $ = e.gapMode, x = Gi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = m, E = Qd([n, t]), z = _e(_e({}, x), o);
  return v.createElement(
    v.Fragment,
    null,
    f && v.createElement(P, { sideCar: r2, removeScrollBar: d, shards: u, noIsolation: p, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: $ }),
    l ? v.cloneElement(v.Children.only(s), _e(_e({}, z), { ref: E })) : v.createElement(w, _e({}, z, { className: c, ref: E }), s)
  );
});
ba.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ba.classNames = {
  fullWidth: Yn,
  zeroRight: Gn
};
var sM = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function cM() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = sM();
  return t && e.setAttribute("nonce", t), e;
}
function dM(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function uM(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var fM = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = cM()) && (dM(t, n), uM(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, hM = function() {
  var e = fM();
  return function(t, n) {
    v.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Yi = function() {
  var e = hM(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, mM = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, oo = function(e) {
  return parseInt(e || "", 10) || 0;
}, pM = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [oo(n), oo(r), oo(o)];
}, vM = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return mM;
  var t = pM(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, gM = Yi(), wn = "data-scroll-locked", yM = function(e, t, n, r) {
  var o = e.left, i = e.top, l = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(nM, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(wn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Gn, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Yn, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Gn, " .").concat(Gn, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Yn, " .").concat(Yn, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(wn, `] {
    `).concat(rM, ": ").concat(s, `px;
  }
`);
}, b1 = function() {
  var e = parseInt(document.body.getAttribute(wn) || "0", 10);
  return isFinite(e) ? e : 0;
}, bM = function() {
  v.useEffect(function() {
    return document.body.setAttribute(wn, (b1() + 1).toString()), function() {
      var e = b1() - 1;
      e <= 0 ? document.body.removeAttribute(wn) : document.body.setAttribute(wn, e.toString());
    };
  }, []);
}, a2 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  bM();
  var i = v.useMemo(function() {
    return vM(o);
  }, [o]);
  return v.createElement(gM, { styles: yM(i, !t, o, n ? "" : "!important") });
}, Ao = !1;
if (typeof window < "u")
  try {
    var zr = Object.defineProperty({}, "passive", {
      get: function() {
        return Ao = !0, !0;
      }
    });
    window.addEventListener("test", zr, zr), window.removeEventListener("test", zr, zr);
  } catch {
    Ao = !1;
  }
var un = Ao ? { passive: !1 } : !1, wM = function(e) {
  return e.tagName === "TEXTAREA";
}, o2 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !wM(e) && n[t] === "visible")
  );
}, $M = function(e) {
  return o2(e, "overflowY");
}, EM = function(e) {
  return o2(e, "overflowX");
}, w1 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = i2(e, r);
    if (o) {
      var i = l2(e, r), l = i[1], s = i[2];
      if (l > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, xM = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, MM = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, i2 = function(e, t) {
  return e === "v" ? $M(t) : EM(t);
}, l2 = function(e, t) {
  return e === "v" ? xM(t) : MM(t);
}, CM = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, PM = function(e, t, n, r, o) {
  var i = CM(e, window.getComputedStyle(t).direction), l = i * r, s = n.target, c = t.contains(s), d = !1, f = l > 0, u = 0, m = 0;
  do {
    var p = l2(e, s), y = p[0], h = p[1], b = p[2], w = h - b - i * y;
    (y || w) && i2(e, s) && (u += w, m += y), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (f && Math.abs(u) < 1 || !f && Math.abs(m) < 1) && (d = !0), d;
}, Fr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, $1 = function(e) {
  return [e.deltaX, e.deltaY];
}, E1 = function(e) {
  return e && "current" in e ? e.current : e;
}, SM = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, zM = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, FM = 0, fn = [];
function NM(e) {
  var t = v.useRef([]), n = v.useRef([0, 0]), r = v.useRef(), o = v.useState(FM++)[0], i = v.useState(Yi)[0], l = v.useRef(e);
  v.useEffect(function() {
    l.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = Jd([e.lockRef.current], (e.shards || []).map(E1), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = v.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !l.current.allowPinchZoom;
    var w = Fr(h), $ = n.current, x = "deltaX" in h ? h.deltaX : $[0] - w[0], P = "deltaY" in h ? h.deltaY : $[1] - w[1], E, z = h.target, S = Math.abs(x) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && S === "h" && z.type === "range")
      return !1;
    var F = w1(S, z);
    if (!F)
      return !0;
    if (F ? E = S : (E = S === "v" ? "h" : "v", F = w1(S, z)), !F)
      return !1;
    if (!r.current && "changedTouches" in h && (x || P) && (r.current = E), !E)
      return !0;
    var O = r.current || E;
    return PM(O, b, h, O === "h" ? x : P);
  }, []), c = v.useCallback(function(h) {
    var b = h;
    if (!(!fn.length || fn[fn.length - 1] !== i)) {
      var w = "deltaY" in b ? $1(b) : Fr(b), $ = t.current.filter(function(E) {
        return E.name === b.type && (E.target === b.target || b.target === E.shadowParent) && SM(E.delta, w);
      })[0];
      if ($ && $.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!$) {
        var x = (l.current.shards || []).map(E1).filter(Boolean).filter(function(E) {
          return E.contains(b.target);
        }), P = x.length > 0 ? s(b, x[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), d = v.useCallback(function(h, b, w, $) {
    var x = { name: h, delta: b, target: w, should: $, shadowParent: DM(w) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== x;
      });
    }, 1);
  }, []), f = v.useCallback(function(h) {
    n.current = Fr(h), r.current = void 0;
  }, []), u = v.useCallback(function(h) {
    d(h.type, $1(h), h.target, s(h, e.lockRef.current));
  }, []), m = v.useCallback(function(h) {
    d(h.type, Fr(h), h.target, s(h, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return fn.push(i), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", c, un), document.addEventListener("touchmove", c, un), document.addEventListener("touchstart", f, un), function() {
      fn = fn.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", c, un), document.removeEventListener("touchmove", c, un), document.removeEventListener("touchstart", f, un);
    };
  }, []);
  var p = e.removeScrollBar, y = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    y ? v.createElement(i, { styles: zM(o) }) : null,
    p ? v.createElement(a2, { gapMode: e.gapMode }) : null
  );
}
function DM(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const OM = n2(r2, NM);
var wa = v.forwardRef(function(e, t) {
  return v.createElement(ba, _e({}, e, { ref: t, sideCar: OM }));
});
wa.classNames = ba.classNames;
var To = ["Enter", " "], AM = ["ArrowDown", "PageUp", "Home"], s2 = ["ArrowUp", "PageDown", "End"], TM = [...AM, ...s2], kM = {
  ltr: [...To, "ArrowRight"],
  rtl: [...To, "ArrowLeft"]
}, HM = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, hr = "Menu", [Jn, IM, RM] = oa(hr), [an, c2] = ur(hr, [
  RM,
  pa,
  Yd
]), mr = pa(), d2 = Yd(), [u2, Yt] = an(hr), [_M, pr] = an(hr), f2 = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: l = !0 } = e, s = mr(t), [c, d] = v.useState(null), f = v.useRef(!1), u = Je(i), m = ia(o);
  return v.useEffect(() => {
    const p = () => {
      f.current = !0, document.addEventListener("pointerdown", y, { capture: !0, once: !0 }), document.addEventListener("pointermove", y, { capture: !0, once: !0 });
    }, y = () => f.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", y, { capture: !0 }), document.removeEventListener("pointermove", y, { capture: !0 });
    };
  }, []), /* @__PURE__ */ g(ji, { ...s, children: /* @__PURE__ */ g(
    u2,
    {
      scope: t,
      open: n,
      onOpenChange: u,
      content: c,
      onContentChange: d,
      children: /* @__PURE__ */ g(
        _M,
        {
          scope: t,
          onClose: v.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: f,
          dir: m,
          modal: l,
          children: r
        }
      )
    }
  ) });
};
f2.displayName = hr;
var LM = "MenuAnchor", Ui = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = mr(n);
    return /* @__PURE__ */ g(Wd, { ...o, ...r, ref: t });
  }
);
Ui.displayName = LM;
var Ki = "MenuPortal", [BM, h2] = an(Ki, {
  forceMount: void 0
}), m2 = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = Yt(Ki, t);
  return /* @__PURE__ */ g(BM, { scope: t, forceMount: n, children: /* @__PURE__ */ g(Gt, { present: n || i.open, children: /* @__PURE__ */ g(va, { asChild: !0, container: o, children: r }) }) });
};
m2.displayName = Ki;
var nt = "MenuContent", [WM, Xi] = an(nt), p2 = v.forwardRef(
  (e, t) => {
    const n = h2(nt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = Yt(nt, e.__scopeMenu), l = pr(nt, e.__scopeMenu);
    return /* @__PURE__ */ g(Jn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ g(Gt, { present: r || i.open, children: /* @__PURE__ */ g(Jn.Slot, { scope: e.__scopeMenu, children: l.modal ? /* @__PURE__ */ g(VM, { ...o, ref: t }) : /* @__PURE__ */ g(jM, { ...o, ref: t }) }) }) });
  }
), VM = v.forwardRef(
  (e, t) => {
    const n = Yt(nt, e.__scopeMenu), r = v.useRef(null), o = xe(t, r);
    return v.useEffect(() => {
      const i = r.current;
      if (i) return ya(i);
    }, []), /* @__PURE__ */ g(
      qi,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: ee(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), jM = v.forwardRef((e, t) => {
  const n = Yt(nt, e.__scopeMenu);
  return /* @__PURE__ */ g(
    qi,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), qi = v.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: l,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: d,
      onPointerDownOutside: f,
      onFocusOutside: u,
      onInteractOutside: m,
      onDismiss: p,
      disableOutsideScroll: y,
      ...h
    } = e, b = Yt(nt, n), w = pr(nt, n), $ = mr(n), x = d2(n), P = IM(n), [E, z] = v.useState(null), S = v.useRef(null), F = xe(t, S, b.onContentChange), O = v.useRef(0), I = v.useRef(""), L = v.useRef(0), _ = v.useRef(null), ne = v.useRef("right"), R = v.useRef(0), Y = y ? wa : v.Fragment, W = y ? { as: en, allowPinchZoom: !0 } : void 0, V = (T) => {
      const N = I.current + T, D = P().filter((A) => !A.disabled), K = document.activeElement, ae = D.find((A) => A.ref.current === K)?.textValue, Q = D.map((A) => A.textValue), ie = nC(Q, N, ae), X = D.find((A) => A.textValue === ie)?.ref.current;
      (function A(U) {
        I.current = U, window.clearTimeout(O.current), U !== "" && (O.current = window.setTimeout(() => A(""), 1e3));
      })(N), X && setTimeout(() => X.focus());
    };
    v.useEffect(() => () => window.clearTimeout(O.current), []), ki();
    const J = v.useCallback((T) => ne.current === _.current?.side && aC(T, _.current?.area), []);
    return /* @__PURE__ */ g(
      WM,
      {
        scope: n,
        searchRef: I,
        onItemEnter: v.useCallback(
          (T) => {
            J(T) && T.preventDefault();
          },
          [J]
        ),
        onItemLeave: v.useCallback(
          (T) => {
            J(T) || (S.current?.focus(), z(null));
          },
          [J]
        ),
        onTriggerLeave: v.useCallback(
          (T) => {
            J(T) && T.preventDefault();
          },
          [J]
        ),
        pointerGraceTimerRef: L,
        onPointerGraceIntentChange: v.useCallback((T) => {
          _.current = T;
        }, []),
        children: /* @__PURE__ */ g(Y, { ...W, children: /* @__PURE__ */ g(
          fa,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: ee(i, (T) => {
              T.preventDefault(), S.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: l,
            children: /* @__PURE__ */ g(
              ua,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: d,
                onPointerDownOutside: f,
                onFocusOutside: u,
                onInteractOutside: m,
                onDismiss: p,
                children: /* @__PURE__ */ g(
                  Zx,
                  {
                    asChild: !0,
                    ...x,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: E,
                    onCurrentTabStopIdChange: z,
                    onEntryFocus: ee(c, (T) => {
                      w.isUsingKeyboardRef.current || T.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ g(
                      Vd,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": O2(b.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...$,
                        ...h,
                        ref: F,
                        style: { outline: "none", ...h.style },
                        onKeyDown: ee(h.onKeyDown, (T) => {
                          const D = T.target.closest("[data-radix-menu-content]") === T.currentTarget, K = T.ctrlKey || T.altKey || T.metaKey, ae = T.key.length === 1;
                          D && (T.key === "Tab" && T.preventDefault(), !K && ae && V(T.key));
                          const Q = S.current;
                          if (T.target !== Q || !TM.includes(T.key)) return;
                          T.preventDefault();
                          const X = P().filter((A) => !A.disabled).map((A) => A.ref.current);
                          s2.includes(T.key) && X.reverse(), eC(X);
                        }),
                        onBlur: ee(e.onBlur, (T) => {
                          T.currentTarget.contains(T.target) || (window.clearTimeout(O.current), I.current = "");
                        }),
                        onPointerMove: ee(
                          e.onPointerMove,
                          Qn((T) => {
                            const N = T.target, D = R.current !== T.clientX;
                            if (T.currentTarget.contains(N) && D) {
                              const K = T.clientX > R.current ? "right" : "left";
                              ne.current = K, R.current = T.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
p2.displayName = nt;
var GM = "MenuGroup", Zi = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ g(me.div, { role: "group", ...r, ref: t });
  }
);
Zi.displayName = GM;
var YM = "MenuLabel", v2 = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ g(me.div, { ...r, ref: t });
  }
);
v2.displayName = YM;
var Yr = "MenuItem", x1 = "menu.itemSelect", $a = v.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = v.useRef(null), l = pr(Yr, e.__scopeMenu), s = Xi(Yr, e.__scopeMenu), c = xe(t, i), d = v.useRef(!1), f = () => {
      const u = i.current;
      if (!n && u) {
        const m = new CustomEvent(x1, { bubbles: !0, cancelable: !0 });
        u.addEventListener(x1, (p) => r?.(p), { once: !0 }), ec(u, m), m.defaultPrevented ? d.current = !1 : l.onClose();
      }
    };
    return /* @__PURE__ */ g(
      g2,
      {
        ...o,
        ref: c,
        disabled: n,
        onClick: ee(e.onClick, f),
        onPointerDown: (u) => {
          e.onPointerDown?.(u), d.current = !0;
        },
        onPointerUp: ee(e.onPointerUp, (u) => {
          d.current || u.currentTarget?.click();
        }),
        onKeyDown: ee(e.onKeyDown, (u) => {
          const m = s.searchRef.current !== "";
          n || m && u.key === " " || To.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
$a.displayName = Yr;
var g2 = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, l = Xi(Yr, n), s = d2(n), c = v.useRef(null), d = xe(t, c), [f, u] = v.useState(!1), [m, p] = v.useState("");
    return v.useEffect(() => {
      const y = c.current;
      y && p((y.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ g(
      Jn.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? m,
        children: /* @__PURE__ */ g(Jx, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ g(
          me.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: d,
            onPointerMove: ee(
              e.onPointerMove,
              Qn((y) => {
                r ? l.onItemLeave(y) : (l.onItemEnter(y), y.defaultPrevented || y.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ee(
              e.onPointerLeave,
              Qn((y) => l.onItemLeave(y))
            ),
            onFocus: ee(e.onFocus, () => u(!0)),
            onBlur: ee(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), UM = "MenuCheckboxItem", y2 = v.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ g(x2, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ g(
      $a,
      {
        role: "menuitemcheckbox",
        "aria-checked": Ur(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": el(n),
        onSelect: ee(
          o.onSelect,
          () => r?.(Ur(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
y2.displayName = UM;
var b2 = "MenuRadioGroup", [KM, XM] = an(
  b2,
  { value: void 0, onValueChange: () => {
  } }
), w2 = v.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = Je(r);
    return /* @__PURE__ */ g(KM, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ g(Zi, { ...o, ref: t }) });
  }
);
w2.displayName = b2;
var $2 = "MenuRadioItem", E2 = v.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = XM($2, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ g(x2, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ g(
      $a,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": el(i),
        onSelect: ee(
          r.onSelect,
          () => o.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
E2.displayName = $2;
var Ji = "MenuItemIndicator", [x2, qM] = an(
  Ji,
  { checked: !1 }
), M2 = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = qM(Ji, n);
    return /* @__PURE__ */ g(
      Gt,
      {
        present: r || Ur(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ g(
          me.span,
          {
            ...o,
            ref: t,
            "data-state": el(i.checked)
          }
        )
      }
    );
  }
);
M2.displayName = Ji;
var ZM = "MenuSeparator", C2 = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ g(
      me.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
C2.displayName = ZM;
var JM = "MenuArrow", P2 = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = mr(n);
    return /* @__PURE__ */ g(jd, { ...o, ...r, ref: t });
  }
);
P2.displayName = JM;
var Qi = "MenuSub", [QM, S2] = an(Qi), z2 = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = Yt(Qi, t), l = mr(t), [s, c] = v.useState(null), [d, f] = v.useState(null), u = Je(o);
  return v.useEffect(() => (i.open === !1 && u(!1), () => u(!1)), [i.open, u]), /* @__PURE__ */ g(ji, { ...l, children: /* @__PURE__ */ g(
    u2,
    {
      scope: t,
      open: r,
      onOpenChange: u,
      content: d,
      onContentChange: f,
      children: /* @__PURE__ */ g(
        QM,
        {
          scope: t,
          contentId: qe(),
          triggerId: qe(),
          trigger: s,
          onTriggerChange: c,
          children: n
        }
      )
    }
  ) });
};
z2.displayName = Qi;
var Vn = "MenuSubTrigger", F2 = v.forwardRef(
  (e, t) => {
    const n = Yt(Vn, e.__scopeMenu), r = pr(Vn, e.__scopeMenu), o = S2(Vn, e.__scopeMenu), i = Xi(Vn, e.__scopeMenu), l = v.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = i, d = { __scopeMenu: e.__scopeMenu }, f = v.useCallback(() => {
      l.current && window.clearTimeout(l.current), l.current = null;
    }, []);
    return v.useEffect(() => f, [f]), v.useEffect(() => {
      const u = s.current;
      return () => {
        window.clearTimeout(u), c(null);
      };
    }, [s, c]), /* @__PURE__ */ g(Ui, { asChild: !0, ...d, children: /* @__PURE__ */ g(
      g2,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": O2(n.open),
        ...e,
        ref: aa(t, o.onTriggerChange),
        onClick: (u) => {
          e.onClick?.(u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: ee(
          e.onPointerMove,
          Qn((u) => {
            i.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !l.current && (i.onPointerGraceIntentChange(null), l.current = window.setTimeout(() => {
              n.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: ee(
          e.onPointerLeave,
          Qn((u) => {
            f();
            const m = n.content?.getBoundingClientRect();
            if (m) {
              const p = n.content?.dataset.side, y = p === "right", h = y ? -5 : 5, b = m[y ? "left" : "right"], w = m[y ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + h, y: u.clientY },
                  { x: b, y: m.top },
                  { x: w, y: m.top },
                  { x: w, y: m.bottom },
                  { x: b, y: m.bottom }
                ],
                side: p
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(u), u.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ee(e.onKeyDown, (u) => {
          const m = i.searchRef.current !== "";
          e.disabled || m && u.key === " " || kM[r.dir].includes(u.key) && (n.onOpenChange(!0), n.content?.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
F2.displayName = Vn;
var N2 = "MenuSubContent", D2 = v.forwardRef(
  (e, t) => {
    const n = h2(nt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = Yt(nt, e.__scopeMenu), l = pr(nt, e.__scopeMenu), s = S2(N2, e.__scopeMenu), c = v.useRef(null), d = xe(t, c);
    return /* @__PURE__ */ g(Jn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ g(Gt, { present: r || i.open, children: /* @__PURE__ */ g(Jn.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ g(
      qi,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: d,
        align: "start",
        side: l.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          l.isUsingKeyboardRef.current && c.current?.focus(), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: ee(e.onFocusOutside, (f) => {
          f.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: ee(e.onEscapeKeyDown, (f) => {
          l.onClose(), f.preventDefault();
        }),
        onKeyDown: ee(e.onKeyDown, (f) => {
          const u = f.currentTarget.contains(f.target), m = HM[l.dir].includes(f.key);
          u && m && (i.onOpenChange(!1), s.trigger?.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
D2.displayName = N2;
function O2(e) {
  return e ? "open" : "closed";
}
function Ur(e) {
  return e === "indeterminate";
}
function el(e) {
  return Ur(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function eC(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function tC(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function nC(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let l = tC(e, Math.max(i, 0));
  o.length === 1 && (l = l.filter((d) => d !== n));
  const c = l.find(
    (d) => d.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function rC(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, l = t.length - 1; i < t.length; l = i++) {
    const s = t[i].x, c = t[i].y, d = t[l].x, f = t[l].y;
    c > r != f > r && n < (d - s) * (r - c) / (f - c) + s && (o = !o);
  }
  return o;
}
function aC(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return rC(n, t);
}
function Qn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var oC = f2, iC = Ui, lC = m2, sC = p2, cC = Zi, dC = v2, uC = $a, fC = y2, hC = w2, mC = E2, pC = M2, vC = C2, gC = P2, yC = z2, bC = F2, wC = D2, tl = "DropdownMenu", [$C] = ur(
  tl,
  [c2]
), Be = c2(), [EC, A2] = $C(tl), T2 = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: l,
    modal: s = !0
  } = e, c = Be(t), d = v.useRef(null), [f = !1, u] = bt({
    prop: o,
    defaultProp: i,
    onChange: l
  });
  return /* @__PURE__ */ g(
    EC,
    {
      scope: t,
      triggerId: qe(),
      triggerRef: d,
      contentId: qe(),
      open: f,
      onOpenChange: u,
      onOpenToggle: v.useCallback(() => u((m) => !m), [u]),
      modal: s,
      children: /* @__PURE__ */ g(oC, { ...c, open: f, onOpenChange: u, dir: r, modal: s, children: n })
    }
  );
};
T2.displayName = tl;
var k2 = "DropdownMenuTrigger", H2 = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = A2(k2, n), l = Be(n);
    return /* @__PURE__ */ g(iC, { asChild: !0, ...l, children: /* @__PURE__ */ g(
      me.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: aa(t, i.triggerRef),
        onPointerDown: ee(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: ee(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
H2.displayName = k2;
var xC = "DropdownMenuPortal", I2 = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Be(t);
  return /* @__PURE__ */ g(lC, { ...r, ...n });
};
I2.displayName = xC;
var R2 = "DropdownMenuContent", _2 = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = A2(R2, n), i = Be(n), l = v.useRef(!1);
    return /* @__PURE__ */ g(
      sC,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: ee(e.onCloseAutoFocus, (s) => {
          l.current || o.triggerRef.current?.focus(), l.current = !1, s.preventDefault();
        }),
        onInteractOutside: ee(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, d = c.button === 0 && c.ctrlKey === !0, f = c.button === 2 || d;
          (!o.modal || f) && (l.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
_2.displayName = R2;
var MC = "DropdownMenuGroup", L2 = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
    return /* @__PURE__ */ g(cC, { ...o, ...r, ref: t });
  }
);
L2.displayName = MC;
var CC = "DropdownMenuLabel", B2 = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
    return /* @__PURE__ */ g(dC, { ...o, ...r, ref: t });
  }
);
B2.displayName = CC;
var PC = "DropdownMenuItem", W2 = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
    return /* @__PURE__ */ g(uC, { ...o, ...r, ref: t });
  }
);
W2.displayName = PC;
var SC = "DropdownMenuCheckboxItem", zC = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
  return /* @__PURE__ */ g(fC, { ...o, ...r, ref: t });
});
zC.displayName = SC;
var FC = "DropdownMenuRadioGroup", V2 = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
  return /* @__PURE__ */ g(hC, { ...o, ...r, ref: t });
});
V2.displayName = FC;
var NC = "DropdownMenuRadioItem", DC = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
  return /* @__PURE__ */ g(mC, { ...o, ...r, ref: t });
});
DC.displayName = NC;
var OC = "DropdownMenuItemIndicator", AC = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
  return /* @__PURE__ */ g(pC, { ...o, ...r, ref: t });
});
AC.displayName = OC;
var TC = "DropdownMenuSeparator", j2 = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
  return /* @__PURE__ */ g(vC, { ...o, ...r, ref: t });
});
j2.displayName = TC;
var kC = "DropdownMenuArrow", HC = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
    return /* @__PURE__ */ g(gC, { ...o, ...r, ref: t });
  }
);
HC.displayName = kC;
var IC = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, l = Be(t), [s = !1, c] = bt({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ g(yC, { ...l, open: s, onOpenChange: c, children: n });
}, RC = "DropdownMenuSubTrigger", G2 = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
  return /* @__PURE__ */ g(bC, { ...o, ...r, ref: t });
});
G2.displayName = RC;
var _C = "DropdownMenuSubContent", Y2 = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Be(n);
  return /* @__PURE__ */ g(
    wC,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Y2.displayName = _C;
var LC = T2, U2 = H2, nl = I2, K2 = _2, BC = L2, X2 = B2, q2 = W2, WC = V2, Z2 = j2, VC = IC, J2 = G2, Q2 = Y2;
const F_ = BC, N_ = nl, D_ = WC, O_ = VC, A_ = (e) => /* @__PURE__ */ g(LC, { modal: !1, ...e }), jC = v.forwardRef((e, t) => /* @__PURE__ */ g(U2, { ref: t, className: "focus-visible:outline-none", ...e }));
jC.displayName = U2.displayName;
const GC = v.forwardRef(({ align: e, className: t, ...n }, r) => /* @__PURE__ */ g(nl, { children: /* @__PURE__ */ g(
  K2,
  {
    ref: r,
    align: e ?? "start",
    className: j(
      "z-10 mt-2 rounded-md bg-white py-2 text-base font-normal text-text-primary shadow-[0px_1px_3px_0px_rgba(166,175,195,0.4)] ring-1 ring-[rgba(166,175,195,0.1)]",
      t
    ),
    ...n
  }
) }));
GC.displayName = K2.displayName;
const YC = v.forwardRef(({ className: e, selected: t, ...n }, r) => /* @__PURE__ */ g(
  q2,
  {
    ref: r,
    className: j(
      "flex cursor-pointer select-none items-center border-l-4 border-transparent py-2 pl-4 pr-5 text-text-primary outline-none transition-colors duration-200 data-[disabled]:pointer-events-none data-[highlighted]:bg-lightBlue-50 data-[disabled]:opacity-38",
      { "border-lightBlue-500 bg-lightBlue-50": t },
      e
    ),
    ...n
  }
));
YC.displayName = q2.displayName;
const UC = v.forwardRef((e, t) => /* @__PURE__ */ g(X2, { ref: t, className: "px-5 py-2 text-sm text-text-secondary", ...e }));
UC.displayName = X2.displayName;
const KC = v.forwardRef((e, t) => /* @__PURE__ */ g(Z2, { ref: t, className: "my-2 h-[0.5px] bg-stroke", ...e }));
KC.displayName = Z2.displayName;
const XC = v.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ re(
  J2,
  {
    ref: r,
    className: j(
      "flex cursor-pointer items-center justify-between gap-2 px-5 py-2 text-text-primary outline-none transition-colors duration-200 data-[highlighted]:bg-lightBlue-50 data-[highlighted]:data-[state=open]:bg-lightBlue-50 data-[state=open]:bg-lightBlue-100",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ g(t6, { className: "size-4 fill-text-secondary" })
    ]
  }
));
XC.displayName = J2.displayName;
const qC = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ g(nl, { children: /* @__PURE__ */ g(
  Q2,
  {
    ref: n,
    className: j(
      "z-20 rounded-md bg-white py-2 text-base font-normal text-text-primary shadow-[0px_1px_3px_0px_rgba(166,175,195,0.4)] ring-1 ring-[rgba(166,175,195,0.1)]",
      e
    ),
    ...t
  }
) }));
qC.displayName = Q2.displayName;
const ZC = Se(["text-sm", "text-text-secondary"], {
  variants: {
    disabled: { true: ["opacity-38"] },
    variant: {
      error: ["text-red-600"],
      success: ["text-success-500"]
    }
  },
  compoundVariants: [
    {
      variant: "error",
      disabled: !0,
      class: ["opacity-38", "text-text-secondary"]
    },
    {
      variant: "success",
      disabled: !0,
      class: ["opacity-38", "text-text-secondary"]
    }
  ]
}), T_ = ({ children: e, disabled: t, variant: n }) => /* @__PURE__ */ g("div", { className: j(ZC({ disabled: t, variant: n })), children: e }), k_ = de(function({
  as: t,
  className: n,
  dark: r = !1,
  disabled: o = !1,
  icon: i,
  inverse: l = !1,
  name: s,
  size: c = "md",
  variant: d = "primary",
  ...f
}, u) {
  const m = `${d}${l ? "-inverse" : ""}`, p = Dc({ className: n, dark: r, inverse: l, size: c, variant: d }), y = /* @__PURE__ */ g(i, { fill: Br[m] ?? Br.primary, className: "h-6 w-6" });
  if (o)
    return /* @__PURE__ */ g(
      "span",
      {
        ref: u,
        "aria-label": s,
        className: j(p, "pointer-events-none opacity-38"),
        children: y
      }
    );
  const h = t ?? "a", b = new zn();
  return /* @__PURE__ */ g(
    h,
    {
      ref: u,
      "aria-label": s,
      className: p,
      ...f,
      onMouseDown: (w) => {
        const $ = f?.onMouseDown;
        return b.apply(w, Lt[m] ?? Lt.primary), typeof $ == "function" && $(w);
      },
      children: y
    }
  );
});
var JC = "Label", e0 = v.forwardRef((e, t) => /* @__PURE__ */ g(
  me.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
e0.displayName = JC;
var t0 = e0;
const QC = Se(["font-medium", "space-x-0.5"], {
  variants: {
    disabled: { true: ["opacity-38"] },
    size: {
      sm: ["text-sm"]
    }
  }
}), eP = de(
  ({ className: e, children: t, required: n, ...r }, o) => /* @__PURE__ */ re(
    t0,
    {
      ref: o,
      className: j(QC({ disabled: r.disabled, size: r.size }), e),
      ...r,
      children: [
        /* @__PURE__ */ g("span", { children: t }),
        n && /* @__PURE__ */ g("span", { className: "text-red-600", children: "*" })
      ]
    }
  )
);
eP.displayName = t0.displayName;
const tP = ({ iconColor: e, className: t, height: n, width: r }) => /* @__PURE__ */ re("svg", { x: "0px", y: "0px", viewBox: "0 0 1725.5 2000", className: t, height: n, width: r, children: [
  /* @__PURE__ */ g("title", { children: "c2fo-brand-mark" }),
  /* @__PURE__ */ g("g", { children: /* @__PURE__ */ re("g", { children: [
    /* @__PURE__ */ g(
      "path",
      {
        fill: e,
        d: `M1038,0.2c217.5,0,435,0,652.6,0c1.9,3,5.3,2.9,8.1,4c19.4,7.8,29.9,34.5,18.2,55.1
      c-15.8,27.7-31.8,55.2-47.7,82.9c-34,59.2-68,118.4-102,177.6c-33.9,59-67.7,118-101.6,177c-38.8,67.4-77.5,134.8-116.4,202.2
      c-19.6,34.1-48.7,51.5-88.5,51.7c-187.9,1-375.8-2.7-563.7,1.8c-20.9,0.5-41.4,3.6-61.7,7.6c-33.6,6.5-66.5,16.2-98.2,29.2
      c-11.3,4.6-13.4,8.2-10.5,20c0.3,1.1,1,2.1,1.1,3.2c6.2,41.4,17.5,81.3,33.7,120c25.8,61.4,62.2,115.7,108.7,163.1
      c28.7,29.2,60.7,54.5,95.5,76.2c29.5,18.4,60.5,33.7,92.9,45.9c29.3,11,59.6,19.5,90.5,24.6c19.9,3.3,40.1,6.8,60.2,6.9
      c72,0.3,144-0.8,215.9-1.4c54.6-0.5,109.3-1.2,163.9-1.7c43.1-0.4,86.2-0.8,129.2-0.8c32.9,0,50,33.4,34.3,58.8
      c-11.8,19.1-22.8,38.6-34,58c-49.2,85.9-98.2,171.9-147.7,257.7c-26.9,46.7-53.8,93.4-80.2,140.3c-35.5,63-71.1,125.9-108,188
      c-17.9,30.2-45.6,46.6-81.8,46.7c-43.7,0.2-87.3,0.2-131,0.9c-78,1.2-155.9-0.3-233.9,1.9c-20.6,0.6-41.7-1-62.6-2.7
      c-24.4-1.9-48.6-4.9-72.5-9.3c-28.6-5.3-57-11.9-84.7-21.1c-31.1-10.4-61.8-21.4-91.5-35.4c-37.8-17.9-73.9-38.6-108.3-62.6
      c-30.7-21.3-59.3-45-86.7-70.3c-13.7-12.7-26.4-26.5-39-40.4c-21.6-23.9-41.6-48.9-59.9-75.3c-39.7-57.3-70.3-119.2-93-185.1
      c-9.1-26.5-15.8-53.6-22-80.8c-5.9-25.9-9.7-52.2-12.3-78.7c-1.7-17.1-1.5-34.5-2.2-51.7c0-13.4,0-26.8,0-40.1
      c0.3-19.5,1.3-38.9,3.5-58.3c1.7-14.9,3.1-30,5.9-44.6c5.2-27.8,11.6-55.3,19.5-82.5c8.5-29.7,18.9-58.8,31.5-86.8
      c19.6-43.4,42.3-85.2,69.7-124.5c21-30.1,43.1-59.2,68.6-85.5c18-18.5,35.3-38,55.6-54.2c11.2-9,21.6-18.9,33.6-27
      c11.3-7.7,22.4-16,21.8-32.9c-0.7-17.8,4-35.4,7.2-52.8c4.9-25.8,11.6-51.3,19.3-76.5c9-29.1,19.2-57.7,32-85.2
      c19.1-41,41-80.4,67.4-117.5c83.7-117.6,191-205.6,324.6-260.8c48-19.8,97.3-35.1,148.9-42.8c21.6-3.2,43.1-7.1,65-8.9
      c6.1-0.5,13.1,0.8,18.9-3.1c5.8,0,11.6,0,17.4,0C1020.6,3,1029.3,2.9,1038,0.2z M219,1270.4c-0.8,19.1,1.3,43.3,5,67.4
      c5.9,38.2,15,75.4,29.1,111.6c25.3,64.9,62.3,122.2,109.9,172.5c46.8,49.4,101.5,87.8,163.8,115.3c23.3,10.3,47.2,18.9,72,25.2
      c24.6,6.3,49.4,11.4,74.6,14.8c13.3,1.8,26.8,3.9,40.1,3.4c40.7-1.7,81.5-1.2,122.2-2.2c52.3-1.3,104.6-2.2,156.9-2.5
      c27-0.2,45.8-13.3,59-35.1c19.6-32.5,38-65.7,57-98.6c26.2-45.4,52.4-90.8,78.4-136.4c11.3-19.8-1.6-42.2-24.3-42.5
      c-9.5-0.1-19,0.6-28.6,0.8c-41.6,0.8-83.1,2.7-124.7,1.8c-17.7-0.4-35.7-2.2-53.5-4.5c-32.1-4.1-63.8-9.6-95.3-17
      c-50.7-12-99-30.8-145.5-53.9c-35.7-17.7-69.8-38.4-102-62c-18.9-13.8-37-28.6-54.6-44.2c-20.5-18.2-39.6-37.8-58.4-57.5
      c-15.7-16.5-29.6-34.9-43.5-53.2c-22.5-29.8-42.6-61.1-60.3-93.8c-21.3-39.4-39.6-80.2-52.6-123.3c-1.3-4.3-2.9-8.6-4.7-12.7
      c-1.8-4-4.1-5.1-7.5-0.9c-37.1,45.8-66.1,96.2-85,152.1C227.9,1150.1,218.5,1206.8,219,1270.4z M932,531.8c0-0.1,0-0.2,0-0.3
      c75.2,0,150.3,0.3,225.5-0.1c25.2-0.1,44.6-12.9,57.2-33.8c18.5-30.6,35-62.4,52.8-93.5c27.3-47.9,55.1-95.5,82.3-143.5
      c11-19.3,0.8-43.6-25.2-43.4c-106,0.9-212-2.6-318,1.6c-18.9,0.7-37.5,2.7-56,5.7c-32.1,5.2-63.6,13.6-94,25.2
      c-99.9,38-180,101.4-241.3,188.8c-23.4,33.4-41.6,69.6-57.9,106.9c-1.5,3.5-2.9,7.3,4.6,5.8c24.8-4.9,49.6-9.6,74.6-13.1
      c23.5-3.2,47.1-5.7,70.6-6C782.2,531.1,857.1,531.8,932,531.8z`
      }
    ),
    /* @__PURE__ */ g(
      "path",
      {
        fill: "transparent",
        d: `M1.6,1284.1c0.7,17.2,0.5,34.6,2.2,51.7c2.6,26.4,6.4,52.8,12.3,78.7c6.2,27.2,12.9,54.3,22,80.8
      c22.7,65.9,53.3,127.8,93,185.1c18.3,26.4,38.3,51.4,59.9,75.3c12.6,13.9,25.3,27.7,39,40.4c27.3,25.3,55.9,49,86.7,70.3
      c34.5,23.9,70.5,44.7,108.3,62.6c29.6,14,60.4,25,91.5,35.4c27.8,9.3,56.2,15.8,84.7,21.1c23.9,4.4,48.1,7.5,72.5,9.3
      c20.9,1.6,42,3.2,62.6,2.7c78-2.2,155.9-0.7,233.9-1.9c43.7-0.7,87.3-0.8,131-0.9c36.1-0.1,63.8-16.5,81.8-46.7
      c36.9-62.1,72.5-125,108-188c26.5-46.9,53.3-93.7,80.2-140.3c49.4-85.8,98.4-171.8,147.7-257.7c11.1-19.4,22.2-39,34-58
      c15.7-25.4-1.4-58.8-34.3-58.8c-43.1,0-86.2,0.4-129.2,0.8c-54.6,0.5-109.3,1.2-163.9,1.7c-72,0.6-144,1.7-215.9,1.4
      c-20.1-0.1-40.3-3.6-60.2-6.9c-30.9-5.2-61.2-13.6-90.5-24.6c-32.4-12.1-63.4-27.5-92.9-45.9c-34.9-21.7-66.9-47-95.5-76.2
      c-46.5-47.4-82.9-101.7-108.7-163.1c-16.2-38.7-27.6-78.6-33.7-120c-0.2-1.1-0.9-2.1-1.1-3.2c-2.9-11.8-0.8-15.4,10.5-20
      c31.8-13,64.7-22.6,98.2-29.2c20.2-3.9,40.8-7.1,61.7-7.6c187.9-4.4,375.8-0.7,563.7-1.8c39.8-0.2,68.8-17.6,88.5-51.7
      c38.8-67.4,77.6-134.8,116.4-202.2c33.9-59,67.7-118,101.6-177c34-59.2,68-118.4,102-177.6c15.9-27.6,31.8-55.2,47.7-82.9
      c11.8-20.6,1.2-47.3-18.2-55.1c-2.8-1.1-6.2-1-8.1-4c10.4,0,20.8,0.1,31.2-0.1c3-0.1,4.1,0.5,3.5,3.6c-0.3,1.4,0,2.9,0,4.3
      c0,661.2,0,1322.4,0.2,1983.6c0,7.1-1.5,8.4-8.5,8.4c-569.4-0.2-1138.8-0.2-1708.3,0c-7.7,0-8.7-2.1-8.7-9
      c0.2-235.6,0.2-471.3,0.2-706.9l0.7,0.1C0.9,1284.2,1.6,1284.1,1.6,1284.1z`
      }
    ),
    /* @__PURE__ */ g(
      "path",
      {
        fill: "transparent",
        d: `M994.6,0.2c-5.8,3.9-12.7,2.6-18.9,3.1c-21.9,1.7-43.4,5.6-65,8.9c-51.6,7.7-100.9,23-148.9,42.8
      C628.3,110.1,521,198.1,437.3,315.7c-26.4,37-48.3,76.4-67.4,117.5c-12.8,27.5-23.1,56.1-32,85.2c-7.8,25.2-14.4,50.6-19.3,76.5
      c-3.3,17.4-7.9,35-7.2,52.8c0.7,16.9-10.4,25.3-21.8,32.9c-12,8.2-22.4,18.1-33.6,27c-20.3,16.2-37.6,35.6-55.6,54.2
      c-25.5,26.2-47.6,55.4-68.6,85.5c-27.4,39.3-50.1,81-69.7,124.5c-12.6,28-22.9,57.1-31.5,86.8c-7.8,27.2-14.2,54.7-19.5,82.5
      c-2.8,14.7-4.2,29.7-5.9,44.6c-2.2,19.4-3.3,38.8-3.5,58.3c-0.5-0.1-1-0.1-1.5,0.1C0.2,832,0.2,420,0,8c0-6.5,1.5-8,8-8
      C336.9,0.2,665.7,0.2,994.6,0.2z`
      }
    ),
    /* @__PURE__ */ g(
      "path",
      {
        d: `M0.2,1244.1c0.5-0.2,1-0.2,1.5-0.1c0,13.4,0,26.8,0,40.1l-0.7,0.1l-0.7-0.1C0.2,1270.7,0.2,1257.4,0.2,1244.1
      z`
      }
    ),
    /* @__PURE__ */ g("path", { d: "M1038,0.2c-8.7,2.8-17.4,2.9-26,0C1020.6,0.2,1029.3,0.2,1038,0.2z" }),
    /* @__PURE__ */ g(
      "path",
      {
        fill: "transparent",
        d: `M219,1270.4c-0.5-63.6,8.9-120.3,27.5-175.4c18.9-55.9,47.9-106.3,85-152.1c3.4-4.1,5.7-3,7.5,0.9
      c1.9,4.1,3.4,8.4,4.7,12.7c13,43,31.3,83.9,52.6,123.3c17.7,32.7,37.7,64,60.3,93.8c13.9,18.3,27.7,36.7,43.5,53.2
      c18.8,19.7,37.9,39.4,58.4,57.5c17.6,15.6,35.6,30.4,54.6,44.2c32.2,23.6,66.2,44.3,102,62c46.6,23.1,94.9,41.9,145.5,53.9
      c31.4,7.5,63.2,13,95.3,17c17.8,2.2,35.8,4.1,53.5,4.5c41.5,0.9,83.1-1,124.7-1.8c9.5-0.2,19.1-0.9,28.6-0.8
      c22.7,0.3,35.6,22.6,24.3,42.5c-26,45.6-52.2,90.9-78.4,136.4c-18.9,32.9-37.4,66.1-57,98.6c-13.2,21.8-32,35-59,35.1
      c-52.3,0.3-104.6,1.2-156.9,2.5c-40.7,1-81.5,0.6-122.2,2.2c-13.3,0.5-26.8-1.6-40.1-3.4c-25.1-3.4-50-8.5-74.6-14.8
      c-24.8-6.3-48.7-15-72-25.2c-62.3-27.5-117-65.9-163.8-115.3c-47.7-50.4-84.7-107.6-109.9-172.5c-14.1-36.2-23.2-73.4-29.1-111.6
      C220.3,1313.7,218.3,1289.5,219,1270.4z`
      }
    ),
    /* @__PURE__ */ g(
      "path",
      {
        fill: "transparent",
        d: `M932,531.8c-74.9,0-149.8-0.7-224.6,0.4c-23.5,0.3-47.1,2.8-70.6,6c-25.1,3.4-49.9,8.2-74.6,13.1
      c-7.6,1.5-6.2-2.3-4.6-5.8c16.2-37.3,34.4-73.5,57.9-106.9c61.3-87.4,141.4-150.8,241.3-188.8c30.5-11.6,61.9-19.9,94-25.2
      c18.4-3,37.1-5,56-5.7c106-4.2,212-0.8,318-1.6c26-0.2,36.1,24,25.2,43.4c-27.2,48-55,95.6-82.3,143.5
      c-17.7,31.1-34.3,62.9-52.8,93.5c-12.6,20.9-32.1,33.7-57.2,33.8c-75.2,0.4-150.3,0.1-225.5,0.1C932,531.6,932,531.7,932,531.8z`
      }
    )
  ] }) })
] }), H_ = (e) => {
  const { brandMark: t, color: n, className: r, height: o, width: i } = e;
  let l = pe.primary[500], s = pe.secondary[500];
  return n === "white" ? (l = pe.white, s = pe.text.inverse) : n === "primary-white" ? s = pe.text.inverse : n === "black" && (l = pe.text.primary), t ? /* @__PURE__ */ g(tP, { iconColor: l, ...e }) : /* @__PURE__ */ re("svg", { x: "0px", y: "0px", viewBox: "0 0 668.97 287.68", className: r, height: o, width: i, children: [
    /* @__PURE__ */ g("title", { children: "c2fo-logo" }),
    /* @__PURE__ */ g(
      "path",
      {
        fill: l,
        d: `M166.19,135.37c-0.69-1.55-2.17-2.51-3.86-2.51l-51.51,0.4c-27.76,0-51.25-20.76-54.64-48.28l-0.06-0.49
      l0.45-0.19c6.85-2.94,14.12-4.43,21.62-4.43h57.02c3.63,0,7.01-1.95,8.81-5.1L183.4,6.32c0.84-1.46,0.74-3.22-0.26-4.6
      C182.38,0.64,181.01,0,179.49,0h-68.67C91.25,0,72.5,7.3,58.04,20.55C43.66,33.72,34.76,51.6,32.96,70.88l-0.03,0.3l-0.24,0.17
      C12.22,86.05,0,109.81,0,134.91c0,43.13,35.13,78.21,78.31,78.21l39.52-0.31c3.6-0.03,6.94-1.98,8.73-5.1l39.3-68.32
      C166.61,138.09,166.74,136.58,166.19,135.37z M78.21,189.96c-17.25,0-33.18-7.89-43.72-21.63c-10.52-13.74-13.91-31.45-9.28-48.6
      c1.75-6.47,4.91-12.66,9.41-18.39l1.06-1.35l0.37,1.2c4.82,15.65,14.73,29.71,27.92,39.61c13.64,10.23,29.87,15.64,46.95,15.64
      l13.31-0.11c1.09,0,2.06,0.55,2.6,1.49s0.54,2.04,0,2.97l-14.6,25.39c-1.26,2.19-3.61,3.56-6.13,3.58L78.21,189.96z M59.68,57.86
      c8.41-21.07,28.49-34.69,51.14-34.69h31.03c1.07,0,2.04,0.55,2.57,1.48c0.54,0.93,0.54,2.04,0,2.97l-14.67,25.5
      c-1.27,2.21-3.64,3.58-6.19,3.58H78.21c-6,0-11.98,0.68-17.77,2.04l-1.22,0.29L59.68,57.86z`
      }
    ),
    /* @__PURE__ */ re("g", { children: [
      /* @__PURE__ */ g(
        "path",
        {
          fill: s,
          d: `M243.77,132.89c-19.63,0-37.45,6.43-50.18,18.11c-14.82,13.6-22.66,34.2-22.66,59.58
        c0,25.34,7.83,45.84,22.64,59.27c12.68,11.5,30.5,17.83,50.2,17.83c16.51,0,55.79-4.92,64.09-50.51c0.19-1.06-0.09-2.14-0.77-2.95
        c-0.66-0.79-1.57-1.22-2.58-1.22h-20.83c-1.51,0-2.82,1.02-3.26,2.54c-5.08,17.55-17.86,28.58-36.94,28.58
        c-27.66,0-44.17-21.11-44.17-53.53c0-15.49,3.9-30.26,11.28-39.41c7.76-9.63,19.13-14.71,32.89-14.71
        c19.07,0,31.84,11.33,36.95,28.93c0.44,1.52,1.75,2.55,3.27,2.55h20.7c1.01,0,1.93-0.44,2.58-1.23c0.69-0.84,0.96-1.94,0.75-3.03
        C299.05,139.72,263.93,132.89,243.77,132.89z`
        }
      ),
      /* @__PURE__ */ g(
        "path",
        {
          fill: s,
          d: `M527.82,99.57V79.95c0-1.11-0.9-2.01-2.01-2.01h-19.88c-27.52,0-43.95,16.09-43.95,43.05v9.52v1.75v1.75h-1.75
        h-1.75h-15.74c-1.26,0-2.28,1.02-2.28,2.28v17.63c0,0.61,0.24,1.18,0.67,1.61c0.43,0.43,1,0.67,1.61,0.67h15.74h1.75h1.75v1.75
        v1.75v124.06c0,1.26,1.02,2.28,2.28,2.28h26.17c1.26,0,2.28-1.02,2.28-2.28V159.69v-1.75v-1.75h1.75h1.75h18.86
        c1.26,0,2.28-1.02,2.28-2.28v-17.63c0-1.26-1.02-2.28-2.28-2.28h-18.86h-1.75h-1.75v-1.75v-1.75v-5.1
        c0-16.04,7.31-23.83,22.36-23.83h10.74C526.92,101.58,527.82,100.68,527.82,99.57z`
        }
      ),
      /* @__PURE__ */ g(
        "path",
        {
          fill: s,
          d: `M641,269.3c14.73-13.65,22.52-34.03,22.52-58.94s-7.79-45.29-22.52-58.94c-12.8-11.86-30.56-18.38-50.02-18.38
        c-33.46,0-72.54,20.25-72.54,77.33c0,26.16,7.97,46.38,23.7,60.11c12.72,11.1,30.07,17.22,48.85,17.22
        C610.44,287.68,628.21,281.15,641,269.3z M559.69,251.6c-8.54-9.24-12.87-24.28-12.87-41.25s4.33-32,12.87-41.25
        c7.76-8.4,18.58-12.84,31.3-12.84c12.58,0,23.31,4.44,31.04,12.85c8.51,9.26,12.83,24.3,12.83,41.24s-4.32,31.98-12.83,41.24
        c-7.73,8.4-18.46,12.84-31.04,12.84C578.27,264.44,567.45,260,559.69,251.6z`
        }
      ),
      /* @__PURE__ */ g(
        "path",
        {
          fill: s,
          d: `M324.81,286.03h101.43c1.94,0,3.52-1.58,3.52-3.52v-15.57c0-1.94-1.58-3.52-3.52-3.52h-28.65h-40.35h-0.51
        h-1.75v-1.75v-0.51v-0.67c0-11.56,10.09-19.24,32.7-32.1l1.57-0.86c18.26-9.99,40.97-22.41,40.97-50.96
        c0-27.36-19.85-43.69-53.09-43.69c-20.99,0-36.11,6.29-44.94,18.68c-7.49,10.52-8.61,23.13-8.61,29.71v3.14
        c0,1.94,1.58,3.52,3.52,3.52h20.7c1.94,0,3.52-1.58,3.52-3.52v-1.79c0-16.32,9.71-26.46,25.35-26.46c8.18,0,15.03,2.42,19.29,6.8
        c3.76,3.86,5.56,9.14,5.38,15.69c-0.22,16.64-14.05,24.22-31.57,33.81c-2.45,1.34-4.96,2.71-7.54,4.17
        c-34.41,19.82-40.93,37.87-40.93,64.25v1.62C321.29,284.45,322.87,286.03,324.81,286.03z`
        }
      )
    ] }),
    /* @__PURE__ */ re("g", { children: [
      /* @__PURE__ */ g("path", { fill: s, d: "M658.21,143.17h-2.66v7.34h-1.47v-7.34h-2.64v-1.2h6.77L658.21,143.17L658.21,143.17z" }),
      /* @__PURE__ */ g(
        "path",
        {
          fill: s,
          d: `M661.25,141.98l2.46,6.54l2.46-6.54h1.92v8.53h-1.48v-2.81l0.15-3.76l-2.52,6.57h-1.06l-2.51-6.57l0.15,3.76
        v2.81h-1.48v-8.53H661.25z`
        }
      )
    ] })
  ] });
};
var rl = "Dialog", [n0] = ur(rl), [nP, pt] = n0(rl), r0 = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: l = !0
  } = e, s = v.useRef(null), c = v.useRef(null), [d = !1, f] = bt({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ g(
    nP,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: qe(),
      titleId: qe(),
      descriptionId: qe(),
      open: d,
      onOpenChange: f,
      onOpenToggle: v.useCallback(() => f((u) => !u), [f]),
      modal: l,
      children: n
    }
  );
};
r0.displayName = rl;
var a0 = "DialogTrigger", rP = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = pt(a0, n), i = xe(t, o.triggerRef);
    return /* @__PURE__ */ g(
      me.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": il(o.open),
        ...r,
        ref: i,
        onClick: ee(e.onClick, o.onOpenToggle)
      }
    );
  }
);
rP.displayName = a0;
var al = "DialogPortal", [aP, o0] = n0(al, {
  forceMount: void 0
}), i0 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = pt(al, t);
  return /* @__PURE__ */ g(aP, { scope: t, forceMount: n, children: v.Children.map(r, (l) => /* @__PURE__ */ g(Gt, { present: n || i.open, children: /* @__PURE__ */ g(va, { asChild: !0, container: o, children: l }) })) });
};
i0.displayName = al;
var Kr = "DialogOverlay", l0 = v.forwardRef(
  (e, t) => {
    const n = o0(Kr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = pt(Kr, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ g(Gt, { present: r || i.open, children: /* @__PURE__ */ g(oP, { ...o, ref: t }) }) : null;
  }
);
l0.displayName = Kr;
var oP = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = pt(Kr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ g(wa, { as: en, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ g(
        me.div,
        {
          "data-state": il(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), nn = "DialogContent", s0 = v.forwardRef(
  (e, t) => {
    const n = o0(nn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = pt(nn, e.__scopeDialog);
    return /* @__PURE__ */ g(Gt, { present: r || i.open, children: i.modal ? /* @__PURE__ */ g(iP, { ...o, ref: t }) : /* @__PURE__ */ g(lP, { ...o, ref: t }) });
  }
);
s0.displayName = nn;
var iP = v.forwardRef(
  (e, t) => {
    const n = pt(nn, e.__scopeDialog), r = v.useRef(null), o = xe(t, n.contentRef, r);
    return v.useEffect(() => {
      const i = r.current;
      if (i) return ya(i);
    }, []), /* @__PURE__ */ g(
      c0,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ee(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: ee(e.onPointerDownOutside, (i) => {
          const l = i.detail.originalEvent, s = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: ee(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), lP = v.forwardRef(
  (e, t) => {
    const n = pt(nn, e.__scopeDialog), r = v.useRef(!1), o = v.useRef(!1);
    return /* @__PURE__ */ g(
      c0,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const l = i.target;
          n.triggerRef.current?.contains(l) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), c0 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...l } = e, s = pt(nn, n), c = v.useRef(null), d = xe(t, c);
    return ki(), /* @__PURE__ */ re(Ge, { children: [
      /* @__PURE__ */ g(
        fa,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ g(
            ua,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": il(s.open),
              ...l,
              ref: d,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ re(Ge, { children: [
        /* @__PURE__ */ g(dP, { titleId: s.titleId }),
        /* @__PURE__ */ g(fP, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), ol = "DialogTitle", d0 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = pt(ol, n);
    return /* @__PURE__ */ g(me.h2, { id: o.titleId, ...r, ref: t });
  }
);
d0.displayName = ol;
var u0 = "DialogDescription", sP = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = pt(u0, n);
    return /* @__PURE__ */ g(me.p, { id: o.descriptionId, ...r, ref: t });
  }
);
sP.displayName = u0;
var f0 = "DialogClose", cP = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = pt(f0, n);
    return /* @__PURE__ */ g(
      me.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ee(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
cP.displayName = f0;
function il(e) {
  return e ? "open" : "closed";
}
var h0 = "DialogTitleWarning", [I_, m0] = ME(h0, {
  contentName: nn,
  titleName: ol,
  docsSlug: "dialog"
}), dP = ({ titleId: e }) => {
  const t = m0(h0), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return v.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, uP = "DialogDescriptionWarning", fP = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${m0(uP).contentName}}.`;
  return v.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, p0 = r0, v0 = i0, g0 = l0, y0 = s0, Ea = d0, hP = "VisuallyHidden", ll = v.forwardRef(
  (e, t) => /* @__PURE__ */ g(
    me.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
ll.displayName = hP;
var mP = ll;
const On = St({}), R_ = ({ children: e }) => {
  const { onClose: t, onCloseAriaLabel: n = "Close Modal", isFullScreen: r = !1 } = rt(On);
  return /* @__PURE__ */ re(
    Ea,
    {
      className: j(
        "m-0 flex shrink-0 items-center justify-between bg-secondary-500 px-6 py-3 text-lg leading-6 text-white",
        {
          "sm:rounded-t-2xl": !r
        }
      ),
      children: [
        e,
        t && /* @__PURE__ */ g(
          "button",
          {
            className: j(
              "ml-auto h-full rounded-full p-1 hover:bg-white/10 focus:outline-none focus:outline-offset-0 focus-visible:outline-offset-0 focus-visible:outline-secondary-400"
            ),
            onClick: () => t(),
            type: "button",
            "aria-label": n,
            children: /* @__PURE__ */ g(Pn, { className: "text-2xl", fill: pe.white })
          }
        )
      ]
    }
  );
}, __ = ({ children: e }) => {
  const { onClose: t, onCloseAriaLabel: n = "Close Modal", isFullScreen: r = !1 } = rt(On);
  return /* @__PURE__ */ re(
    Ea,
    {
      className: j("m-0 flex shrink-0 items-center justify-between px-6 py-3 text-lg leading-6 text-text-primary", {
        "sm:rounded-t-2xl": !r
      }),
      children: [
        e,
        t && /* @__PURE__ */ g(
          "button",
          {
            className: j(
              "ml-auto h-full rounded-full p-1 hover:bg-black/10 focus:outline-none focus:outline-offset-0 focus-visible:outline-offset-0 focus-visible:outline-gray-100"
            ),
            onClick: () => t(),
            type: "button",
            "aria-label": n,
            children: /* @__PURE__ */ g(Pn, { className: "text-2xl", fill: pe.black })
          }
        )
      ]
    }
  );
}, L_ = ({ children: e, className: t }) => {
  const { onClose: n, onCloseAriaLabel: r = "Close Modal", isFullScreen: o = !1 } = rt(On);
  return /* @__PURE__ */ re(
    Ea,
    {
      className: j(
        "m-0 flex shrink-0 flex-col items-center justify-center px-6 pb-2 pt-12 text-center text-2xl font-bold leading-6 text-text-primary sm:text-3xl sm:font-medium",
        {
          "sm:rounded-t-2xl": !o
        },
        t
      ),
      children: [
        e,
        n && /* @__PURE__ */ g(
          "button",
          {
            className: j(
              "absolute right-3 top-3 ml-auto rounded-full p-1 hover:bg-black/10 focus:outline-none focus:outline-offset-0 focus-visible:outline-offset-0 focus-visible:outline-gray-100"
            ),
            onClick: () => n(),
            type: "button",
            "aria-label": r,
            children: /* @__PURE__ */ g(Pn, { className: "text-2xl", fill: pe.black })
          }
        )
      ]
    }
  );
}, B_ = ({
  children: e,
  center: t = !1,
  className: n
}) => {
  const r = ue(null), [o, i] = Ce(!1), [l, s] = Ce(!1), c = 1, d = se(() => {
    const u = r.current;
    if (!u)
      return;
    const { scrollTop: m, scrollHeight: p, clientHeight: y } = u, h = p > y, b = m <= c, w = p - m - y <= c;
    i(!b && h), s(!w && h);
  }, []);
  En(() => {
    const u = r.current;
    if (!u)
      return;
    const m = setTimeout(d, 350), p = new ResizeObserver(d);
    p.observe(u);
    const y = new MutationObserver(d);
    return y.observe(u, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      clearTimeout(m), p.disconnect(), y.disconnect();
    };
  }, [d, e]);
  const f = (u) => {
    const { scrollTop: m, scrollHeight: p, clientHeight: y } = u.currentTarget, h = p > y, b = m <= c, w = p - m - y <= c;
    i(!b && h), s(!w && h);
  };
  return /* @__PURE__ */ re("div", { className: j("relative flex h-full flex-col overflow-hidden"), children: [
    /* @__PURE__ */ g(
      "div",
      {
        className: j(
          "absolute left-0 top-0 w-full select-none opacity-0 shadow-[0px_-8px_12px_8px_rgba(0,0,0,0.25)] transition-opacity",
          {
            "opacity-100": o
          }
        )
      }
    ),
    /* @__PURE__ */ g(
      "div",
      {
        className: j(
          "h-full overflow-auto p-6",
          {
            "flex flex-col items-center gap-4 text-center": t
          },
          n
        ),
        ref: r,
        onScroll: f,
        children: e
      }
    ),
    /* @__PURE__ */ g(
      "div",
      {
        className: j(
          "absolute bottom-0 left-0 w-full select-none opacity-0 shadow-[0px_8px_12px_8px_rgba(0,0,0,0.2)] transition-opacity",
          {
            "opacity-100": l
          }
        )
      }
    )
  ] });
}, W_ = ({ children: e }) => /* @__PURE__ */ g(mP, { asChild: !0, children: /* @__PURE__ */ g(Ea, { children: e }) });
function V_({ className: e, ...t }) {
  const { isFullScreen: n = !1 } = rt(On);
  return /* @__PURE__ */ g(
    "div",
    {
      className: j(
        "flex shrink-0 flex-col gap-3 border-t p-6 sm:flex-row sm:justify-end",
        {
          "sm:rounded-b-2xl": !n
        },
        e
      ),
      ...t
    }
  );
}
const j_ = (e) => {
  const {
    open: t,
    onClose: n,
    className: r,
    size: o = "auto",
    ariaDescription: i,
    disableOutsideClickClose: l = !1,
    children: s
  } = e;
  ye(() => {
    const d = (f) => {
      f.key === "Escape" && t && n && n();
    };
    return document.addEventListener("keydown", d), () => {
      document.removeEventListener("keydown", d);
    };
  }, [n, t]);
  const c = Le(() => ({ ...e, isFullScreen: !1 }), [e]);
  return /* @__PURE__ */ g(p0, { open: t, modal: !0, children: /* @__PURE__ */ g(v0, { children: /* @__PURE__ */ g(g0, { className: "fixed inset-0 z-10 flex bg-black/[0.25] text-center data-[state=closed]:animate-fade-out data-[state=open]:animate-fade-in sm:min-h-full sm:items-center sm:justify-center", children: /* @__PURE__ */ g(On.Provider, { value: c, children: /* @__PURE__ */ g(
    y0,
    {
      "aria-describedby": void 0,
      "aria-description": i,
      className: j(
        "container relative flex w-full flex-col overflow-visible rounded-none bg-white text-left align-middle shadow-xl focus:outline-none focus:outline-offset-0 focus-visible:outline-none focus-visible:outline-offset-0 data-[state=closed]:animate-zoom-out data-[state=open]:animate-zoom-in sm:h-fit sm:max-h-[95%] sm:rounded-2xl",
        {
          "sm:w-fit sm:min-w-[550px]": o === "auto",
          "sm:w-[550px] sm:max-w-[95%]": o === "sm"
        },
        r
      ),
      onInteractOutside: () => n && !l ? n() : null,
      children: s
    }
  ) }) }) }) });
}, G_ = (e) => {
  const { open: t, onClose: n, className: r, ariaDescription: o, disableOutsideClickClose: i = !1, children: l } = e;
  ye(() => {
    const c = (d) => {
      d.key === "Escape" && t && n && n();
    };
    return document.addEventListener("keydown", c), () => {
      document.removeEventListener("keydown", c);
    };
  }, [n, t]);
  const s = Le(() => ({ ...e, isFullScreen: !0 }), [e]);
  return /* @__PURE__ */ g(p0, { open: t, modal: !0, children: /* @__PURE__ */ g(v0, { children: /* @__PURE__ */ g(g0, { className: "fixed inset-0 z-10", children: /* @__PURE__ */ g(On.Provider, { value: s, children: /* @__PURE__ */ g(
    y0,
    {
      "aria-describedby": void 0,
      "aria-description": o,
      className: j(
        "relative flex h-screen max-h-screen w-full flex-col overflow-hidden bg-white text-left align-middle focus:outline-none focus:outline-offset-0 focus-visible:outline-none focus-visible:outline-offset-0 data-[state=closed]:animate-zoom-out data-[state=open]:animate-zoom-in",
        r
      ),
      onInteractOutside: () => n && !i ? n() : null,
      children: l
    }
  ) }) }) }) });
}, pP = Se(["bg-white"], {
  variants: {
    variant: {
      elevated: [],
      outlined: ["shadow-inner", "border-deepGray-200", "border"]
    },
    square: {
      true: ["rounded-md"],
      false: ["rounded-2xl"]
    },
    elevation: {
      0: ["shadow-none"],
      1: ["shadow-sm"],
      2: ["shadow-md"],
      3: ["shadow-lg"],
      4: ["shadow-xl"],
      5: ["shadow-2xl"]
    }
  },
  defaultVariants: {
    variant: "elevated",
    square: !1,
    elevation: 1
  }
}), Y_ = ({ variant: e, square: t, elevation: n, children: r, className: o }) => /* @__PURE__ */ g("div", { className: pP({ variant: e, square: t, elevation: n, className: o }), children: r }), b0 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
var Nr = { exports: {} }, Dr = { exports: {} }, $e = {};
var M1;
function vP() {
  if (M1) return $e;
  M1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function x(E) {
    if (typeof E == "object" && E !== null) {
      var z = E.$$typeof;
      switch (z) {
        case t:
          switch (E = E.type, E) {
            case c:
            case d:
            case r:
            case i:
            case o:
            case u:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case s:
                case f:
                case y:
                case p:
                case l:
                  return E;
                default:
                  return z;
              }
          }
        case n:
          return z;
      }
    }
  }
  function P(E) {
    return x(E) === d;
  }
  return $e.AsyncMode = c, $e.ConcurrentMode = d, $e.ContextConsumer = s, $e.ContextProvider = l, $e.Element = t, $e.ForwardRef = f, $e.Fragment = r, $e.Lazy = y, $e.Memo = p, $e.Portal = n, $e.Profiler = i, $e.StrictMode = o, $e.Suspense = u, $e.isAsyncMode = function(E) {
    return P(E) || x(E) === c;
  }, $e.isConcurrentMode = P, $e.isContextConsumer = function(E) {
    return x(E) === s;
  }, $e.isContextProvider = function(E) {
    return x(E) === l;
  }, $e.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, $e.isForwardRef = function(E) {
    return x(E) === f;
  }, $e.isFragment = function(E) {
    return x(E) === r;
  }, $e.isLazy = function(E) {
    return x(E) === y;
  }, $e.isMemo = function(E) {
    return x(E) === p;
  }, $e.isPortal = function(E) {
    return x(E) === n;
  }, $e.isProfiler = function(E) {
    return x(E) === i;
  }, $e.isStrictMode = function(E) {
    return x(E) === o;
  }, $e.isSuspense = function(E) {
    return x(E) === u;
  }, $e.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === d || E === i || E === o || E === u || E === m || typeof E == "object" && E !== null && (E.$$typeof === y || E.$$typeof === p || E.$$typeof === l || E.$$typeof === s || E.$$typeof === f || E.$$typeof === b || E.$$typeof === w || E.$$typeof === $ || E.$$typeof === h);
  }, $e.typeOf = x, $e;
}
var Ee = {};
var C1;
function gP() {
  return C1 || (C1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function x(k) {
      return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      k === r || k === d || k === i || k === o || k === u || k === m || typeof k == "object" && k !== null && (k.$$typeof === y || k.$$typeof === p || k.$$typeof === l || k.$$typeof === s || k.$$typeof === f || k.$$typeof === b || k.$$typeof === w || k.$$typeof === $ || k.$$typeof === h);
    }
    function P(k) {
      if (typeof k == "object" && k !== null) {
        var ze = k.$$typeof;
        switch (ze) {
          case t:
            var Ie = k.type;
            switch (Ie) {
              case c:
              case d:
              case r:
              case i:
              case o:
              case u:
                return Ie;
              default:
                var We = Ie && Ie.$$typeof;
                switch (We) {
                  case s:
                  case f:
                  case y:
                  case p:
                  case l:
                    return We;
                  default:
                    return ze;
                }
            }
          case n:
            return ze;
        }
      }
    }
    var E = c, z = d, S = s, F = l, O = t, I = f, L = r, _ = y, ne = p, R = n, Y = i, W = o, V = u, J = !1;
    function T(k) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(k) || P(k) === c;
    }
    function N(k) {
      return P(k) === d;
    }
    function D(k) {
      return P(k) === s;
    }
    function K(k) {
      return P(k) === l;
    }
    function ae(k) {
      return typeof k == "object" && k !== null && k.$$typeof === t;
    }
    function Q(k) {
      return P(k) === f;
    }
    function ie(k) {
      return P(k) === r;
    }
    function X(k) {
      return P(k) === y;
    }
    function A(k) {
      return P(k) === p;
    }
    function U(k) {
      return P(k) === n;
    }
    function oe(k) {
      return P(k) === i;
    }
    function G(k) {
      return P(k) === o;
    }
    function ce(k) {
      return P(k) === u;
    }
    Ee.AsyncMode = E, Ee.ConcurrentMode = z, Ee.ContextConsumer = S, Ee.ContextProvider = F, Ee.Element = O, Ee.ForwardRef = I, Ee.Fragment = L, Ee.Lazy = _, Ee.Memo = ne, Ee.Portal = R, Ee.Profiler = Y, Ee.StrictMode = W, Ee.Suspense = V, Ee.isAsyncMode = T, Ee.isConcurrentMode = N, Ee.isContextConsumer = D, Ee.isContextProvider = K, Ee.isElement = ae, Ee.isForwardRef = Q, Ee.isFragment = ie, Ee.isLazy = X, Ee.isMemo = A, Ee.isPortal = U, Ee.isProfiler = oe, Ee.isStrictMode = G, Ee.isSuspense = ce, Ee.isValidElementType = x, Ee.typeOf = P;
  }()), Ee;
}
var P1;
function w0() {
  return P1 || (P1 = 1, process.env.NODE_ENV === "production" ? Dr.exports = vP() : Dr.exports = gP()), Dr.exports;
}
var io, S1;
function yP() {
  if (S1) return io;
  S1 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, s = 0; s < 10; s++)
        l["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(l).map(function(f) {
        return l[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return io = o() ? Object.assign : function(i, l) {
    for (var s, c = r(i), d, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var u in s)
        t.call(s, u) && (c[u] = s[u]);
      if (e) {
        d = e(s);
        for (var m = 0; m < d.length; m++)
          n.call(s, d[m]) && (c[d[m]] = s[d[m]]);
      }
    }
    return c;
  }, io;
}
var lo, z1;
function sl() {
  if (z1) return lo;
  z1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return lo = e, lo;
}
var so, F1;
function $0() {
  return F1 || (F1 = 1, so = Function.call.bind(Object.prototype.hasOwnProperty)), so;
}
var co, N1;
function bP() {
  if (N1) return co;
  N1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ sl(), n = {}, r = /* @__PURE__ */ $0();
    e = function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(i, l, s, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var u;
          try {
            if (typeof i[f] != "function") {
              var m = Error(
                (c || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            u = i[f](l, f, c, s, null, t);
          } catch (y) {
            u = y;
          }
          if (u && !(u instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var p = d ? d() : "";
            e(
              "Failed " + s + " type: " + u.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, co = o, co;
}
var uo, D1;
function wP() {
  if (D1) return uo;
  D1 = 1;
  var e = w0(), t = yP(), n = /* @__PURE__ */ sl(), r = /* @__PURE__ */ $0(), o = /* @__PURE__ */ bP(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return uo = function(s, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function u(N) {
      var D = N && (d && N[d] || N[f]);
      if (typeof D == "function")
        return D;
    }
    var m = "<<anonymous>>", p = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: $(),
      arrayOf: x,
      element: P(),
      elementType: E(),
      instanceOf: z,
      node: I(),
      objectOf: F,
      oneOf: S,
      oneOfType: O,
      shape: _,
      exact: ne
    };
    function y(N, D) {
      return N === D ? N !== 0 || 1 / N === 1 / D : N !== N && D !== D;
    }
    function h(N, D) {
      this.message = N, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function b(N) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, K = 0;
      function ae(ie, X, A, U, oe, G, ce) {
        if (U = U || m, G = G || A, ce !== n) {
          if (c) {
            var k = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw k.name = "Invariant Violation", k;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ze = U + ":" + A;
            !D[ze] && // Avoid spamming the console because they are often not actionable except for lib authors
            K < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + G + "` prop on `" + U + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[ze] = !0, K++);
          }
        }
        return X[A] == null ? ie ? X[A] === null ? new h("The " + oe + " `" + G + "` is marked as required " + ("in `" + U + "`, but its value is `null`.")) : new h("The " + oe + " `" + G + "` is marked as required in " + ("`" + U + "`, but its value is `undefined`.")) : null : N(X, A, U, oe, G);
      }
      var Q = ae.bind(null, !1);
      return Q.isRequired = ae.bind(null, !0), Q;
    }
    function w(N) {
      function D(K, ae, Q, ie, X, A) {
        var U = K[ae], oe = W(U);
        if (oe !== N) {
          var G = V(U);
          return new h(
            "Invalid " + ie + " `" + X + "` of type " + ("`" + G + "` supplied to `" + Q + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return b(D);
    }
    function $() {
      return b(l);
    }
    function x(N) {
      function D(K, ae, Q, ie, X) {
        if (typeof N != "function")
          return new h("Property `" + X + "` of component `" + Q + "` has invalid PropType notation inside arrayOf.");
        var A = K[ae];
        if (!Array.isArray(A)) {
          var U = W(A);
          return new h("Invalid " + ie + " `" + X + "` of type " + ("`" + U + "` supplied to `" + Q + "`, expected an array."));
        }
        for (var oe = 0; oe < A.length; oe++) {
          var G = N(A, oe, Q, ie, X + "[" + oe + "]", n);
          if (G instanceof Error)
            return G;
        }
        return null;
      }
      return b(D);
    }
    function P() {
      function N(D, K, ae, Q, ie) {
        var X = D[K];
        if (!s(X)) {
          var A = W(X);
          return new h("Invalid " + Q + " `" + ie + "` of type " + ("`" + A + "` supplied to `" + ae + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(N);
    }
    function E() {
      function N(D, K, ae, Q, ie) {
        var X = D[K];
        if (!e.isValidElementType(X)) {
          var A = W(X);
          return new h("Invalid " + Q + " `" + ie + "` of type " + ("`" + A + "` supplied to `" + ae + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(N);
    }
    function z(N) {
      function D(K, ae, Q, ie, X) {
        if (!(K[ae] instanceof N)) {
          var A = N.name || m, U = T(K[ae]);
          return new h("Invalid " + ie + " `" + X + "` of type " + ("`" + U + "` supplied to `" + Q + "`, expected ") + ("instance of `" + A + "`."));
        }
        return null;
      }
      return b(D);
    }
    function S(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function D(K, ae, Q, ie, X) {
        for (var A = K[ae], U = 0; U < N.length; U++)
          if (y(A, N[U]))
            return null;
        var oe = JSON.stringify(N, function(ce, k) {
          var ze = V(k);
          return ze === "symbol" ? String(k) : k;
        });
        return new h("Invalid " + ie + " `" + X + "` of value `" + String(A) + "` " + ("supplied to `" + Q + "`, expected one of " + oe + "."));
      }
      return b(D);
    }
    function F(N) {
      function D(K, ae, Q, ie, X) {
        if (typeof N != "function")
          return new h("Property `" + X + "` of component `" + Q + "` has invalid PropType notation inside objectOf.");
        var A = K[ae], U = W(A);
        if (U !== "object")
          return new h("Invalid " + ie + " `" + X + "` of type " + ("`" + U + "` supplied to `" + Q + "`, expected an object."));
        for (var oe in A)
          if (r(A, oe)) {
            var G = N(A, oe, Q, ie, X + "." + oe, n);
            if (G instanceof Error)
              return G;
          }
        return null;
      }
      return b(D);
    }
    function O(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var D = 0; D < N.length; D++) {
        var K = N[D];
        if (typeof K != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + J(K) + " at index " + D + "."
          ), l;
      }
      function ae(Q, ie, X, A, U) {
        for (var oe = [], G = 0; G < N.length; G++) {
          var ce = N[G], k = ce(Q, ie, X, A, U, n);
          if (k == null)
            return null;
          k.data && r(k.data, "expectedType") && oe.push(k.data.expectedType);
        }
        var ze = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
        return new h("Invalid " + A + " `" + U + "` supplied to " + ("`" + X + "`" + ze + "."));
      }
      return b(ae);
    }
    function I() {
      function N(D, K, ae, Q, ie) {
        return R(D[K]) ? null : new h("Invalid " + Q + " `" + ie + "` supplied to " + ("`" + ae + "`, expected a ReactNode."));
      }
      return b(N);
    }
    function L(N, D, K, ae, Q) {
      return new h(
        (N || "React class") + ": " + D + " type `" + K + "." + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Q + "`."
      );
    }
    function _(N) {
      function D(K, ae, Q, ie, X) {
        var A = K[ae], U = W(A);
        if (U !== "object")
          return new h("Invalid " + ie + " `" + X + "` of type `" + U + "` " + ("supplied to `" + Q + "`, expected `object`."));
        for (var oe in N) {
          var G = N[oe];
          if (typeof G != "function")
            return L(Q, ie, X, oe, V(G));
          var ce = G(A, oe, Q, ie, X + "." + oe, n);
          if (ce)
            return ce;
        }
        return null;
      }
      return b(D);
    }
    function ne(N) {
      function D(K, ae, Q, ie, X) {
        var A = K[ae], U = W(A);
        if (U !== "object")
          return new h("Invalid " + ie + " `" + X + "` of type `" + U + "` " + ("supplied to `" + Q + "`, expected `object`."));
        var oe = t({}, K[ae], N);
        for (var G in oe) {
          var ce = N[G];
          if (r(N, G) && typeof ce != "function")
            return L(Q, ie, X, G, V(ce));
          if (!ce)
            return new h(
              "Invalid " + ie + " `" + X + "` key `" + G + "` supplied to `" + Q + "`.\nBad object: " + JSON.stringify(K[ae], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var k = ce(A, G, Q, ie, X + "." + G, n);
          if (k)
            return k;
        }
        return null;
      }
      return b(D);
    }
    function R(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every(R);
          if (N === null || s(N))
            return !0;
          var D = u(N);
          if (D) {
            var K = D.call(N), ae;
            if (D !== N.entries) {
              for (; !(ae = K.next()).done; )
                if (!R(ae.value))
                  return !1;
            } else
              for (; !(ae = K.next()).done; ) {
                var Q = ae.value;
                if (Q && !R(Q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Y(N, D) {
      return N === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function W(N) {
      var D = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : Y(D, N) ? "symbol" : D;
    }
    function V(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var D = W(N);
      if (D === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function J(N) {
      var D = V(N);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function T(N) {
      return !N.constructor || !N.constructor.name ? m : N.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, uo;
}
var fo, O1;
function $P() {
  if (O1) return fo;
  O1 = 1;
  var e = /* @__PURE__ */ sl();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, fo = function() {
    function r(l, s, c, d, f, u) {
      if (u !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, fo;
}
var A1;
function EP() {
  if (A1) return Nr.exports;
  if (A1 = 1, process.env.NODE_ENV !== "production") {
    var e = w0(), t = !0;
    Nr.exports = /* @__PURE__ */ wP()(e.isElement, t);
  } else
    Nr.exports = /* @__PURE__ */ $P()();
  return Nr.exports;
}
var xP = /* @__PURE__ */ EP();
const H = /* @__PURE__ */ Qs(xP);
var ho = { exports: {} };
var T1;
function MP() {
  return T1 || (T1 = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", l = 0; l < arguments.length; l++) {
          var s = arguments[l];
          s && (i = o(i, r(s)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var l = "";
        for (var s in i)
          t.call(i, s) && i[s] && (l = o(l, s));
        return l;
      }
      function o(i, l) {
        return l ? i ? i + " " + l : i + l : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(ho)), ho.exports;
}
var CP = MP();
const Xr = /* @__PURE__ */ Qs(CP);
function PP(e, t, n) {
  switch (n) {
    case "Backspace":
      t > 0 && (e = e.slice(0, t - 1) + e.slice(t), t--);
      break;
    case "Delete":
      e = e.slice(0, t) + e.slice(t + 1);
      break;
  }
  return {
    value: e,
    caret: t
  };
}
function SP(e, t, n) {
  for (var r = {}, o = "", i = 0, l = 0; l < e.length; ) {
    var s = n(e[l], o, r);
    s !== void 0 && (o += s, t !== void 0 && (t === l ? i = o.length - 1 : t > l && (i = o.length))), l++;
  }
  t === void 0 && (i = o.length);
  var c = {
    value: o,
    caret: i
  };
  return c;
}
function zP(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = FP(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FP(e, t) {
  if (e) {
    if (typeof e == "string") return k1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return k1(e, t);
  }
}
function k1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ko(e, t) {
  for (var n = 0, r = zP(t.split("")), o; !(o = r()).done; ) {
    var i = o.value;
    i === e && n++;
  }
  return n;
}
function NP(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", o = e.length, i = ko("(", e), l = ko(")", e), s = i - l; s > 0 && o < t.length; )
    e += t[o].replace(n, r), t[o] === ")" && s--, o++;
  return e;
}
function DP(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = OP(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function OP(e, t) {
  if (e) {
    if (typeof e == "string") return H1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return H1(e, t);
  }
}
function H1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AP(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", n = arguments.length > 2 ? arguments[2] : void 0;
  if (!e)
    return function(o) {
      return {
        text: o
      };
    };
  var r = ko(t, e);
  return function(o) {
    if (!o)
      return {
        text: "",
        template: e
      };
    for (var i = 0, l = "", s = DP(e.split("")), c; !(c = s()).done; ) {
      var d = c.value;
      if (d !== t) {
        l += d;
        continue;
      }
      if (l += o[i], i++, i === o.length && o.length < r)
        break;
    }
    return n && (l = NP(l, e)), {
      text: l,
      template: e
    };
  };
}
function TP(e, t, n) {
  typeof n == "string" && (n = AP(n));
  var r = n(e) || {}, o = r.text, i = r.template;
  if (o === void 0 && (o = e), i)
    if (t === void 0)
      t = o.length;
    else {
      for (var l = 0, s = !1, c = -1; l < o.length && l < i.length; ) {
        if (o[l] !== i[l]) {
          if (t === 0) {
            s = !0, t = l;
            break;
          }
          c = l, t--;
        }
        l++;
      }
      s || (t = c + 1);
    }
  return {
    text: o,
    caret: t
  };
}
function kP(e) {
  return e.hasAttribute("readonly");
}
function HP(e) {
  if (e.selectionStart !== e.selectionEnd)
    return {
      start: e.selectionStart,
      end: e.selectionEnd
    };
}
var I1 = {
  Backspace: 8,
  Delete: 46
};
function IP(e) {
  switch (e.keyCode) {
    case I1.Backspace:
      return "Backspace";
    case I1.Delete:
      return "Delete";
  }
}
function RP(e) {
  return e.selectionStart;
}
function E0(e, t) {
  t !== void 0 && (_P() ? setTimeout(function() {
    return e.setSelectionRange(t, t);
  }, 0) : e.setSelectionRange(t, t));
}
function _P() {
  if (typeof navigator < "u")
    return LP.test(navigator.userAgent);
}
var LP = /Android/i;
function BP(e, t, n, r, o) {
  Ho(t, n, r, void 0, o);
}
function WP(e, t, n, r, o) {
  if (!kP(t)) {
    var i = IP(e);
    switch (i) {
      case "Delete":
      case "Backspace":
        e.preventDefault();
        var l = HP(t);
        return l ? (VP(t, l), Ho(t, n, r, void 0, o)) : Ho(t, n, r, i, o);
    }
  }
}
function VP(e, t) {
  var n = e.value;
  n = n.slice(0, t.start) + n.slice(t.end), e.value = n, E0(e, t.start);
}
function Ho(e, t, n, r, o) {
  var i = SP(e.value, RP(e), t), l = i.value, s = i.caret;
  if (r) {
    var c = PP(l, s, r);
    l = c.value, s = c.caret;
  }
  var d = TP(l, s, n), f = d.text;
  s = d.caret, e.value = f, E0(e, s), o(l);
}
var jP = ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"];
function Io() {
  return Io = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Io.apply(this, arguments);
}
function GP(e, t) {
  if (e == null) return {};
  var n = YP(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function YP(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function er(e, t) {
  var n = e.value, r = e.parse, o = e.format, i = e.inputComponent, l = e.onChange, s = e.onKeyDown, c = GP(e, jP), d = ue(), f = se(function(p) {
    d.current = p, t && (typeof t == "function" ? t(p) : t.current = p);
  }, [t]), u = se(function(p) {
    return BP(p, d.current, r, o, l);
  }, [d, r, o, l]), m = se(function(p) {
    if (s && s(p), !p.defaultPrevented)
      return WP(p, d.current, r, o, l);
  }, [d, r, o, l, s]);
  return /* @__PURE__ */ a.createElement(i, Io({}, c, {
    ref: f,
    value: o(UP(n) ? "" : n).text,
    onKeyDown: m,
    onChange: u
  }));
}
er = /* @__PURE__ */ a.forwardRef(er);
er.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: H.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: H.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: H.elementType.isRequired,
  // `<input/>` `type` attribute.
  type: H.string.isRequired,
  // Is parsed from <input/> text.
  value: H.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: H.func.isRequired,
  // Passthrough
  onKeyDown: H.func,
  onCut: H.func,
  onPaste: H.func
};
er.defaultProps = {
  // Renders `<input/>` by default.
  inputComponent: "input",
  // `<input/>` `type` attribute.
  type: "text"
};
function UP(e) {
  return e == null;
}
function R1(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), o = 0; o < 3; o++) {
    var i = Number(n[o]), l = Number(r[o]);
    if (i > l) return 1;
    if (l > i) return -1;
    if (!isNaN(i) && isNaN(l)) return 1;
    if (isNaN(i) && !isNaN(l)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var KP = {}.constructor;
function Qt(e) {
  return e != null && e.constructor === KP;
}
function Ro(e) {
  "@babel/helpers - typeof";
  return Ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ro(e);
}
function xa(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function XP(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ma(e, t, n) {
  return t && XP(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var qP = "1.2.0", ZP = "1.7.35", _1 = " ext. ", JP = /^\d+$/, Te = /* @__PURE__ */ function() {
  function e(t) {
    xa(this, e), x0(t), this.metadata = t, C0.call(this, t);
  }
  return Ma(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && JP.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new L1(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new L1(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var o = this.nonGeographic()[n];
        if (o)
          return o;
      } else {
        var i = this.countryCallingCodes()[n];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), L1 = /* @__PURE__ */ function() {
  function e(t, n) {
    xa(this, e), this.globalMetadataObject = n, this.metadata = t, C0.call(this, n.metadata);
  }
  return Ma(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(o) {
        return new QP(o, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && B1(this.types(), n))
        return new tS(B1(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? _1 : this.metadata[13] || _1;
    }
  }]), e;
}(), QP = /* @__PURE__ */ function() {
  function e(t, n) {
    xa(this, e), this._format = t, this.metadata = n;
  }
  return Ma(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !eS.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), eS = /^\(?\$1\)?$/, tS = /* @__PURE__ */ function() {
  function e(t, n) {
    xa(this, e), this.type = t, this.metadata = n;
  }
  return Ma(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function B1(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function x0(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Qt(e) || !Qt(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Qt(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + nS(e) + ": " + e, "."));
}
var nS = function(t) {
  return Ro(t);
};
function At(e, t) {
  if (t = new Te(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function M0(e, t) {
  return t.countries.hasOwnProperty(e);
}
function C0(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? R1(t, qP) === -1 ? this.v2 = !0 : R1(t, ZP) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function Ca(e, t) {
  return rS(e, void 0, t);
}
function rS(e, t, n) {
  var r = n.type(t), o = r && r.possibleLengths() || n.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var i = e.length, l = o[0];
  return l === i ? "IS_POSSIBLE" : l > i ? "TOO_SHORT" : o[o.length - 1] < i ? "TOO_LONG" : o.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function aS(e, t, n) {
  if (t === void 0 && (t = {}), n = new Te(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return P0(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function P0(e, t) {
  switch (Ca(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function Nt(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function oS(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = iS(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iS(e, t) {
  if (e) {
    if (typeof e == "string") return W1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return W1(e, t);
  }
}
function W1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var lS = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function cl(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new Te(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (Nt(r, n.nationalNumberPattern())) {
      if (mo(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || mo(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = oS(lS), i; !(i = o()).done; ) {
        var l = i.value;
        if (mo(r, l, n))
          return l;
      }
    }
  }
}
function mo(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Nt(e, t.pattern());
}
function sS(e, t, n) {
  if (t = t || {}, n = new Te(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return cl(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return Nt(r, n.nationalNumberPattern());
}
function cS(e, t, n) {
  var r = new Te(n), o = r.getCountryCodesForCallingCode(e);
  return o ? o.filter(function(i) {
    return dS(t, i, n);
  }) : [];
}
function dS(e, t, n) {
  var r = new Te(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var dl = 2, uS = 17, fS = 3, je = "0-9０-９٠-٩۰-۹", hS = "-‐-―−ー－", mS = "／/", pS = "．.", vS = "  ­​⁠　", gS = "()（）［］\\[\\]", yS = "~⁓∼～", ft = "".concat(hS).concat(mS).concat(pS).concat(vS).concat(gS).concat(yS), Pa = "+＋", bS = new RegExp("([" + je + "])");
function S0(e, t, n, r) {
  if (t) {
    var o = new Te(r);
    o.selectNumberingPlan(t, n);
    var i = new RegExp(o.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var l = e.match(bS);
      if (!(l && l[1] != null && l[1].length > 0 && l[1] === "0"))
        return e;
    }
  }
}
function _o(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var o, i, l = r.length - 1, s = l > 0 && r[l];
      if (t.nationalPrefixTransformRule() && s)
        o = e.replace(n, t.nationalPrefixTransformRule()), l > 1 && (i = r[1]);
      else {
        var c = r[0];
        o = e.slice(c.length), s && (i = r[1]);
      }
      var d;
      if (s) {
        var f = e.indexOf(r[1]), u = e.slice(0, f);
        u === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = r[0];
      return {
        nationalNumber: o,
        nationalPrefix: d,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Lo(e, t) {
  var n = _o(e, t), r = n.carrierCode, o = n.nationalNumber;
  if (o !== e) {
    if (!wS(e, o, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !$S(o, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: o,
    carrierCode: r
  };
}
function wS(e, t, n) {
  return !(Nt(e, n.nationalNumberPattern()) && !Nt(t, n.nationalNumberPattern()));
}
function $S(e, t) {
  switch (Ca(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function z0(e, t, n, r) {
  var o = t ? At(t, r) : n;
  if (e.indexOf(o) === 0) {
    r = new Te(r), r.selectNumberingPlan(t, n);
    var i = e.slice(o.length), l = Lo(i, r), s = l.nationalNumber, c = Lo(e, r), d = c.nationalNumber;
    if (!Nt(d, r.nationalNumberPattern()) && Nt(s, r.nationalNumberPattern()) || Ca(d, r) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: i
      };
  }
  return {
    number: e
  };
}
function ul(e, t, n, r) {
  if (!e)
    return {};
  var o;
  if (e[0] !== "+") {
    var i = S0(e, t, n, r);
    if (i && i !== e)
      o = !0, e = "+" + i;
    else {
      if (t || n) {
        var l = z0(e, t, n, r), s = l.countryCallingCode, c = l.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new Te(r);
  for (var d = 2; d - 1 <= fS && d <= e.length; ) {
    var f = e.slice(1, d);
    if (r.hasCallingCode(f))
      return r.selectNumberingPlan(f), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: f,
        number: e.slice(d)
      };
    d++;
  }
  return {};
}
function F0(e) {
  return e.replace(new RegExp("[".concat(ft, "]+"), "g"), " ").trim();
}
var N0 = /(\$\d)/;
function D0(e, t, n) {
  var r = n.useInternationalFormat, o = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var i = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && t.nationalPrefixFormattingRule() ? t.format().replace(N0, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? F0(i) : i;
}
var ES = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function xS(e, t, n) {
  var r = new Te(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (ES.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
var MS = ";ext=", hn = function(t) {
  return "([".concat(je, "]{1,").concat(t, "})");
};
function O0(e) {
  var t = "20", n = "15", r = "9", o = "6", i = "[  \\t,]*", l = "[:\\.．]?[  \\t,-]*", s = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", f = "[- ]+", u = "[  \\t]*", m = "(?:,{2}|;)", p = MS + hn(t), y = i + c + l + hn(t) + s, h = i + d + l + hn(r) + s, b = f + hn(o) + "#", w = u + m + l + hn(n) + s, $ = u + "(?:,)+" + l + hn(r) + s;
  return p + "|" + y + "|" + h + "|" + b + "|" + w + "|" + $;
}
var CS = "[" + je + "]{" + dl + "}", PS = "[" + Pa + "]{0,1}(?:[" + ft + "]*[" + je + "]){3,}[" + ft + je + "]*", SS = new RegExp("^[" + Pa + "]{0,1}(?:[" + ft + "]*[" + je + "]){1,2}$", "i"), zS = PS + // Phone number extensions
"(?:" + O0() + ")?", FS = new RegExp(
  // Either a short two-digit-only phone number
  "^" + CS + "$|^" + zS + "$",
  "i"
);
function NS(e) {
  return e.length >= dl && FS.test(e);
}
function DS(e) {
  return SS.test(e);
}
function OS(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function AS(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = TS(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TS(e, t) {
  if (e) {
    if (typeof e == "string") return V1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return V1(e, t);
  }
}
function V1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function j1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j1(Object(n), !0).forEach(function(r) {
      kS(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : j1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kS(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Y1 = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function HS(e, t, n, r) {
  if (n ? n = G1(G1({}, Y1), n) : n = Y1, r = new Te(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var o = r.countryCallingCode(), i = n.v2 ? e.nationalNumber : e.phone, l;
  switch (t) {
    case "NATIONAL":
      return i ? (l = qr(i, e.carrierCode, "NATIONAL", r, n), po(l, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (l = qr(i, null, "INTERNATIONAL", r, n), l = "+".concat(o, " ").concat(l), po(l, e.ext, r, n.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(i);
    case "RFC3966":
      return OS({
        number: "+".concat(o).concat(i),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = RS(i, e.carrierCode, o, n.fromCountry, r);
      return po(s, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function qr(e, t, n, r, o) {
  var i = IS(r.formats(), e);
  return i ? D0(e, i, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function IS(e, t) {
  for (var n = AS(e), r; !(r = n()).done; ) {
    var o = r.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var i = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (Nt(t, o.pattern()))
      return o;
  }
}
function po(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function RS(e, t, n, r, o) {
  var i = At(r, o.metadata);
  if (i === n) {
    var l = qr(e, t, "NATIONAL", o);
    return n === "1" ? n + " " + l : l;
  }
  var s = xS(r, void 0, o.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(qr(e, null, "INTERNATIONAL", o));
}
function U1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function K1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U1(Object(n), !0).forEach(function(r) {
      _S(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : U1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _S(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function LS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function BS(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function WS(e, t, n) {
  return t && BS(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var A0 = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (LS(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !n)
        throw new TypeError("`metadata` argument not passed");
      if (Qt(n) && Qt(n.countries)) {
        r = n;
        var o = t;
        if (!GS.test(o))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var i = ul(o, void 0, void 0, r), l = i.countryCallingCode, s = i.number;
        if (n = s, t = l, !n)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!n)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof n != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    x0(r);
    var c = jS(t, r), d = c.country, f = c.countryCallingCode;
    this.country = d, this.countryCallingCode = f, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return WS(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : cS(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return aS(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return sS(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Te(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return cl(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return HS(this, n, r ? K1(K1({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), VS = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function jS(e, t) {
  var n, r, o = new Te(t);
  return VS(e) ? (n = e, o.selectNumberingPlan(n), r = o.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var GS = /^\+\d+$/;
function Bo(e) {
  "@babel/helpers - typeof";
  return Bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bo(e);
}
function YS(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function US(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function KS(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && tr(e, t);
}
function XS(e) {
  var t = k0();
  return function() {
    var r = nr(e), o;
    if (t) {
      var i = nr(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return qS(this, o);
  };
}
function qS(e, t) {
  if (t && (Bo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return T0(e);
}
function T0(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wo(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Wo = function(r) {
    if (r === null || !ZS(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, o);
    }
    function o() {
      return Ir(r, arguments, nr(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), tr(o, r);
  }, Wo(e);
}
function Ir(e, t, n) {
  return k0() ? Ir = Reflect.construct : Ir = function(o, i, l) {
    var s = [null];
    s.push.apply(s, i);
    var c = Function.bind.apply(o, s), d = new c();
    return l && tr(d, l.prototype), d;
  }, Ir.apply(null, arguments);
}
function k0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ZS(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function tr(e, t) {
  return tr = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, tr(e, t);
}
function nr(e) {
  return nr = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, nr(e);
}
var xt = /* @__PURE__ */ function(e) {
  KS(n, e);
  var t = XS(n);
  function n(r) {
    var o;
    return US(this, n), o = t.call(this, r), Object.setPrototypeOf(T0(o), n.prototype), o.name = o.constructor.name, o;
  }
  return YS(n);
}(/* @__PURE__ */ Wo(Error)), X1 = new RegExp("(?:" + O0() + ")$", "i");
function JS(e) {
  var t = e.search(X1);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(X1), o = 1; o < r.length; ) {
    if (r[o])
      return {
        number: n,
        ext: r[o]
      };
    o++;
  }
}
function QS(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = ez(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ez(e, t) {
  if (e) {
    if (typeof e == "string") return q1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return q1(e, t);
  }
}
function q1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var tz = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function H0(e) {
  return tz[e];
}
function Zr(e) {
  for (var t = "", n = QS(e.split("")), r; !(r = n()).done; ) {
    var o = r.value, i = H0(o);
    i && (t += i);
  }
  return t;
}
function nz(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = rz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rz(e, t) {
  if (e) {
    if (typeof e == "string") return Z1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Z1(e, t);
  }
}
function Z1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Vo(e) {
  for (var t = "", n = nz(e.split("")), r; !(r = n()).done; ) {
    var o = r.value;
    t += I0(o, t) || "";
  }
  return t;
}
function I0(e, t, n) {
  if (e === "+") {
    if (t) {
      typeof n == "function" && n("end");
      return;
    }
    return "+";
  }
  return H0(e);
}
function az(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = oz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oz(e, t) {
  if (e) {
    if (typeof e == "string") return J1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return J1(e, t);
  }
}
function J1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function R0(e, t) {
  var n = t.countries;
  t.defaultCountry;
  var r = t.metadata;
  r = new Te(r);
  for (var o = az(n), i; !(i = o()).done; ) {
    var l = i.value;
    if (r.country(l), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return l;
    } else if (cl({
      phone: e,
      country: l
    }, void 0, r.metadata))
      return l;
  }
}
function _0(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, o = t.metadata, i = o.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : R0(n, {
      countries: i,
      defaultCountry: r,
      metadata: o.metadata
    });
}
var L0 = "+", iz = "[\\-\\.\\(\\)]?", Q1 = "([" + je + "]|" + iz + ")", lz = "^\\" + L0 + Q1 + "*[" + je + "]" + Q1 + "*$", sz = new RegExp(lz, "g"), jo = je, cz = "[" + jo + "]+((\\-)*[" + jo + "])*", dz = "a-zA-Z", uz = "[" + dz + "]+((\\-)*[" + jo + "])*", fz = "^(" + cz + "\\.)*" + uz + "\\.?$", hz = new RegExp(fz, "g"), es = "tel:", Go = ";phone-context=", mz = ";isub=";
function pz(e) {
  var t = e.indexOf(Go);
  if (t < 0)
    return null;
  var n = t + Go.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function vz(e) {
  return e === null ? !0 : e.length === 0 ? !1 : sz.test(e) || hz.test(e);
}
function gz(e, t) {
  var n = t.extractFormattedPhoneNumber, r = pz(e);
  if (!vz(r))
    throw new xt("NOT_A_NUMBER");
  var o;
  if (r === null)
    o = n(e) || "";
  else {
    o = "", r.charAt(0) === L0 && (o += r);
    var i = e.indexOf(es), l;
    i >= 0 ? l = i + es.length : l = 0;
    var s = e.indexOf(Go);
    o += e.substring(l, s);
  }
  var c = o.indexOf(mz);
  if (c > 0 && (o = o.substring(0, c)), o !== "")
    return o;
}
var yz = 250, bz = new RegExp("[" + Pa + je + "]"), wz = new RegExp("[^" + je + "#]+$");
function $z(e, t, n) {
  if (t = t || {}, n = new Te(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new xt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = xz(e, t.v2, t.extract), o = r.number, i = r.ext, l = r.error;
  if (!o) {
    if (t.v2)
      throw l === "TOO_SHORT" ? new xt("TOO_SHORT") : new xt("NOT_A_NUMBER");
    return {};
  }
  var s = Cz(o, t.defaultCountry, t.defaultCallingCode, n), c = s.country, d = s.nationalNumber, f = s.countryCallingCode, u = s.countryCallingCodeSource, m = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new xt("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < dl) {
    if (t.v2)
      throw new xt("TOO_SHORT");
    return {};
  }
  if (d.length > uS) {
    if (t.v2)
      throw new xt("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var p = new A0(f, d, n.metadata);
    return c && (p.country = c), m && (p.carrierCode = m), i && (p.ext = i), p.__countryCallingCodeSource = u, p;
  }
  var y = (t.extended ? n.hasSelectedNumberingPlan() : c) ? Nt(d, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: c,
    countryCallingCode: f,
    carrierCode: m,
    valid: y,
    possible: y ? !0 : !!(t.extended === !0 && n.possibleLengths() && P0(d, n)),
    phone: d,
    ext: i
  } : y ? Mz(c, d, i) : {};
}
function Ez(e, t, n) {
  if (e) {
    if (e.length > yz) {
      if (n)
        throw new xt("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(bz);
    if (!(r < 0))
      return e.slice(r).replace(wz, "");
  }
}
function xz(e, t, n) {
  var r = gz(e, {
    extractFormattedPhoneNumber: function(l) {
      return Ez(l, n, t);
    }
  });
  if (!r)
    return {};
  if (!NS(r))
    return DS(r) ? {
      error: "TOO_SHORT"
    } : {};
  var o = JS(r);
  return o.ext ? o : {
    number: r
  };
}
function Mz(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function Cz(e, t, n, r) {
  var o = ul(Vo(e), t, n, r.metadata), i = o.countryCallingCodeSource, l = o.countryCallingCode, s = o.number, c;
  if (l)
    r.selectNumberingPlan(l);
  else if (s && (t || n))
    r.selectNumberingPlan(t, n), t && (c = t), l = n || At(t, r.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: l
    };
  var d = Lo(Vo(s), r), f = d.nationalNumber, u = d.carrierCode, m = _0(l, {
    nationalNumber: f,
    defaultCountry: t,
    metadata: r
  });
  return m && (c = m, m === "001" || r.country(c)), {
    country: c,
    countryCallingCode: l,
    countryCallingCodeSource: i,
    nationalNumber: f,
    carrierCode: u
  };
}
function ts(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ns(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ts(Object(n), !0).forEach(function(r) {
      Pz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ts(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Pz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Sz(e, t, n) {
  return $z(e, ns(ns({}, t), {}, {
    v2: !0
  }), n);
}
function rs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zz(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rs(Object(n), !0).forEach(function(r) {
      Fz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Fz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nz(e, t) {
  return Tz(e) || Az(e, t) || Oz(e, t) || Dz();
}
function Dz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Oz(e, t) {
  if (e) {
    if (typeof e == "string") return as(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return as(e, t);
  }
}
function as(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Az(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, l, s;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function Tz(e) {
  if (Array.isArray(e)) return e;
}
function fl(e) {
  var t = Array.prototype.slice.call(e), n = Nz(t, 4), r = n[0], o = n[1], i = n[2], l = n[3], s, c, d;
  if (typeof r == "string")
    s = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    l ? (c = i, d = l) : (c = void 0, d = i), o && (c = zz({
      defaultCountry: o
    }, c));
  else if (Qt(o))
    i ? (c = o, d = i) : d = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: s,
    options: c,
    metadata: d
  };
}
function os(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function is(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? os(Object(n), !0).forEach(function(r) {
      kz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : os(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function hl(e, t, n) {
  t && t.defaultCountry && !M0(t.defaultCountry, n) && (t = is(is({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return Sz(e, t, n);
  } catch (r) {
    if (!(r instanceof xt)) throw r;
  }
}
function B0() {
  var e = fl(arguments), t = e.text, n = e.options, r = e.metadata;
  return hl(t, n, r);
}
function ls(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ss(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ls(Object(n), !0).forEach(function(r) {
      Hz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ls(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Hz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Iz() {
  var e = fl(arguments), t = e.text, n = e.options, r = e.metadata;
  n = ss(ss({}, n), {}, {
    extract: !1
  });
  var o = hl(t, n, r);
  return o && o.isValid() || !1;
}
function cs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ds(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cs(Object(n), !0).forEach(function(r) {
      Rz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Rz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _z() {
  var e = fl(arguments), t = e.text, n = e.options, r = e.metadata;
  n = ds(ds({}, n), {}, {
    extract: !1
  });
  var o = hl(t, n, r);
  return o && o.isPossible() || !1;
}
function Lz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Bz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Wz(e, t, n) {
  return t && Bz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Vz = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.onCountryChange, r = t.onCallingCodeChange;
    Lz(this, e), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  return Wz(e, [{
    key: "reset",
    value: function(n) {
      var r = n.country, o = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, o);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var r = 0, o = Object.keys(n); r < o.length; r++) {
        var i = o[r];
        this[i] = n[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, r) {
      this.setCountry(n), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      this.international = !0, this.initCountryAndCallingCode(n, r);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function jz(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Gz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gz(e, t) {
  if (e) {
    if (typeof e == "string") return us(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return us(e, t);
  }
}
function us(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var ct = "x", vo = new RegExp(ct);
function Rr(e, t) {
  if (t < 1)
    return "";
  for (var n = ""; t > 1; )
    t & 1 && (n += e), t >>= 1, e += e;
  return n + e;
}
function fs(e, t) {
  return e[t] === ")" && t++, Yz(e.slice(0, t));
}
function Yz(e) {
  for (var t = [], n = 0; n < e.length; )
    e[n] === "(" ? t.push(n) : e[n] === ")" && t.pop(), n++;
  var r = 0, o = "";
  t.push(e.length);
  for (var i = 0, l = t; i < l.length; i++) {
    var s = l[i];
    o += e.slice(r, s), r = s + 1;
  }
  return o;
}
function Uz(e, t, n) {
  for (var r = jz(n.split("")), o; !(o = r()).done; ) {
    var i = o.value;
    if (e.slice(t + 1).search(vo) < 0)
      return;
    t = e.search(vo), e = e.replace(vo, i);
  }
  return [e, t];
}
function Kz(e, t, n) {
  var r = n.metadata, o = n.shouldTryNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix, l = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (l.test(e.nationalSignificantNumber))
    return qz(e, t, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: o,
      getSeparatorAfterNationalPrefix: i
    });
}
function Xz(e, t) {
  return Ca(e, t) === "IS_POSSIBLE";
}
function qz(e, t, n) {
  var r = n.metadata, o = n.shouldTryNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, o(t)) {
    var l = hs(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: i,
      metadata: r
    });
    if (l)
      return l;
  }
  return hs(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: i,
    metadata: r
  });
}
function hs(e, t, n) {
  var r = n.metadata, o = n.useNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix, l = D0(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: o,
    metadata: r
  });
  if (o || (e.nationalPrefix ? l = e.nationalPrefix + i(t) + l : e.complexPrefixBeforeNationalSignificantNumber && (l = e.complexPrefixBeforeNationalSignificantNumber + " " + l)), Zz(l, e))
    return l;
}
function Zz(e, t) {
  return Zr(e) === t.getNationalDigits();
}
function Jz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function eF(e, t, n) {
  return t && Qz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var tF = /* @__PURE__ */ function() {
  function e() {
    Jz(this, e);
  }
  return eF(e, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], o = r.branches, i = r.instructions;
      if (o)
        return {
          op: "|",
          args: o.concat([go(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var r = n.match(aF);
      if (!r) {
        if (rF.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var o = r[1], i = n.slice(0, r.index), l = n.slice(r.index + o.length);
      switch (o) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var s = this.getContext(), c = s.branches;
          c.push(go(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: c
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(go(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: nF(i)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(o));
      }
      l && this.parsePattern(l);
    }
  }]), e;
}();
function nF(e) {
  for (var t = [], n = 0; n < e.length; ) {
    if (e[n] === "-") {
      if (n === 0 || n === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[n - 1].charCodeAt(0) + 1, o = e[n + 1].charCodeAt(0) - 1, i = r; i <= o; )
        t.push(String.fromCharCode(i)), i++;
    } else
      t.push(e[n]);
    n++;
  }
  return t;
}
var rF = /[\(\)\[\]\?\:\|]/, aF = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function go(e) {
  return e.length === 1 ? e[0] : e;
}
function ms(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = oF(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oF(e, t) {
  if (e) {
    if (typeof e == "string") return ps(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ps(e, t);
  }
}
function ps(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function iF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lF(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function sF(e, t, n) {
  return t && lF(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var cF = /* @__PURE__ */ function() {
  function e(t) {
    iF(this, e), this.matchTree = new tF().parse(t);
  }
  return sF(e, [{
    key: "match",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var i = Yo(n.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !o))
        return i;
    }
  }]), e;
}();
function Yo(e, t, n) {
  if (typeof t == "string") {
    var r = e.join("");
    return t.indexOf(r) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(t) === 0 ? n && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var o = e.slice(), i = 0; i < t.length; ) {
      var l = t[i], s = Yo(o, l, n && i === t.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (o = o.slice(s.matchedChars.length), o.length === 0)
            return i === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else return;
      i++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - o.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var c, d = ms(t.args), f; !(f = d()).done; ) {
        var u = f.value, m = Yo(e, u, n);
        if (m) {
          if (m.overflow)
            return m;
          if (m.match)
            return {
              match: !0,
              matchedChars: m.matchedChars
            };
          if (m.partialMatch)
            c = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(m, null, 2)));
        }
      }
      return c ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var p = ms(t.args), y; !(y = p()).done; ) {
        var h = y.value;
        if (e[0] === h)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [h]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function vs(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = dF(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dF(e, t) {
  if (e) {
    if (typeof e == "string") return gs(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gs(e, t);
  }
}
function gs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function uF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function fF(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function hF(e, t, n) {
  return t && fF(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Uo = "9", mF = 15, pF = Rr(Uo, mF), vF = /[- ]/, gF = function() {
  return /\[([^\[\]])*\]/g;
}, yF = function() {
  return /\d(?=[^,}][^,}])/g;
}, bF = new RegExp("[" + ft + "]*\\$1[" + ft + "]*(\\$\\d[" + ft + "]*)*$"), ys = 3, wF = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var n = t.metadata;
    uF(this, e), this.metadata = n, this.resetFormat();
  }
  return hF(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, r) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, r) {
      var o = this;
      if (Xz(r.nationalSignificantNumber, this.metadata))
        for (var i = vs(this.matchingFormats), l; !(l = i()).done; ) {
          var s = l.value, c = Kz(r, s, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(f) {
              return o.shouldTryNationalPrefixFormattingRule(f, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(f) {
              return o.getSeparatorAfterNationalPrefix(f);
            }
          });
          if (c)
            return this.resetFormat(), this.chosenFormat = s, this.setNationalNumberTemplate(c.replace(/\d/g, ct), r), this.populatedNationalNumberTemplate = c, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(ct), c;
        }
      return this.formatNationalNumberWithNextDigits(n, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, r) {
      var o = this.chosenFormat, i = this.chooseFormat(r);
      if (i)
        return i === o ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var r = this, o = n.nationalSignificantNumber, i = n.nationalPrefix, l = n.international, s = o, c = s.length - ys;
      c < 0 && (c = 0), this.matchingFormats = this.matchingFormats.filter(function(d) {
        return r.formatSuits(d, l, i) && r.formatMatches(d, s, c);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, r, o) {
      return !(o && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !o && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, r, o) {
      var i = n.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      o = Math.min(o, i - 1);
      var l = n.leadingDigitsPatterns()[o];
      if (r.length < ys)
        try {
          return new cF(l).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (s) {
          return console.error(s), !0;
        }
      return new RegExp("^(".concat(l, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, r) {
      return r ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var r = this, o = function() {
        var d = l.value;
        return r.chosenFormat === d ? "break" : bF.test(r.getFormatFormat(d, n.international)) ? r.createTemplateForFormat(d, n) ? (r.chosenFormat = d, "break") : (r.matchingFormats = r.matchingFormats.filter(function(f) {
          return f !== d;
        }), "continue") : "continue";
      }, i = vs(this.matchingFormats.slice()), l; !(l = i()).done; ) {
        var s = o();
        if (s === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, r) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var o = this.getTemplateForFormat(n, r);
        if (o)
          return this.setNationalNumberTemplate(o, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && vF.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, r) {
      var o = n.IDDPrefix, i = n.missingPlus;
      return o ? r && r.spacing === !1 ? o : o + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var r = -1, o = 0, i = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; o < i.length + n.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(ct, r + 1), o++;
        return fs(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, r) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, ct) + Rr(ct, r.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, r) {
      var o = r.nationalSignificantNumber, i = r.international, l = r.nationalPrefix, s = r.complexPrefixBeforeNationalSignificantNumber, c = n.pattern();
      c = c.replace(gF(), "\\d").replace(yF(), "\\d");
      var d = pF.match(c)[0];
      if (!(o.length > d.length)) {
        var f = new RegExp("^" + c + "$"), u = o.replace(/\d/g, Uo);
        f.test(u) && (d = u);
        var m = this.getFormatFormat(n, i), p;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: i,
          nationalPrefix: l
        })) {
          var y = m.replace(N0, n.nationalPrefixFormattingRule());
          if (Zr(n.nationalPrefixFormattingRule()) === (l || "") + Zr("$1") && (m = y, p = !0, l))
            for (var h = l.length; h > 0; )
              m = m.replace(/\d/, ct), h--;
        }
        var b = d.replace(new RegExp(c), m).replace(new RegExp(Uo, "g"), ct);
        return p || (s ? b = Rr(ct, s.length) + " " + b : l && (b = Rr(ct, l.length) + this.getSeparatorAfterNationalPrefix(n) + b)), i && (b = F0(b)), b;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var r = Uz(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], fs(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, r) {
      var o = r.international, i = r.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var l = n.usesNationalPrefix();
        if (l && i || !l && !o)
          return !0;
      }
    }
  }]), e;
}();
function W0(e, t) {
  return MF(e) || xF(e, t) || EF(e, t) || $F();
}
function $F() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EF(e, t) {
  if (e) {
    if (typeof e == "string") return bs(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bs(e, t);
  }
}
function bs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function xF(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, l, s;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function MF(e) {
  if (Array.isArray(e)) return e;
}
function CF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function PF(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function SF(e, t, n) {
  return t && PF(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var zF = "[" + ft + je + "]+", FF = new RegExp("^" + zF + "$", "i"), NF = "(?:[" + Pa + "][" + ft + je + "]*|[" + ft + je + "]+)", DF = new RegExp("[^" + ft + je + "]+.*$"), OF = /[^\d\[\]]/, AF = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.defaultCountry, r = t.defaultCallingCode, o = t.metadata, i = t.onNationalSignificantNumberChange;
    CF(this, e), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = o, this.onNationalSignificantNumberChange = i;
  }
  return SF(e, [{
    key: "input",
    value: function(n, r) {
      var o = HF(n), i = W0(o, 2), l = i[0], s = i[1], c = Zr(l), d;
      return s && (r.digits || (r.startInternationalNumber(), c || (d = !0))), c && this.inputDigits(c, r), {
        digits: c,
        justLeadingPlus: d
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, r) {
      var o = r.digits, i = o.length < 3 && o.length + n.length >= 3;
      if (r.appendDigits(n), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(n);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(l) {
        return r.update(l);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var r = n.international, o = n.callingCode;
      return r && !o;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var r = ul("+" + n.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode, i = r.number;
      if (o)
        return n.setCallingCode(o), n.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var r = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && OF.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, r) {
      if (this.hasSelectedNumberingPlan) {
        var o = _o(n, this.metadata), i = o.nationalPrefix, l = o.nationalNumber, s = o.carrierCode;
        if (l !== n)
          return this.onExtractedNationalNumber(i, s, l, n, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, r, o) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, o);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = _o(n, this.metadata), l = i.nationalPrefix, s = i.nationalNumber, c = i.carrierCode;
        if (s !== r)
          return this.onExtractedNationalNumber(l, c, s, n, o), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, r, o, i, l) {
      var s, c, d = i.lastIndexOf(o);
      if (d >= 0 && d === i.length - o.length) {
        c = !0;
        var f = i.slice(0, d);
        f !== n && (s = f);
      }
      l({
        nationalPrefix: n,
        carrierCode: r,
        nationalSignificantNumber: o,
        nationalSignificantNumberMatchesInput: c,
        complexPrefixBeforeNationalSignificantNumber: s
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(r) {
        return n.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var r = n.international, o = n.IDDPrefix, i = n.digits;
      if (n.nationalSignificantNumber, !(r || o)) {
        var l = S0(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (l !== void 0 && l !== i)
          return n.update({
            IDDPrefix: i.slice(0, i.length - l.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var r = z0(n.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode;
        if (r.number, o)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: o
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      var o = r.country, i = r.callingCode;
      n.startInternationalNumber(o, i), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(r) {
        return n.update(r);
      });
    }
  }]), e;
}();
function TF(e) {
  var t = e.search(NF);
  if (!(t < 0)) {
    e = e.slice(t);
    var n;
    return e[0] === "+" && (n = !0, e = e.slice(1)), e = e.replace(DF, ""), n && (e = "+" + e), e;
  }
}
function kF(e) {
  var t = TF(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function HF(e) {
  var t = kF(e), n = W0(t, 2), r = n[0], o = n[1];
  return FF.test(r) || (r = ""), [r, o];
}
function IF(e, t) {
  return BF(e) || LF(e, t) || _F(e, t) || RF();
}
function RF() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _F(e, t) {
  if (e) {
    if (typeof e == "string") return ws(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ws(e, t);
  }
}
function ws(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function LF(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, l, s;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function BF(e) {
  if (Array.isArray(e)) return e;
}
function WF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function VF(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function jF(e, t, n) {
  return t && VF(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var An = /* @__PURE__ */ function() {
  function e(t, n) {
    WF(this, e), this.metadata = new Te(n);
    var r = this.getCountryAndCallingCode(t), o = IF(r, 2), i = o[0], l = o[1];
    this.defaultCountry = i, this.defaultCallingCode = l, this.reset();
  }
  return jF(e, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var r, o;
      return n && (Qt(n) ? (r = n.defaultCountry, o = n.defaultCallingCode) : r = n), r && !this.metadata.hasCountry(r) && (r = void 0), [r, o];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var r = this.parser.input(n, this.state), o = r.digits, i = r.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (o) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var l;
        if (this.metadata.hasSelectedNumberingPlan() && (l = this.formatter.format(o, this.state)), l === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var s = this.state.getNationalDigits();
          s && (l = this.formatter.format(s, this.state));
        }
        this.formattedOutput = l ? this.getFullNumber(l) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new Vz({
        onCountryChange: function(o) {
          n.country = o;
        },
        onCallingCodeChange: function(o, i) {
          n.metadata.selectNumberingPlan(i, o), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new wF({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new AF({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var r = this;
      if (this.isInternational()) {
        var o = function(s) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!s
          }) + s;
        }, i = this.state.callingCode;
        return o(i ? n ? "".concat(i, " ").concat(n) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, o = n.complexPrefixBeforeNationalSignificantNumber, i = n.nationalPrefix, l = r, s = o || i;
      return s && (l = s + l), l;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(n ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, ct);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(n);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(_0(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, r = n.digits, o = n.callingCode, i = n.country, l = n.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return o ? "+" + o + l : "+" + r;
        if (i || o) {
          var s = i ? this.metadata.countryCallingCode() : o;
          return "+" + s + l;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, o = n.carrierCode, i = n.callingCode, l = this._getCountry();
      if (r && !(!l && !i)) {
        if (l && l === this.defaultCountry) {
          var s = new Te(this.metadata.metadata);
          s.selectNumberingPlan(l);
          var c = s.numberingPlan.callingCode(), d = this.metadata.getCountryCodesForCallingCode(c);
          if (d.length > 1) {
            var f = R0(r, {
              countries: d,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            f && (l = f);
          }
        }
        var u = new A0(l || i, r, this.metadata.metadata);
        return o && (u.carrierCode = o), u;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function Ko(e) {
  return new Te(e).getCountries();
}
function GF(e, t, n) {
  return n || (n = t, t = void 0), new An(t, n).input(e);
}
function V0(e) {
  var t = e.country, n = e.international, r = e.withCountryCallingCode, o = e.metadata;
  return t && n && !r ? "+".concat(At(t, o)) : "";
}
function Xo(e, t) {
  return t && (e = e.slice(t.length), e[0] === " " && (e = e.slice(1))), e;
}
function YF(e, t, n) {
  if (!(n && n.ignoreRest)) {
    var r = function(i) {
      if (n)
        switch (i) {
          case "end":
            n.ignoreRest = !0;
            break;
        }
    };
    return I0(e, t, r);
  }
}
function j0(e) {
  var t = e.onKeyDown, n = e.international;
  return se(function(r) {
    if (r.keyCode === UF && n && r.target instanceof HTMLInputElement && KF(r.target) === XF) {
      r.preventDefault();
      return;
    }
    t && t(r);
  }, [t, n]);
}
var UF = 8;
function KF(e) {
  return e.selectionStart;
}
var XF = 1, qF = ["onKeyDown", "country", "international", "withCountryCallingCode", "metadata"];
function qo() {
  return qo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qo.apply(this, arguments);
}
function ZF(e, t) {
  if (e == null) return {};
  var n = JF(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function JF(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function QF(e) {
  function t(n, r) {
    var o = n.onKeyDown, i = n.country, l = n.international, s = n.withCountryCallingCode, c = n.metadata, d = c === void 0 ? e : c, f = ZF(n, qF), u = se(function(p) {
      var y = new An(i, d), h = V0({
        country: i,
        international: l,
        withCountryCallingCode: s,
        metadata: d
      }), b = y.input(h + p), w = y.getTemplate();
      return h && (b = Xo(b, h), w && (w = Xo(w, h))), {
        text: b,
        template: w
      };
    }, [i, d]), m = j0({
      onKeyDown: o,
      international: l
    });
    return /* @__PURE__ */ a.createElement(er, qo({}, f, {
      ref: r,
      parse: YF,
      format: u,
      onKeyDown: m
    }));
  }
  return t = /* @__PURE__ */ a.forwardRef(t), t.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: H.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: H.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: H.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: H.string,
    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: H.bool,
    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: H.bool,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: H.object
  }, t;
}
const eN = QF();
var tN = ["value", "onChange", "onKeyDown", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"];
function Zo() {
  return Zo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zo.apply(this, arguments);
}
function nN(e, t) {
  if (e == null) return {};
  var n = rN(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function rN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function aN(e) {
  function t(n, r) {
    var o = n.value, i = n.onChange, l = n.onKeyDown, s = n.country, c = n.international, d = n.withCountryCallingCode, f = n.metadata, u = f === void 0 ? e : f, m = n.inputComponent, p = m === void 0 ? "input" : m, y = nN(n, tN), h = V0({
      country: s,
      international: c,
      withCountryCallingCode: d,
      metadata: u
    }), b = se(function($) {
      var x = Vo($.target.value);
      if (x === o) {
        var P = $s(h, x, s, u);
        P.indexOf($.target.value) === 0 && (x = x.slice(0, -1));
      }
      i(x);
    }, [h, o, i, s, u]), w = j0({
      onKeyDown: l,
      international: c
    });
    return /* @__PURE__ */ a.createElement(p, Zo({}, y, {
      ref: r,
      value: $s(h, o, s, u),
      onChange: b,
      onKeyDown: w
    }));
  }
  return t = /* @__PURE__ */ a.forwardRef(t), t.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: H.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: H.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: H.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: H.string,
    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: H.bool,
    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: H.bool,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: H.object,
    /**
     * The `<input/>` component.
     */
    inputComponent: H.elementType
  }, t;
}
const oN = aN();
function $s(e, t, n, r) {
  return Xo(GF(e + t, n, r), e);
}
function iN(e) {
  return Es(e[0]) + Es(e[1]);
}
function Es(e) {
  return String.fromCodePoint(127397 + e.toUpperCase().charCodeAt(0));
}
var lN = ["value", "onChange", "options", "disabled", "readOnly"], sN = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];
function cN(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = dN(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dN(e, t) {
  if (e) {
    if (typeof e == "string") return xs(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return xs(e, t);
  }
}
function xs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Jr() {
  return Jr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jr.apply(this, arguments);
}
function G0(e, t) {
  if (e == null) return {};
  var n = uN(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function uN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Y0(e) {
  var t = e.value, n = e.onChange, r = e.options, o = e.disabled, i = e.readOnly, l = G0(e, lN), s = se(function(c) {
    var d = c.target.value;
    n(d === "ZZ" ? void 0 : d);
  }, [n]);
  return Le(function() {
    return K0(r, t);
  }, [r, t]), /* @__PURE__ */ a.createElement("select", Jr({}, l, {
    disabled: o || i,
    readOnly: i,
    value: t || "ZZ",
    onChange: s
  }), r.map(function(c) {
    var d = c.value, f = c.label, u = c.divider;
    return /* @__PURE__ */ a.createElement("option", {
      key: u ? "|" : d || "ZZ",
      value: u ? "|" : d || "ZZ",
      disabled: !!u,
      style: u ? fN : void 0
    }, f);
  }));
}
Y0.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: H.string,
  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: H.func.isRequired,
  // `<select/>` options.
  options: H.arrayOf(H.shape({
    value: H.string,
    label: H.string,
    divider: H.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: H.bool,
  readOnly: H.bool
};
var fN = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function U0(e) {
  var t = e.value, n = e.options, r = e.className, o = e.iconComponent;
  e.getIconAspectRatio;
  var i = e.arrowComponent, l = i === void 0 ? hN : i, s = e.unicodeFlags, c = G0(e, sN), d = Le(function() {
    return K0(n, t);
  }, [n, t]);
  return /* @__PURE__ */ a.createElement("div", {
    className: "PhoneInputCountry"
  }, /* @__PURE__ */ a.createElement(Y0, Jr({}, c, {
    value: t,
    options: n,
    className: Xr("PhoneInputCountrySelect", r)
  })), s && t && /* @__PURE__ */ a.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, iN(t)), !(s && t) && /* @__PURE__ */ a.createElement(o, {
    "aria-hidden": !0,
    country: t,
    label: d && d.label,
    aspectRatio: s ? 1 : void 0
  }), /* @__PURE__ */ a.createElement(l, null));
}
U0.propTypes = {
  // Country flag component.
  iconComponent: H.elementType,
  // Select arrow component.
  arrowComponent: H.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: H.bool
};
function hN() {
  return /* @__PURE__ */ a.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}
function K0(e, t) {
  for (var n = cN(e), r; !(r = n()).done; ) {
    var o = r.value;
    if (!o.divider && o.value === t)
      return o;
  }
}
var mN = ["country", "countryName", "flags", "flagUrl"];
function Jo() {
  return Jo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jo.apply(this, arguments);
}
function pN(e, t) {
  if (e == null) return {};
  var n = vN(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function vN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function ml(e) {
  var t = e.country, n = e.countryName, r = e.flags, o = e.flagUrl, i = pN(e, mN);
  return r && r[t] ? r[t]({
    title: n
  }) : /* @__PURE__ */ a.createElement("img", Jo({}, i, {
    alt: n,
    role: n ? void 0 : "presentation",
    src: o.replace("{XX}", t).replace("{xx}", t.toLowerCase())
  }));
}
ml.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: H.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: H.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: H.objectOf(H.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: H.string.isRequired
};
var gN = ["aspectRatio"], yN = ["title"], bN = ["title"];
function Qr() {
  return Qr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qr.apply(this, arguments);
}
function pl(e, t) {
  if (e == null) return {};
  var n = wN(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function wN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Sa(e) {
  var t = e.aspectRatio, n = pl(e, gN);
  return t === 1 ? /* @__PURE__ */ a.createElement(q0, n) : /* @__PURE__ */ a.createElement(X0, n);
}
Sa.propTypes = {
  title: H.string.isRequired,
  aspectRatio: H.number
};
function X0(e) {
  var t = e.title, n = pl(e, yN);
  return /* @__PURE__ */ a.createElement("svg", Qr({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /* @__PURE__ */ a.createElement("title", null, t), /* @__PURE__ */ a.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /* @__PURE__ */ a.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /* @__PURE__ */ a.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /* @__PURE__ */ a.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}
X0.propTypes = {
  title: H.string.isRequired
};
function q0(e) {
  var t = e.title, n = pl(e, bN);
  return /* @__PURE__ */ a.createElement("svg", Qr({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /* @__PURE__ */ a.createElement("title", null, t), /* @__PURE__ */ a.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /* @__PURE__ */ a.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /* @__PURE__ */ a.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /* @__PURE__ */ a.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}
q0.propTypes = {
  title: H.string.isRequired
};
function $N(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = EN(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EN(e, t) {
  if (e) {
    if (typeof e == "string") return Ms(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ms(e, t);
  }
}
function Ms(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function xN(e, t) {
  if (!t)
    return e;
  for (var n = [], r = [], o = n, i = $N(t), l; !(l = i()).done; ) {
    var s = l.value;
    s === "|" ? o.push({
      divider: !0
    }) : s === "..." || s === "…" ? o = r : function() {
      var c = void 0;
      s === "🌐" ? c = void 0 : c = s;
      var d = e.indexOf(e.filter(function(u) {
        return u.value === c;
      })[0]), f = e[d];
      e.splice(d, 1), o.push(f);
    }();
  }
  return n.concat(e).concat(r);
}
function MN(e, t) {
  if (e && (e = e.filter(function(n) {
    switch (n) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return za(n, t);
    }
  }), e.length > 0))
    return e;
}
function za(e, t) {
  return M0(e, t) ? !0 : (console.error("Country not found: ".concat(e)), !1);
}
function Z0(e, t) {
  return e && (e = e.filter(function(n) {
    return za(n, t);
  }), e.length === 0 && (e = void 0)), e;
}
var CN = ["country", "label", "aspectRatio"];
function Qo() {
  return Qo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qo.apply(this, arguments);
}
function PN(e, t) {
  if (e == null) return {};
  var n = SN(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function SN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function J0(e) {
  var t = e.flags, n = e.flagUrl, r = e.flagComponent, o = e.internationalIcon;
  function i(l) {
    var s = l.country, c = l.label, d = l.aspectRatio, f = PN(l, CN), u = o === Sa ? d : void 0;
    return /* @__PURE__ */ a.createElement("div", Qo({}, f, {
      className: Xr("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": u === 1,
        "PhoneInputCountryIcon--border": s
      })
    }), s ? /* @__PURE__ */ a.createElement(r, {
      country: s,
      countryName: c,
      flags: t,
      flagUrl: n,
      className: "PhoneInputCountryIconImg"
    }) : /* @__PURE__ */ a.createElement(o, {
      title: c,
      aspectRatio: u,
      className: "PhoneInputCountryIconImg"
    }));
  }
  return i.propTypes = {
    country: H.string,
    label: H.string.isRequired,
    aspectRatio: H.number
  }, i;
}
J0({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: ml,
  internationalIcon: Sa
});
function zN(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = FN(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FN(e, t) {
  if (e) {
    if (typeof e == "string") return Cs(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Cs(e, t);
  }
}
function Cs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function NN(e, t) {
  for (var n = zN(e), r; !(r = n()).done; ) {
    var o = r.value;
    o && DN(o, t);
  }
}
function DN(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
var Q0 = H.shape({
  country_calling_codes: H.object.isRequired,
  countries: H.object.isRequired
}), eu = H.objectOf(H.string);
function Pt(e, t) {
  var n = "+" + At(e, t);
  return n;
}
function ON(e) {
  var t = e.value, n = e.phoneNumber, r = e.defaultCountry, o = e.getAnyCountry, i = e.countries, l = e.required, s = e.metadata, c;
  return n && n.country ? c = n.country : r && (!t || au(t, r, s)) && (c = r), i && i.indexOf(c) < 0 && (c = void 0), !c && l && i && i.length > 0 && (c = o()), c;
}
function AN(e) {
  var t = e.countries, n = e.countryNames, r = e.addInternationalOption, o = e.compareStringsLocales, i = e.compareStrings;
  i || (i = LN);
  var l = t.map(function(s) {
    return {
      value: s,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: n[s] || s
    };
  });
  return l.sort(function(s, c) {
    return i(s.label, c.label, o);
  }), r && l.unshift({
    label: n.ZZ
  }), l;
}
function tu(e, t) {
  return B0(e || "", t);
}
function TN(e) {
  return e.formatNational().replace(/\D/g, "");
}
function kN(e, t) {
  var n = t.prevCountry, r = t.newCountry, o = t.metadata, i = t.useNationalFormat;
  if (n === r)
    return e;
  if (!e)
    return i ? "" : r ? Pt(r, o) : "";
  if (r) {
    if (e[0] === "+") {
      if (i)
        return e.indexOf("+" + At(r, o)) === 0 ? BN(e, r, o) : "";
      if (n) {
        var l = Pt(r, o);
        return e.indexOf(l) === 0 ? e : l;
      } else {
        var s = Pt(r, o);
        return e.indexOf(s) === 0 ? e : s;
      }
    }
  } else if (e[0] !== "+")
    return gn(e, n, o) || "";
  return e;
}
function gn(e, t, n) {
  if (e) {
    if (e[0] === "+") {
      if (e === "+")
        return;
      var r = new An(t, n);
      return r.input(e), r.getNumberValue();
    }
    if (t) {
      var o = ru(e, t, n);
      return "+".concat(At(t, n)).concat(o || "");
    }
  }
}
function HN(e, t, n) {
  var r = ru(e, t, n);
  if (r) {
    var o = r.length - IN(t, n);
    if (o > 0)
      return e.slice(0, e.length - o);
  }
  return e;
}
function IN(e, t) {
  return t = new Te(t), t.selectNumberingPlan(e), t.numberingPlan.possibleLengths()[t.numberingPlan.possibleLengths().length - 1];
}
function nu(e, t) {
  var n = t.country, r = t.countries, o = t.required, i = t.metadata;
  if (e === "+")
    return n;
  var l = _N(e, i);
  return l && (!r || r.indexOf(l) >= 0) ? l : n && !o && !au(e, n, i) ? void 0 : n;
}
function RN(e, t) {
  var n = t.prevPhoneDigits, r = t.country, o = t.defaultCountry, i = t.countryRequired, l = t.getAnyCountry, s = t.countries, c = t.international, d = t.limitMaxLength, f = t.countryCallingCodeEditable, u = t.metadata;
  if (c && f === !1 && r) {
    var m = Pt(r, u);
    if (e.indexOf(m) !== 0) {
      var p, y = e && e[0] !== "+";
      return y ? (e = m + e, p = gn(e, r, u)) : e = m, {
        phoneDigits: e,
        value: p,
        country: r
      };
    }
  }
  c === !1 && r && e && e[0] === "+" && (e = Ps(e, r, u)), e && r && d && (e = HN(e, r, u)), e && e[0] !== "+" && (!r || c) && (e = "+" + e), !e && n && n[0] === "+" && (c ? r = void 0 : r = o), e === "+" && n && n[0] === "+" && n.length > 1 && (r = void 0);
  var h;
  return e && (e[0] === "+" && (e === "+" || r && Pt(r, u).indexOf(e) === 0) ? h = void 0 : h = gn(e, r, u)), h && (r = nu(h, {
    country: r,
    countries: s,
    metadata: u
  }), c === !1 && r && e && e[0] === "+" && (e = Ps(e, r, u), h = gn(e, r, u))), !r && i && (r = o || l()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: e,
    country: r,
    value: h
  };
}
function Ps(e, t, n) {
  if (e.indexOf(Pt(t, n)) === 0) {
    var r = new An(t, n);
    r.input(e);
    var o = r.getNumber();
    return o ? o.formatNational().replace(/\D/g, "") : "";
  } else
    return e.replace(/\D/g, "");
}
function _N(e, t) {
  var n = new An(null, t);
  return n.input(e), n.getCountry();
}
function LN(e, t, n) {
  return String.prototype.localeCompare ? e.localeCompare(t, n) : e < t ? -1 : e > t ? 1 : 0;
}
function BN(e, t, n) {
  if (t) {
    var r = "+" + At(t, n);
    if (e.length < r.length) {
      if (r.indexOf(e) === 0)
        return "";
    } else if (e.indexOf(r) === 0)
      return e.slice(r.length);
  }
  for (var o = 0, i = Object.keys(n.country_calling_codes); o < i.length; o++) {
    var l = i[o];
    if (e.indexOf(l) === 1)
      return e.slice(1 + l.length);
  }
  return "";
}
function ru(e, t, n) {
  var r = new An(t, n);
  r.input(e);
  var o = r.getNumber();
  return o && o.nationalNumber;
}
function au(e, t, n) {
  for (var r = Pt(t, n), o = 0; o < e.length && o < r.length; ) {
    if (e[o] !== r[o])
      return !1;
    o++;
  }
  return !0;
}
function ou(e) {
  var t = e.value, n = e.phoneNumber, r = e.defaultCountry, o = e.international, i = e.useNationalFormat, l = e.metadata;
  return (o === !1 || i) && n && n.country ? TN(n) : !t && o && r ? Pt(r, l) : t;
}
function Ss(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Or(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ss(Object(n), !0).forEach(function(r) {
      WN(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ss(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function WN(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function VN(e, t, n) {
  var r = e.metadata, o = e.countries, i = e.defaultCountry, l = e.value, s = e.reset, c = e.international, d = e.displayInitialValueAsLocalNumber, f = e.initialValueFormat, u = t.defaultCountry, m = t.value, p = t.reset;
  n.country;
  var y = n.value, h = n.hasUserSelectedACountry, b = function(O) {
    return ou(Or(Or({}, O), {}, {
      international: c,
      useNationalFormat: d || f === "national",
      metadata: r
    }));
  };
  if (s !== p)
    return {
      phoneDigits: b({
        value: void 0,
        defaultCountry: i
      }),
      value: void 0,
      country: i,
      hasUserSelectedACountry: void 0
    };
  if (i !== u) {
    var w = !i || za(i, r), $ = (
      // By default, "no value has been entered" means `value` is `undefined`.
      !y || // When `international` is `true`, and some country has been pre-selected,
      // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
      // so in case of `international` being `true`, "the user hasn't entered anything" situation
      // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
      c && y === b({
        value: void 0,
        defaultCountry: u
      })
    ), x = !l && $;
    if (!h && w && x)
      return {
        country: i,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: b({
          value: void 0,
          defaultCountry: i
        }),
        // `value` is `undefined` and it stays so.
        value: void 0
      };
  }
  if (!zs(l, m) && !zs(l, y)) {
    var P, E;
    if (l) {
      P = tu(l, r);
      var z = Z0(o, r);
      P && P.country ? (!z || z.indexOf(P.country) >= 0) && (E = P.country) : (E = nu(l, {
        country: void 0,
        countries: z,
        metadata: r
      }), E || i && l.indexOf(Pt(i, r)) === 0 && (E = i));
    }
    var S;
    return l || (S = {
      hasUserSelectedACountry: void 0
    }), Or(Or({}, S), {}, {
      phoneDigits: b({
        phoneNumber: P,
        value: l,
        defaultCountry: i
      }),
      value: l,
      country: l ? E : i
    });
  }
}
function zs(e, t) {
  return e === null && (e = void 0), t === null && (t = void 0), e === t;
}
function ei(e) {
  "@babel/helpers - typeof";
  return ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ei(e);
}
var jN = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "containerComponentProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];
function Fs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function iu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fs(Object(n), !0).forEach(function(r) {
      st(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $n() {
  return $n = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $n.apply(this, arguments);
}
function GN(e, t) {
  if (e == null) return {};
  var n = YN(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function YN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function UN(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ns(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function KN(e, t, n) {
  return t && Ns(e.prototype, t), n && Ns(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function XN(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ti(e, t);
}
function ti(e, t) {
  return ti = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, ti(e, t);
}
function qN(e) {
  var t = JN();
  return function() {
    var r = ea(e), o;
    if (t) {
      var i = ea(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return ZN(this, o);
  };
}
function ZN(e, t) {
  if (t && (ei(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lt(e);
}
function lt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JN() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ea(e) {
  return ea = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ea(e);
}
function st(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var QN = /* @__PURE__ */ function(e) {
  XN(n, e);
  var t = qN(n);
  function n(r) {
    var o;
    UN(this, n), o = t.call(this, r), st(lt(o), "setInputRef", function(w) {
      NN([o.props.inputRef, o.inputRef], w);
    }), st(lt(o), "isCountrySupportedWithError", function(w) {
      var $ = o.props.metadata;
      return za(w, $);
    }), st(lt(o), "onCountryChange", function(w) {
      var $ = o.props, x = $.international, P = $.metadata, E = $.onChange, z = $.focusInputOnCountrySelection, S = o.state, F = S.phoneDigits, O = S.country, I = kN(F, {
        prevCountry: O,
        newCountry: w,
        metadata: P,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !x
      }), L = gn(I, w, P);
      z && o.inputRef.current.focus(), o.setState({
        country: w,
        hasUserSelectedACountry: !0,
        phoneDigits: I,
        value: L
      }, function() {
        E(L);
      });
    }), st(lt(o), "onChange", function(w) {
      var $ = o.props, x = $.defaultCountry, P = $.onChange, E = $.addInternationalOption, z = $.international, S = $.limitMaxLength, F = $.countryCallingCodeEditable, O = $.metadata, I = o.state, L = I.countries, _ = I.phoneDigits, ne = I.country, R = RN(w, {
        prevPhoneDigits: _,
        country: ne,
        countryRequired: !E,
        defaultCountry: x,
        getAnyCountry: function() {
          return o.getFirstSupportedCountry({
            countries: L
          });
        },
        countries: L,
        international: z,
        limitMaxLength: S,
        countryCallingCodeEditable: F,
        metadata: O
      }), Y = R.phoneDigits, W = R.country, V = R.value, J = {
        phoneDigits: Y,
        value: V,
        country: W
      };
      F === !1 && !V && Y === o.state.phoneDigits && (J.forceRerender = {}), o.setState(
        J,
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        function() {
          return P(V);
        }
      );
    }), st(lt(o), "_onFocus", function() {
      return o.setState({
        isFocused: !0
      });
    }), st(lt(o), "_onBlur", function() {
      return o.setState({
        isFocused: !1
      });
    }), st(lt(o), "onFocus", function(w) {
      o._onFocus();
      var $ = o.props.onFocus;
      $ && $(w);
    }), st(lt(o), "onBlur", function(w) {
      var $ = o.props.onBlur;
      o._onBlur(), $ && $(w);
    }), st(lt(o), "onCountryFocus", function(w) {
      o._onFocus();
      var $ = o.props.countrySelectProps;
      if ($) {
        var x = $.onFocus;
        x && x(w);
      }
    }), st(lt(o), "onCountryBlur", function(w) {
      o._onBlur();
      var $ = o.props.countrySelectProps;
      if ($) {
        var x = $.onBlur;
        x && x(w);
      }
    }), o.inputRef = /* @__PURE__ */ a.createRef();
    var i = o.props, l = i.value;
    i.labels;
    var s = i.international, c = i.addInternationalOption, d = i.displayInitialValueAsLocalNumber, f = i.initialValueFormat, u = i.metadata, m = o.props, p = m.defaultCountry, y = m.countries;
    p && (o.isCountrySupportedWithError(p) || (p = void 0)), y = Z0(y, u);
    var h = tu(l, u);
    o.CountryIcon = J0(o.props);
    var b = ON({
      value: l,
      phoneNumber: h,
      defaultCountry: p,
      required: !c,
      countries: y || Ko(u),
      getAnyCountry: function() {
        return o.getFirstSupportedCountry({
          countries: y
        });
      },
      metadata: u
    });
    return o.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: o.props,
      // The country selected.
      country: b,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: y,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: ou({
        value: l,
        phoneNumber: h,
        defaultCountry: p,
        international: s,
        useNationalFormat: d || f === "national",
        metadata: u
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: l
    }, o;
  }
  return KN(n, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props.onCountryChange, i = this.props.defaultCountry, l = this.state.country;
      o && (i && (this.isCountrySupportedWithError(i) || (i = void 0)), l !== i && o(l));
    }
  }, {
    key: "componentDidUpdate",
    value: function(o, i) {
      var l = this.props.onCountryChange, s = this.state.country;
      l && s !== i.country && l(s);
    }
    // This function mimicks `refSetter` function returned from `useExternalRef()` hook
    // because this class-like React component can't use the `useExternalRef()` hook.
  }, {
    key: "getCountrySelectOptions",
    value: function(o) {
      var i = o.countries, l = this.props, s = l.international, c = l.countryCallingCodeEditable, d = l.countryOptionsOrder, f = l.addInternationalOption, u = l.labels, m = l.locales, p = l.metadata;
      return this.useMemoCountrySelectOptions(function() {
        return xN(AN({
          countries: i || Ko(p),
          countryNames: u,
          addInternationalOption: s && c === !1 ? !1 : f,
          compareStringsLocales: m
          // compareStrings
        }), MN(d, p));
      }, [i, d, f, u, p]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function(o, i) {
      return (!this.countrySelectOptionsMemoDependencies || !tD(i, this.countrySelectOptionsMemoDependencies)) && (this.countrySelectOptionsMemo = o(), this.countrySelectOptionsMemoDependencies = i), this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function(o) {
      var i = o.countries, l = this.getCountrySelectOptions({
        countries: i
      });
      return l[0].value;
    }
    // A shorthand for not passing `metadata` as a second argument.
  }, {
    key: "render",
    value: function() {
      var o = this.props, i = o.name, l = o.disabled, s = o.readOnly, c = o.autoComplete, d = o.style, f = o.className;
      o.inputRef;
      var u = o.inputComponent, m = o.numberInputProps, p = o.smartCaret, y = o.countrySelectComponent, h = o.countrySelectProps, b = o.containerComponent, w = o.containerComponentProps;
      o.defaultCountry, o.countries, o.countryOptionsOrder;
      var $ = o.labels;
      o.flags, o.flagComponent, o.flagUrl, o.addInternationalOption, o.internationalIcon, o.displayInitialValueAsLocalNumber, o.initialValueFormat, o.onCountryChange, o.limitMaxLength, o.countryCallingCodeEditable, o.focusInputOnCountrySelection, o.reset;
      var x = o.metadata, P = o.international;
      o.locales;
      var E = GN(o, jN), z = this.state, S = z.country, F = z.countries, O = z.phoneDigits, I = z.isFocused, L = p ? eN : oN, _ = this.getCountrySelectOptions({
        countries: F
      });
      return /* @__PURE__ */ a.createElement(b, $n({
        style: d,
        className: Xr(f, "PhoneInput", {
          "PhoneInput--focus": I,
          "PhoneInput--disabled": l,
          "PhoneInput--readOnly": s
        })
      }, w), /* @__PURE__ */ a.createElement(y, $n({
        name: i ? "".concat(i, "Country") : void 0,
        "aria-label": $.country
      }, h, {
        value: S,
        options: _,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: l || h && h.disabled,
        readOnly: s || h && h.readOnly,
        iconComponent: this.CountryIcon
      })), /* @__PURE__ */ a.createElement(L, $n({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: c
      }, m, E, {
        international: P ? !0 : void 0,
        withCountryCallingCode: P ? !0 : void 0,
        name: i,
        metadata: x,
        country: S,
        value: O || "",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: l,
        readOnly: s,
        inputComponent: u,
        className: Xr("PhoneInputInput", m && m.className, E.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: (
      // `state` holds previous props as `props`, and also:
      // * `country` — The currently selected country, e.g. `"RU"`.
      // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
      // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
      // (and a couple of other less significant properties)
      function(o, i) {
        return iu({
          // Emulate `prevProps` via `state.props`.
          props: o
        }, VN(o, i.props, i));
      }
    )
  }]), n;
}(a.PureComponent), lu = /* @__PURE__ */ a.forwardRef(function(e, t) {
  return /* @__PURE__ */ a.createElement(QN, $n({}, eD(e), {
    inputRef: t
  }));
});
lu.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: H.string,
  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: H.func.isRequired,
  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: H.func,
  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: H.func,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: H.bool,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: H.bool,
  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: H.string,
  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: H.oneOf(["national"]),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: H.bool,
  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: H.string,
  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: H.arrayOf(H.string),
  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: eu,
  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: H.oneOfType([H.string, H.arrayOf(H.string)]),
  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */
  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: H.string,
  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: H.objectOf(H.elementType),
  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: H.elementType,
  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: H.bool,
  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: H.elementType,
  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: H.arrayOf(H.string),
  /**
   * `<Phone/>` component CSS style object.
   */
  style: H.object,
  /**
   * `<Phone/>` component CSS class.
   */
  className: H.string,
  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: H.elementType,
  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: H.object,
  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: H.elementType,
  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: H.object,
  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: H.elementType,
  /**
   * Wrapping `<div/>` component props.
   */
  containerComponentProps: H.object,
  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: H.bool,
  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */
  international: H.bool,
  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: H.bool,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: H.bool,
  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: Q0,
  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: H.func,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: H.bool
};
var Ds = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: "tel",
  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: U0,
  /**
   * Flag icon component.
   */
  flagComponent: ml,
  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: Sa,
  /**
   * Phone number `<input/>` component.
   */
  inputComponent: "input",
  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: "div",
  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: H.any,
  /**
   *
   */
  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: !0,
  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: !0,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: !0,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: !0
};
function eD(e) {
  e = iu({}, e);
  for (var t in Ds)
    e[t] === void 0 && (e[t] = Ds[t]);
  return e;
}
function tD(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; ) {
    if (e[n] !== t[n])
      return !1;
    n++;
  }
  return !0;
}
const ni = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AB: "Abkhazia",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  OS: "South Ossetia",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
var nD = ["metadata", "labels"];
function ri() {
  return ri = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ri.apply(this, arguments);
}
function rD(e, t) {
  if (e == null) return {};
  var n = aD(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function aD(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function su(e) {
  var t = /* @__PURE__ */ a.forwardRef(function(n, r) {
    var o = n.metadata, i = o === void 0 ? e : o, l = n.labels, s = l === void 0 ? ni : l, c = rD(n, nD);
    return /* @__PURE__ */ a.createElement(lu, ri({}, c, {
      ref: r,
      metadata: i,
      labels: s
    }));
  });
  return t.propTypes = {
    metadata: Q0,
    labels: eu
  }, t;
}
su();
function vr(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(b0), e.apply(this, n);
}
su(b0);
function oD() {
  return vr(B0, arguments);
}
function U_() {
  return vr(Iz, arguments);
}
function K_() {
  return vr(_z, arguments);
}
function iD() {
  return vr(Ko, arguments);
}
function yo() {
  return vr(At, arguments);
}
var lD = ["title"], sD = ["title"], cD = ["title"], dD = ["title"], uD = ["title"], fD = ["title"], hD = ["title"], mD = ["title"], pD = ["title"], vD = ["title"], gD = ["title"], yD = ["title"], bD = ["title"], wD = ["title"], $D = ["title"], ED = ["title"], xD = ["title"], MD = ["title"], CD = ["title"], PD = ["title"], SD = ["title"], zD = ["title"], FD = ["title"], ND = ["title"], DD = ["title"], OD = ["title"], AD = ["title"], TD = ["title"], kD = ["title"], HD = ["title"], ID = ["title"], RD = ["title"], _D = ["title"], LD = ["title"], BD = ["title"], WD = ["title"], VD = ["title"], jD = ["title"], GD = ["title"], YD = ["title"], UD = ["title"], KD = ["title"], XD = ["title"], qD = ["title"], ZD = ["title"], JD = ["title"], QD = ["title"], eO = ["title"], tO = ["title"], nO = ["title"], rO = ["title"], aO = ["title"], oO = ["title"], iO = ["title"], lO = ["title"], sO = ["title"], cO = ["title"], dO = ["title"], uO = ["title"], fO = ["title"], hO = ["title"], mO = ["title"], pO = ["title"], vO = ["title"], gO = ["title"], yO = ["title"], bO = ["title"], wO = ["title"], $O = ["title"], EO = ["title"], xO = ["title"], MO = ["title"], CO = ["title"], PO = ["title"], SO = ["title"], zO = ["title"], FO = ["title"], NO = ["title"], DO = ["title"], OO = ["title"], AO = ["title"], TO = ["title"], kO = ["title"], HO = ["title"], IO = ["title"], RO = ["title"], _O = ["title"], LO = ["title"], BO = ["title"], WO = ["title"], VO = ["title"], jO = ["title"], GO = ["title"], YO = ["title"], UO = ["title"], KO = ["title"], XO = ["title"], qO = ["title"], ZO = ["title"], JO = ["title"], QO = ["title"], eA = ["title"], tA = ["title"], nA = ["title"], rA = ["title"], aA = ["title"], oA = ["title"], iA = ["title"], lA = ["title"], sA = ["title"], cA = ["title"], dA = ["title"], uA = ["title"], fA = ["title"], hA = ["title"], mA = ["title"], pA = ["title"], vA = ["title"], gA = ["title"], yA = ["title"], bA = ["title"], wA = ["title"], $A = ["title"], EA = ["title"], xA = ["title"], MA = ["title"], CA = ["title"], PA = ["title"], SA = ["title"], zA = ["title"], FA = ["title"], NA = ["title"], DA = ["title"], OA = ["title"], AA = ["title"], TA = ["title"], kA = ["title"], HA = ["title"], IA = ["title"], RA = ["title"], _A = ["title"], LA = ["title"], BA = ["title"], WA = ["title"], VA = ["title"], jA = ["title"], GA = ["title"], YA = ["title"], UA = ["title"], KA = ["title"], XA = ["title"], qA = ["title"], ZA = ["title"], JA = ["title"], QA = ["title"], eT = ["title"], tT = ["title"], nT = ["title"], rT = ["title"], aT = ["title"], oT = ["title"], iT = ["title"], lT = ["title"], sT = ["title"], cT = ["title"], dT = ["title"], uT = ["title"], fT = ["title"], hT = ["title"], mT = ["title"], pT = ["title"], vT = ["title"], gT = ["title"], yT = ["title"], bT = ["title"], wT = ["title"], $T = ["title"], ET = ["title"], xT = ["title"], MT = ["title"], CT = ["title"], PT = ["title"], ST = ["title"], zT = ["title"], FT = ["title"], NT = ["title"], DT = ["title"], OT = ["title"], AT = ["title"], TT = ["title"], kT = ["title"], HT = ["title"], IT = ["title"], RT = ["title"], _T = ["title"], LT = ["title"], BT = ["title"], WT = ["title"], VT = ["title"], jT = ["title"], GT = ["title"], YT = ["title"], UT = ["title"], KT = ["title"], XT = ["title"], qT = ["title"], ZT = ["title"], JT = ["title"], QT = ["title"], ek = ["title"], tk = ["title"], nk = ["title"], rk = ["title"], ak = ["title"], ok = ["title"], ik = ["title"], lk = ["title"], sk = ["title"], ck = ["title"], dk = ["title"], uk = ["title"], fk = ["title"], hk = ["title"], mk = ["title"], pk = ["title"], vk = ["title"], gk = ["title"], yk = ["title"], bk = ["title"], wk = ["title"], $k = ["title"], Ek = ["title"], xk = ["title"], Mk = ["title"], Ck = ["title"], Pk = ["title"], Sk = ["title"], zk = ["title"], Fk = ["title"], Nk = ["title"], Dk = ["title"], Ok = ["title"], Ak = ["title"], Tk = ["title"], kk = ["title"], Hk = ["title"], Ik = ["title"], Rk = ["title"], _k = ["title"], Lk = ["title"], Bk = ["title"], Wk = ["title"], Vk = ["title"], jk = ["title"];
function M() {
  return M = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M.apply(this, arguments);
}
function C(e, t) {
  if (e == null) return {};
  var n = Gk(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Gk(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var cu = function(t) {
  var n = t.title, r = C(t, lD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#29DBFF",
    d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#29DBFF",
    d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#29DBFF",
    d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#5CC85C",
    d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-82.3 291.431 225.686)",
    fill: "#F7A226",
    cx: 291.4,
    cy: 225.7,
    rx: 48.7,
    ry: 15.7
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-68.099 303.087 164.67)",
    fill: "#DDC7AB",
    cx: 303.1,
    cy: 164.7,
    rx: 11.7,
    ry: 7.2
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-81.738 291.697 271.697)",
    fill: "#DDC7AB",
    cx: 291.7,
    cy: 271.7,
    rx: 11.4,
    ry: 3.3
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
    fill: "#DDC7AB",
    cx: 299.6,
    cy: 269.4,
    rx: 3.3,
    ry: 11
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-21.518 314.54 201.06)",
    fill: "#DDC7AB",
    cx: 314.5,
    cy: 201.1,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-21.518 317.511 178.077)",
    fill: "#DDC7AB",
    cx: 317.5,
    cy: 178.1,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-7.7 473.781 225.857)",
    fill: "#F7A226",
    cx: 473.6,
    cy: 225.9,
    rx: 15.7,
    ry: 48.7
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-21.901 462.057 164.866)",
    fill: "#DDC7AB",
    cx: 462,
    cy: 164.9,
    rx: 7.2,
    ry: 11.7
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-8.27 473.27 271.908)",
    fill: "#DDC7AB",
    cx: 473.4,
    cy: 271.9,
    rx: 3.3,
    ry: 11.4
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
    fill: "#DDC7AB",
    cx: 465.5,
    cy: 269.6,
    rx: 11,
    ry: 3.3
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-68.482 450.552 201.247)",
    fill: "#DDC7AB",
    cx: 450.6,
    cy: 201.2,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ a.createElement("ellipse", {
    transform: "rotate(-68.482 447.58 178.265)",
    fill: "#DDC7AB",
    cx: 447.6,
    cy: 178.3,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#B0C6CC",
    d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }));
}, du = function(t) {
  var n = t.title, r = C(t, sD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
    stroke: "#D80027",
    strokeWidth: 7
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
    stroke: "#D80027",
    strokeWidth: 5
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#BC8B00",
    d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
  }));
}, uu = function(t) {
  var n = t.title, r = C(t, cD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#009e49",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h171v342H0z"
  }));
}, fu = function(t) {
  var n = t.title, r = C(t, dD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#DB3E00",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#479900",
    d: "M331 0h182v342H331z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h181.8v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
  }));
}, hu = function(t) {
  var n = t.title, r = C(t, uD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0072c6",
    d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#ce1126"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M256.5 342 0 0v342z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M513 342V0L256 342z"
  })));
}, mu = function(t) {
  var n = t.title, r = C(t, fD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#00318b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#8DCCFF",
    d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D87B00",
    d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D87B00",
    d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D87B00",
    d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
  }));
}, pu = function(t) {
  var n = t.title, r = C(t, hD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#ED2024",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#212121",
    d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
    fill: "#212121"
  }));
}, vu = function(t) {
  var n = t.title, r = C(t, mD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF9811",
    d: "M0 228h513v114H0z"
  }));
}, gu = function(t) {
  var n = t.title, r = C(t, pD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    d: "M0 171h513v171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#000",
    d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
  })));
}, yu = function(t) {
  var n = t.title, r = C(t, vD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744 496"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#3A7DCE",
    d: "M0 0h744v496H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
  }));
}, bu = function(t) {
  var n = t.title, r = C(t, gD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v114H0zm0 228h512v114H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFDA44",
    stroke: "#d6ab00",
    strokeWidth: 5,
    cx: 256.5,
    cy: 171,
    r: 40
  }));
}, wu = function(t) {
  var n = t.title, r = C(t, yD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M513 33 95.3 171 513 310.76V342L0 171 513 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M513 287.18v24.58L81.72 171 513 30v24.16"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#EFC100",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
  }));
}, $u = function(t) {
  var n = t.title, r = C(t, bD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0zm0 228h513v114H0z"
  }));
}, Eu = function(t) {
  var n = t.title, r = C(t, wD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
    fill: "#D80027"
  }));
}, xu = function(t) {
  var n = t.title, r = C(t, $D);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363 242"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h363v242H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f30028",
    d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
    fill: "#FFDA44"
  }));
}, Mu = function(t) {
  var n = t.title, r = C(t, ED);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
  }));
}, Cu = function(t) {
  var n = t.title, r = C(t, xD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#ef3340",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#00b5e2",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#509e2f",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
  })));
}, Pu = function(t) {
  var n = t.title, r = C(t, MD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#10338C",
    d: "M0 0h513.1v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#F6C500",
    d: "M99.9 0h342v342"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
  })));
}, Su = function(t) {
  var n = t.title, r = C(t, CD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#ffc726",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#00267f"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
  }));
}, zu = function(t) {
  var n = t.title, r = C(t, PD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#2d6e41",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#F40B32",
    cx: 218.902,
    cy: 256.5,
    r: 115
  }));
}, Fu = function(t) {
  var n = t.title, r = C(t, SD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#fdda25",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ef3340",
    d: "M342 0h171v342H342z"
  }));
}, Nu = function(t) {
  var n = t.title, r = C(t, zD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#3d944f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
  }));
}, Du = function(t) {
  var n = t.title, r = C(t, FD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#00966e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#d62612",
    d: "M0 228h513v114H0z"
  }));
}, Ou = function(t) {
  var n = t.title, r = C(t, ND);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
  }));
}, Au = function(t) {
  var n = t.title, r = C(t, DD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
    fill: "#47a644"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 251.6,
    cy: 170.7,
    r: 100.2
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
    fill: "#D80027",
    stroke: "#47a644",
    strokeWidth: 3
  }));
}, Tu = function(t) {
  var n = t.title, r = C(t, OD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#008751",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#fcd116",
    d: "M196.666 85.333H513v171H196.666z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#e8112d",
    d: "M196.666 256H513v171H196.666z"
  }));
}, ku = function(t) {
  var n = t.title, r = C(t, AD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E6BC00",
    d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ADADAD",
    d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E6BC00",
    d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#125ECC",
    d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFE600",
    d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D60537",
    d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#EACE00",
    d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#7A6920",
    d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ADADAD",
    d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 258.2,
    cy: 204.19,
    r: 16.93
  }));
}, Hu = function(t) {
  var n = t.title, r = C(t, TD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#012169",
    d: "M0 .1h256.5v171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#c8102e",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#c8102e",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ a.createElement("g", {
    transform: "translate(13 5)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2F8F22",
    d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#65B5D2",
    cx: 383.65,
    cy: 214.56,
    r: 39.88
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#c8102e",
    cx: 343.77,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#c8102e",
    cx: 423.52,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#c8102e",
    cx: 383.65,
    cy: 154.75,
    r: 19.94
  })));
}, Iu = function(t) {
  var n = t.title, r = C(t, kD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m0 193.74 513 127.19V214.26L0 97.08z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M513 234.26v-86.67L0 20.41v86.67"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
  })));
}, Ru = function(t) {
  var n = t.title, r = C(t, HD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f9e300",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#007934",
    d: "M0 228h513v114H0z"
  }));
}, _u = function(t) {
  var n = t.title, r = C(t, ID);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#012a87",
    d: "M0 342h513V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f9d90f",
    d: "M250.4 0H0v166.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#dc171d",
    d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    cx: 140.4,
    cy: 160.6,
    r: 57.7
  }));
}, Lu = function(t) {
  var n = t.title, r = C(t, RD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#009b3a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#fedf00",
    d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 80.4
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#002776",
    d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
  }));
}, Bu = function(t) {
  var n = t.title, r = C(t, _D);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#ffc72c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#00778b"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M256 171 0 342V0z"
  }));
}, Wu = function(t) {
  var n = t.title, r = C(t, LD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF7415",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M513 0H0v342"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 42,
    strokeMiterlimit: 10,
    d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
  }));
}, Vu = function(t) {
  var n = t.title, r = C(t, BD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 33.333 1100 733.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  }));
}, ju = function(t) {
  var n = t.title, r = C(t, WD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 238h513v104H0zM0 0h513v104H0z",
    fill: "#6da9d2"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 125.5h513v89.656H0z"
  }));
}, Gu = function(t) {
  var n = t.title, r = C(t, VD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#007C30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#CE1720",
    d: "M0 230h513V0H0"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M100 230V0H0v342h513-413z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
    fill: "#CE1720"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
    fill: "none",
    stroke: "#CE1720",
    strokeWidth: 7
  }));
}, Yu = function(t) {
  var n = t.title, r = C(t, jD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#003e87",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 260.9,
    cy: 170.9,
    r: 118.9
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "none",
    stroke: "#6DA544",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    cx: 261.9,
    cy: 173.1,
    r: 94.5
  }), /* @__PURE__ */ a.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#003e87",
    d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M211.3 128.1h101.3v46.7H211.3z"
  })), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v35H0zm0 306h513v35H0z",
    fill: "#ce1127"
  }));
}, Uu = function(t) {
  var n = t.title, r = C(t, GD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
    fill: "red"
  }));
}, Ku = function(t) {
  var n = t.title, r = C(t, YD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "green",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
  }));
}, Xu = function(t) {
  var n = t.title, r = C(t, UD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M513 66.9V0H411.7L0 274.4V342h100.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M513 0v40.1L60.2 342H0v-40.8L451.8 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
  }));
}, qu = function(t) {
  var n = t.title, r = C(t, KD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#d21034",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z",
    fill: "#3a9927"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#003082",
    d: "M0 0v85.3h211.5V0h89v85.3H513V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
    fill: "#FFF"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
    fill: "#ffce00"
  }));
}, Zu = function(t) {
  var n = t.title, r = C(t, XD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#da1a35",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#009543",
    d: "M443.726 85.331 102.4 426.657H0V85.331z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#fbde4a",
    d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
  }));
}, Ju = function(t) {
  var n = t.title, r = C(t, qD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "red",
    d: "M0 85.337h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
  }));
}, Qu = function(t) {
  var n = t.title, r = C(t, ZD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#009e60",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f77f00",
    d: "M0 0h171v342H0z"
  }));
}, e3 = function(t) {
  var n = t.title, r = C(t, JD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#01237a",
    d: "M0 85.332h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
    fill: "#FFF"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
  })));
}, t3 = function(t) {
  var n = t.title, r = C(t, QD);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M196 0h317v171H196z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0037A1",
    d: "M0 0h196v171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
  }));
}, n3 = function(t) {
  var n = t.title, r = C(t, eO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
    fill: "#fcd116"
  }));
}, r3 = function(t) {
  var n = t.title, r = C(t, tO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
    fill: "#FFDA44"
  }));
}, a3 = function(t) {
  var n = t.title, r = C(t, nO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 256.5h513V342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 171h513v85.5H0z"
  }));
}, o3 = function(t) {
  var n = t.title, r = C(t, rO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 285h513v57H0zM0 0h513v57H0z"
  }));
}, i3 = function(t) {
  var n = t.title, r = C(t, aO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF9811",
    d: "M0-40.8v422.9-211.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
  }));
}, l3 = function(t) {
  var n = t.title, r = C(t, oO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#003893",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#cf2027",
    d: "M0 182.2h513v41.4H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
    fill: "#f7d116",
    stroke: "#000"
  }));
}, s3 = function(t) {
  var n = t.title, r = C(t, iO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f9e814",
    d: "M0 233.5h513v51H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
    fill: "#FFF"
  }));
}, c3 = function(t) {
  var n = t.title, r = C(t, lO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1c8a42",
    d: "M0 0h513v342"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
    fill: "#FFF"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#ffc639",
    cx: 267.1,
    cy: 170.7,
    r: 74.5
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1c8a42",
    d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ffc639",
    d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
  }));
}, d3 = function(t) {
  var n = t.title, r = C(t, sO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#DB7D00",
    d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#006651"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
  })));
}, u3 = function(t) {
  var n = t.title, r = C(t, cO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#11457e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#d7141a",
    d: "M513 171v171H0l215-171z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H215.185L0 0z"
  }));
}, f3 = function(t) {
  var n = t.title, r = C(t, dO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 228h513v114H0z"
  }));
}, h3 = function(t) {
  var n = t.title, r = C(t, uO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#12ad2b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6ab2e7",
    d: "M513 0v166.7L0 170.8V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#d7141a",
    d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
  }));
}, m3 = function(t) {
  var n = t.title, r = C(t, fO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
  }));
}, p3 = function(t) {
  var n = t.title, r = C(t, hO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 110.7v120h513v-120z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 110.7h513v40H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 190.7h513v40H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M196 0h120v342H196z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M196 0h40v342h-40z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M274.7 0h40v342h-40z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#D80027",
    cx: 256,
    cy: 170.7,
    r: 123.1
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
    fill: "#496E2D"
  }));
}, v3 = function(t) {
  var n = t.title, r = C(t, mO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 215.2h211.5v126.1H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h211.5v126.2H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M300.5 0H512v126.2H300.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M300.5 215.2H512v126.1H300.5z"
  }), /* @__PURE__ */ a.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
  })));
}, g3 = function(t) {
  var n = t.title, r = C(t, pO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#41662E",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0H513v342H256.5z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
  })));
}, y3 = function(t) {
  var n = t.title, r = C(t, vO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 170.7h513V256H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 256h513v85.3H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 171,
    r: 60
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#4C1F00",
    d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#57BA17",
    d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
  }));
}, b3 = function(t) {
  var n = t.title, r = C(t, gO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#111",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#368FD8",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 228h513v114H0z"
  }));
}, w3 = function(t) {
  var n = t.title, r = C(t, yO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#C09300",
    d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
  }));
}, $3 = function(t) {
  var n = t.title, r = C(t, bO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#428823",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
  })));
}, E3 = function(t) {
  var n = t.title, r = C(t, wO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#56AF35",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "m0 342 513-171L0 0v342z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#ffc945"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 119.5,
    cy: 148.3,
    r: 17.5
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 148.9,
    cy: 158.5,
    r: 17.5
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 134.7,
    cy: 135.2,
    r: 17.5
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 119.5,
    cy: 172.7,
    r: 17.5
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 149.9,
    cy: 182.8,
    r: 17.5
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 122.5,
    cy: 198,
    r: 17.5
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 145.9,
    cy: 205.2,
    r: 17.5
  })));
}, x3 = function(t) {
  var n = t.title, r = C(t, $O);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D03433",
    d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FBCA46",
    d: "M0 4h22.5v7H0V4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M7.8 7h1v.5h-1V7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A41517",
    d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A41517",
    d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
  }));
}, M3 = function(t) {
  var n = t.title, r = C(t, EO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#20AA46",
    d: "M0 0h22.5v5H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E92F3B",
    d: "M0 10h22.5v5H0v-5z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FADF50",
    d: "M0 5h22.5v5H0V5z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#205CCA",
    cx: 11.3,
    cy: 7.5,
    r: 5.2
  }), /* @__PURE__ */ a.createElement("g", {
    stroke: "#FFDB3D",
    fill: "none"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
    strokeWidth: 0.5
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
    strokeWidth: 0.25
  })));
}, C3 = function(t) {
  var n = t.title, r = C(t, xO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810 540"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#039",
    d: "M0 0h810v540H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FC0",
    d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
  }));
}, P3 = function(t) {
  var n = t.title, r = C(t, MO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
  }));
}, S3 = function(t) {
  var n = t.title, r = C(t, CO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#62b5e5",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256v170H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#F3F3F3",
    d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
  }));
}, z3 = function(t) {
  var n = t.title, r = C(t, PO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1F8BDE",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#187536",
    d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
  }));
}, F3 = function(t) {
  var n = t.title, r = C(t, SO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
    fill: "#FFF"
  }));
}, N3 = function(t) {
  var n = t.title, r = C(t, zO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0F61A5",
    d: "M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E50E3D",
    d: "M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, D3 = function(t) {
  var n = t.title, r = C(t, FO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, O3 = function(t) {
  var n = t.title, r = C(t, NO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }));
}, A3 = function(t) {
  var n = t.title, r = C(t, DO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v341.3H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z"
  })), /* @__PURE__ */ a.createElement("path", {
    d: "M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z",
    fill: "#0052B4"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z"
  })));
}, T3 = function(t) {
  var n = t.title, r = C(t, OO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#c60a0a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#3E8446",
    d: "m256.5 170.7-212 126.1V44.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#3E8446",
    d: "M467.5 44.5v252.3l-211-126.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#c60a0a",
    cx: 244.5,
    cy: 170.7,
    r: 76.2
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#A2001D",
    cx: 99.1,
    cy: 182.1,
    r: 7.4
  }));
}, k3 = function(t) {
  var n = t.title, r = C(t, AO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M.8 0h21v15H.8V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#eb000e",
    d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#eb000e",
    d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
  }));
}, H3 = function(t) {
  var n = t.title, r = C(t, TO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FDEB01",
    d: "m0 0 90 60H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#58A846",
    d: "M90 0v60L0 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ED3D24",
    d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
  }));
}, I3 = function(t) {
  var n = t.title, r = C(t, kO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
  }));
}, R3 = function(t) {
  var n = t.title, r = C(t, HO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z"
  }));
}, _3 = function(t) {
  var n = t.title, r = C(t, IO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 230h513v112H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
  }));
}, L3 = function(t) {
  var n = t.title, r = C(t, RO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H0V0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 185.8,
    cy: 171.2,
    r: 117.8
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
  }));
}, B3 = function(t) {
  var n = t.title, r = C(t, _O);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#cf0d19",
    d: "M0 0h513v100H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 121h513v100H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1a7e25",
    d: "M0 242h513v100H0z"
  }));
}, W3 = function(t) {
  var n = t.title, r = C(t, LO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h171v342H0z"
  }));
}, V3 = function(t) {
  var n = t.title, r = C(t, BO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, j3 = function(t) {
  var n = t.title, r = C(t, WO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v113.8H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 227.6h513V342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0070C8",
    d: "M126 171 0 342V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#786145",
    d: "M264.5 179.8h9.8l4 25.8h-17.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
    fill: "#FFDA00",
    stroke: "#000",
    strokeMiterlimit: 10
  }));
}, G3 = function(t) {
  var n = t.title, r = C(t, VO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#0d5eaf"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h190v190H0z"
  })), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M0 76h190v38H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M76 0h38v190H76z"
  })));
}, Y3 = function(t) {
  var n = t.title, r = C(t, jO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#FFF",
    cx: 443.4,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 406.9,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 364,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#39B200",
    d: "m342 190.1 43.4 86.9 43.5-86.9z"
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#9B9B9B",
    cx: 327.5,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#757575",
    d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#C6B56F",
    cx: 385.4,
    cy: 67,
    r: 29
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#A54A00",
    cx: 386,
    cy: 88.7,
    r: 29
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 443.4,
    cy: 117.7,
    r: 29
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#0049FF",
    cx: 342.2,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#0041F9",
    cx: 429.8,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#F7D71E",
    cx: 386,
    cy: 233.6,
    r: 29
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#CEC851",
    cx: 457.9,
    cy: 190.1,
    r: 29
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 385.4,
    cy: 289.5,
    r: 29
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#7C0B29",
    d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 327.5,
    cy: 117.4,
    r: 29
  }));
}, U3 = function(t) {
  var n = t.title, r = C(t, GO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#338AF3"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#DCC26D",
    cx: 256,
    cy: 155.8,
    r: 25.5
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#628A40",
    d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
  }));
}, K3 = function(t) {
  var n = t.title, r = C(t, YO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M11.1 11.1h489.7v319.1H11.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#7DBEF1",
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1C8AE6",
    d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF042",
    d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#259C7B",
    d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#8E5715",
    d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    stroke: "#D80027",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }));
}, X3 = function(t) {
  var n = t.title, r = C(t, UO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h182v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z"
  }));
}, q3 = function(t) {
  var n = t.title, r = C(t, KO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#009E49",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m0 0 947 300L0 600V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFD00D",
    d: "M0 26.1 870 300 0 573.9V26.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2D2D2D",
    d: "m0 0 450 300L0 600V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D3132F",
    d: "m0 35 397.5 265L0 565V35z"
  }));
}, Z3 = function(t) {
  var n = t.title, r = C(t, XO);
  return /* @__PURE__ */ a.createElement("svg", M({
    viewBox: "0 0.5 21 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
    fill: "#FFF"
  })));
}, J3 = function(t) {
  var n = t.title, r = C(t, qO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M223.4 170.7c.3-.3.5-.6.8-.9-.3.3-.5.6-.8.9zm-34.2 41.9 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }));
}, Q3 = function(t) {
  var n = t.title, r = C(t, ZO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
    fill: "#338AF3"
  }));
}, e4 = function(t) {
  var n = t.title, r = C(t, JO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
    fill: "#338AF3"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
    fill: "#0052B4"
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "#D80027",
    fill: "#FFF",
    d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
    fill: "#D80027"
  }));
}, t4 = function(t) {
  var n = t.title, r = C(t, QO);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M0 0h513v172H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 172h513v172H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#0052B4",
    cx: 270.7,
    cy: 182.3,
    r: 55.4
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#A2001D",
    cx: 270.7,
    cy: 182.3,
    r: 27.7
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M229.1 113.1h83.1l-41.5 41.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M256.8 140.8h27.7v83h-27.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
  }));
}, n4 = function(t) {
  var n = t.title, r = C(t, eA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }));
}, r4 = function(t) {
  var n = t.title, r = C(t, tA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#fc0",
    d: "M0 0h300v200H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0768a9",
    d: "M0 0h200v200H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v200H0z"
  }));
}, a4 = function(t) {
  var n = t.title, r = C(t, nA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E00",
    d: "M0 0h513v171H0z"
  }));
}, o4 = function(t) {
  var n = t.title, r = C(t, rA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF9811",
    d: "M342 0h171v342H342z"
  }));
}, i4 = function(t) {
  var n = t.title, r = C(t, aA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
    fill: "#2E52B2"
  }));
}, l4 = function(t) {
  var n = t.title, r = C(t, oA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#E52D42",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#F8DD4E",
    d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
  }));
}, s4 = function(t) {
  var n = t.title, r = C(t, iA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#181A93",
    d: "M17.3 0h478.4v342H17.3V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFA44A",
    d: "M0 0h513v114H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1A9F0B",
    d: "M0 228h513v114H0V228z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0V114z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 34.2
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#181A93",
    d: "M256.5 216.6c-25.1 0-45.6-20.5-45.6-45.6s20.5-45.6 45.6-45.6 45.6 20.5 45.6 45.6-20.5 45.6-45.6 45.6zm0-11.4c18.2 0 34.2-16 34.2-34.2s-15.9-34.2-34.2-34.2-34.2 16-34.2 34.2 16 34.2 34.2 34.2z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#181A93",
    cx: 256.5,
    cy: 171,
    r: 22.8
  }));
}, c4 = function(t) {
  var n = t.title, r = C(t, lA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h513V342H0V-.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h256v171H0V-.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
    fill: "#A2001D"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
  })), /* @__PURE__ */ a.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#5DA51E",
    stroke: "#45602C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E2DD24",
    stroke: "#525625",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
  }));
}, d4 = function(t) {
  var n = t.title, r = C(t, sA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
    fill: "#547C31"
  }));
}, u4 = function(t) {
  var n = t.title, r = C(t, cA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
    fill: "#FFF",
    opacity: 0.5
  }));
}, f4 = function(t) {
  var n = t.title, r = C(t, dA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, h4 = function(t) {
  var n = t.title, r = C(t, uA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M342 0H0v341.3h512V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, m4 = function(t) {
  var n = t.title, r = C(t, fA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
  }));
}, p4 = function(t) {
  var n = t.title, r = C(t, hA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }));
}, v4 = function(t) {
  var n = t.title, r = C(t, mA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M256.5 170.7 0 341.3V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
  }));
}, g4 = function(t) {
  var n = t.title, r = C(t, pA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#D80027",
    cx: 256.5,
    cy: 171,
    r: 96
  }));
}, y4 = function(t) {
  var n = t.title, r = C(t, vA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h512v90.579H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 251h513v91H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z"
  })), /* @__PURE__ */ a.createElement("path", {
    d: "M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z",
    fill: "#A2001D"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z"
  }));
}, b4 = function(t) {
  var n = t.title, r = C(t, gA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 256,
    cy: 170.7,
    r: 170.7
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#D80027",
    cx: 257.4,
    cy: 170.7,
    r: 71.6
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
    fill: "#FFDA44"
  }));
}, w4 = function(t) {
  var n = t.title, r = C(t, yA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
  }));
}, $4 = function(t) {
  var n = t.title, r = C(t, bA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h450v300H0V0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FCD116"
  }, /* @__PURE__ */ a.createElement("circle", {
    cx: 227.6,
    cy: 161.2,
    r: 56.2
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#003F87",
    d: "M0 175h450v125H0V175z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
  }), /* @__PURE__ */ a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCD116",
    d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
  }));
}, E4 = function(t) {
  var n = t.title, r = C(t, wA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v85.5H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513V171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 171h513v85.5H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M256.5 171 0 342V0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  })));
}, x4 = function(t) {
  var n = t.title, r = C(t, $A);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M512 0H0v342"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
    fill: "#FFF"
  }));
}, M4 = function(t) {
  var n = t.title, r = C(t, EA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#91DC5A",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v57.188H0zm0 284.1h513v57.177H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 79.9h513v181.582H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 190.33,
    cy: 171,
    r: 65.668
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
  }));
}, C4 = function(t) {
  var n = t.title, r = C(t, xA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    transform: "rotate(-56.31)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "M0 753.3v125"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#ca163a",
    cy: 540.8,
    r: 150
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0e4896",
    d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
  })), /* @__PURE__ */ a.createElement("path", {
    d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
  }));
}, P4 = function(t) {
  var n = t.title, r = C(t, MA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M167 227.6 0 341.3V0l167 113.8z"
  }));
}, S4 = function(t) {
  var n = t.title, r = C(t, CA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#6DA544",
    cx: 384,
    cy: 96.5,
    r: 29.7
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M332.1 89H436v44.5H332.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M435.9 170.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z",
    fill: "#F3F3F3"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })));
}, z4 = function(t) {
  var n = t.title, r = C(t, PA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#36B6CC",
    d: "M0 0h513v342H0V0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFD400",
    cx: 256.5,
    cy: 170.9,
    r: 68.4
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFD400",
    d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
  }));
}, F4 = function(t) {
  var n = t.title, r = C(t, SA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 65.9
  }));
}, N4 = function(t) {
  var n = t.title, r = C(t, zA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#14AF5A",
    d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
  }));
}, D4 = function(t) {
  var n = t.title, r = C(t, FA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#55B2FF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#F3F3F3",
    d: "M148.5 298.1h216l-108-254.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#333",
    d: "m186 272.7 70.5-160.3L327 272.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M148.5 298.1h216l-108-101.7z"
  }));
}, O4 = function(t) {
  var n = t.title, r = C(t, NA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
  }));
}, A4 = function(t) {
  var n = t.title, r = C(t, DA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M222.6 22.3h267.1v296.8H222.6z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M22.3 22.3h200.3v296.8H22.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M200.3 0h22.3v342h-22.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M22.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF9811",
    d: "M111.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    stroke: "#FFDA44",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
  }));
}, T4 = function(t) {
  var n = t.title, r = C(t, OA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z",
    fill: "#bf0a30"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#002868",
    d: "M0 0h155.6v155.6H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
  }));
}, k4 = function(t) {
  var n = t.title, r = C(t, AA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 227.6h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
  }));
}, H4 = function(t) {
  var n = t.title, r = C(t, TA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }));
}, I4 = function(t) {
  var n = t.title, r = C(t, kA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 228h513v114H0z"
  }));
}, R4 = function(t) {
  var n = t.title, r = C(t, HA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    className: "prefix__st1",
    d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
    fill: "#A2001D"
  }));
}, _4 = function(t) {
  var n = t.title, r = C(t, IA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z"
  })));
}, L4 = function(t) {
  var n = t.title, r = C(t, RA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 .3V342h513V.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#20661B",
    d: "M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
  }));
}, B4 = function(t) {
  var n = t.title, r = C(t, _A);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#c70000",
    d: "M0 85.333h512V256H0z"
  }));
}, W4 = function(t) {
  var n = t.title, r = C(t, LA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#AF7F59",
    d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
  }));
}, V4 = function(t) {
  var n = t.title, r = C(t, BA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#E6BE53",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E01D24",
    d: "M20 20h473v302H20z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#E6BE53",
    d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#215F90",
    d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
  }));
}, j4 = function(t) {
  var n = t.title, r = C(t, WA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 72"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h108v72H0z",
    fill: "#003787"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h108L60 48v24H48V48z",
    fill: "#fff"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 54,
    cy: 30,
    r: 8,
    fill: "#f9d90f"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M44 30h20L54 48z",
    fill: "#fff"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M54 48 38 33h32z",
    fill: "#cf142b"
  }));
}, G4 = function(t) {
  var n = t.title, r = C(t, VA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M512 426.666V85.329H0v341.337h512z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331H0v170.666h512V85.331z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h181.793v341.337H0z"
  }));
}, Y4 = function(t) {
  var n = t.title, r = C(t, jA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#1E509C",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M513 176.1V81.3L0 342l513-165.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#F18D36",
    d: "M513 0v81.3L0 342 513 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
  }));
}, U4 = function(t) {
  var n = t.title, r = C(t, GA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 256,
    cy: 252.29,
    r: 59.359
  })), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 252.29,
    r: 44.522
  }));
}, K4 = function(t) {
  var n = t.title, r = C(t, YA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, X4 = function(t) {
  var n = t.title, r = C(t, UA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
  }));
}, q4 = function(t) {
  var n = t.title, r = C(t, KA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#095FAD",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M342 0h171v342H342zM0 0h171v342H0z",
    fill: "#BE1229"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 86,
    cy: 203.4,
    r: 14.8
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 86,
    cy: 144,
    r: 14.8
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M76.3 123.9h19.5L86 108.3z"
  })));
}, Z4 = function(t) {
  var n = t.title, r = C(t, XA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#00745a",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
    fill: "#FFF"
  }));
}, J4 = function(t) {
  var n = t.title, r = C(t, qA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0071BC",
    d: "M0 0h750v500H0V0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 1.9
  }, /* @__PURE__ */ a.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 225,
    fill: "#fff"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 165,
    fill: "#0071BC"
  })), /* @__PURE__ */ a.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#8C8A8C",
    strokeWidth: 1.9,
    d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
  })));
}, Q4 = function(t) {
  var n = t.title, r = C(t, ZA);
  return /* @__PURE__ */ a.createElement("svg", M({
    viewBox: "0 0 900 600",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#231f1e",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#00a650",
    d: "M0 0h900v300H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ef1923",
    d: "m0 0 450 300L0 600z"
  }));
}, ef = function(t) {
  var n = t.title, r = C(t, JA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 100 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#006233",
    d: "M0 100h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#cd2a3e",
    d: "M0 100h513v46H0zm0 296h513v46H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ffc400",
    d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ffc400",
    d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
  }));
}, tf = function(t) {
  var n = t.title, r = C(t, QA);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#1B4991",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#00A2B8",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A35023",
    d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
  }));
}, nf = function(t) {
  var n = t.title, r = C(t, eT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#C31B28",
    d: "M256 0h256.5v342H256z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ACABB1",
    stroke: "#C31B28",
    strokeWidth: 2,
    d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
  }));
}, rf = function(t) {
  var n = t.title, r = C(t, tT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#f7ce00",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#e32737",
    d: "M0 85.331h512v85.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#191f6a",
    d: "M0 170.657h512v85.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#00a04e",
    d: "M0 341.331h512v85.337H0z"
  }));
}, af = function(t) {
  var n = t.title, r = C(t, nT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#d01920",
    d: "M0 85.331h512v341.333H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#017c3b",
    d: "M144.696 174.375h222.609v163.25H144.696z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
  }));
}, of = function(t) {
  var n = t.title, r = C(t, rT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#272727",
    d: "M0 0h512v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#e40112",
    d: "M0 114h512v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#07893f",
    d: "M0 228h512v114H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#e40112",
    cx: 256,
    cy: 125,
    r: 95
  }));
}, lf = function(t) {
  var n = t.title, r = C(t, aT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#dc2339",
    d: "M342 0H0v341.3h513V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#11865d",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M171 0h171v342H171z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#8C9157",
    d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#C59262",
    cx: 256.5,
    cy: 159.1,
    rx: 24.3,
    ry: 36.4
  }));
}, sf = function(t) {
  var n = t.title, r = C(t, oT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
    fill: "#c00"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#006",
    d: "M0 0h256.5v195.4H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
    fill: "#fc0"
  }));
}, cf = function(t) {
  var n = t.title, r = C(t, iT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f4d900",
    d: "M0 323.333h513v104H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#006d66",
    d: "M0 85.333h513v104H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 204.333h513v104H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#cb0f31",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f4d900",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, df = function(t) {
  var n = t.title, r = C(t, lT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
  }));
}, uf = function(t) {
  var n = t.title, r = C(t, sT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 426.7"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#009543",
    d: "M0 293h640v133.7H0V293z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ED4135",
    d: "M0 132h640v161.3H0V132z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0035AD",
    d: "M0 0h640v133.3H0V0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FAE600",
    stroke: "#000",
    strokeWidth: 5.3,
    cx: 240,
    cy: 213.3,
    r: 157.3
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
  }), /* @__PURE__ */ a.createElement("ellipse", {
    cx: 237.8,
    cy: 280.5,
    rx: 16.8,
    ry: 26.5
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 237.4,
    cy: 143.4,
    r: 20.9
  }), /* @__PURE__ */ a.createElement("ellipse", {
    cx: 238.4,
    cy: 211.1,
    rx: 19.9,
    ry: 12.1
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
  }));
}, ff = function(t) {
  var n = t.title, r = C(t, cT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#e05206",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0db02b",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#e05206",
    cx: 256,
    cy: 256,
    r: 32
  }));
}, hf = function(t) {
  var n = t.title, r = C(t, dT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
    fill: "#007b23"
  }));
}, mf = function(t) {
  var n = t.title, r = C(t, uT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342z",
    fill: "#007b23"
  }));
}, pf = function(t) {
  var n = t.title, r = C(t, fT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#338AF3"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
  }));
}, vf = function(t) {
  var n = t.title, r = C(t, hT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#cd1f2a",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1d4185",
    d: "M0 228h513v114H0z"
  }));
}, gf = function(t) {
  var n = t.title, r = C(t, mT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, yf = function(t) {
  var n = t.title, r = C(t, pT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
  })));
}, bf = function(t) {
  var n = t.title, r = C(t, vT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 239.994h512v32H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
  }));
}, wf = function(t) {
  var n = t.title, r = C(t, gT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h256v170.663H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80z"
  })), /* @__PURE__ */ a.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.329v15.083l57.377 38.251H80z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 255.997v-15.082l57.377-38.252H80z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M256 255.997v-15.082l-57.377-38.252H176z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 128,
    cy: 170.66,
    r: 22.627
  })), /* @__PURE__ */ a.createElement("path", {
    d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
    fill: "#FFDA44"
  }));
}, $f = function(t) {
  var n = t.title, r = C(t, yT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
    fill: "#D80027"
  }));
}, Ef = function(t) {
  var n = t.title, r = C(t, bT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M138 0h377v114H138z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#4A7C3A",
    d: "M138 230h377v114H138z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 10,
    strokeMiterlimit: 2
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
  })));
}, xf = function(t) {
  var n = t.title, r = C(t, wT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M256 256v170.663H0V256h256z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H256V85.337h256z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }));
}, Mf = function(t) {
  var n = t.title, r = C(t, $T);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
    fill: "#D80027"
  }));
}, Cf = function(t) {
  var n = t.title, r = C(t, ET);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
    fill: "#D80027"
  }));
}, Pf = function(t) {
  var n = t.title, r = C(t, xT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M0 85.33h512v341.332"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
  }));
}, Sf = function(t) {
  var n = t.title, r = C(t, MT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M512 85.337V256H256L0 85.337z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M512 256v170.663H0L256 256z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
    fill: "#FFDA44"
  }));
}, zf = function(t) {
  var n = t.title, r = C(t, CT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.343h512v341.326H0z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#01411c",
    d: "M128 85.331h384v341.337H128z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
    fill: "#FFF"
  }));
}, Ff = function(t) {
  var n = t.title, r = C(t, PT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512V256H0z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v170.663H0z"
  }));
}, Nf = function(t) {
  var n = t.title, r = C(t, ST);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 26.666 640 426.666"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  })));
}, Df = function(t) {
  var n = t.title, r = C(t, zT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ACABB1",
    d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, Of = function(t) {
  var n = t.title, r = C(t, FT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, Af = function(t) {
  var n = t.title, r = C(t, NT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#268024",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#e4312b",
    d: "M256 256.006 0 426.668V85.331z"
  }));
}, Tf = function(t) {
  var n = t.title, r = C(t, DT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M196.641 85.337v341.326H0V85.337z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFDA44",
    cx: 196.641,
    cy: 256,
    r: 64
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
  }));
}, kf = function(t) {
  var n = t.title, r = C(t, OT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFDA44",
    cx: 218.902,
    cy: 255.994,
    r: 74.207
  }));
}, Hf = function(t) {
  var n = t.title, r = C(t, AT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
  }));
}, If = function(t) {
  var n = t.title, r = C(t, TT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#751A46",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
  }));
}, Rf = function(t) {
  var n = t.title, r = C(t, kT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 26.666 640 426.666"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  })));
}, _f = function(t) {
  var n = t.title, r = C(t, HT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, Lf = function(t) {
  var n = t.title, r = C(t, IT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 312.882h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
  }));
}, Bf = function(t) {
  var n = t.title, r = C(t, RT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.33v341.332h512V85.33z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.884h512v113.775H0z"
  }));
}, Wf = function(t) {
  var n = t.title, r = C(t, _T);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 255.994h512v81.619H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 337.614h512v89.043H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
  }));
}, Vf = function(t) {
  var n = t.title, r = C(t, LT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#055e1c",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M207.093 248.57h32.601v22.261h-32.601z"
  })));
}, jf = function(t) {
  var n = t.title, r = C(t, BT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.329h512"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
    fill: "#FFF"
  }));
}, Gf = function(t) {
  var n = t.title, r = C(t, WT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M235.454 85.337 0 426.663 427.345 85.337z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M512 329.393 0 426.663h512z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337h-84.655L0 426.663l512-204.512z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337v341.326L235.454 85.337z"
  }));
}, Yf = function(t) {
  var n = t.title, r = C(t, VT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 426.668V85.331l256 170.675z"
  }));
}, Uf = function(t) {
  var n = t.title, r = C(t, jT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
  }));
}, Kf = function(t) {
  var n = t.title, r = C(t, GT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512V256H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
  })));
}, Xf = function(t) {
  var n = t.title, r = C(t, YT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#29DBFF",
    d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ffda44",
    d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#BF521B",
    d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#474747",
    d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
  }));
}, qf = function(t) {
  var n = t.title, r = C(t, UT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 199.112h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
  }));
}, Zf = function(t) {
  var n = t.title, r = C(t, KT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, Jf = function(t) {
  var n = t.title, r = C(t, XT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 196.641h512v118.717H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 315.359h512v111.304H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
  }));
}, Qf = function(t) {
  var n = t.title, r = C(t, qT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 312.888h512v113.775H0z"
  }));
}, e5 = function(t) {
  var n = t.title, r = C(t, ZT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.34h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M512 85.334v166.69L0 256.175V85.334z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
  }));
}, t5 = function(t) {
  var n = t.title, r = C(t, JT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M330.207 85.331H512v341.337H330.207z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
    fill: "#496E2D"
  }));
}, n5 = function(t) {
  var n = t.title, r = C(t, QT);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
  }));
}, r5 = function(t) {
  var n = t.title, r = C(t, ek);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M0 196.636h512v118.728H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
  }));
}, a5 = function(t) {
  var n = t.title, r = C(t, tk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
  }));
}, o5 = function(t) {
  var n = t.title, r = C(t, nk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
  }));
}, i5 = function(t) {
  var n = t.title, r = C(t, rk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M228.582 261.936 256 214.447l27.418 47.489z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
  }));
}, l5 = function(t) {
  var n = t.title, r = C(t, ak);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331v166.69L0 256.173V85.331z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 118.862,
    cy: 210.287,
    r: 18.286
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#F3F3F3",
    d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
  }));
}, s5 = function(t) {
  var n = t.title, r = C(t, ok);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 312.882h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m187.31 215.184 9.208 28.341h29.802l-24.11 17.518 9.209 28.342-24.109-17.516-24.11 17.516 9.209-28.342-24.109-17.518h29.801zm137.38 0 9.209 28.341H363.7l-24.109 17.518 9.209 28.342-24.11-17.516-24.109 17.516 9.209-28.342-24.11-17.518h29.802z",
    fill: "#6DA544"
  }));
}, c5 = function(t) {
  var n = t.title, r = C(t, ik);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#2B5DEA",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDF29",
    d: "M0 100h900v400H0V100z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D70000",
    d: "M0 150h900v300H0V150z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }));
}, d5 = function(t) {
  var n = t.title, r = C(t, lk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#29DBFF",
    d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#29DBFF",
    d: "m385.4 251.7-22.9-43h45.8z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m385.4 165.8-22.9 42.9h45.8z"
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 474.8,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 295.3,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
  }), /* @__PURE__ */ a.createElement("ellipse", {
    fill: "#A5A5A5",
    cx: 386.3,
    cy: 104.3,
    rx: 34.3,
    ry: 23.3
  }));
}, u5 = function(t) {
  var n = t.title, r = C(t, sk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF9811",
    d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#A2001D",
    d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, f5 = function(t) {
  var n = t.title, r = C(t, ck);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, h5 = function(t) {
  var n = t.title, r = C(t, dk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#073AB6",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h11.3v7.5H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#F44653",
    d: "M7.1 0h3.6v7H7.1V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1035BB",
    d: "M0 0h3.6v7H0V0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
  }));
}, m5 = function(t) {
  var n = t.title, r = C(t, uk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
    fill: "#496E2D"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h204.054v204.054H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
  }));
}, p5 = function(t) {
  var n = t.title, r = C(t, fk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512V426.66H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 194.056h512v123.882H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
    fill: "#D80027"
  }));
}, v5 = function(t) {
  var n = t.title, r = C(t, hk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
    fill: "#FFDA44"
  }));
}, g5 = function(t) {
  var n = t.title, r = C(t, mk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
    fill: "#FFDA44"
  }));
}, y5 = function(t) {
  var n = t.title, r = C(t, pk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 90.691v330.618L189.217 256z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
  }));
}, b5 = function(t) {
  var n = t.title, r = C(t, vk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M83.478 85.337h89.043v341.326H83.478z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
    fill: "#496E2D"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M120.576 248.576h14.84v14.84h-14.84z"
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 128,
    cy: 206.113,
    r: 7.421
  }), /* @__PURE__ */ a.createElement("circle", {
    cx: 128,
    cy: 305.887,
    r: 7.421
  })));
}, w5 = function(t) {
  var n = t.title, r = C(t, gk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 255.994,
    r: 96
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
  })));
}, $5 = function(t) {
  var n = t.title, r = C(t, yk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
  }));
}, E5 = function(t) {
  var n = t.title, r = C(t, bk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#E30A17",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
  }));
}, x5 = function(t) {
  var n = t.title, r = C(t, wk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
  }));
}, M5 = function(t) {
  var n = t.title, r = C(t, $k);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#00B2EE",
    d: "M0 300h450V0h450v600H0V300z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M449.9 39.9v53.9h-81z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
  }));
}, C5 = function(t) {
  var n = t.title, r = C(t, Ek);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h256V256H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#0052B4",
    cx: 128,
    cy: 170.674,
    r: 29.006
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
  }));
}, P5 = function(t) {
  var n = t.title, r = C(t, xk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }));
}, S5 = function(t) {
  var n = t.title, r = C(t, Mk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512V256H0z"
  }));
}, z5 = function(t) {
  var n = t.title, r = C(t, Ck);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#232323",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 56.9h512v56.9H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D32300",
    d: "M0 113.8h512v56.9H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 227.6h512v56.9H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D32300",
    d: "M0 284.4h512v56.9H0z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 170.7,
    r: 80.7
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
  }));
}, F5 = function(t) {
  var n = t.title, r = C(t, Pk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, N5 = function(t) {
  var n = t.title, r = C(t, Sk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, D5 = function(t) {
  var n = t.title, r = C(t, zk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
    fill: "#0038a8"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h256.5v190H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FED443",
    d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
  }));
}, O5 = function(t) {
  var n = t.title, r = C(t, Fk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
    fill: "#FFF"
  }));
}, A5 = function(t) {
  var n = t.title, r = C(t, Nk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.331h256v341.337H256z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ACABB1",
    d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
  }));
}, T5 = function(t) {
  var n = t.title, r = C(t, Dk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
    fill: "#6DA544"
  }));
}, k5 = function(t) {
  var n = t.title, r = C(t, Ok);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFCE00",
    d: "M0 0h22.5v5H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#203899",
    d: "M0 5h22.5v5H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D82B2B",
    d: "M0 10h22.5v5H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
  }));
}, H5 = function(t) {
  var n = t.title, r = C(t, Ak);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M372.87 215.181h22.261v59.359H372.87z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#A2001D",
    cx: 384,
    cy: 215.181,
    r: 11.13
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
    fill: "#FFDA44"
  }));
}, I5 = function(t) {
  var n = t.title, r = C(t, Tk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1583C4",
    d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1583C4",
    d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1583C4",
    d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#409347",
    d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFD836",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
  })), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M201.3 111.8h119.4v37.9H201.3z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#1583C4",
    d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
  }));
}, R5 = function(t) {
  var n = t.title, r = C(t, kk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M196.641 85.337H0v341.326h512V85.337z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
  }));
}, _5 = function(t) {
  var n = t.title, r = C(t, Hk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#6DA544",
    d: "M512 256v170.663H0L215.185 256z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H215.185L0 85.337z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
  }), /* @__PURE__ */ a.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
  })));
}, L5 = function(t) {
  var n = t.title, r = C(t, Ik);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#ED2939",
    d: "M0 0h150v100H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#002395",
    d: "M0 0h20v44.33H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M20 0h20v44.33H20z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M0 44.33h62.75V0"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
  }));
}, B5 = function(t) {
  var n = t.title, r = C(t, Rk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
    fill: "#FFF"
  }));
}, W5 = function(t) {
  var n = t.title, r = C(t, _k);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.34H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
    fill: "#FFF"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
  }));
}, V5 = function(t) {
  var n = t.title, r = C(t, Lk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }));
}, j5 = function(t) {
  var n = t.title, r = C(t, Bk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "#7f7f7f",
    strokeWidth: 0.25,
    fill: "#ABABAB",
    d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#DE393A",
    d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#3951A3",
    d: "M31 13.1h28v15.7H31z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FEE05F",
    cx: 39.1,
    cy: 36.5,
    r: 3
  }), /* @__PURE__ */ a.createElement("circle", {
    fill: "#FEE05F",
    cx: 50.9,
    cy: 36.5,
    r: 3
  }));
}, G5 = function(t) {
  var n = t.title, r = C(t, Wk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M114.024 256.001 0 141.926v228.17z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#ffb915",
    d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#007847",
    d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#000c8a",
    d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#e1392d",
    d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
  }));
}, Y5 = function(t) {
  var n = t.title, r = C(t, Vk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF9811",
    d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 255.994h56.888v170.663h-56.888z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FF9811",
    d: "M455.112 255.994H512v170.663h-56.888z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M398.225 255.994h56.888v170.663h-56.888z"
  }));
}, U5 = function(t) {
  var n = t.title, r = C(t, jk);
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ a.createElement("title", null, n), /* @__PURE__ */ a.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#057f44",
    d: "M0 85.333h512v48.868H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#057f44",
    d: "M0 378.542h512v48.128H0z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFF",
    d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#D80027",
    d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "#FFDA44",
    d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
  }));
};
const Yk = {
  AC: cu,
  AD: du,
  AE: uu,
  AF: fu,
  AG: hu,
  AI: mu,
  AL: pu,
  AM: vu,
  AO: gu,
  AQ: yu,
  AR: bu,
  AS: wu,
  AT: $u,
  AU: Eu,
  AW: xu,
  AX: Mu,
  AZ: Cu,
  BA: Pu,
  BB: Su,
  BD: zu,
  BE: Fu,
  BF: Nu,
  BG: Du,
  BH: Ou,
  BI: Au,
  BJ: Tu,
  BL: ku,
  BM: Hu,
  BN: Iu,
  BO: Ru,
  BQ: _u,
  BR: Lu,
  BS: Bu,
  BT: Wu,
  BV: Vu,
  BW: ju,
  BY: Gu,
  BZ: Yu,
  CA: Uu,
  CC: Ku,
  CD: Xu,
  CF: qu,
  CG: Zu,
  CH: Ju,
  CI: Qu,
  CK: e3,
  CL: t3,
  CM: n3,
  CN: r3,
  CO: a3,
  CR: o3,
  CU: i3,
  CV: l3,
  CW: s3,
  CX: c3,
  CY: d3,
  CZ: u3,
  DE: f3,
  DJ: h3,
  DK: m3,
  DM: p3,
  DO: v3,
  DZ: g3,
  EC: y3,
  EE: b3,
  EG: w3,
  EH: $3,
  ER: E3,
  ES: x3,
  ET: M3,
  EU: C3,
  FI: P3,
  FJ: S3,
  FK: z3,
  FM: F3,
  FO: N3,
  FR: D3,
  GA: O3,
  GB: A3,
  GD: T3,
  GE: k3,
  GF: H3,
  GG: I3,
  GH: R3,
  GI: _3,
  GL: L3,
  GM: B3,
  GN: W3,
  GP: V3,
  GQ: j3,
  GR: G3,
  GS: Y3,
  GT: U3,
  GU: K3,
  GW: X3,
  GY: q3,
  HK: Z3,
  HM: J3,
  HN: Q3,
  HR: e4,
  HT: t4,
  HU: n4,
  IC: r4,
  ID: a4,
  IE: o4,
  IL: i4,
  IM: l4,
  IN: s4,
  IO: c4,
  IQ: d4,
  IR: u4,
  IS: f4,
  IT: h4,
  JE: m4,
  JM: p4,
  JO: v4,
  JP: g4,
  KE: y4,
  KG: b4,
  KH: w4,
  KI: $4,
  KM: E4,
  KN: x4,
  KP: M4,
  KR: C4,
  KW: P4,
  KY: S4,
  KZ: z4,
  LA: F4,
  LB: N4,
  LC: D4,
  LI: O4,
  LK: A4,
  LR: T4,
  LS: k4,
  LT: H4,
  LU: I4,
  LV: R4,
  LY: _4,
  MA: L4,
  MC: B4,
  MD: W4,
  ME: V4,
  MF: j4,
  MG: G4,
  MH: Y4,
  MK: U4,
  ML: K4,
  MM: X4,
  MN: q4,
  MO: Z4,
  MP: J4,
  MQ: Q4,
  MR: ef,
  MS: tf,
  MT: nf,
  MU: rf,
  MV: af,
  MW: of,
  MX: lf,
  MY: sf,
  MZ: cf,
  NA: df,
  NC: uf,
  NE: ff,
  NF: hf,
  NG: mf,
  NI: pf,
  NL: vf,
  NO: gf,
  NP: yf,
  NR: bf,
  NU: wf,
  NZ: $f,
  OM: Ef,
  PA: xf,
  PE: Mf,
  PF: Cf,
  PG: Pf,
  PH: Sf,
  PK: zf,
  PL: Ff,
  PM: Nf,
  PN: Df,
  PR: Of,
  PS: Af,
  PT: Tf,
  PW: kf,
  PY: Hf,
  QA: If,
  RE: Rf,
  RO: _f,
  RS: Lf,
  RU: Bf,
  RW: Wf,
  SA: Vf,
  SB: jf,
  SC: Gf,
  SD: Yf,
  SE: Uf,
  SG: Kf,
  SH: Xf,
  SI: qf,
  SJ: Zf,
  SK: Jf,
  SL: Qf,
  SM: e5,
  SN: t5,
  SO: n5,
  SR: r5,
  SS: a5,
  ST: o5,
  SV: i5,
  SX: l5,
  SY: s5,
  SZ: c5,
  TA: d5,
  TC: u5,
  TD: f5,
  TF: h5,
  TG: m5,
  TH: p5,
  TJ: v5,
  TK: g5,
  TL: y5,
  TM: b5,
  TN: w5,
  TO: $5,
  TR: E5,
  TT: x5,
  TV: M5,
  TW: C5,
  TZ: P5,
  UA: S5,
  UG: z5,
  UM: F5,
  US: N5,
  UY: D5,
  UZ: O5,
  VA: A5,
  VC: T5,
  VE: k5,
  VG: H5,
  VI: I5,
  VN: R5,
  VU: _5,
  WF: L5,
  WS: B5,
  XK: W5,
  YE: V5,
  YT: j5,
  ZA: G5,
  ZM: Y5,
  ZW: U5
}, K5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AC: cu,
  AD: du,
  AE: uu,
  AF: fu,
  AG: hu,
  AI: mu,
  AL: pu,
  AM: vu,
  AO: gu,
  AQ: yu,
  AR: bu,
  AS: wu,
  AT: $u,
  AU: Eu,
  AW: xu,
  AX: Mu,
  AZ: Cu,
  BA: Pu,
  BB: Su,
  BD: zu,
  BE: Fu,
  BF: Nu,
  BG: Du,
  BH: Ou,
  BI: Au,
  BJ: Tu,
  BL: ku,
  BM: Hu,
  BN: Iu,
  BO: Ru,
  BQ: _u,
  BR: Lu,
  BS: Bu,
  BT: Wu,
  BV: Vu,
  BW: ju,
  BY: Gu,
  BZ: Yu,
  CA: Uu,
  CC: Ku,
  CD: Xu,
  CF: qu,
  CG: Zu,
  CH: Ju,
  CI: Qu,
  CK: e3,
  CL: t3,
  CM: n3,
  CN: r3,
  CO: a3,
  CR: o3,
  CU: i3,
  CV: l3,
  CW: s3,
  CX: c3,
  CY: d3,
  CZ: u3,
  DE: f3,
  DJ: h3,
  DK: m3,
  DM: p3,
  DO: v3,
  DZ: g3,
  EC: y3,
  EE: b3,
  EG: w3,
  EH: $3,
  ER: E3,
  ES: x3,
  ET: M3,
  EU: C3,
  FI: P3,
  FJ: S3,
  FK: z3,
  FM: F3,
  FO: N3,
  FR: D3,
  GA: O3,
  GB: A3,
  GD: T3,
  GE: k3,
  GF: H3,
  GG: I3,
  GH: R3,
  GI: _3,
  GL: L3,
  GM: B3,
  GN: W3,
  GP: V3,
  GQ: j3,
  GR: G3,
  GS: Y3,
  GT: U3,
  GU: K3,
  GW: X3,
  GY: q3,
  HK: Z3,
  HM: J3,
  HN: Q3,
  HR: e4,
  HT: t4,
  HU: n4,
  IC: r4,
  ID: a4,
  IE: o4,
  IL: i4,
  IM: l4,
  IN: s4,
  IO: c4,
  IQ: d4,
  IR: u4,
  IS: f4,
  IT: h4,
  JE: m4,
  JM: p4,
  JO: v4,
  JP: g4,
  KE: y4,
  KG: b4,
  KH: w4,
  KI: $4,
  KM: E4,
  KN: x4,
  KP: M4,
  KR: C4,
  KW: P4,
  KY: S4,
  KZ: z4,
  LA: F4,
  LB: N4,
  LC: D4,
  LI: O4,
  LK: A4,
  LR: T4,
  LS: k4,
  LT: H4,
  LU: I4,
  LV: R4,
  LY: _4,
  MA: L4,
  MC: B4,
  MD: W4,
  ME: V4,
  MF: j4,
  MG: G4,
  MH: Y4,
  MK: U4,
  ML: K4,
  MM: X4,
  MN: q4,
  MO: Z4,
  MP: J4,
  MQ: Q4,
  MR: ef,
  MS: tf,
  MT: nf,
  MU: rf,
  MV: af,
  MW: of,
  MX: lf,
  MY: sf,
  MZ: cf,
  NA: df,
  NC: uf,
  NE: ff,
  NF: hf,
  NG: mf,
  NI: pf,
  NL: vf,
  NO: gf,
  NP: yf,
  NR: bf,
  NU: wf,
  NZ: $f,
  OM: Ef,
  PA: xf,
  PE: Mf,
  PF: Cf,
  PG: Pf,
  PH: Sf,
  PK: zf,
  PL: Ff,
  PM: Nf,
  PN: Df,
  PR: Of,
  PS: Af,
  PT: Tf,
  PW: kf,
  PY: Hf,
  QA: If,
  RE: Rf,
  RO: _f,
  RS: Lf,
  RU: Bf,
  RW: Wf,
  SA: Vf,
  SB: jf,
  SC: Gf,
  SD: Yf,
  SE: Uf,
  SG: Kf,
  SH: Xf,
  SI: qf,
  SJ: Zf,
  SK: Jf,
  SL: Qf,
  SM: e5,
  SN: t5,
  SO: n5,
  SR: r5,
  SS: a5,
  ST: o5,
  SV: i5,
  SX: l5,
  SY: s5,
  SZ: c5,
  TA: d5,
  TC: u5,
  TD: f5,
  TF: h5,
  TG: m5,
  TH: p5,
  TJ: v5,
  TK: g5,
  TL: y5,
  TM: b5,
  TN: w5,
  TO: $5,
  TR: E5,
  TT: x5,
  TV: M5,
  TW: C5,
  TZ: P5,
  UA: S5,
  UG: z5,
  UM: F5,
  US: N5,
  UY: D5,
  UZ: O5,
  VA: A5,
  VC: T5,
  VE: k5,
  VG: H5,
  VI: I5,
  VN: R5,
  VU: _5,
  WF: L5,
  WS: B5,
  XK: W5,
  YE: V5,
  YT: j5,
  ZA: G5,
  ZM: Y5,
  ZW: U5,
  default: Yk
}, Symbol.toStringTag, { value: "Module" }));
function Os(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function X5(e) {
  const t = v.useRef({ value: e, previous: e });
  return v.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Uk = [" ", "Enter", "ArrowUp", "ArrowDown"], Kk = [" ", "Enter"], gr = "Select", [Fa, Na, Xk] = oa(gr), [Tn] = ur(gr, [
  Xk,
  pa
]), Da = pa(), [qk, Ut] = Tn(gr), [Zk, Jk] = Tn(gr), vl = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: l,
    defaultValue: s,
    onValueChange: c,
    dir: d,
    name: f,
    autoComplete: u,
    disabled: m,
    required: p,
    form: y
  } = e, h = Da(t), [b, w] = v.useState(null), [$, x] = v.useState(null), [P, E] = v.useState(!1), z = ia(d), [S = !1, F] = bt({
    prop: r,
    defaultProp: o,
    onChange: i
  }), [O, I] = bt({
    prop: l,
    defaultProp: s,
    onChange: c
  }), L = v.useRef(null), _ = b ? y || !!b.closest("form") : !0, [ne, R] = v.useState(/* @__PURE__ */ new Set()), Y = Array.from(ne).map((W) => W.props.value).join(";");
  return /* @__PURE__ */ g(ji, { ...h, children: /* @__PURE__ */ re(
    qk,
    {
      required: p,
      scope: t,
      trigger: b,
      onTriggerChange: w,
      valueNode: $,
      onValueNodeChange: x,
      valueNodeHasChildren: P,
      onValueNodeHasChildrenChange: E,
      contentId: qe(),
      value: O,
      onValueChange: I,
      open: S,
      onOpenChange: F,
      dir: z,
      triggerPointerDownPosRef: L,
      disabled: m,
      children: [
        /* @__PURE__ */ g(Fa.Provider, { scope: t, children: /* @__PURE__ */ g(
          Zk,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: v.useCallback((W) => {
              R((V) => new Set(V).add(W));
            }, []),
            onNativeOptionRemove: v.useCallback((W) => {
              R((V) => {
                const J = new Set(V);
                return J.delete(W), J;
              });
            }, []),
            children: n
          }
        ) }),
        _ ? /* @__PURE__ */ re(
          gh,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: f,
            autoComplete: u,
            value: O,
            onChange: (W) => I(W.target.value),
            disabled: m,
            form: y,
            children: [
              O === void 0 ? /* @__PURE__ */ g("option", { value: "" }) : null,
              Array.from(ne)
            ]
          },
          Y
        ) : null
      ]
    }
  ) });
};
vl.displayName = gr;
var q5 = "SelectTrigger", Z5 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = Da(n), l = Ut(q5, n), s = l.disabled || r, c = xe(t, l.onTriggerChange), d = Na(n), f = v.useRef("touch"), [u, m, p] = yh((h) => {
      const b = d().filter((x) => !x.disabled), w = b.find((x) => x.value === l.value), $ = bh(b, h, w);
      $ !== void 0 && l.onValueChange($.value);
    }), y = (h) => {
      s || (l.onOpenChange(!0), p()), h && (l.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      });
    };
    return /* @__PURE__ */ g(Wd, { asChild: !0, ...i, children: /* @__PURE__ */ g(
      me.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": l.contentId,
        "aria-expanded": l.open,
        "aria-required": l.required,
        "aria-autocomplete": "none",
        dir: l.dir,
        "data-state": l.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": vh(l.value) ? "" : void 0,
        ...o,
        ref: c,
        onClick: ee(o.onClick, (h) => {
          h.currentTarget.focus(), f.current !== "mouse" && y(h);
        }),
        onPointerDown: ee(o.onPointerDown, (h) => {
          f.current = h.pointerType;
          const b = h.target;
          b.hasPointerCapture(h.pointerId) && b.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && h.pointerType === "mouse" && (y(h), h.preventDefault());
        }),
        onKeyDown: ee(o.onKeyDown, (h) => {
          const b = u.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && m(h.key), !(b && h.key === " ") && Uk.includes(h.key) && (y(), h.preventDefault());
        })
      }
    ) });
  }
);
Z5.displayName = q5;
var J5 = "SelectValue", Q5 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: l = "", ...s } = e, c = Ut(J5, n), { onValueNodeHasChildrenChange: d } = c, f = i !== void 0, u = xe(t, c.onValueNodeChange);
    return ke(() => {
      d(f);
    }, [d, f]), /* @__PURE__ */ g(
      me.span,
      {
        ...s,
        ref: u,
        style: { pointerEvents: "none" },
        children: vh(c.value) ? /* @__PURE__ */ g(Ge, { children: l }) : i
      }
    );
  }
);
Q5.displayName = J5;
var Qk = "SelectIcon", eh = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ g(me.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
eh.displayName = Qk;
var eH = "SelectPortal", th = (e) => /* @__PURE__ */ g(va, { asChild: !0, ...e });
th.displayName = eH;
var rn = "SelectContent", nh = v.forwardRef(
  (e, t) => {
    const n = Ut(rn, e.__scopeSelect), [r, o] = v.useState();
    if (ke(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? ir.createPortal(
        /* @__PURE__ */ g(rh, { scope: e.__scopeSelect, children: /* @__PURE__ */ g(Fa.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ g("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ g(ah, { ...e, ref: t });
  }
);
nh.displayName = rn;
var dt = 10, [rh, Kt] = Tn(rn), tH = "SelectContentImpl", ah = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      //
      // PopperContent props
      side: s,
      sideOffset: c,
      align: d,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: y,
      hideWhenDetached: h,
      avoidCollisions: b,
      //
      ...w
    } = e, $ = Ut(rn, n), [x, P] = v.useState(null), [E, z] = v.useState(null), S = xe(t, (A) => P(A)), [F, O] = v.useState(null), [I, L] = v.useState(
      null
    ), _ = Na(n), [ne, R] = v.useState(!1), Y = v.useRef(!1);
    v.useEffect(() => {
      if (x) return ya(x);
    }, [x]), ki();
    const W = v.useCallback(
      (A) => {
        const [U, ...oe] = _().map((k) => k.ref.current), [G] = oe.slice(-1), ce = document.activeElement;
        for (const k of A)
          if (k === ce || (k?.scrollIntoView({ block: "nearest" }), k === U && E && (E.scrollTop = 0), k === G && E && (E.scrollTop = E.scrollHeight), k?.focus(), document.activeElement !== ce)) return;
      },
      [_, E]
    ), V = v.useCallback(
      () => W([F, x]),
      [W, F, x]
    );
    v.useEffect(() => {
      ne && V();
    }, [ne, V]);
    const { onOpenChange: J, triggerPointerDownPosRef: T } = $;
    v.useEffect(() => {
      if (x) {
        let A = { x: 0, y: 0 };
        const U = (G) => {
          A = {
            x: Math.abs(Math.round(G.pageX) - (T.current?.x ?? 0)),
            y: Math.abs(Math.round(G.pageY) - (T.current?.y ?? 0))
          };
        }, oe = (G) => {
          A.x <= 10 && A.y <= 10 ? G.preventDefault() : x.contains(G.target) || J(!1), document.removeEventListener("pointermove", U), T.current = null;
        };
        return T.current !== null && (document.addEventListener("pointermove", U), document.addEventListener("pointerup", oe, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", U), document.removeEventListener("pointerup", oe, { capture: !0 });
        };
      }
    }, [x, J, T]), v.useEffect(() => {
      const A = () => J(!1);
      return window.addEventListener("blur", A), window.addEventListener("resize", A), () => {
        window.removeEventListener("blur", A), window.removeEventListener("resize", A);
      };
    }, [J]);
    const [N, D] = yh((A) => {
      const U = _().filter((ce) => !ce.disabled), oe = U.find((ce) => ce.ref.current === document.activeElement), G = bh(U, A, oe);
      G && setTimeout(() => G.ref.current.focus());
    }), K = v.useCallback(
      (A, U, oe) => {
        const G = !Y.current && !oe;
        ($.value !== void 0 && $.value === U || G) && (O(A), G && (Y.current = !0));
      },
      [$.value]
    ), ae = v.useCallback(() => x?.focus(), [x]), Q = v.useCallback(
      (A, U, oe) => {
        const G = !Y.current && !oe;
        ($.value !== void 0 && $.value === U || G) && L(A);
      },
      [$.value]
    ), ie = r === "popper" ? ai : oh, X = ie === ai ? {
      side: s,
      sideOffset: c,
      align: d,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: y,
      hideWhenDetached: h,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ g(
      rh,
      {
        scope: n,
        content: x,
        viewport: E,
        onViewportChange: z,
        itemRefCallback: K,
        selectedItem: F,
        onItemLeave: ae,
        itemTextRefCallback: Q,
        focusSelectedItem: V,
        selectedItemText: I,
        position: r,
        isPositioned: ne,
        searchRef: N,
        children: /* @__PURE__ */ g(wa, { as: en, allowPinchZoom: !0, children: /* @__PURE__ */ g(
          fa,
          {
            asChild: !0,
            trapped: $.open,
            onMountAutoFocus: (A) => {
              A.preventDefault();
            },
            onUnmountAutoFocus: ee(o, (A) => {
              $.trigger?.focus({ preventScroll: !0 }), A.preventDefault();
            }),
            children: /* @__PURE__ */ g(
              ua,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: l,
                onFocusOutside: (A) => A.preventDefault(),
                onDismiss: () => $.onOpenChange(!1),
                children: /* @__PURE__ */ g(
                  ie,
                  {
                    role: "listbox",
                    id: $.contentId,
                    "data-state": $.open ? "open" : "closed",
                    dir: $.dir,
                    onContextMenu: (A) => A.preventDefault(),
                    ...w,
                    ...X,
                    onPlaced: () => R(!0),
                    ref: S,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: ee(w.onKeyDown, (A) => {
                      const U = A.ctrlKey || A.altKey || A.metaKey;
                      if (A.key === "Tab" && A.preventDefault(), !U && A.key.length === 1 && D(A.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(A.key)) {
                        let G = _().filter((ce) => !ce.disabled).map((ce) => ce.ref.current);
                        if (["ArrowUp", "End"].includes(A.key) && (G = G.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(A.key)) {
                          const ce = A.target, k = G.indexOf(ce);
                          G = G.slice(k + 1);
                        }
                        setTimeout(() => W(G)), A.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
ah.displayName = tH;
var nH = "SelectItemAlignedPosition", oh = v.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = Ut(rn, n), l = Kt(rn, n), [s, c] = v.useState(null), [d, f] = v.useState(null), u = xe(t, (S) => f(S)), m = Na(n), p = v.useRef(!1), y = v.useRef(!0), { viewport: h, selectedItem: b, selectedItemText: w, focusSelectedItem: $ } = l, x = v.useCallback(() => {
    if (i.trigger && i.valueNode && s && d && h && b && w) {
      const S = i.trigger.getBoundingClientRect(), F = d.getBoundingClientRect(), O = i.valueNode.getBoundingClientRect(), I = w.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ce = I.left - F.left, k = O.left - ce, ze = S.left - k, Ie = S.width + ze, We = Math.max(Ie, F.width), Tt = window.innerWidth - dt, Xt = Os(k, [
          dt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(dt, Tt - We)
        ]);
        s.style.minWidth = Ie + "px", s.style.left = Xt + "px";
      } else {
        const ce = F.right - I.right, k = window.innerWidth - O.right - ce, ze = window.innerWidth - S.right - k, Ie = S.width + ze, We = Math.max(Ie, F.width), Tt = window.innerWidth - dt, Xt = Os(k, [
          dt,
          Math.max(dt, Tt - We)
        ]);
        s.style.minWidth = Ie + "px", s.style.right = Xt + "px";
      }
      const L = m(), _ = window.innerHeight - dt * 2, ne = h.scrollHeight, R = window.getComputedStyle(d), Y = parseInt(R.borderTopWidth, 10), W = parseInt(R.paddingTop, 10), V = parseInt(R.borderBottomWidth, 10), J = parseInt(R.paddingBottom, 10), T = Y + W + ne + J + V, N = Math.min(b.offsetHeight * 5, T), D = window.getComputedStyle(h), K = parseInt(D.paddingTop, 10), ae = parseInt(D.paddingBottom, 10), Q = S.top + S.height / 2 - dt, ie = _ - Q, X = b.offsetHeight / 2, A = b.offsetTop + X, U = Y + W + A, oe = T - U;
      if (U <= Q) {
        const ce = L.length > 0 && b === L[L.length - 1].ref.current;
        s.style.bottom = "0px";
        const k = d.clientHeight - h.offsetTop - h.offsetHeight, ze = Math.max(
          ie,
          X + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ce ? ae : 0) + k + V
        ), Ie = U + ze;
        s.style.height = Ie + "px";
      } else {
        const ce = L.length > 0 && b === L[0].ref.current;
        s.style.top = "0px";
        const ze = Math.max(
          Q,
          Y + h.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ce ? K : 0) + X
        ) + oe;
        s.style.height = ze + "px", h.scrollTop = U - Q + h.offsetTop;
      }
      s.style.margin = `${dt}px 0`, s.style.minHeight = N + "px", s.style.maxHeight = _ + "px", r?.(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    m,
    i.trigger,
    i.valueNode,
    s,
    d,
    h,
    b,
    w,
    i.dir,
    r
  ]);
  ke(() => x(), [x]);
  const [P, E] = v.useState();
  ke(() => {
    d && E(window.getComputedStyle(d).zIndex);
  }, [d]);
  const z = v.useCallback(
    (S) => {
      S && y.current === !0 && (x(), $?.(), y.current = !1);
    },
    [x, $]
  );
  return /* @__PURE__ */ g(
    aH,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: z,
      children: /* @__PURE__ */ g(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: P
          },
          children: /* @__PURE__ */ g(
            me.div,
            {
              ...o,
              ref: u,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
oh.displayName = nH;
var rH = "SelectPopperPosition", ai = v.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = dt,
    ...i
  } = e, l = Da(n);
  return /* @__PURE__ */ g(
    Vd,
    {
      ...l,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
ai.displayName = rH;
var [aH, gl] = Tn(rn, {}), oi = "SelectViewport", ih = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = Kt(oi, n), l = gl(oi, n), s = xe(t, i.onViewportChange), c = v.useRef(0);
    return /* @__PURE__ */ re(Ge, { children: [
      /* @__PURE__ */ g(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ g(Fa.Slot, { scope: n, children: /* @__PURE__ */ g(
        me.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: ee(o.onScroll, (d) => {
            const f = d.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: m } = l;
            if (m?.current && u) {
              const p = Math.abs(c.current - f.scrollTop);
              if (p > 0) {
                const y = window.innerHeight - dt * 2, h = parseFloat(u.style.minHeight), b = parseFloat(u.style.height), w = Math.max(h, b);
                if (w < y) {
                  const $ = w + p, x = Math.min(y, $), P = $ - x;
                  u.style.height = x + "px", u.style.bottom === "0px" && (f.scrollTop = P > 0 ? P : 0, u.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
ih.displayName = oi;
var lh = "SelectGroup", [oH, iH] = Tn(lh), sh = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = qe();
    return /* @__PURE__ */ g(oH, { scope: n, id: o, children: /* @__PURE__ */ g(me.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
sh.displayName = lh;
var ch = "SelectLabel", lH = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = iH(ch, n);
    return /* @__PURE__ */ g(me.div, { id: o.id, ...r, ref: t });
  }
);
lH.displayName = ch;
var ta = "SelectItem", [sH, dh] = Tn(ta), uh = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...l
    } = e, s = Ut(ta, n), c = Kt(ta, n), d = s.value === r, [f, u] = v.useState(i ?? ""), [m, p] = v.useState(!1), y = xe(
      t,
      ($) => c.itemRefCallback?.($, r, o)
    ), h = qe(), b = v.useRef("touch"), w = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ g(
      sH,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: h,
        isSelected: d,
        onItemTextChange: v.useCallback(($) => {
          u((x) => x || ($?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ g(
          Fa.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: f,
            children: /* @__PURE__ */ g(
              me.div,
              {
                role: "option",
                "aria-labelledby": h,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": d && m,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...l,
                ref: y,
                onFocus: ee(l.onFocus, () => p(!0)),
                onBlur: ee(l.onBlur, () => p(!1)),
                onClick: ee(l.onClick, () => {
                  b.current !== "mouse" && w();
                }),
                onPointerUp: ee(l.onPointerUp, () => {
                  b.current === "mouse" && w();
                }),
                onPointerDown: ee(l.onPointerDown, ($) => {
                  b.current = $.pointerType;
                }),
                onPointerMove: ee(l.onPointerMove, ($) => {
                  b.current = $.pointerType, o ? c.onItemLeave?.() : b.current === "mouse" && $.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ee(l.onPointerLeave, ($) => {
                  $.currentTarget === document.activeElement && c.onItemLeave?.();
                }),
                onKeyDown: ee(l.onKeyDown, ($) => {
                  c.searchRef?.current !== "" && $.key === " " || (Kk.includes($.key) && w(), $.key === " " && $.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
uh.displayName = ta;
var jn = "SelectItemText", fh = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, l = Ut(jn, n), s = Kt(jn, n), c = dh(jn, n), d = Jk(jn, n), [f, u] = v.useState(null), m = xe(
      t,
      (w) => u(w),
      c.onItemTextChange,
      (w) => s.itemTextRefCallback?.(w, c.value, c.disabled)
    ), p = f?.textContent, y = v.useMemo(
      () => /* @__PURE__ */ g("option", { value: c.value, disabled: c.disabled, children: p }, c.value),
      [c.disabled, c.value, p]
    ), { onNativeOptionAdd: h, onNativeOptionRemove: b } = d;
    return ke(() => (h(y), () => b(y)), [h, b, y]), /* @__PURE__ */ re(Ge, { children: [
      /* @__PURE__ */ g(me.span, { id: c.textId, ...i, ref: m }),
      c.isSelected && l.valueNode && !l.valueNodeHasChildren ? ir.createPortal(i.children, l.valueNode) : null
    ] });
  }
);
fh.displayName = jn;
var hh = "SelectItemIndicator", cH = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return dh(hh, n).isSelected ? /* @__PURE__ */ g(me.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
cH.displayName = hh;
var ii = "SelectScrollUpButton", dH = v.forwardRef((e, t) => {
  const n = Kt(ii, e.__scopeSelect), r = gl(ii, e.__scopeSelect), [o, i] = v.useState(!1), l = xe(t, r.onScrollButtonChange);
  return ke(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const d = c.scrollTop > 0;
        i(d);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ g(
    mh,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
dH.displayName = ii;
var li = "SelectScrollDownButton", uH = v.forwardRef((e, t) => {
  const n = Kt(li, e.__scopeSelect), r = gl(li, e.__scopeSelect), [o, i] = v.useState(!1), l = xe(t, r.onScrollButtonChange);
  return ke(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const d = c.scrollHeight - c.clientHeight, f = Math.ceil(c.scrollTop) < d;
        i(f);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ g(
    mh,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
uH.displayName = li;
var mh = v.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = Kt("SelectScrollButton", n), l = v.useRef(null), s = Na(n), c = v.useCallback(() => {
    l.current !== null && (window.clearInterval(l.current), l.current = null);
  }, []);
  return v.useEffect(() => () => c(), [c]), ke(() => {
    s().find((f) => f.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ g(
    me.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: ee(o.onPointerDown, () => {
        l.current === null && (l.current = window.setInterval(r, 50));
      }),
      onPointerMove: ee(o.onPointerMove, () => {
        i.onItemLeave?.(), l.current === null && (l.current = window.setInterval(r, 50));
      }),
      onPointerLeave: ee(o.onPointerLeave, () => {
        c();
      })
    }
  );
}), fH = "SelectSeparator", ph = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ g(me.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
ph.displayName = fH;
var si = "SelectArrow", hH = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Da(n), i = Ut(si, n), l = Kt(si, n);
    return i.open && l.position === "popper" ? /* @__PURE__ */ g(jd, { ...o, ...r, ref: t }) : null;
  }
);
hH.displayName = si;
function vh(e) {
  return e === "" || e === void 0;
}
var gh = v.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = v.useRef(null), i = xe(t, o), l = X5(n);
    return v.useEffect(() => {
      const s = o.current, c = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (l !== n && f) {
        const u = new Event("change", { bubbles: !0 });
        f.call(s, n), s.dispatchEvent(u);
      }
    }, [l, n]), /* @__PURE__ */ g(ll, { asChild: !0, children: /* @__PURE__ */ g("select", { ...r, ref: i, defaultValue: n }) });
  }
);
gh.displayName = "BubbleSelect";
function yh(e) {
  const t = Je(e), n = v.useRef(""), r = v.useRef(0), o = v.useCallback(
    (l) => {
      const s = n.current + l;
      t(s), function c(d) {
        n.current = d, window.clearTimeout(r.current), d !== "" && (r.current = window.setTimeout(() => c(""), 1e3));
      }(s);
    },
    [t]
  ), i = v.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return v.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function bh(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let l = mH(e, Math.max(i, 0));
  o.length === 1 && (l = l.filter((d) => d !== n));
  const c = l.find(
    (d) => d.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function mH(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var pH = vl, yl = Z5, vH = Q5, wh = eh, $h = th, bl = nh, Eh = ih, gH = sh, na = uh, ci = fh, xh = ph;
const yH = Se(["w-full", "flex", "items-center", "justify-between", "border-none", "text-left"], {
  variants: {
    variant: {
      standard: ["bg-transparent", "px-2", "py-2", "overflow-auto", "focus-visible:outline-none"],
      outlined: ["p-3", "outline-green-500", "text-text-primary", "gap-2"]
    },
    error: {
      true: ["border-error-500", "outline-error-500", "text-error-500"]
    },
    disabled: {
      true: ["border-text-disabled", "text-text-disabled"]
    },
    size: {
      small: ["min-h-[28px]"],
      medium: ["min-h-[42px]"],
      large: ["min-h-[55px] text-lg"]
    }
  },
  compoundVariants: [
    {
      variant: "outlined",
      disabled: !1,
      error: !1,
      class: ["hover:border-text-primary"]
    }
  ],
  defaultVariants: {
    variant: "standard",
    size: "medium"
  }
}), As = Se(["px-4"], {
  variants: {
    variant: {
      standard: ["py-2", "border-b", "last-of-type:border-none"],
      outlined: ["flex", "items-center", "gap-1", "py-1", "focus-visible:outline-none"]
    }
  },
  defaultVariants: {
    variant: "standard"
  }
}), bH = Se(
  ["font-sans", "text-sm", "leading-normal", "flex", "items-center", "gap-1", "font-normal", "mt-2"],
  {
    variants: {
      error: {
        false: ["text-gray-700"],
        true: ["text-error-500"]
      }
    }
  }
), Mh = a.forwardRef(
  ({
    variant: e = "standard",
    size: t = "medium",
    error: n = !1,
    disabled: r = !1,
    helperText: o,
    readOnly: i,
    items: l,
    quickAccessItems: s,
    className: c,
    onChange: d,
    ...f
  }, u) => {
    const m = K5[f.country];
    return /* @__PURE__ */ re(Ge, { children: [
      /* @__PURE__ */ re(vl, { open: i ? !1 : void 0, disabled: r, onValueChange: d, ...f, children: [
        /* @__PURE__ */ re(yl, { ref: u, className: yH({ variant: e, error: n, disabled: r, size: t, className: c }), children: [
          f.country ? /* @__PURE__ */ g(m, { className: "h-4 w-8" }) : /* @__PURE__ */ g(n6, { className: "h-6 w-8" }),
          /* @__PURE__ */ g(
            wh,
            {
              className: j("fill-text-secondary", {
                "fill-text-disabled": r
              }),
              children: /* @__PURE__ */ g(r6, {})
            }
          )
        ] }),
        /* @__PURE__ */ g($h, { children: /* @__PURE__ */ g(
          bl,
          {
            className: "z-20 h-64 w-full cursor-pointer overflow-auto rounded-md bg-white py-2 shadow-md",
            position: e === "outlined" ? void 0 : "popper",
            side: e === "outlined" ? void 0 : "bottom",
            children: /* @__PURE__ */ g(Eh, { children: /* @__PURE__ */ re(gH, { children: [
              s && s.length > 0 && /* @__PURE__ */ re(Ge, { children: [
                s.map((p, y) => /* @__PURE__ */ g(
                  na,
                  {
                    className: `${As({ variant: e, className: c })} data-[highlighted]:bg-lightBlue-500/5
                data-[state=checked]:bg-lightBlue-500/10
                data-[state=checked]:shadow-[inset_4px_0_0_0]
                data-[state=checked]:shadow-lightBlue-500
                data-[highlighted]:outline-none
                ${y === s.length - 1 && "border-none"}`,
                    value: p.value,
                    children: /* @__PURE__ */ g(ci, { children: p.label })
                  },
                  p.key
                )),
                /* @__PURE__ */ g("div", { className: "flex w-full cursor-default items-center px-8 py-2", children: /* @__PURE__ */ g("div", { className: "h-0.5 w-full bg-deepGray-500/[0.12]" }) })
              ] }),
              l.map((p) => /* @__PURE__ */ g(
                na,
                {
                  className: `${As({ variant: e, className: c })} data-[highlighted]:bg-lightBlue-500/5
                data-[state=checked]:bg-lightBlue-500/10
                data-[state=checked]:shadow-[inset_4px_0_0_0]
                data-[state=checked]:shadow-lightBlue-500
                data-[highlighted]:outline-none`,
                  value: p.value,
                  children: /* @__PURE__ */ g(ci, { children: p.label })
                },
                p.key
              ))
            ] }) })
          }
        ) })
      ] }),
      o && /* @__PURE__ */ g("p", { className: bH({ error: n }), children: o })
    ] });
  }
);
Mh.displayName = "CountryDropdown";
const wH = 'before:content-[" "]', $H = 'after:content-[" "]', EH = Se(
  [
    "group",
    "peer",
    "h-full",
    "w-full",
    "rounded-md",
    "border",
    "border-t-transparent",
    "bg-transparent",
    "pl-20",
    "font-sans",
    "font-normal",
    "outline",
    "outline-0",
    "transition-all",
    "text-[0.875rem]",
    "py-2.5",
    "placeholder-shown:border",
    "focus:border-2",
    "focus:border-t-transparent",
    "focus:outline-0",
    "disabled:border-deepGray-500",
    "disabled:border-t-transparent",
    "placeholder-shown:disabled:border-t-deepGray-500",
    "placeholder-shown:disabled:border-t",
    "disabled:text-deepGray-400",
    "disabled:bg-deepGray-50"
  ],
  {
    variants: {
      lightBorder: {
        false: [],
        true: [
          "disabled:border-deepGray-100",
          "disabled:border-t-transparent",
          "placeholder-shown:disabled:border-t-deepGray-100",
          "placeholder-shown:disabled:border-t",
          "disabled:hover:border-deepGray-100",
          "disabled:hover:border-t-transparent",
          "placeholder-shown:disabled:hover:border-t-deepGray-100",
          "placeholder-shown:disabled:hover:border-t"
        ]
      },
      hasStartAdornment: {
        false: [],
        true: ["pl-16"]
      },
      hasEndAdornment: {
        false: [],
        true: ["pr-10"]
      },
      size: {
        normal: [],
        large: ["text-[1.125rem]", "py-4"]
      },
      state: {
        default: [
          "text-deepGray-700",
          "border-deepGray-500",
          "border-t-transparent",
          "focus:border-success-700",
          "focus:border-t-transparent",
          "placeholder-shown:border-deepGray-500",
          "placeholder-shown:border-t-deepGray-500"
        ],
        error: [
          "text-error-500",
          "border-error-500",
          "border-t-transparent",
          "focus:border-error-500",
          "focus:border-t-transparent",
          "placeholder-shown:border-error-500",
          "placeholder-shown:border-t-error-500"
        ],
        success: [
          "text-success-700",
          "border-success-700",
          "border-t-transparent",
          "focus:border-success-700",
          "focus:border-t-transparent",
          "placeholder-shown:border-success-700",
          "placeholder-shown:border-t-success-700"
        ]
      }
    },
    defaultVariants: {
      state: "default"
    },
    compoundVariants: [
      {
        state: "default",
        lightBorder: !0,
        class: "border-deepGray-100 border-t-transparent placeholder-shown:border-deepGray-100 hover:border-text-primary hover:border-t-transparent placeholder-shown:hover:border-text-primary focus:hover:border-success-700 focus:hover:border-t-transparent"
      }
    ]
  }
), xH = Se(
  [
    wH,
    $H,
    "pointer-events-none",
    "absolute",
    "left-0",
    "-top-1.5",
    "flex",
    "h-full",
    "w-full",
    "select-none",
    "text-[0.875rem]",
    "font-normal",
    "leading-tight",
    "transition-all",
    "box-border",
    "before:pointer-events-none",
    "before:mt-[6.5px]",
    "before:mr-1",
    "before:box-border",
    "before:block",
    "before:h-1.5",
    "before:w-2.5",
    "before:rounded-tl-md",
    "before:border-t",
    "before:border-l",
    "before:transition-all",
    "after:pointer-events-none",
    "after:mt-[6.5px]",
    "after:ml-1",
    "after:box-border",
    "after:block",
    "after:grow",
    "after:rounded-tr-md",
    "after:border-t",
    "after:border-r",
    "after:transition-all",
    "peer-focus:leading-tight",
    "peer-placeholder-shown:leading-[3.75]",
    "peer-placeholder-shown:before:border-transparent",
    "peer-placeholder-shown:after:border-transparent",
    "peer-focus:before:border-t-2",
    "peer-focus:before:border-l-2",
    "peer-focus:after:border-t-2",
    "peer-focus:after:border-r-2",
    "peer-disabled:text-deepGray-400",
    "peer-disabled:before:border-t-deepGray-400",
    "peer-disabled:after:border-t-deepGray-400",
    "peer-disabled:peer-placeholder-shown:before:border-t-0",
    "peer-disabled:peer-placeholder-shown:after:border-t-0"
  ],
  {
    variants: {
      lightBorder: {
        false: [],
        true: [
          "peer-disabled:before:border-t-deepGray-100",
          "peer-disabled:before:border-l-0",
          "peer-disabled:after:border-t-deepGray-100",
          "peer-disabled:after:border-r-0",
          "peer-disabled:peer-hover:before:border-t-deepGray-100",
          "peer-disabled:peer-hover:after:border-t-deepGray-100",
          "peer-placeholder-shown:peer-disabled:peer-hover:before:border-t-0",
          "peer-placeholder-shown:peer-disabled:peer-hover:after:border-t-0"
        ]
      },
      size: {
        normal: [],
        large: [
          "text-[0.875rem]",
          "peer-focus:leading-[0.75]",
          "peer-placeholder-shown:text-[1.125rem]",
          "leading-[0.75]",
          "peer-placeholder-shown:leading-[3.75]"
        ]
      },
      hasStartAdornment: {
        false: [],
        true: ["peer-placeholder-shown:pl-12", "peer-focus:peer-placeholder-shown:pl-0"]
      },
      state: {
        default: [
          "text-deepGray-400",
          "peer-disabled:peer-placeholder-shown:text-deepGray-500",
          "peer-placeholder-shown:text-deepGray-500",
          "after:border-deepGray-500",
          "peer-focus:text-success-700",
          "peer-focus:before:border-success-700",
          "peer-focus:after:border-success-700",
          "before:border-deepGray-500"
        ],
        error: [
          "text-error-500",
          "after:border-error-500",
          "peer-placeholder-shown:text-error-500",
          "peer-focus:text-error-500",
          "peer-focus:before:border-error-500",
          "peer-focus:after:border-error-500",
          "before:border-error-500"
        ],
        success: [
          "text-success-700",
          "after:border-error-500",
          "peer-placeholder-shown:text-success-700",
          "peer-focus:text-success-700",
          "peer-focus:before:border-success-700",
          "peer-focus:after:border-success-700",
          "before:border-success-700"
        ]
      }
    },
    defaultVariants: {
      state: "default",
      size: "normal"
    },
    compoundVariants: [
      {
        state: "default",
        lightBorder: !0,
        class: "before:border-deepGray-100 after:border-deepGray-100 peer-hover:before:border-text-primary peer-hover:after:border-text-primary peer-placeholder-shown:peer-hover:before:border-transparent peer-placeholder-shown:peer-hover:after:border-transparent peer-placeholder-shown:peer-focus:peer-hover:before:border-success-700 peer-placeholder-shown:peer-focus:peer-hover:after:border-success-700"
      }
    ]
  }
), MH = Se(["font-sans", "text-sm", "leading-normal", "flex", "items-center", "gap-1", "font-normal", "mt-2"], {
  variants: {
    error: {
      false: ["text-gray-700"],
      true: ["text-error-500"]
    }
  }
}), CH = de(
  ({
    label: e,
    error: t = !1,
    state: n = "default",
    className: r,
    full: o,
    helperText: i,
    size: l = "normal",
    lightBorder: s,
    classNames: c,
    defaultCountry: d = "",
    quickAccessCountries: f = [],
    required: u,
    ...m
  }, p) => {
    const y = oD(String(m.value)), [h, b] = Ce(d), [w, $] = Ce("");
    ye(() => {
      if (y && y.country) {
        const S = y?.country ?? "";
        b(S), $(`+${yo(S)} ${S}`);
      }
    }, [y]);
    const x = (S) => S.map((F) => {
      const O = K5[F];
      return {
        key: `qa:${ni[F]}`,
        label: /* @__PURE__ */ re("div", { className: "flex", children: [
          /* @__PURE__ */ g(O, { className: "mr-1 h-4 w-8 bg-gray-100" }),
          ni[F],
          " +",
          yo(F)
        ] }),
        value: `+${yo(F)} ${F}`
      };
    }), P = x(f), E = x(iD().filter((S) => !f.includes(S))), z = (S) => {
      m.onChange && m.onChange(S.target.value);
    };
    return /* @__PURE__ */ re(Ge, { children: [
      /* @__PURE__ */ g("div", { className: j("flex rounded-md shadow-sm", o && "w-full"), children: /* @__PURE__ */ re("div", { className: j("relative", o && "w-full"), children: [
        /* @__PURE__ */ g("div", { className: "absolute inset-y-0 left-0 flex items-center pl-0", children: /* @__PURE__ */ g(
          Mh,
          {
            value: w,
            country: h,
            disabled: m.disabled,
            size: "small",
            items: E,
            quickAccessItems: P,
            onChange: (S) => {
              const [F, O] = S.split(" ");
              m.onChange && m.onChange(F), $(S), b(O);
            }
          }
        ) }),
        /* @__PURE__ */ g(
          "input",
          {
            ref: p,
            "aria-invalid": !!t,
            className: EH({
              state: t ? "error" : n,
              size: l,
              lightBorder: s,
              hasStartAdornment: !0,
              className: r
            }),
            placeholder: " ",
            ...m,
            onChange: z
          }
        ),
        /* @__PURE__ */ g(
          "label",
          {
            htmlFor: m.id,
            className: j(
              xH({
                state: t ? "error" : n,
                size: l,
                lightBorder: s,
                hasStartAdornment: !0
              }),
              c?.label
            ),
            children: /* @__PURE__ */ re("div", { children: [
              e,
              u && /* @__PURE__ */ g("span", { className: "text-red-500", children: "*" })
            ] })
          }
        )
      ] }) }),
      i && /* @__PURE__ */ g("p", { className: MH({ error: n === "error" }), children: i })
    ] });
  }
);
CH.displayName = "PhoneNumberInput";
const Ts = "transition-all duration-300 ease-in-out", X_ = ({
  isOpen: e,
  onClose: t,
  title: n,
  children: r,
  dialogClassName: o,
  backdropClassName: i,
  titleClassName: l,
  disableBackdrop: s,
  actionButtons: c,
  portalContainer: d,
  portalContainerRef: f,
  hideCloseButton: u = !1,
  position: m = "right"
}) => {
  const p = ue(null), y = ue(null), h = Gm(), b = se(
    (E) => {
      p.current = E, f && (f.current = E);
    },
    [f]
  ), w = Le(() => typeof document > "u" ? null : d || document.body, [d]), $ = se((E) => {
    const z = [
      "a[href]",
      "button:not([disabled])",
      "textarea:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ], S = E.querySelectorAll(z.join(","));
    return Array.from(S).filter(
      (O) => !O.hasAttribute("disabled") && !O.getAttribute("aria-hidden") && (O.offsetWidth > 0 || O.offsetHeight > 0 || O === document.activeElement)
    );
  }, []), x = se(() => {
    const E = p.current;
    if (!E) return;
    const S = $(E)[0];
    if (S) {
      S.focus();
      return;
    }
    E.focus();
  }, [$]);
  ye(() => {
    const E = document.body, z = E.style.overflow, S = E.style.paddingRight, F = E.style.paddingLeft;
    if (e) {
      const O = window.innerWidth - document.documentElement.clientWidth;
      if (O > 0)
        if (m === "right") {
          const I = parseFloat(getComputedStyle(E).paddingRight) || 0;
          E.style.paddingRight = `${I + O}px`;
        } else {
          const I = parseFloat(getComputedStyle(E).paddingLeft) || 0;
          E.style.paddingLeft = `${I + O}px`;
        }
      E.style.overflow = "hidden";
    } else
      E.style.overflow = z || "", E.style.paddingRight = S || "", E.style.paddingLeft = F || "";
    return () => {
      E.style.overflow = z || "", E.style.paddingRight = S || "", E.style.paddingLeft = F || "";
    };
  }, [e, m]), ye(() => {
    if (e) {
      y.current = document.activeElement || null;
      const z = window.setTimeout(x, 0);
      return () => window.clearTimeout(z);
    }
    const E = y.current;
    E && typeof E.focus == "function" && E.focus();
  }, [e, x]), ye(() => {
    if (!e) return;
    const E = (z) => {
      const S = p.current;
      if (!S) return;
      if (z.key === "Escape") {
        z.preventDefault(), t();
        return;
      }
      if (z.key !== "Tab") return;
      const F = $(S);
      if (F.length === 0) {
        z.preventDefault(), S.focus();
        return;
      }
      const O = F[0], I = F[F.length - 1], L = document.activeElement, _ = !!L && S.contains(L);
      if (z.shiftKey) {
        (!_ || L === O) && (z.preventDefault(), I.focus());
        return;
      }
      (!_ || L === I) && (z.preventDefault(), O.focus());
    };
    return document.addEventListener("keydown", E), () => document.removeEventListener("keydown", E);
  }, [e, $, t]);
  const P = /* @__PURE__ */ re(
    "div",
    {
      "data-testid": "drawer-container",
      className: j({ "pointer-events-none": !e, "pointer-events-auto": e }),
      children: [
        /* @__PURE__ */ g(
          "div",
          {
            "data-testid": "drawer-backdrop",
            className: j(
              "fixed inset-0 z-[8] bg-gray-700/50",
              {
                "opacity-100 backdrop-blur-sm": e,
                "opacity-0 backdrop-blur-none": !e
              },
              {
                // If the backdrop is disabled, we don't want to show it visually, but we keep it so we can "click out" and close the drawer.
                "bg-transparent backdrop-blur-none": s
              },
              Ts,
              i
            ),
            "aria-hidden": "true",
            onClick: t
          }
        ),
        /* @__PURE__ */ re(
          "div",
          {
            ref: b,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": h,
            "aria-hidden": !e,
            tabIndex: -1,
            inert: e ? void 0 : "",
            className: j(
              "fixed top-0 z-[9] flex h-full w-full max-w-[600px] flex-col bg-white outline-none",
              {
                "right-0": m === "right",
                "left-0": m === "left"
              },
              {
                "translate-x-0 shadow-2xl": e,
                "translate-x-full shadow-none": !e && m === "right",
                "-translate-x-full shadow-none": !e && m === "left"
              },
              Ts,
              o
            ),
            children: [
              /* @__PURE__ */ re("div", { className: j("flex items-center justify-between p-4", l), children: [
                n && (typeof n == "string" ? /* @__PURE__ */ g("p", { id: h, className: "text-lg font-bold", children: n }) : /* @__PURE__ */ g("div", { id: h, children: n })),
                !u && /* @__PURE__ */ g(
                  Oc,
                  {
                    onClick: t,
                    icon: a6,
                    type: "button",
                    variant: "ancillary",
                    name: "close",
                    className: "ml-auto p-1"
                  }
                )
              ] }),
              /* @__PURE__ */ g("div", { className: "h-full overflow-y-auto", children: r }),
              c && /* @__PURE__ */ g("div", { className: "mt-auto flex flex-col items-center justify-end gap-2 p-6 md:flex-row", children: c.map((E, z) => /* @__PURE__ */ g(
                P7,
                {
                  variant: "secondary",
                  size: "md",
                  ...E,
                  className: j(E.className, "w-full md:w-auto")
                },
                typeof E.children == "string" ? E.children : z
              )) })
            ]
          }
        )
      ]
    }
  );
  return w ? Um(P, w) : P;
};
function Fe() {
  return Fe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fe.apply(null, arguments);
}
function Oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented) return t?.(o);
  };
}
function PH(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ch(...e) {
  return (t) => e.forEach(
    (n) => PH(n, t)
  );
}
function He(...e) {
  return se(Ch(...e), e);
}
function yr(e, t = []) {
  let n = [];
  function r(i, l) {
    const s = /* @__PURE__ */ St(l), c = n.length;
    n = [
      ...n,
      l
    ];
    function d(u) {
      const { scope: m, children: p, ...y } = u, h = m?.[e][c] || s, b = Le(
        () => y,
        Object.values(y)
      );
      return /* @__PURE__ */ B(h.Provider, {
        value: b
      }, p);
    }
    function f(u, m) {
      const p = m?.[e][c] || s, y = rt(p);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [
      d,
      f
    ];
  }
  const o = () => {
    const i = n.map((l) => /* @__PURE__ */ St(l));
    return function(s) {
      const c = s?.[e] || i;
      return Le(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    SH(o, ...t)
  ];
}
function SH(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const l = r.reduce((s, { useScope: c, scopeName: d }) => {
        const u = c(i)[`__scope${d}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return Le(
        () => ({
          [`__scope${t.scopeName}`]: l
        }),
        [
          l
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function et() {
  return et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, et.apply(null, arguments);
}
const rr = /* @__PURE__ */ de((e, t) => {
  const { children: n, ...r } = e, o = yn.toArray(n), i = o.find(zH);
  if (i) {
    const l = i.props.children, s = o.map((c) => c === i ? yn.count(l) > 1 ? yn.only(null) : /* @__PURE__ */ _r(l) ? l.props.children : null : c);
    return /* @__PURE__ */ B(di, et({}, r, {
      ref: t
    }), /* @__PURE__ */ _r(l) ? /* @__PURE__ */ vi(l, void 0, s) : null);
  }
  return /* @__PURE__ */ B(di, et({}, r, {
    ref: t
  }), n);
});
rr.displayName = "Slot";
const di = /* @__PURE__ */ de((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ _r(n) ? /* @__PURE__ */ vi(n, {
    ...FH(r, n.props),
    ref: t ? Ch(t, n.ref) : n.ref
  }) : yn.count(n) > 1 ? yn.only(null) : null;
});
di.displayName = "SlotClone";
const Ph = ({ children: e }) => /* @__PURE__ */ B(Ym, null, e);
function zH(e) {
  return /* @__PURE__ */ _r(e) && e.type === Ph;
}
function FH(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const NH = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ye = NH.reduce((e, t) => {
  const n = /* @__PURE__ */ de((r, o) => {
    const { asChild: i, ...l } = r, s = i ? rr : t;
    return ye(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ B(s, et({}, l, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function DH(e, t) {
  e && Zs(
    () => e.dispatchEvent(t)
  );
}
function jt(e) {
  const t = ue(e);
  return ye(() => {
    t.current = e;
  }), Le(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function OH(e, t = globalThis?.document) {
  const n = jt(e);
  ye(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const ui = "dismissableLayer.update", AH = "dismissableLayer.pointerDownOutside", TH = "dismissableLayer.focusOutside";
let ks;
const kH = /* @__PURE__ */ St({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Sh = /* @__PURE__ */ de((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: l, onInteractOutside: s, onDismiss: c, ...d } = e, f = rt(kH), [u, m] = Ce(null), p = (n = u?.ownerDocument) !== null && n !== void 0 ? n : globalThis?.document, [, y] = Ce({}), h = He(
    t,
    (F) => m(F)
  ), b = Array.from(f.layers), [w] = [
    ...f.layersWithOutsidePointerEventsDisabled
  ].slice(-1), $ = b.indexOf(w), x = u ? b.indexOf(u) : -1, P = f.layersWithOutsidePointerEventsDisabled.size > 0, E = x >= $, z = HH((F) => {
    const O = F.target, I = [
      ...f.branches
    ].some(
      (L) => L.contains(O)
    );
    !E || I || (i?.(F), s?.(F), F.defaultPrevented || c?.());
  }, p), S = IH((F) => {
    const O = F.target;
    [
      ...f.branches
    ].some(
      (L) => L.contains(O)
    ) || (l?.(F), s?.(F), F.defaultPrevented || c?.());
  }, p);
  return OH((F) => {
    x === f.layers.size - 1 && (o?.(F), !F.defaultPrevented && c && (F.preventDefault(), c()));
  }, p), ye(() => {
    if (u)
      return r && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (ks = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(u)), f.layers.add(u), Hs(), () => {
        r && f.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = ks);
      };
  }, [
    u,
    p,
    r,
    f
  ]), ye(() => () => {
    u && (f.layers.delete(u), f.layersWithOutsidePointerEventsDisabled.delete(u), Hs());
  }, [
    u,
    f
  ]), ye(() => {
    const F = () => y({});
    return document.addEventListener(ui, F), () => document.removeEventListener(ui, F);
  }, []), /* @__PURE__ */ B(Ye.div, et({}, d, {
    ref: h,
    style: {
      pointerEvents: P ? E ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Oe(e.onFocusCapture, S.onFocusCapture),
    onBlurCapture: Oe(e.onBlurCapture, S.onBlurCapture),
    onPointerDownCapture: Oe(e.onPointerDownCapture, z.onPointerDownCapture)
  }));
});
function HH(e, t = globalThis?.document) {
  const n = jt(e), r = ue(!1), o = ue(() => {
  });
  return ye(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let d = function() {
          zh(AH, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = d, t.addEventListener("click", o.current, {
          once: !0
        })) : d();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function IH(e, t = globalThis?.document) {
  const n = jt(e), r = ue(!1);
  return ye(() => {
    const o = (i) => {
      i.target && !r.current && zh(TH, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Hs() {
  const e = new CustomEvent(ui);
  document.dispatchEvent(e);
}
function zh(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? DH(o, i) : o.dispatchEvent(i);
}
let bo = 0;
function RH() {
  ye(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Is()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Is()), bo++, () => {
      bo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), bo--;
    };
  }, []);
}
function Is() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const wo = "focusScope.autoFocusOnMount", $o = "focusScope.autoFocusOnUnmount", Rs = {
  bubbles: !1,
  cancelable: !0
}, _H = /* @__PURE__ */ de((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...l } = e, [s, c] = Ce(null), d = jt(o), f = jt(i), u = ue(null), m = He(
    t,
    (h) => c(h)
  ), p = ue({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ye(() => {
    if (r) {
      let h = function(x) {
        if (p.paused || !s) return;
        const P = x.target;
        s.contains(P) ? u.current = P : _t(u.current, {
          select: !0
        });
      }, b = function(x) {
        if (p.paused || !s) return;
        const P = x.relatedTarget;
        P !== null && (s.contains(P) || _t(u.current, {
          select: !0
        }));
      }, w = function(x) {
        if (document.activeElement === document.body)
          for (const E of x) E.removedNodes.length > 0 && _t(s);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const $ = new MutationObserver(w);
      return s && $.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), $.disconnect();
      };
    }
  }, [
    r,
    s,
    p.paused
  ]), ye(() => {
    if (s) {
      Ls.add(p);
      const h = document.activeElement;
      if (!s.contains(h)) {
        const w = new CustomEvent(wo, Rs);
        s.addEventListener(wo, d), s.dispatchEvent(w), w.defaultPrevented || (LH(GH(Fh(s)), {
          select: !0
        }), document.activeElement === h && _t(s));
      }
      return () => {
        s.removeEventListener(wo, d), setTimeout(() => {
          const w = new CustomEvent($o, Rs);
          s.addEventListener($o, f), s.dispatchEvent(w), w.defaultPrevented || _t(h ?? document.body, {
            select: !0
          }), s.removeEventListener($o, f), Ls.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    d,
    f,
    p
  ]);
  const y = se((h) => {
    if (!n && !r || p.paused) return;
    const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
    if (b && w) {
      const $ = h.currentTarget, [x, P] = BH($);
      x && P ? !h.shiftKey && w === P ? (h.preventDefault(), n && _t(x, {
        select: !0
      })) : h.shiftKey && w === x && (h.preventDefault(), n && _t(P, {
        select: !0
      })) : w === $ && h.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ B(Ye.div, et({
    tabIndex: -1
  }, l, {
    ref: m,
    onKeyDown: y
  }));
});
function LH(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (_t(r, {
      select: t
    }), document.activeElement !== n) return;
}
function BH(e) {
  const t = Fh(e), n = _s(t, e), r = _s(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Fh(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function _s(e, t) {
  for (const n of e)
    if (!WH(n, {
      upTo: t
    })) return n;
}
function WH(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function VH(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function _t(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && VH(e) && t && e.select();
  }
}
const Ls = jH();
function jH() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Bs(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Bs(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Bs(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function GH(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Cn = globalThis?.document ? En : () => {
}, YH = v.useId || (() => {
});
let UH = 0;
function Nh(e) {
  const [t, n] = v.useState(YH());
  return Cn(() => {
    n(
      (r) => r ?? String(UH++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const KH = /* @__PURE__ */ de((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ B(Ye.svg, et({}, i, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ B("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), XH = KH;
function Dh(e) {
  const [t, n] = Ce(void 0);
  return Cn(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length) return;
        const i = o[0];
        let l, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          l = d.inlineSize, s = d.blockSize;
        } else
          l = e.offsetWidth, s = e.offsetHeight;
        n({
          width: l,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Oh = "Popper", [Ah, Oa] = yr(Oh), [qH, Th] = Ah(Oh), ZH = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = Ce(null);
  return /* @__PURE__ */ B(qH, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, JH = "PopperAnchor", QH = /* @__PURE__ */ de((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, i = Th(JH, n), l = ue(null), s = He(t, l);
  return ye(() => {
    i.onAnchorChange(r?.current || l.current);
  }), r ? null : /* @__PURE__ */ B(Ye.div, et({}, o, {
    ref: s
  }));
}), kh = "PopperContent", [eI, tI] = Ah(kh), nI = /* @__PURE__ */ de((e, t) => {
  var n, r, o, i, l, s, c, d;
  const { __scopePopper: f, side: u = "bottom", sideOffset: m = 0, align: p = "center", alignOffset: y = 0, arrowPadding: h = 0, avoidCollisions: b = !0, collisionBoundary: w = [], collisionPadding: $ = 0, sticky: x = "partial", hideWhenDetached: P = !1, updatePositionStrategy: E = "optimized", onPlaced: z, ...S } = e, F = Th(kh, f), [O, I] = Ce(null), L = He(
    t,
    (We) => I(We)
  ), [_, ne] = Ce(null), R = Dh(_), Y = (n = R?.width) !== null && n !== void 0 ? n : 0, W = (r = R?.height) !== null && r !== void 0 ? r : 0, V = u + (p !== "center" ? "-" + p : ""), J = typeof $ == "number" ? $ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...$
  }, T = Array.isArray(w) ? w : [
    w
  ], N = T.length > 0, D = {
    padding: J,
    boundary: T.filter(iI),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: N
  }, { refs: K, floatingStyles: ae, placement: Q, isPositioned: ie, middlewareData: X } = xd({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: V,
    whileElementsMounted: (...We) => $d(...We, {
      animationFrame: E === "always"
    }),
    elements: {
      reference: F.anchor
    },
    middleware: [
      Md({
        mainAxis: m + W,
        alignmentAxis: y
      }),
      b && Cd({
        mainAxis: !0,
        crossAxis: !1,
        limiter: x === "partial" ? Pd() : void 0,
        ...D
      }),
      b && Sd({
        ...D
      }),
      zd({
        ...D,
        apply: ({ elements: We, rects: Tt, availableWidth: Xt, availableHeight: _a }) => {
          const { width: La, height: Ba } = Tt.reference, ln = We.floating.style;
          ln.setProperty("--radix-popper-available-width", `${Xt}px`), ln.setProperty("--radix-popper-available-height", `${_a}px`), ln.setProperty("--radix-popper-anchor-width", `${La}px`), ln.setProperty("--radix-popper-anchor-height", `${Ba}px`);
        }
      }),
      _ && Nd({
        element: _,
        padding: h
      }),
      lI({
        arrowWidth: Y,
        arrowHeight: W
      }),
      P && Fd({
        strategy: "referenceHidden",
        ...D
      })
    ]
  }), [A, U] = Hh(Q), oe = jt(z);
  Cn(() => {
    ie && oe?.();
  }, [
    ie,
    oe
  ]);
  const G = (o = X.arrow) === null || o === void 0 ? void 0 : o.x, ce = (i = X.arrow) === null || i === void 0 ? void 0 : i.y, k = ((l = X.arrow) === null || l === void 0 ? void 0 : l.centerOffset) !== 0, [ze, Ie] = Ce();
  return Cn(() => {
    O && Ie(window.getComputedStyle(O).zIndex);
  }, [
    O
  ]), /* @__PURE__ */ B("div", {
    ref: K.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...ae,
      transform: ie ? ae.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ze,
      "--radix-popper-transform-origin": [
        (s = X.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = X.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ B(eI, {
    scope: f,
    placedSide: A,
    onArrowChange: ne,
    arrowX: G,
    arrowY: ce,
    shouldHideArrow: k
  }, /* @__PURE__ */ B(Ye.div, et({
    "data-side": A,
    "data-align": U
  }, S, {
    ref: L,
    style: {
      ...S.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ie ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (d = X.hide) !== null && d !== void 0 && d.referenceHidden ? 0 : void 0
    }
  }))));
}), rI = "PopperArrow", aI = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, oI = /* @__PURE__ */ de(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = tI(rI, r), l = aI[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ B("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [l]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ B(XH, et({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function iI(e) {
  return e !== null;
}
const lI = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, i, l;
    const { placement: s, rects: c, middlewareData: d } = t, u = ((n = d.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, m = u ? 0 : e.arrowWidth, p = u ? 0 : e.arrowHeight, [y, h] = Hh(s), b = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[h], w = ((r = (o = d.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + m / 2, $ = ((i = (l = d.arrow) === null || l === void 0 ? void 0 : l.y) !== null && i !== void 0 ? i : 0) + p / 2;
    let x = "", P = "";
    return y === "bottom" ? (x = u ? b : `${w}px`, P = `${-p}px`) : y === "top" ? (x = u ? b : `${w}px`, P = `${c.floating.height + p}px`) : y === "right" ? (x = `${-p}px`, P = u ? b : `${$}px`) : y === "left" && (x = `${c.floating.width + p}px`, P = u ? b : `${$}px`), {
      data: {
        x,
        y: P
      }
    };
  }
});
function Hh(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Ih = ZH, Rh = QH, _h = nI, Lh = oI, Bh = /* @__PURE__ */ de((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ qs.createPortal(/* @__PURE__ */ B(Ye.div, et({}, o, {
    ref: t
  })), r) : null;
});
function sI(e, t) {
  return Xs((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const br = (e) => {
  const { present: t, children: n } = e, r = cI(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : yn.only(n), i = He(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ vi(o, {
    ref: i
  }) : null;
};
br.displayName = "Presence";
function cI(e) {
  const [t, n] = Ce(), r = ue({}), o = ue(e), i = ue("none"), l = e ? "mounted" : "unmounted", [s, c] = sI(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ye(() => {
    const d = Ar(r.current);
    i.current = s === "mounted" ? d : "none";
  }, [
    s
  ]), Cn(() => {
    const d = r.current, f = o.current;
    if (f !== e) {
      const m = i.current, p = Ar(d);
      e ? c("MOUNT") : p === "none" || d?.display === "none" ? c("UNMOUNT") : c(f && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), Cn(() => {
    if (t) {
      const d = (u) => {
        const p = Ar(r.current).includes(u.animationName);
        u.target === t && p && Zs(
          () => c("ANIMATION_END")
        );
      }, f = (u) => {
        u.target === t && (i.current = Ar(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: se((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Ar(e) {
  return e?.animationName || "none";
}
function wl({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = dI({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : r, s = jt(n), c = se((d) => {
    if (i) {
      const u = typeof d == "function" ? d(e) : d;
      u !== e && s(u);
    } else o(d);
  }, [
    i,
    e,
    o,
    s
  ]);
  return [
    l,
    c
  ];
}
function dI({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = ue(r), i = jt(t);
  return ye(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
var Wh = e2(), Eo = function() {
}, Aa = v.forwardRef(function(e, t) {
  var n = v.useRef(null), r = v.useState({
    onScrollCapture: Eo,
    onWheelCapture: Eo,
    onTouchMoveCapture: Eo
  }), o = r[0], i = r[1], l = e.forwardProps, s = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, u = e.shards, m = e.sideCar, p = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, $ = Gi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), x = m, P = Qd([n, t]), E = _e(_e({}, $), o);
  return v.createElement(
    v.Fragment,
    null,
    f && v.createElement(x, { sideCar: Wh, removeScrollBar: d, shards: u, noIsolation: p, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n }),
    l ? v.cloneElement(v.Children.only(s), _e(_e({}, E), { ref: P })) : v.createElement(w, _e({}, E, { className: c, ref: P }), s)
  );
});
Aa.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Aa.classNames = {
  fullWidth: Yn,
  zeroRight: Gn
};
var fi = !1;
if (typeof window < "u")
  try {
    var Tr = Object.defineProperty({}, "passive", {
      get: function() {
        return fi = !0, !0;
      }
    });
    window.addEventListener("test", Tr, Tr), window.removeEventListener("test", Tr, Tr);
  } catch {
    fi = !1;
  }
var mn = fi ? { passive: !1 } : !1, uI = function(e) {
  return e.tagName === "TEXTAREA";
}, Vh = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !uI(e) && n[t] === "visible")
  );
}, fI = function(e) {
  return Vh(e, "overflowY");
}, hI = function(e) {
  return Vh(e, "overflowX");
}, Ws = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = jh(e, n);
    if (r) {
      var o = Gh(e, n), i = o[1], l = o[2];
      if (i > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, mI = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, pI = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, jh = function(e, t) {
  return e === "v" ? fI(t) : hI(t);
}, Gh = function(e, t) {
  return e === "v" ? mI(t) : pI(t);
}, vI = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, gI = function(e, t, n, r, o) {
  var i = vI(e, window.getComputedStyle(t).direction), l = i * r, s = n.target, c = t.contains(s), d = !1, f = l > 0, u = 0, m = 0;
  do {
    var p = Gh(e, s), y = p[0], h = p[1], b = p[2], w = h - b - i * y;
    (y || w) && jh(e, s) && (u += w, m += y), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (f && u === 0 || !f && m === 0) && (d = !0), d;
}, kr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Vs = function(e) {
  return [e.deltaX, e.deltaY];
}, js = function(e) {
  return e && "current" in e ? e.current : e;
}, yI = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, bI = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, wI = 0, pn = [];
function $I(e) {
  var t = v.useRef([]), n = v.useRef([0, 0]), r = v.useRef(), o = v.useState(wI++)[0], i = v.useState(function() {
    return Yi();
  })[0], l = v.useRef(e);
  v.useEffect(function() {
    l.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = Jd([e.lockRef.current], (e.shards || []).map(js), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = v.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2)
      return !l.current.allowPinchZoom;
    var w = kr(h), $ = n.current, x = "deltaX" in h ? h.deltaX : $[0] - w[0], P = "deltaY" in h ? h.deltaY : $[1] - w[1], E, z = h.target, S = Math.abs(x) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && S === "h" && z.type === "range")
      return !1;
    var F = Ws(S, z);
    if (!F)
      return !0;
    if (F ? E = S : (E = S === "v" ? "h" : "v", F = Ws(S, z)), !F)
      return !1;
    if (!r.current && "changedTouches" in h && (x || P) && (r.current = E), !E)
      return !0;
    var O = r.current || E;
    return gI(O, b, h, O === "h" ? x : P);
  }, []), c = v.useCallback(function(h) {
    var b = h;
    if (!(!pn.length || pn[pn.length - 1] !== i)) {
      var w = "deltaY" in b ? Vs(b) : kr(b), $ = t.current.filter(function(E) {
        return E.name === b.type && E.target === b.target && yI(E.delta, w);
      })[0];
      if ($ && $.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!$) {
        var x = (l.current.shards || []).map(js).filter(Boolean).filter(function(E) {
          return E.contains(b.target);
        }), P = x.length > 0 ? s(b, x[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), d = v.useCallback(function(h, b, w, $) {
    var x = { name: h, delta: b, target: w, should: $ };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== x;
      });
    }, 1);
  }, []), f = v.useCallback(function(h) {
    n.current = kr(h), r.current = void 0;
  }, []), u = v.useCallback(function(h) {
    d(h.type, Vs(h), h.target, s(h, e.lockRef.current));
  }, []), m = v.useCallback(function(h) {
    d(h.type, kr(h), h.target, s(h, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return pn.push(i), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", c, mn), document.addEventListener("touchmove", c, mn), document.addEventListener("touchstart", f, mn), function() {
      pn = pn.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", c, mn), document.removeEventListener("touchmove", c, mn), document.removeEventListener("touchstart", f, mn);
    };
  }, []);
  var p = e.removeScrollBar, y = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    y ? v.createElement(i, { styles: bI(o) }) : null,
    p ? v.createElement(a2, { gapMode: "margin" }) : null
  );
}
const EI = n2(Wh, $I);
var Yh = v.forwardRef(function(e, t) {
  return v.createElement(Aa, _e({}, e, { ref: t, sideCar: EI }));
});
Yh.classNames = Aa.classNames;
const Uh = "Popover", [Kh] = yr(Uh, [
  Oa
]), Ta = Oa(), [xI, on] = Kh(Uh), MI = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: l = !1 } = e, s = Ta(t), c = ue(null), [d, f] = Ce(!1), [u = !1, m] = wl({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ B(Ih, s, /* @__PURE__ */ B(xI, {
    scope: t,
    contentId: Nh(),
    triggerRef: c,
    open: u,
    onOpenChange: m,
    onOpenToggle: se(
      () => m(
        (p) => !p
      ),
      [
        m
      ]
    ),
    hasCustomAnchor: d,
    onCustomAnchorAdd: se(
      () => f(!0),
      []
    ),
    onCustomAnchorRemove: se(
      () => f(!1),
      []
    ),
    modal: l
  }, n));
}, CI = "PopoverTrigger", PI = /* @__PURE__ */ de((e, t) => {
  const { __scopePopover: n, ...r } = e, o = on(CI, n), i = Ta(n), l = He(t, o.triggerRef), s = /* @__PURE__ */ B(Ye.button, Fe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": Zh(o.open)
  }, r, {
    ref: l,
    onClick: Oe(e.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? s : /* @__PURE__ */ B(Rh, Fe({
    asChild: !0
  }, i), s);
}), Xh = "PopoverPortal", [SI, zI] = Kh(Xh, {
  forceMount: void 0
}), FI = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = on(Xh, t);
  return /* @__PURE__ */ B(SI, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ B(br, {
    present: n || i.open
  }, /* @__PURE__ */ B(Bh, {
    asChild: !0,
    container: o
  }, r)));
}, ar = "PopoverContent", NI = /* @__PURE__ */ de((e, t) => {
  const n = zI(ar, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = on(ar, e.__scopePopover);
  return /* @__PURE__ */ B(br, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ B(DI, Fe({}, o, {
    ref: t
  })) : /* @__PURE__ */ B(OI, Fe({}, o, {
    ref: t
  })));
}), DI = /* @__PURE__ */ de((e, t) => {
  const n = on(ar, e.__scopePopover), r = ue(null), o = He(t, r), i = ue(!1);
  return ye(() => {
    const l = r.current;
    if (l) return ya(l);
  }, []), /* @__PURE__ */ B(Yh, {
    as: rr,
    allowPinchZoom: !0
  }, /* @__PURE__ */ B(qh, Fe({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Oe(e.onCloseAutoFocus, (l) => {
      var s;
      l.preventDefault(), i.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Oe(e.onPointerDownOutside, (l) => {
      const s = l.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, d = s.button === 2 || c;
      i.current = d;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Oe(
      e.onFocusOutside,
      (l) => l.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), OI = /* @__PURE__ */ de((e, t) => {
  const n = on(ar, e.__scopePopover), r = ue(!1), o = ue(!1);
  return /* @__PURE__ */ B(qh, Fe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var l;
      if ((l = e.onCloseAutoFocus) === null || l === void 0 || l.call(e, i), !i.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var l, s;
      (l = e.onInteractOutside) === null || l === void 0 || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), qh = /* @__PURE__ */ de((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, disableOutsidePointerEvents: l, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: d, onInteractOutside: f, ...u } = e, m = on(ar, n), p = Ta(n);
  return RH(), /* @__PURE__ */ B(_H, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ B(Sh, {
    asChild: !0,
    disableOutsidePointerEvents: l,
    onInteractOutside: f,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: d,
    onDismiss: () => m.onOpenChange(!1)
  }, /* @__PURE__ */ B(_h, Fe({
    "data-state": Zh(m.open),
    role: "dialog",
    id: m.contentId
  }, p, u, {
    ref: t,
    style: {
      ...u.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), AI = "PopoverClose", TI = /* @__PURE__ */ de((e, t) => {
  const { __scopePopover: n, ...r } = e, o = on(AI, n);
  return /* @__PURE__ */ B(Ye.button, Fe({
    type: "button"
  }, r, {
    ref: t,
    onClick: Oe(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), kI = /* @__PURE__ */ de((e, t) => {
  const { __scopePopover: n, ...r } = e, o = Ta(n);
  return /* @__PURE__ */ B(Lh, Fe({}, o, r, {
    ref: t
  }));
});
function Zh(e) {
  return e ? "open" : "closed";
}
const HI = MI, II = PI, RI = FI, Jh = NI, _I = TI, LI = kI, Qh = de(
  ({
    className: e,
    align: t = "center",
    sideOffset: n = 4,
    children: r,
    arrow: o,
    classNames: i,
    variant: l = "dark",
    portal: s = !0,
    ...c
  }, d) => {
    const f = /* @__PURE__ */ re(
      Jh,
      {
        ref: d,
        align: t,
        sideOffset: n,
        className: j(
          [
            "relative z-[101] rounded-md bg-white p-2 text-sm text-text-primary shadow-md will-change-[transform,opacity]"
          ],
          { "bg-deepGray-500 text-white": l === "dark" },
          e
        ),
        ...c,
        children: [
          r,
          o && /* @__PURE__ */ g(
            LI,
            {
              "data-testid": "arrow",
              className: j("fill-white", { "fill-deepGray-500": l === "dark" }, i?.arrow)
            }
          )
        ]
      }
    );
    return s ? /* @__PURE__ */ g(RI, { children: f }) : f;
  }
);
Qh.displayName = Jh.displayName;
function $l(e) {
  return /* @__PURE__ */ g(HI, { ...e });
}
$l.Trigger = II;
$l.Content = Qh;
$l.Close = _I;
const q_ = pH, Z_ = vH, em = Se(
  [
    "flex",
    "w-full",
    "items-center",
    "justify-between",
    "text-left",
    "rounded",
    "bg-white",
    "border",
    "border-stroke",
    "px-4",
    "py-3",
    "hover:border-lightBlue-500",
    "focus:outline-none",
    "focus-visible:border-lightBlue-500",
    "focus-visible:ring-2",
    "focus-visible:ring-lightBlue-500",
    "disabled:bg-gray-200",
    "disabled:border-stroke",
    "disabled:opacity-38",
    "disabled:hover:border-stroke",
    "data-[state=open]:border-lightBlue-500",
    "data-[state=open]:ring-2",
    "data-[state=open]:ring-lightBlue-500",
    "data-[placeholder]:text-text-secondary",
    "[&>span]:truncate"
  ],
  {
    variants: {
      hasError: {
        true: [
          "border-error-600",
          "hover:border-error-600",
          "focus-visible:border-error-400",
          "focus-visible:ring-error-400",
          "data-[state=open]:border-error-400",
          "data-[state=open]:ring-error-400"
        ]
      },
      hasSuccess: {
        true: [
          "border-primary-500",
          "hover:border-primary-500",
          "focus-visible:border-primary-400",
          "focus-visible:ring-primary-400",
          "data-[state=open]:border-primary-400",
          "data-[state=open]:ring-primary-400"
        ]
      },
      isRound: {
        true: ["rounded-full"]
      },
      size: {
        sm: ["px-3", "py-2", "text-sm"]
      }
    }
  }
), tm = v.forwardRef(({ className: e, children: t, hasError: n, hasSuccess: r, isRound: o = !1, size: i, ...l }, s) => /* @__PURE__ */ re(
  yl,
  {
    ref: s,
    className: j(em({ hasError: n, hasSuccess: r, isRound: o, size: i }), e),
    ...l,
    children: [
      t,
      /* @__PURE__ */ g(wh, { asChild: !0, children: /* @__PURE__ */ g(Js, { className: j("ml-4 h-4 w-4 shrink-0 fill-text-primary", { "ml-3": i === "sm" }) }) })
    ]
  }
));
tm.displayName = yl.displayName;
const BI = v.forwardRef(({ className: e, children: t, icon: n, iconFill: r, isRound: o = !0, label: i, size: l, ...s }, c) => {
  const d = n;
  return /* @__PURE__ */ g(tm, { ref: c, className: j(em({ isRound: o, size: l }), e), ...s, children: /* @__PURE__ */ re("span", { className: "flex items-center gap-1", children: [
    d && /* @__PURE__ */ g("span", { children: /* @__PURE__ */ g(d, { className: j("h-6 w-6", { "h-5 w-5": l === "sm" }, r) }) }),
    /* @__PURE__ */ re("span", { className: "text-text-secondary", children: [
      i,
      ":"
    ] }),
    /* @__PURE__ */ g("span", { className: "font-medium", children: t })
  ] }) });
});
BI.displayName = "SelectFilterTrigger";
const WI = v.forwardRef(({ children: e, className: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ g($h, { children: /* @__PURE__ */ g(
  bl,
  {
    ref: o,
    className: j(
      "relative z-50 max-h-64 overflow-hidden rounded border border-stroke bg-white shadow",
      n === "popper" && "data-[side=bottom]:translate-y-2 data-[side=left]:-translate-x-2 data-[side=right]:translate-x-2 data-[side=top]:-translate-y-2"
    ),
    position: n,
    ...r,
    children: /* @__PURE__ */ g(
      Eh,
      {
        className: j(
          "py-1",
          n === "popper" && "h-[var(--radix-select-trigger-height)] min-w-[var(--radix-select-trigger-width)] max-w-[var(--radix-select-trigger-width)]",
          t
        ),
        children: e
      }
    )
  }
) }));
WI.displayName = bl.displayName;
const VI = v.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ g(
  na,
  {
    ref: r,
    className: j(
      "my-1 flex w-full cursor-pointer select-none items-center px-4 py-2 outline-none data-[disabled]:pointer-events-none data-[highlighted]:bg-lightBlue-500/5 data-[state=checked]:bg-lightBlue-500/10 data-[disabled]:opacity-38 data-[state=checked]:shadow-[inset_4px_0_0_0] data-[state=checked]:shadow-lightBlue-500 data-[highlighted]:outline-none [&>span]:truncate",
      e
    ),
    ...n,
    children: /* @__PURE__ */ g(ci, { children: t })
  }
));
VI.displayName = na.displayName;
const jI = v.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ g(xh, { ref: n, className: j("my-1 h-px bg-gray-200", e), ...t }));
jI.displayName = xh.displayName;
const ra = Se(["h-5", "w-5", "fill-text-secondary"], {
  variants: {
    disabled: { true: ["opacity-38"] },
    hasError: { true: ["fill-error-800"] },
    hasSuccess: { true: ["fill-success-800"] },
    isStartIcon: { true: [] },
    size: {
      sm: ["h-4", "w-4"]
    }
  },
  compoundVariants: [
    {
      hasError: !0,
      disabled: !0,
      class: ["fill-text-secondary"]
    },
    {
      hasSuccess: !0,
      disabled: !0,
      class: ["fill-text-secondary"]
    },
    {
      hasError: !0,
      isStartIcon: !0,
      class: ["fill-text-secondary"]
    },
    {
      hasSuccess: !0,
      isStartIcon: !0,
      class: ["fill-text-secondary"]
    }
  ]
}), GI = Se(
  [
    "rounded",
    "border",
    "border-stroke",
    "pt-3",
    "pr-4",
    "pb-3",
    "pl-4",
    "w-full",
    "hover:border-lightBlue-500",
    "focus-visible:outline-none",
    "focus-visible:border-lightBlue-500",
    "focus-visible:ring-2",
    "focus-visible:ring-lightBlue-500",
    "disabled:bg-gray-200",
    "disabled:border-stroke",
    "disabled:hover:border-stroke",
    "disabled:opacity-38",
    "placeholder:text-text-secondary"
  ],
  {
    variants: {
      hasEndSlot: { true: ["pr-11"] },
      hasStartSlot: { true: ["pl-11"] },
      hasError: {
        true: [
          "border-error-600",
          "hover:border-error-600",
          "focus-visible:border-error-400",
          "focus-visible:ring-error-400"
        ]
      },
      hasSuccess: {
        true: [
          "border-success-500",
          "hover:border-success-500",
          "focus-visible:border-success-400",
          "focus-visible:ring-success-400"
        ]
      },
      size: {
        sm: ["pt-2", "pr-3", "pb-2", "pl-3"]
      }
    },
    compoundVariants: [
      {
        hasEndSlot: !0,
        size: "sm",
        class: ["pr-8"]
      },
      {
        hasStartSlot: !0,
        size: "sm",
        class: ["pl-8"]
      },
      {
        hasEndSlot: !0,
        hasStartSlot: !0,
        class: ["pr-11", "pl-11"]
      },
      {
        hasEndSlot: !0,
        hasStartSlot: !0,
        size: "sm",
        class: ["pr-8", "pl-8"]
      }
    ]
  }
), El = de(
  ({ className: e, endSlot: t, startSlot: n, hasError: r = !1, hasSuccess: o = !1, size: i, ...l }, s) => {
    const c = !!t, d = !!n;
    return /* @__PURE__ */ re("div", { className: j("relative w-fit", e), children: [
      n && /* @__PURE__ */ g("div", { className: j("absolute inset-y-0 left-0 flex items-center pl-4", { "pl-3": i === "sm" }), children: n.component }),
      /* @__PURE__ */ g(
        "input",
        {
          ref: s,
          "aria-invalid": !!r,
          className: j(GI({ hasEndSlot: c, hasError: r, hasSuccess: o, hasStartSlot: d, size: i })),
          type: "text",
          ...l
        }
      ),
      t && /* @__PURE__ */ g(
        "div",
        {
          className: j("absolute inset-y-0 right-0 flex items-center pr-4", {
            "pr-3": i === "sm" || t.type === "button",
            "pr-2": i === "sm" && t.type === "button"
          }),
          children: t.component
        }
      )
    ] });
  }
);
El.displayName = "BaseInput";
const YI = de(
  ({
    className: e,
    hasError: t = !1,
    hasSuccess: n = !1,
    onChange: r,
    onClear: o,
    size: i,
    value: l,
    withSearchIcon: s = !1,
    ...c
  }, d) => {
    const f = {
      disabled: c.disabled,
      size: i
    }, [u, m] = Ce(l ?? ""), p = (h) => {
      m(h.target.value), r?.(h);
    }, y = () => {
      m(""), o?.();
    };
    return /* @__PURE__ */ g(
      El,
      {
        ref: d,
        className: e,
        endSlot: {
          component: /* @__PURE__ */ g(
            "button",
            {
              className: j("invisible rounded-full p-0.5 hover:bg-secondary-100", {
                visible: u.toString().length > 0
              }),
              onClick: y,
              type: "button",
              children: /* @__PURE__ */ g(Pn, { className: ra({ ...f, isStartIcon: !1 }) })
            }
          ),
          type: "button"
        },
        hasError: t,
        hasSuccess: n,
        onChange: p,
        size: i,
        startSlot: s ? {
          component: /* @__PURE__ */ g(o6, { className: ra({ ...f, isStartIcon: !0 }) }),
          type: "icon"
        } : void 0,
        value: u,
        ...c
      }
    );
  }
);
YI.displayName = "SearchInput";
function nm(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
const UI = /* @__PURE__ */ St(void 0);
function KI(e) {
  const t = rt(UI);
  return e || t || "ltr";
}
function XI(e) {
  const t = ue({
    value: e,
    previous: e
  });
  return Le(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function qI(e) {
  const t = e + "CollectionProvider", [n, r] = yr(t), [o, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), l = (p) => {
    const { scope: y, children: h } = p, b = a.useRef(null), w = a.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ a.createElement(o, {
      scope: y,
      itemMap: w,
      collectionRef: b
    }, h);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ a.forwardRef((p, y) => {
    const { scope: h, children: b } = p, w = i(s, h), $ = He(y, w.collectionRef);
    return /* @__PURE__ */ a.createElement(rr, {
      ref: $
    }, b);
  }), d = e + "CollectionItemSlot", f = "data-radix-collection-item", u = /* @__PURE__ */ a.forwardRef((p, y) => {
    const { scope: h, children: b, ...w } = p, $ = a.useRef(null), x = He(y, $), P = i(d, h);
    return a.useEffect(() => (P.itemMap.set($, {
      ref: $,
      ...w
    }), () => void P.itemMap.delete($))), /* @__PURE__ */ a.createElement(rr, {
      [f]: "",
      ref: x
    }, b);
  });
  function m(p) {
    const y = i(e + "CollectionConsumer", p);
    return a.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${f}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, E) => w.indexOf(P.ref.current) - w.indexOf(E.ref.current)
      );
    }, [
      y.collectionRef,
      y.itemMap
    ]);
  }
  return [
    {
      Provider: l,
      Slot: c,
      ItemSlot: u
    },
    m,
    r
  ];
}
const rm = [
  "PageUp",
  "PageDown"
], am = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], om = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, wr = "Slider", [hi, ZI, JI] = qI(wr), [im, QI] = yr(wr, [
  JI
]), [eR, ka] = im(wr), lm = /* @__PURE__ */ de((e, t) => {
  const { name: n, min: r = 0, max: o = 100, step: i = 1, orientation: l = "horizontal", disabled: s = !1, minStepsBetweenThumbs: c = 0, defaultValue: d = [
    r
  ], value: f, onValueChange: u = () => {
  }, onValueCommit: m = () => {
  }, inverted: p = !1, ...y } = e, [h, b] = Ce(null), w = He(
    t,
    (R) => b(R)
  ), $ = ue(/* @__PURE__ */ new Set()), x = ue(0), P = l === "horizontal", E = h ? !!h.closest("form") : !0, z = P ? tR : nR, [S = [], F] = wl({
    prop: f,
    defaultProp: d,
    onChange: (R) => {
      var Y;
      (Y = [
        ...$.current
      ][x.current]) === null || Y === void 0 || Y.focus(), u(R);
    }
  }), O = ue(S);
  function I(R) {
    const Y = sR(S, R);
    ne(R, Y);
  }
  function L(R) {
    ne(R, x.current);
  }
  function _() {
    const R = O.current[x.current];
    S[x.current] !== R && m(S);
  }
  function ne(R, Y, { commit: W } = {
    commit: !1
  }) {
    const V = fR(i), J = hR(Math.round((R - r) / i) * i + r, V), T = nm(J, [
      r,
      o
    ]);
    F((N = []) => {
      const D = iR(N, T, Y);
      if (uR(D, c * i)) {
        x.current = D.indexOf(T);
        const K = String(D) !== String(N);
        return K && W && m(D), K ? D : N;
      } else return N;
    });
  }
  return /* @__PURE__ */ B(eR, {
    scope: e.__scopeSlider,
    disabled: s,
    min: r,
    max: o,
    valueIndexToChangeRef: x,
    thumbs: $.current,
    values: S,
    orientation: l
  }, /* @__PURE__ */ B(hi.Provider, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ B(hi.Slot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ B(z, Fe({
    "aria-disabled": s,
    "data-disabled": s ? "" : void 0
  }, y, {
    ref: w,
    onPointerDown: Oe(y.onPointerDown, () => {
      s || (O.current = S);
    }),
    min: r,
    max: o,
    inverted: p,
    onSlideStart: s ? void 0 : I,
    onSlideMove: s ? void 0 : L,
    onSlideEnd: s ? void 0 : _,
    onHomeKeyDown: () => !s && ne(r, 0, {
      commit: !0
    }),
    onEndKeyDown: () => !s && ne(o, S.length - 1, {
      commit: !0
    }),
    onStepKeyDown: ({ event: R, direction: Y }) => {
      if (!s) {
        const J = rm.includes(R.key) || R.shiftKey && am.includes(R.key) ? 10 : 1, T = x.current, N = S[T], D = i * J * Y;
        ne(N + D, T, {
          commit: !0
        });
      }
    }
  })))), E && S.map(
    (R, Y) => /* @__PURE__ */ B(oR, {
      key: Y,
      name: n ? n + (S.length > 1 ? "[]" : "") : void 0,
      value: R
    })
  ));
}), [sm, cm] = im(wr, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), tR = /* @__PURE__ */ de((e, t) => {
  const { min: n, max: r, dir: o, inverted: i, onSlideStart: l, onSlideMove: s, onSlideEnd: c, onStepKeyDown: d, ...f } = e, [u, m] = Ce(null), p = He(
    t,
    (x) => m(x)
  ), y = ue(), h = KI(o), b = h === "ltr", w = b && !i || !b && i;
  function $(x) {
    const P = y.current || u.getBoundingClientRect(), E = [
      0,
      P.width
    ], S = xl(E, w ? [
      n,
      r
    ] : [
      r,
      n
    ]);
    return y.current = P, S(x - P.left);
  }
  return /* @__PURE__ */ B(sm, {
    scope: e.__scopeSlider,
    startEdge: w ? "left" : "right",
    endEdge: w ? "right" : "left",
    direction: w ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ B(dm, Fe({
    dir: h,
    "data-orientation": "horizontal"
  }, f, {
    ref: p,
    style: {
      ...f.style,
      "--radix-slider-thumb-transform": "translateX(-50%)"
    },
    onSlideStart: (x) => {
      const P = $(x.clientX);
      l?.(P);
    },
    onSlideMove: (x) => {
      const P = $(x.clientX);
      s?.(P);
    },
    onSlideEnd: () => {
      y.current = void 0, c?.();
    },
    onStepKeyDown: (x) => {
      const E = om[w ? "from-left" : "from-right"].includes(x.key);
      d?.({
        event: x,
        direction: E ? -1 : 1
      });
    }
  })));
}), nR = /* @__PURE__ */ de((e, t) => {
  const { min: n, max: r, inverted: o, onSlideStart: i, onSlideMove: l, onSlideEnd: s, onStepKeyDown: c, ...d } = e, f = ue(null), u = He(t, f), m = ue(), p = !o;
  function y(h) {
    const b = m.current || f.current.getBoundingClientRect(), w = [
      0,
      b.height
    ], x = xl(w, p ? [
      r,
      n
    ] : [
      n,
      r
    ]);
    return m.current = b, x(h - b.top);
  }
  return /* @__PURE__ */ B(sm, {
    scope: e.__scopeSlider,
    startEdge: p ? "bottom" : "top",
    endEdge: p ? "top" : "bottom",
    size: "height",
    direction: p ? 1 : -1
  }, /* @__PURE__ */ B(dm, Fe({
    "data-orientation": "vertical"
  }, d, {
    ref: u,
    style: {
      ...d.style,
      "--radix-slider-thumb-transform": "translateY(50%)"
    },
    onSlideStart: (h) => {
      const b = y(h.clientY);
      i?.(b);
    },
    onSlideMove: (h) => {
      const b = y(h.clientY);
      l?.(b);
    },
    onSlideEnd: () => {
      m.current = void 0, s?.();
    },
    onStepKeyDown: (h) => {
      const w = om[p ? "from-bottom" : "from-top"].includes(h.key);
      c?.({
        event: h,
        direction: w ? -1 : 1
      });
    }
  })));
}), dm = /* @__PURE__ */ de((e, t) => {
  const { __scopeSlider: n, onSlideStart: r, onSlideMove: o, onSlideEnd: i, onHomeKeyDown: l, onEndKeyDown: s, onStepKeyDown: c, ...d } = e, f = ka(wr, n);
  return /* @__PURE__ */ B(Ye.span, Fe({}, d, {
    ref: t,
    onKeyDown: Oe(e.onKeyDown, (u) => {
      u.key === "Home" ? (l(u), u.preventDefault()) : u.key === "End" ? (s(u), u.preventDefault()) : rm.concat(am).includes(u.key) && (c(u), u.preventDefault());
    }),
    onPointerDown: Oe(e.onPointerDown, (u) => {
      const m = u.target;
      m.setPointerCapture(u.pointerId), u.preventDefault(), f.thumbs.has(m) ? m.focus() : r(u);
    }),
    onPointerMove: Oe(e.onPointerMove, (u) => {
      u.target.hasPointerCapture(u.pointerId) && o(u);
    }),
    onPointerUp: Oe(e.onPointerUp, (u) => {
      const m = u.target;
      m.hasPointerCapture(u.pointerId) && (m.releasePointerCapture(u.pointerId), i(u));
    })
  }));
}), rR = "SliderTrack", um = /* @__PURE__ */ de((e, t) => {
  const { __scopeSlider: n, ...r } = e, o = ka(rR, n);
  return /* @__PURE__ */ B(Ye.span, Fe({
    "data-disabled": o.disabled ? "" : void 0,
    "data-orientation": o.orientation
  }, r, {
    ref: t
  }));
}), Gs = "SliderRange", fm = /* @__PURE__ */ de((e, t) => {
  const { __scopeSlider: n, ...r } = e, o = ka(Gs, n), i = cm(Gs, n), l = ue(null), s = He(t, l), c = o.values.length, d = o.values.map(
    (m) => mm(m, o.min, o.max)
  ), f = c > 1 ? Math.min(...d) : 0, u = 100 - Math.max(...d);
  return /* @__PURE__ */ B(Ye.span, Fe({
    "data-orientation": o.orientation,
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: s,
    style: {
      ...e.style,
      [i.startEdge]: f + "%",
      [i.endEdge]: u + "%"
    }
  }));
}), Ys = "SliderThumb", hm = /* @__PURE__ */ de((e, t) => {
  const n = ZI(e.__scopeSlider), [r, o] = Ce(null), i = He(
    t,
    (s) => o(s)
  ), l = Le(
    () => r ? n().findIndex(
      (s) => s.ref.current === r
    ) : -1,
    [
      n,
      r
    ]
  );
  return /* @__PURE__ */ B(aR, Fe({}, e, {
    ref: i,
    index: l
  }));
}), aR = /* @__PURE__ */ de((e, t) => {
  const { __scopeSlider: n, index: r, ...o } = e, i = ka(Ys, n), l = cm(Ys, n), [s, c] = Ce(null), d = He(
    t,
    (b) => c(b)
  ), f = Dh(s), u = i.values[r], m = u === void 0 ? 0 : mm(u, i.min, i.max), p = lR(r, i.values.length), y = f?.[l.size], h = y ? cR(y, m, l.direction) : 0;
  return ye(() => {
    if (s)
      return i.thumbs.add(s), () => {
        i.thumbs.delete(s);
      };
  }, [
    s,
    i.thumbs
  ]), /* @__PURE__ */ B("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [l.startEdge]: `calc(${m}% + ${h}px)`
    }
  }, /* @__PURE__ */ B(hi.ItemSlot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ B(Ye.span, Fe({
    role: "slider",
    "aria-label": e["aria-label"] || p,
    "aria-valuemin": i.min,
    "aria-valuenow": u,
    "aria-valuemax": i.max,
    "aria-orientation": i.orientation,
    "data-orientation": i.orientation,
    "data-disabled": i.disabled ? "" : void 0,
    tabIndex: i.disabled ? void 0 : 0
  }, o, {
    ref: d,
    style: u === void 0 ? {
      display: "none"
    } : e.style,
    onFocus: Oe(e.onFocus, () => {
      i.valueIndexToChangeRef.current = r;
    })
  }))));
}), oR = (e) => {
  const { value: t, ...n } = e, r = ue(null), o = XI(t);
  return ye(() => {
    const i = r.current, l = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(l, "value").set;
    if (o !== t && c) {
      const d = new Event("input", {
        bubbles: !0
      });
      c.call(i, t), i.dispatchEvent(d);
    }
  }, [
    o,
    t
  ]), /* @__PURE__ */ B("input", Fe({
    style: {
      display: "none"
    }
  }, n, {
    ref: r,
    defaultValue: t
  }));
};
function iR(e = [], t, n) {
  const r = [
    ...e
  ];
  return r[n] = t, r.sort(
    (o, i) => o - i
  );
}
function mm(e, t, n) {
  const i = 100 / (n - t) * (e - t);
  return nm(i, [
    0,
    100
  ]);
}
function lR(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? [
    "Minimum",
    "Maximum"
  ][e] : void 0;
}
function sR(e, t) {
  if (e.length === 1) return 0;
  const n = e.map(
    (o) => Math.abs(o - t)
  ), r = Math.min(...n);
  return n.indexOf(r);
}
function cR(e, t, n) {
  const r = e / 2, i = xl([
    0,
    50
  ], [
    0,
    r
  ]);
  return (r - i(t) * n) * n;
}
function dR(e) {
  return e.slice(0, -1).map(
    (t, n) => e[n + 1] - t
  );
}
function uR(e, t) {
  if (t > 0) {
    const n = dR(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function xl(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function fR(e) {
  return (String(e).split(".")[1] || "").length;
}
function hR(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
const mR = lm, pR = um, vR = fm, gR = hm, J_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Range: vR,
  Root: mR,
  Slider: lm,
  SliderRange: fm,
  SliderThumb: hm,
  SliderTrack: um,
  Thumb: gR,
  Track: pR,
  createSliderScope: QI
}, Symbol.toStringTag, { value: "Module" })), pm = St({ queue: [] }), vm = St(null);
function yR(e, t) {
  return t.type === "enqueue" ? t.message.closeable ?? !0 ? { ...e, queue: [t.message, ...e.queue.filter((r) => !r.closeable)] } : { ...e, queue: [...e.queue, t.message] } : { ...e, queue: e.queue.filter((n) => n.id !== t.id) };
}
function Q_({ children: e }) {
  const [t, n] = Xs(yR, { queue: [] });
  return /* @__PURE__ */ g(pm.Provider, { value: t, children: /* @__PURE__ */ g(vm.Provider, { value: n, children: e }) });
}
const bR = () => rt(pm), wR = () => rt(vm), Ml = ({ className: e, fill: t }) => /* @__PURE__ */ re(
  "svg",
  {
    "aria-hidden": "true",
    className: j("animate-spin p-1 text-transparent", e),
    fill: "none",
    viewBox: "0 0 100 101",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ g(
        "path",
        {
          d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ g(
        "path",
        {
          d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
          fill: t ?? "currentFill"
        }
      )
    ]
  }
), $R = Se(["fixed", "space-y-2", "z-50"], {
  variants: {
    vertical: {
      top: ["top-10"],
      bottom: ["bottom-10"]
    },
    horizontal: {
      left: ["left-10"],
      center: ["right-1/2", "translate-x-1/2"],
      right: ["right-10"]
    }
  }
}), ER = Se(
  [
    "bg-deepGray-500",
    "flex",
    "items-center",
    "justify-between",
    "px-4",
    "py-2",
    "rounded-md",
    "shadow-lg",
    "text-white",
    "w-fit"
  ],
  {
    variants: {
      vertical: {
        top: [],
        bottom: []
      },
      horizontal: {
        left: [],
        center: [],
        right: []
      },
      action: {
        true: "py-2",
        false: "py-3"
      }
    },
    compoundVariants: [
      {
        vertical: "top",
        horizontal: "left",
        className: ["animate-top-left"]
      },
      {
        vertical: "top",
        horizontal: "right",
        className: ["animate-top-right"]
      },
      {
        vertical: "bottom",
        horizontal: "left",
        className: ["animate-bottom-left"]
      },
      {
        vertical: "bottom",
        horizontal: "right",
        className: ["animate-bottom-right"]
      },
      {
        vertical: "top",
        horizontal: "center",
        className: ["animate-top-center"]
      },
      {
        vertical: "bottom",
        horizontal: "center",
        className: ["animate-bottom-center"]
      }
    ]
  }
);
function eL({ vertical: e = "bottom", horizontal: t = "left" }) {
  const { queue: n } = bR(), r = new zn();
  return /* @__PURE__ */ g("div", { className: $R({ vertical: e, horizontal: t }), children: n.map((o) => /* @__PURE__ */ re(
    "div",
    {
      className: ER({
        vertical: e,
        horizontal: t,
        action: !!o.action
      }),
      children: [
        /* @__PURE__ */ re(
          "div",
          {
            className: j("text-sm", {
              "mr-8": o.action ?? o.closeable,
              "flex items-center gap-3": o.loading
            }),
            children: [
              o.loading && /* @__PURE__ */ g(Ml, { className: "h-5 w-5 p-0", fill: "white" }),
              /* @__PURE__ */ g("span", { children: o.content })
            ]
          }
        ),
        /* @__PURE__ */ re("div", { className: "flex items-center", children: [
          o.action && /* @__PURE__ */ g(
            "button",
            {
              className: j("rounded-full px-2 py-1 font-bold text-lightBlue-400 hover:bg-white/10", {
                "mr-2": o.closeable
              }),
              onClick: o.action.onClick,
              onMouseDown: (i) => {
                r.apply(i, { color: pe.white, opacity: 0.1 });
              },
              type: "button",
              children: o.action.text
            }
          ),
          o.closeable && /* @__PURE__ */ g(
            "button",
            {
              "aria-label": "Close",
              className: "rounded-full p-1 text-xl hover:bg-white/10",
              onClick: o.onClose,
              type: "button",
              children: /* @__PURE__ */ g(Pn, { fill: pe.lightBlue[400] })
            }
          )
        ] })
      ]
    },
    o.id
  )) });
}
function tL() {
  const e = wR();
  function t({ message: n, action: r, closeable: o = !0, delay: i = 8e3, loading: l = !1 }) {
    const s = y7(), c = o ? setTimeout(() => {
      e?.({ type: "dequeue", id: s });
    }, i) : null;
    e?.({
      type: "enqueue",
      message: {
        id: s,
        action: r,
        closeable: o,
        content: n,
        loading: l,
        onClose: () => {
          e?.({ type: "dequeue", id: s }), c && clearTimeout(c);
        },
        open: !0
      }
    });
  }
  return t;
}
function xR(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function Us(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function gm(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Us(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Us(e[o], null);
        }
      };
  };
}
function MR(...e) {
  return v.useCallback(gm(...e), e);
}
var ym = v.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = v.Children.toArray(n), i = o.find(PR);
  if (i) {
    const l = i.props.children, s = o.map((c) => c === i ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : c);
    return /* @__PURE__ */ g(mi, { ...r, ref: t, children: v.isValidElement(l) ? v.cloneElement(l, void 0, s) : null });
  }
  return /* @__PURE__ */ g(mi, { ...r, ref: t, children: n });
});
ym.displayName = "Slot";
var mi = v.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (v.isValidElement(n)) {
    const o = zR(n);
    return v.cloneElement(n, {
      ...SR(r, n.props),
      // @ts-ignore
      ref: t ? gm(t, o) : o
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
mi.displayName = "SlotClone";
var CR = ({ children: e }) => /* @__PURE__ */ g(Ge, { children: e });
function PR(e) {
  return v.isValidElement(e) && e.type === CR;
}
function SR(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function zR(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var FR = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], bm = FR.reduce((e, t) => {
  const n = v.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, s = i ? ym : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(s, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Cl = "Switch", [NR] = ur(Cl), [DR, OR] = NR(Cl), wm = v.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: l,
      disabled: s,
      value: c = "on",
      onCheckedChange: d,
      form: f,
      ...u
    } = e, [m, p] = v.useState(null), y = MR(t, (x) => p(x)), h = v.useRef(!1), b = m ? f || !!m.closest("form") : !0, [w = !1, $] = bt({
      prop: o,
      defaultProp: i,
      onChange: d
    });
    return /* @__PURE__ */ re(DR, { scope: n, checked: w, disabled: s, children: [
      /* @__PURE__ */ g(
        bm.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": l,
          "data-state": xm(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...u,
          ref: y,
          onClick: xR(e.onClick, (x) => {
            $((P) => !P), b && (h.current = x.isPropagationStopped(), h.current || x.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ g(
        AR,
        {
          control: m,
          bubbles: !h.current,
          name: r,
          value: c,
          checked: w,
          required: l,
          disabled: s,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
wm.displayName = Cl;
var $m = "SwitchThumb", Em = v.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = OR($m, n);
    return /* @__PURE__ */ g(
      bm.span,
      {
        "data-state": xm(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
Em.displayName = $m;
var AR = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = v.useRef(null), l = X5(n), s = Od(t);
  return v.useEffect(() => {
    const c = i.current, d = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (l !== n && u) {
      const m = new Event("click", { bubbles: r });
      u.call(c, n), c.dispatchEvent(m);
    }
  }, [l, n, r]), /* @__PURE__ */ g(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function xm(e) {
  return e ? "checked" : "unchecked";
}
var Pl = wm, Mm = Em;
const TR = Se(
  [
    "cursor-pointer",
    "rounded-full",
    "outline-none",
    "flex",
    "items-center",
    "justify-center",
    "bg-deepGray-500/38",
    "[&_span]:data-[state=unchecked]:hover:ring-black/10",
    "[&_span]:data-[state=unchecked]:focus-visible:ring-black/20",
    "disabled:opacity-38",
    "disabled:cursor-default",
    "[&_span]:disabled:hover:ring-0"
  ],
  {
    variants: {
      size: {
        sm: ["h-2.5", "w-7", "[&_span]:hover:ring-4", "[&_span]:focus-visible:ring-4"],
        md: ["h-[14px]", "w-9", "[&_span]:hover:ring-8", "[&_span]:focus-visible:ring-8"]
      },
      variant: {
        secondary: [
          "data-[state=checked]:bg-secondary-500/50",
          "[&_span]:data-[state=checked]:hover:ring-secondary-500/10",
          "[&_span]:data-[state=checked]:focus-visible:ring-secondary-500/20"
        ],
        info: [
          "data-[state=checked]:bg-info-500/50",
          "[&_span]:data-[state=checked]:hover:ring-info-500/10",
          "[&_span]:data-[state=checked]:focus-visible:ring-info-500/20"
        ],
        primary: [
          "data-[state=checked]:bg-primary-500/50",
          "[&_span]:data-[state=checked]:hover:ring-primary-500/10",
          "[&_span]:data-[state=checked]:focus-visible:ring-primary-500/20"
        ]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), kR = Se(
  [
    "block",
    "-translate-x-2",
    "rounded-full",
    "transition-transform",
    "duration-100",
    "will-change-transform",
    "shadow-sm",
    "shadow-black/40",
    "bg-gray-50",
    "[&_svg]:data-[state=checked]:fill-white",
    "[&_svg]:data-[state=unchecked]:fill-black/80"
  ],
  {
    variants: {
      size: {
        sm: ["h-4", "w-4", "data-[state=checked]:translate-x-[8px]"],
        md: ["h-5", "w-5", "data-[state=checked]:translate-x-[8px]"]
      },
      variant: {
        secondary: ["data-[state=checked]:bg-secondary-500"],
        info: ["data-[state=checked]:bg-info-500"],
        primary: ["data-[state=checked]:bg-primary-500"]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), HR = v.forwardRef(({ accessibilityLabel: e, className: t, loading: n, size: r = "md", variant: o = "primary", ...i }, l) => /* @__PURE__ */ re(
  Pl,
  {
    ref: l,
    className: j(TR({ size: r, variant: o }), t),
    disabled: n || i.disabled,
    ...i,
    children: [
      /* @__PURE__ */ g("span", { className: "sr-only", children: e }),
      /* @__PURE__ */ g(Mm, { className: j(kR({ size: r, variant: o })), children: n && /* @__PURE__ */ g(Ml, { className: j("h-5 w-5", { "h-4 w-4": r === "sm" }) }) })
    ]
  }
));
HR.displayName = Pl.displayName;
const IR = de(
  ({ className: e, endIcon: t, hasError: n = !1, hasSuccess: r = !1, startIcon: o, size: i, ...l }, s) => {
    const c = {
      disabled: l.disabled,
      hasError: n,
      hasSuccess: r,
      size: i
    }, d = t, f = o;
    return /* @__PURE__ */ g(
      El,
      {
        ref: s,
        className: e,
        endSlot: d ? {
          component: /* @__PURE__ */ g(d, { className: ra({ ...c, isStartIcon: !1 }) }),
          type: "icon"
        } : void 0,
        hasError: n,
        hasSuccess: r,
        size: i,
        startSlot: f ? {
          component: /* @__PURE__ */ g(f, { className: ra({ ...c, isStartIcon: !0 }) }),
          type: "icon"
        } : void 0,
        ...l
      }
    );
  }
);
IR.displayName = "TextInput";
const RR = Se(
  [
    "cursor-pointer",
    "rounded-full",
    "outline-none",
    "disabled:opacity-38",
    "disabled:cursor-default",
    "[&_span]:data-[state=checked]:hover:ring-4",
    "[&_span]:data-[state=checked]:hover:ring-primary-800/40",
    "[&_span]:data-[state=unchecked]:hover:ring-4",
    "[&_span]:data-[state=unchecked]:hover:ring-red-800/40",
    "[&_span]:data-[state=checked]:focus-visible:ring-4",
    "[&_span]:data-[state=checked]:focus-visible:ring-primary-800/40",
    "[&_span]:data-[state=checked]:disabled:hover:ring-0",
    "[&_span]:data-[state=unchecked]:focus-visible:ring-4",
    "[&_span]:data-[state=unchecked]:focus-visible:ring-red-800/40",
    "[&_span]:data-[state=unchecked]:disabled:hover:ring-0"
  ],
  {
    variants: {
      size: {
        sm: ["h-5", "w-10"],
        md: ["h-7", "w-12"],
        lg: ["h-8", "w-14"]
      },
      variant: {
        primary: ["bg-red-500", "data-[state=checked]:bg-primary-500"],
        secondary: ["bg-gray-800", "data-[state=checked]:bg-gray-800"],
        tertiary: ["bg-gray-200", "data-[state=checked]:bg-gray-200"]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), _R = Se(
  [
    "block",
    "translate-x-0.5",
    "rounded-full",
    "transition-transform",
    "duration-100",
    "will-change-transform",
    "flex",
    "items-center",
    "justify-center"
  ],
  {
    variants: {
      size: {
        sm: ["h-4", "w-4", "data-[state=checked]:translate-x-[22px]"],
        md: ["h-6", "w-6", "data-[state=checked]:translate-x-[22px]"],
        lg: ["h-7", "w-7", "data-[state=checked]:translate-x-[26px]"]
      },
      variant: {
        primary: ["border", "border-red-800", "bg-white", "data-[state=checked]:border-primary-800"],
        secondary: ["bg-white", "data-[state=checked]:border-primary-800"],
        tertiary: [
          "border",
          "border-red-800",
          "bg-red-500",
          "data-[state=checked]:bg-primary-500",
          "data-[state=checked]:border-primary-800"
        ]
      }
    },
    defaultVariants: {
      size: "md",
      variant: "primary"
    }
  }
), Ln = Se([], {
  variants: {
    checked: {
      true: ["fill-primary-500"],
      false: ["fill-red-500"]
    },
    locked: {
      true: [],
      false: []
    },
    size: {
      sm: ["h-4", "w-4"],
      md: ["h-5", "w-5"],
      lg: ["h-6", "w-6"]
    },
    variant: {
      primary: [],
      secondary: [],
      tertiary: ["fill-white"]
    },
    scheduled: {
      true: [],
      false: []
    }
  },
  compoundVariants: [
    {
      size: "sm",
      locked: !0,
      class: ["h-3", "w-3"]
    },
    {
      size: "md",
      locked: !0,
      class: ["h-4", "w-4"]
    },
    {
      size: "lg",
      locked: !0,
      class: ["h-5", "w-5"]
    },
    {
      size: "sm",
      scheduled: !0,
      class: ["h-3", "w-3"]
    }
  ],
  defaultVariants: {
    size: "md",
    variant: "primary"
  }
}), LR = v.forwardRef(
  ({
    accessibilityLabel: e,
    className: t,
    loading: n = !1,
    locked: r = !1,
    scheduled: o = !1,
    size: i = "md",
    variant: l = "primary",
    ...s
  }, c) => /* @__PURE__ */ re(
    Pl,
    {
      ref: c,
      className: j(RR({ size: i, variant: l }), t),
      disabled: s.disabled || r || n || o,
      ...s,
      children: [
        /* @__PURE__ */ g("span", { className: "sr-only", children: e }),
        /* @__PURE__ */ g(Mm, { className: j(_R({ size: i, variant: l })), children: o ? /* @__PURE__ */ g(i6, { className: Ln({ checked: s.checked, scheduled: o, size: i, variant: l }) }) : r ? /* @__PURE__ */ g(l6, { className: Ln({ checked: s.checked, locked: r, size: i, variant: l }) }) : n ? /* @__PURE__ */ g(Ml, { className: j(Ln({ checked: s.checked, size: i, variant: l }), "p-0.5") }) : s.checked ? /* @__PURE__ */ g(s6, { className: Ln({ checked: s.checked, size: i, variant: l }) }) : /* @__PURE__ */ g(Pn, { className: Ln({ checked: s.checked, size: i, variant: l }) }) })
      ]
    }
  )
);
LR.displayName = "Toggle";
const BR = /* @__PURE__ */ de((e, t) => /* @__PURE__ */ B(Ye.span, et({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), WR = BR, [Ha] = yr("Tooltip", [
  Oa
]), Ia = Oa(), VR = "TooltipProvider", jR = 700, pi = "tooltip.open", [GR, Sl] = Ha(VR), YR = (e) => {
  const { __scopeTooltip: t, delayDuration: n = jR, skipDelayDuration: r = 300, disableHoverableContent: o = !1, children: i } = e, [l, s] = Ce(!0), c = ue(!1), d = ue(0);
  return ye(() => {
    const f = d.current;
    return () => window.clearTimeout(f);
  }, []), /* @__PURE__ */ B(GR, {
    scope: t,
    isOpenDelayed: l,
    delayDuration: n,
    onOpen: se(() => {
      window.clearTimeout(d.current), s(!1);
    }, []),
    onClose: se(() => {
      window.clearTimeout(d.current), d.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: se((f) => {
      c.current = f;
    }, []),
    disableHoverableContent: o
  }, i);
}, zl = "Tooltip", [UR, $r] = Ha(zl), KR = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: o = !1, onOpenChange: i, disableHoverableContent: l, delayDuration: s } = e, c = Sl(zl, e.__scopeTooltip), d = Ia(t), [f, u] = Ce(null), m = Nh(), p = ue(0), y = l ?? c.disableHoverableContent, h = s ?? c.delayDuration, b = ue(!1), [w = !1, $] = wl({
    prop: r,
    defaultProp: o,
    onChange: (S) => {
      S ? (c.onOpen(), document.dispatchEvent(new CustomEvent(pi))) : c.onClose(), i?.(S);
    }
  }), x = Le(() => w ? b.current ? "delayed-open" : "instant-open" : "closed", [
    w
  ]), P = se(() => {
    window.clearTimeout(p.current), b.current = !1, $(!0);
  }, [
    $
  ]), E = se(() => {
    window.clearTimeout(p.current), $(!1);
  }, [
    $
  ]), z = se(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      b.current = !0, $(!0);
    }, h);
  }, [
    h,
    $
  ]);
  return ye(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ B(Ih, d, /* @__PURE__ */ B(UR, {
    scope: t,
    contentId: m,
    open: w,
    stateAttribute: x,
    trigger: f,
    onTriggerChange: u,
    onTriggerEnter: se(() => {
      c.isOpenDelayed ? z() : P();
    }, [
      c.isOpenDelayed,
      z,
      P
    ]),
    onTriggerLeave: se(() => {
      y ? E() : window.clearTimeout(p.current);
    }, [
      E,
      y
    ]),
    onOpen: P,
    onClose: E,
    disableHoverableContent: y
  }, n));
}, Ks = "TooltipTrigger", XR = /* @__PURE__ */ de((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = $r(Ks, n), i = Sl(Ks, n), l = Ia(n), s = ue(null), c = He(t, s, o.onTriggerChange), d = ue(!1), f = ue(!1), u = se(
    () => d.current = !1,
    []
  );
  return ye(() => () => document.removeEventListener("pointerup", u), [
    u
  ]), /* @__PURE__ */ B(Rh, Fe({
    asChild: !0
  }, l), /* @__PURE__ */ B(Ye.button, Fe({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: Oe(e.onPointerMove, (m) => {
      m.pointerType !== "touch" && !f.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), f.current = !0);
    }),
    onPointerLeave: Oe(e.onPointerLeave, () => {
      o.onTriggerLeave(), f.current = !1;
    }),
    onPointerDown: Oe(e.onPointerDown, () => {
      d.current = !0, document.addEventListener("pointerup", u, {
        once: !0
      });
    }),
    onFocus: Oe(e.onFocus, () => {
      d.current || o.onOpen();
    }),
    onBlur: Oe(e.onBlur, o.onClose),
    onClick: Oe(e.onClick, o.onClose)
  })));
}), Cm = "TooltipPortal", [qR, ZR] = Ha(Cm, {
  forceMount: void 0
}), JR = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = $r(Cm, t);
  return /* @__PURE__ */ B(qR, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ B(br, {
    present: n || i.open
  }, /* @__PURE__ */ B(Bh, {
    asChild: !0,
    container: o
  }, r)));
}, or = "TooltipContent", QR = /* @__PURE__ */ de((e, t) => {
  const n = ZR(or, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, l = $r(or, e.__scopeTooltip);
  return /* @__PURE__ */ B(br, {
    present: r || l.open
  }, l.disableHoverableContent ? /* @__PURE__ */ B(Pm, Fe({
    side: o
  }, i, {
    ref: t
  })) : /* @__PURE__ */ B(e_, Fe({
    side: o
  }, i, {
    ref: t
  })));
}), e_ = /* @__PURE__ */ de((e, t) => {
  const n = $r(or, e.__scopeTooltip), r = Sl(or, e.__scopeTooltip), o = ue(null), i = He(t, o), [l, s] = Ce(null), { trigger: c, onClose: d } = n, f = o.current, { onPointerInTransitChange: u } = r, m = se(() => {
    s(null), u(!1);
  }, [
    u
  ]), p = se((y, h) => {
    const b = y.currentTarget, w = {
      x: y.clientX,
      y: y.clientY
    }, $ = o_(w, b.getBoundingClientRect()), x = i_(w, $), P = l_(h.getBoundingClientRect()), E = c_([
      ...x,
      ...P
    ]);
    s(E), u(!0);
  }, [
    u
  ]);
  return ye(() => () => m(), [
    m
  ]), ye(() => {
    if (c && f) {
      const y = (b) => p(b, f), h = (b) => p(b, c);
      return c.addEventListener("pointerleave", y), f.addEventListener("pointerleave", h), () => {
        c.removeEventListener("pointerleave", y), f.removeEventListener("pointerleave", h);
      };
    }
  }, [
    c,
    f,
    p,
    m
  ]), ye(() => {
    if (l) {
      const y = (h) => {
        const b = h.target, w = {
          x: h.clientX,
          y: h.clientY
        }, $ = c?.contains(b) || f?.contains(b), x = !s_(w, l);
        $ ? m() : x && (m(), d());
      };
      return document.addEventListener("pointermove", y), () => document.removeEventListener("pointermove", y);
    }
  }, [
    c,
    f,
    l,
    d,
    m
  ]), /* @__PURE__ */ B(Pm, Fe({}, e, {
    ref: i
  }));
}), [t_, n_] = Ha(zl, {
  isInside: !1
}), Pm = /* @__PURE__ */ de((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": o, onEscapeKeyDown: i, onPointerDownOutside: l, ...s } = e, c = $r(or, n), d = Ia(n), { onClose: f } = c;
  return ye(() => (document.addEventListener(pi, f), () => document.removeEventListener(pi, f)), [
    f
  ]), ye(() => {
    if (c.trigger) {
      const u = (m) => {
        const p = m.target;
        p != null && p.contains(c.trigger) && f();
      };
      return window.addEventListener("scroll", u, {
        capture: !0
      }), () => window.removeEventListener("scroll", u, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    f
  ]), /* @__PURE__ */ B(Sh, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: l,
    onFocusOutside: (u) => u.preventDefault(),
    onDismiss: f
  }, /* @__PURE__ */ B(_h, Fe({
    "data-state": c.stateAttribute
  }, d, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ B(Ph, null, r), /* @__PURE__ */ B(t_, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ B(WR, {
    id: c.contentId,
    role: "tooltip"
  }, o || r))));
}), r_ = "TooltipArrow", a_ = /* @__PURE__ */ de((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = Ia(n);
  return n_(r_, n).isInside ? null : /* @__PURE__ */ B(Lh, Fe({}, o, r, {
    ref: t
  }));
});
function o_(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function i_(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function l_(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    {
      x: o,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: o,
      y: r
    }
  ];
}
function s_(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, l = t.length - 1; i < t.length; l = i++) {
    const s = t[i].x, c = t[i].y, d = t[l].x, f = t[l].y;
    c > r != f > r && n < (d - s) * (r - c) / (f - c) + s && (o = !o);
  }
  return o;
}
function c_(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), d_(t);
}
function d_(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], l = t[t.length - 2];
      if ((i.x - l.x) * (o.y - l.y) >= (i.y - l.y) * (o.x - l.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], l = n[n.length - 2];
      if ((i.x - l.x) * (o.y - l.y) >= (i.y - l.y) * (o.x - l.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const u_ = YR, f_ = KR, h_ = XR, m_ = JR, Sm = QR, p_ = a_, zm = de(
  ({ className: e, classNames: t, arrow: n, sideOffset: r = 4, children: o, variant: i = "light", ...l }, s) => /* @__PURE__ */ re(
    Sm,
    {
      ref: s,
      sideOffset: r,
      className: j(
        ["z-50 overflow-hidden rounded-md bg-white p-2 text-sm text-text-primary shadow-md"],
        { "bg-deepGray-500 text-white": i === "dark" },
        e
      ),
      ...l,
      children: [
        o,
        n && /* @__PURE__ */ g(
          p_,
          {
            width: 11,
            height: 5,
            className: j("fill-white", { "fill-deepGray-500": i === "dark" }, t?.arrow)
          }
        )
      ]
    }
  )
);
zm.displayName = Sm.displayName;
function Ra(e) {
  return /* @__PURE__ */ g(f_, { ...e });
}
Ra.Content = zm;
Ra.Trigger = h_;
Ra.Provider = u_;
Ra.Portal = m_;
export {
  x_ as Accordion,
  M7 as AccordionContent,
  E7 as AccordionHeader,
  $7 as AccordionItem,
  x7 as AccordionTrigger,
  M_ as Alert,
  P7 as Button,
  C_ as ButtonLink,
  P_ as Calendar,
  S_ as Checkbox,
  z_ as Chip,
  X_ as Drawer,
  A_ as DropdownMenu,
  GC as DropdownMenuContent,
  F_ as DropdownMenuGroup,
  YC as DropdownMenuItem,
  UC as DropdownMenuLabel,
  N_ as DropdownMenuPortal,
  D_ as DropdownMenuRadioGroup,
  KC as DropdownMenuSeparator,
  O_ as DropdownMenuSub,
  qC as DropdownMenuSubContent,
  XC as DropdownMenuSubTrigger,
  jC as DropdownMenuTrigger,
  T_ as HelperText,
  Oc as IconButton,
  k_ as IconButtonLink,
  eP as Label,
  H_ as Logo,
  j_ as Modal,
  V_ as ModalActions,
  B_ as ModalContent,
  G_ as ModalFullScreen,
  W_ as ModalScreenReaderTitle,
  R_ as ModalTitle,
  L_ as ModalTitleInfo,
  __ as ModalTitleInverse,
  Y_ as Paper,
  CH as PhoneNumberInput,
  $l as Popover,
  YI as SearchInput,
  q_ as Select,
  WI as SelectContent,
  BI as SelectFilterTrigger,
  VI as SelectItem,
  jI as SelectSeparator,
  tm as SelectTrigger,
  Z_ as SelectValue,
  J_ as Slider,
  eL as Snackbar,
  Q_ as SnackbarProvider,
  Ml as Spinner,
  HR as Switch,
  IR as TextInput,
  LR as Toggle,
  Ra as Tooltip,
  Ac as buttonCva,
  j as cn,
  E_ as createSlots,
  Se as cva,
  y7 as generateUniqueId,
  Dc as iconButtonCva,
  Br as iconFillMap,
  K_ as isPossiblePhoneNumber,
  U_ as isValidPhoneNumber,
  tL as useSnackbar,
  bR as useSnackbarContext,
  wR as useSnackbarDispatchContext
};
